/*! timestamp creation: 1574069892210 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define("lmmMapsWidget", ["jQuery"], factory);
	else if(typeof exports === 'object')
		exports["lmmMapsWidget"] = factory(require("jQuery"));
	else
		root["lmmMapsWidget"] = factory(root["jQuery"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonplmmMapsWidget"];
/******/ 	window["webpackJsonplmmMapsWidget"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		1: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "./dist/js/lmm-maps-widget-" + ({"0":"validators"}[chunkId]||chunkId) + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 89);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.9.1
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            this ||
            {};

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  // (`nodeType` is checked to ensure that `module`
  // and `exports` are not HTML elements.)
  if (typeof exports != 'undefined' && !exports.nodeType) {
    if (typeof module != 'undefined' && !module.nodeType && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.9.1';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  var builtinIteratee;

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
    return _.property(value);
  };

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only argCount argument.
  _.iteratee = builtinIteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  var restArguments = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var shallowProperty = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  var has = function(obj, path) {
    return obj != null && hasOwnProperty.call(obj, path);
  }

  var deepGet = function(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = shallowProperty('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (_.isFunction(path)) {
      func = path;
    } else if (_.isArray(path)) {
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return _.map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, Boolean);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        // Flatten current level of array or arguments object.
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArguments(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArguments(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArguments(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArguments(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of _.pairs.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions.
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test.
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions.
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments.
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArguments(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArguments(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArguments(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, result;

    var later = function(context, args) {
      timeout = null;
      if (args) result = func.apply(context, args);
    };

    var debounced = restArguments(function(args) {
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(this, args);
      } else {
        timeout = _.delay(later, wait, this, args);
      }

      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };

    return debounced;
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArguments = restArguments;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object.
  // In contrast to _.map it returns an object.
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
        length = keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of _.object.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`.
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test.
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, path) {
    if (!_.isArray(path)) {
      return has(obj, path);
    }
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (obj == null || !hasOwnProperty.call(obj, key)) {
        return false;
      }
      obj = obj[key];
    }
    return !!length;
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indexes.
  _.property = function(path) {
    if (!_.isArray(path)) {
      return shallowProperty(path);
    }
    return function(obj) {
      return deepGet(obj, path);
    };
  };

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    if (obj == null) {
      return function(){};
    }
    return function(path) {
      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  _.result = function(obj, path, fallback) {
    if (!_.isArray(path)) path = [path];
    var length = path.length;
    if (!length) {
      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = _.isFunction(prop) ? prop.call(obj) : prop;
    }
    return obj;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
    return _;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return String(this._wrapped);
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17), __webpack_require__(93)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

// Create a simple path alias to allow browserify to resolve
// the runtime on a supported path.
module.exports = __webpack_require__(107)['default'];


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _runtime = __webpack_require__(13);

var _runtime2 = _interopRequireDefault(_runtime);

var _formatCssClass = __webpack_require__(122);

var _formatCssClass2 = _interopRequireDefault(_formatCssClass);

var _getBrowser = __webpack_require__(123);

var _getBrowser2 = _interopRequireDefault(_getBrowser);

var _assertValidConfig = __webpack_require__(46);

var _assertValidConfig2 = _interopRequireDefault(_assertValidConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _backbone2.default.View.extend(
/**
 * @lends core.components.base.ComponentBase.prototype
 */
{

  /**
   * The CSS class used for the root element of the component. It needs to be set in derivate classes.
   * @protected
   * @readonly
   * @type {string}
   */
  componentClass: null,

  /**
   * The widget instance the component is created within.
   * @protected
   * @readonly
   * @type {core.widget.WidgetCommon}
   */
  widget: null,

  /**
   * The event bus instance used by extending component classes to talk to other components
   * @protected
   * @readonly
   * @type {core.widget.widgetHelpers.EventBus}
   */
  bus: null,

  /** 
   * Validation function, normally generated by requiring an JSON schema file and 
   * letting Webpack compile the proper validaiton function.
   * Override this to allow for adding custom configuration properties to the class extending ComponentBase.
   * @function
   * @param {core.component.base.ComponentBase.ComponentBaseConfig} config
   * @protected
   */
  validation: __webpack_require__(125),

  /**
   * Events to be attached to the HTML of the component. Keys must be of the form "eventName classSelector", 
   * and values the name of the method to call.
   * @protected
   * @type {Object<string,string>}
   */
  events: {
    'click': 'toggleActivation',
    'click .close-btn': '_closefn'
  },

  /** 
   * It is a template function used to generate the component's DOM, normally generated by requiring a Handlebars template and 
   * letting the appropiate Webpack loader convert it to a function.
   *
   * ComponentBase extending classes must provide their own templates.
   * @protected
   * @function 
   * @param {object} data The data to be used to be referenced in the template to generate the DOM.
   */
  template: null,

  /**
   * The data to be passed to the template function  when it gets rendered. 
   * @protected
   */
  templateConfig: {},

  /**
   * @typedef {object} ComponentBaseConfig
   * @property {core.widget.Widget} widget The widget instance the component is attached to.
   * @property {string} identifier The identifier of the component.
   * @property {string} [position=] The position of the component in the map or parent component
   * @property {object} [properties={}] The configuration for the component 
   * @property {string[]} [imcompatibilities] Identifiers of components this component is incompatible with,
   * i.e. if this component is active and one on this array is activated, this component will deactivate.
   * @property {boolean} [isChild=false] True if the component is child of another component
   * @memberof core.components.base.ComponentBase
   */

  /**
   * Creates a ComponentBase instance.
   * @class ComponentBase
   * @memberof core.components.base
   * @classdesc This is a component base on which the visualization components will be built
   * @extends Backbone.View
   * @abstract
   * @param {core.components.base.ComponentBase.ComponentBaseConfig} options The config provided by json.    
   * @throws {Error} If the options parameter doesn't contain widget, componentClass or identifier properties.
   */
  constructor: function constructor(options) {
    if (!options.properties) {
      options.properties = {};
    }

    this.position = options.position;
    this.widget = options.widget;

    if (!this.widget) {
      throw new Error('ComponentBase::constructor: needs a widget property in the options');
    }

    if (!options.identifier) {
      throw new Error('ComponentBase::constructor: the component identifier must be received in the options');
    }
    this.identifier = options.identifier;

    if (!this.componentClass) {
      throw new Error('ComponentBase::constructor: A ComponentBase subclass needs to define a componentClass property');
    }

    (0, _assertValidConfig2.default)('Component ' + this.identifier, this.validation, options);

    this.map = options.map || options.widget.map;
    this.imagesPath = this.widget.config.imagesPath;
    this.isChild = options.isChild || false;

    this.bus = options.widget.bus;

    this.incompatibilities = options.incompatibilities || [];
    this.componentConstructorClass = options.componentConstructorClass;

    this.templateConfig = {
      componentClass: this.componentClass || null,
      iconClassName: options.properties ? options.properties.iconClassName : null
    };
    this.isActivated = false;
    this.filterManager = options.widget.filterManager || null;
    this.handleLayers = this.widget.handleLayers;
    this.properties = options.properties || {};
    this.parentComponent = options.parent;

    _backbone2.default.View.prototype.constructor.call(this, options);
  },

  /**
   * Initialize the component and insert it as either child of another component,
   * embedded in the map or as Google Maps Control
   * @summary Initialize the component
   * @function
   * @memberof ComponentBase
   * @param {Object} options - The config provided by json
   * @listens  Widget#ACTIVATE_TOOL
   */
  initialize: function initialize(options) {
    var _this = this;

    if (_underscore2.default.isUndefined(this.template)) {
      return;
    }

    if (!_underscore2.default.isUndefined(this.templatePartials)) {
      for (var partialName in this.templatePartials) {
        if (!this.templatePartials.hasOwnProperty(partialName)) {
          continue;
        }
        _runtime2.default.default.registerPartial(partialName, this.templatePartials[partialName]);
      }
    }

    //render the template
    if (!this.position && _underscore2.default.isUndefined(this.widget.map)) {
      //Autocomplete widget
      this.widget.$el.find('.lmm-autocomplete-widget-container').append(this.render().el);
    } else if (this.isChild) {
      this.render();
    } else if (!this.position) {
      this.widget.$el.find('.lmm-maps-widget-container').append(this.render().el);
    } else {
      this.map.controls[google.maps.ControlPosition[this.position]].push(this.render().el);
    }

    if (!_underscore2.default.isEmpty(this.incompatibilities)) {
      this.listenTo(this.bus, 'ACTIVATE_TOOL', function (tool) {
        if (_this.isActivated && _underscore2.default.contains(_this.incompatibilities, tool.identifier)) {
          _this.deactivate({
            disable: true
          });
        }
      });
    }
  },

  /**
   * Changes the component's activation state
   */
  toggleActivation: function toggleActivation() {
    if (!this.isActivated) {
      this.activate();
    } else {
      this.deactivate();
    }
  },


  /**
   * Activate the component
   * @fires Widget#ACTIVATE_TOOL
   */
  activate: function activate() {
    this.isActivated = true;
    /**
     * Activate the component.
     * @event Widget#ACTIVATE_TOOL
     * @type {object}
     * @property {object} myObj
     * @property  {string} myObj.identifier - Indicates the id of the hovered marker
     * @property  {ComponentBase} myObj.instanceObj - The instance of component
     */
    this.bus.trigger('ACTIVATE_TOOL', {
      identifier: this.identifier,
      instanceObj: this
    });
  },


  /**
   * Deactivate the component
   * @params {object} options - The options that will send in event
   * @fires Widget#DEACTIVATE_TOOL
   */
  deactivate: function deactivate(options) {
    var deactivationOpt = _underscore2.default.extend({
      identifier: this.identifier
    }, options);
    this.isActivated = false;
    /**
     * Deactivate the component.
     * @event Widget#DEACTIVATE_TOOL
     * @type {object}
     * @property {object} deactivationOpt - The options for deactivation
     * @property  {string} deactivationOpt.identifier - Indicates the id of the hovered marker
     */
    this.bus.trigger('DEACTIVATE_TOOL', deactivationOpt);
  },


  /**
   * Hide the view of the component. Put display as 'none'
   * @function
   */
  hide: function hide() {
    var name = (0, _getBrowser2.default)().name;
    if (name === 'IE' || name === 'Edge') {
      this.$el.wrap('<span>').hide();
    }
    if (this.position && google.maps.ControlPosition[this.position]) {
      var idx = this.map.controls[google.maps.ControlPosition[this.position]].indexOf(this.el);
      if (idx !== -1) {
        this.map.controls[google.maps.ControlPosition[this.position]].removeAt(idx);
      }
    }
    this.$el.hide();
  },


  /**
   * Show the view of the component. Put display as 'block'
   * @function
   */
  show: function show() {
    this.$el.show();
    // position is a map position (not a container's) 
    // and it isn't already set as control to avoid duplicates
    if (this.position && this.map.controls[google.maps.ControlPosition[this.position]] && this.map.controls[google.maps.ControlPosition[this.position]].indexOf(this.el) === -1) {
      this.map.controls[google.maps.ControlPosition[this.position]].push(this.el);
    }
  },


  /**
   * Overrides 
   * @final 
   * @override
   */
  delegateEvents: function delegateEvents() {
    this.customEventDelegation();
    _backbone2.default.View.prototype.delegateEvents.call(this);
  },


  /**
   * Allows to add a specified functionality before ComponentBase#delegateEvents
   * @function
   * @protected
   * @virtual
   */
  customEventDelegation: function customEventDelegation() {},


  /**
   * Renders the template of the widget
   * @function
   * @returns {ComponentBase} the instance
   */
  render: function render() {
    var classComp = this.isChild ? 'component' : 'componentOnMap';
    this.setElement(this.template(this.templateConfig));
    this.$el.addClass((0, _formatCssClass2.default)(this.componentClass)).addClass((0, _formatCssClass2.default)(classComp)).addClass((0, _formatCssClass2.default)(this.identifier)).addClass((0, _formatCssClass2.default)(this.componentClass + '-' + this.identifier));

    return this;
  },

  _closefn: function _closefn() {
    if (this.parentComponent) {
      this.parentComponent.unSelect();
    }
  }
});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Backbone.js 1.3.3

//     (c) 2010-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(factory) {

  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
  // We use `self` instead of `window` for `WebWorker` support.
  var root = (typeof self == 'object' && self.self === self && self) ||
            (typeof global == 'object' && global.global === global && global);

  // Set up Backbone appropriately for the environment. Start with AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(0), exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function(_, $, exports) {
      // Export global even in AMD case in case this script is loaded with
      // others that may still expect a global Backbone.
      root.Backbone = factory(root, exports, _, $);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
  } else if (typeof exports !== 'undefined') {
    var _ = require('underscore'), $;
    try { $ = require('jquery'); } catch (e) {}
    factory(root, exports, _, $);

  // Finally, as a browser global.
  } else {
    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
  }

})(function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create a local reference to a common array method we'll want to use later.
  var slice = Array.prototype.slice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.3.3';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = $;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... this will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Proxy Backbone class methods to Underscore functions, wrapping the model's
  // `attributes` object or collection's `models` array behind the scenes.
  //
  // collection.filter(function(model) { return model.get('age') > 10 });
  // collection.each(this.addView);
  //
  // `Function#apply` can be slow so we use the method's arg count, if we know it.
  var addMethod = function(length, method, attribute) {
    switch (length) {
      case 1: return function() {
        return _[method](this[attribute]);
      };
      case 2: return function(value) {
        return _[method](this[attribute], value);
      };
      case 3: return function(iteratee, context) {
        return _[method](this[attribute], cb(iteratee, this), context);
      };
      case 4: return function(iteratee, defaultVal, context) {
        return _[method](this[attribute], cb(iteratee, this), defaultVal, context);
      };
      default: return function() {
        var args = slice.call(arguments);
        args.unshift(this[attribute]);
        return _[method].apply(_, args);
      };
    }
  };
  var addUnderscoreMethods = function(Class, methods, attribute) {
    _.each(methods, function(length, method) {
      if (_[method]) Class.prototype[method] = addMethod(length, method, attribute);
    });
  };

  // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
  var cb = function(iteratee, instance) {
    if (_.isFunction(iteratee)) return iteratee;
    if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
    if (_.isString(iteratee)) return function(model) { return model.get(iteratee); };
    return iteratee;
  };
  var modelMatcher = function(attrs) {
    var matcher = _.matches(attrs);
    return function(model) {
      return matcher(model.attributes);
    };
  };

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // a custom event channel. You may bind a callback to an event with `on` or
  // remove with `off`; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {};

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Iterates over the standard `event, callback` (as well as the fancy multiple
  // space-separated events `"change blur", callback` and jQuery-style event
  // maps `{event: callback}`).
  var eventsApi = function(iteratee, events, name, callback, opts) {
    var i = 0, names;
    if (name && typeof name === 'object') {
      // Handle event maps.
      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
      for (names = _.keys(name); i < names.length ; i++) {
        events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
      }
    } else if (name && eventSplitter.test(name)) {
      // Handle space-separated event names by delegating them individually.
      for (names = name.split(eventSplitter); i < names.length; i++) {
        events = iteratee(events, names[i], callback, opts);
      }
    } else {
      // Finally, standard events.
      events = iteratee(events, name, callback, opts);
    }
    return events;
  };

  // Bind an event to a `callback` function. Passing `"all"` will bind
  // the callback to all events fired.
  Events.on = function(name, callback, context) {
    return internalOn(this, name, callback, context);
  };

  // Guard the `listening` argument from the public API.
  var internalOn = function(obj, name, callback, context, listening) {
    obj._events = eventsApi(onApi, obj._events || {}, name, callback, {
      context: context,
      ctx: obj,
      listening: listening
    });

    if (listening) {
      var listeners = obj._listeners || (obj._listeners = {});
      listeners[listening.id] = listening;
    }

    return obj;
  };

  // Inversion-of-control versions of `on`. Tell *this* object to listen to
  // an event in another object... keeping track of what it's listening to
  // for easier unbinding later.
  Events.listenTo = function(obj, name, callback) {
    if (!obj) return this;
    var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
    var listeningTo = this._listeningTo || (this._listeningTo = {});
    var listening = listeningTo[id];

    // This object is not listening to any other events on `obj` yet.
    // Setup the necessary references to track the listening callbacks.
    if (!listening) {
      var thisId = this._listenId || (this._listenId = _.uniqueId('l'));
      listening = listeningTo[id] = {obj: obj, objId: id, id: thisId, listeningTo: listeningTo, count: 0};
    }

    // Bind callbacks on obj, and keep track of them on listening.
    internalOn(obj, name, callback, this, listening);
    return this;
  };

  // The reducing API that adds a callback to the `events` object.
  var onApi = function(events, name, callback, options) {
    if (callback) {
      var handlers = events[name] || (events[name] = []);
      var context = options.context, ctx = options.ctx, listening = options.listening;
      if (listening) listening.count++;

      handlers.push({callback: callback, context: context, ctx: context || ctx, listening: listening});
    }
    return events;
  };

  // Remove one or many callbacks. If `context` is null, removes all
  // callbacks with that function. If `callback` is null, removes all
  // callbacks for the event. If `name` is null, removes all bound
  // callbacks for all events.
  Events.off = function(name, callback, context) {
    if (!this._events) return this;
    this._events = eventsApi(offApi, this._events, name, callback, {
      context: context,
      listeners: this._listeners
    });
    return this;
  };

  // Tell this object to stop listening to either specific events ... or
  // to every object it's currently listening to.
  Events.stopListening = function(obj, name, callback) {
    var listeningTo = this._listeningTo;
    if (!listeningTo) return this;

    var ids = obj ? [obj._listenId] : _.keys(listeningTo);

    for (var i = 0; i < ids.length; i++) {
      var listening = listeningTo[ids[i]];

      // If listening doesn't exist, this object is not currently
      // listening to obj. Break out early.
      if (!listening) break;

      listening.obj.off(name, callback, this);
    }

    return this;
  };

  // The reducing API that removes a callback from the `events` object.
  var offApi = function(events, name, callback, options) {
    if (!events) return;

    var i = 0, listening;
    var context = options.context, listeners = options.listeners;

    // Delete all events listeners and "drop" events.
    if (!name && !callback && !context) {
      var ids = _.keys(listeners);
      for (; i < ids.length; i++) {
        listening = listeners[ids[i]];
        delete listeners[listening.id];
        delete listening.listeningTo[listening.objId];
      }
      return;
    }

    var names = name ? [name] : _.keys(events);
    for (; i < names.length; i++) {
      name = names[i];
      var handlers = events[name];

      // Bail out if there are no events stored.
      if (!handlers) break;

      // Replace events if there are any remaining.  Otherwise, clean up.
      var remaining = [];
      for (var j = 0; j < handlers.length; j++) {
        var handler = handlers[j];
        if (
          callback && callback !== handler.callback &&
            callback !== handler.callback._callback ||
              context && context !== handler.context
        ) {
          remaining.push(handler);
        } else {
          listening = handler.listening;
          if (listening && --listening.count === 0) {
            delete listeners[listening.id];
            delete listening.listeningTo[listening.objId];
          }
        }
      }

      // Update tail event if the list has any events.  Otherwise, clean up.
      if (remaining.length) {
        events[name] = remaining;
      } else {
        delete events[name];
      }
    }
    return events;
  };

  // Bind an event to only be triggered a single time. After the first time
  // the callback is invoked, its listener will be removed. If multiple events
  // are passed in using the space-separated syntax, the handler will fire
  // once for each event, not once for a combination of all events.
  Events.once = function(name, callback, context) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.off, this));
    if (typeof name === 'string' && context == null) callback = void 0;
    return this.on(events, callback, context);
  };

  // Inversion-of-control versions of `once`.
  Events.listenToOnce = function(obj, name, callback) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.stopListening, this, obj));
    return this.listenTo(obj, events);
  };

  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
  // `offer` unbinds the `onceWrapper` after it has been called.
  var onceMap = function(map, name, callback, offer) {
    if (callback) {
      var once = map[name] = _.once(function() {
        offer(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
    }
    return map;
  };

  // Trigger one or many events, firing all bound callbacks. Callbacks are
  // passed the same arguments as `trigger` is, apart from the event name
  // (unless you're listening on `"all"`, which will cause your callback to
  // receive the true name of the event as the first argument).
  Events.trigger = function(name) {
    if (!this._events) return this;

    var length = Math.max(0, arguments.length - 1);
    var args = Array(length);
    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];

    eventsApi(triggerApi, this._events, name, void 0, args);
    return this;
  };

  // Handles triggering the appropriate event callbacks.
  var triggerApi = function(objEvents, name, callback, args) {
    if (objEvents) {
      var events = objEvents[name];
      var allEvents = objEvents.all;
      if (events && allEvents) allEvents = allEvents.slice();
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, [name].concat(args));
    }
    return objEvents;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId(this.cidPrefix);
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    var defaults = _.result(this, 'defaults');
    attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // The prefix is used to create the client id which is used to identify models locally.
    // You may want to override this if you're experiencing name clashes with model ids.
    cidPrefix: 'c',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Special-cased proxy to underscore's `_.matches` method.
    matches: function(attrs) {
      return !!_.iteratee(attrs, this)(this.attributes);
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      var unset      = options.unset;
      var silent     = options.silent;
      var changes    = [];
      var changing   = this._changing;
      this._changing = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }

      var current = this.attributes;
      var changed = this.changed;
      var prev    = this._previousAttributes;

      // For each `set` attribute, update or delete the current value.
      for (var attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          changed[attr] = val;
        } else {
          delete changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Update the `id`.
      if (this.idAttribute in attrs) this.id = this.get(this.idAttribute);

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0; i < changes.length; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      var changed = {};
      for (var attr in diff) {
        var val = diff[attr];
        if (_.isEqual(old[attr], val)) continue;
        changed[attr] = val;
      }
      return _.size(changed) ? changed : false;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server, merging the response with the model's
    // local attributes. Any changed attributes will trigger a "change" event.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (!model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true, parse: true}, options);
      var wait = options.wait;

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !wait) {
        if (!this.set(attrs, options)) return false;
      } else if (!this._validate(attrs, options)) {
        return false;
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      var model = this;
      var success = options.success;
      var attributes = this.attributes;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
        if (serverAttrs && !model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      // Set temporary attributes if `{wait: true}` to properly find new ids.
      if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);

      var method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch' && !options.attrs) options.attrs = attrs;
      var xhr = this.sync(method, this, options);

      // Restore attributes.
      this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;
      var wait = options.wait;

      var destroy = function() {
        model.stopListening();
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (wait) destroy();
        if (success) success.call(options.context, model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      var xhr = false;
      if (this.isNew()) {
        _.defer(options.success);
      } else {
        wrapError(this, options);
        xhr = this.sync('delete', this, options);
      }
      if (!wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      var id = this.get(this.idAttribute);
      return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend({}, options, {validate: true}));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model, mapped to the
  // number of arguments they take.
  var modelMethods = {keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
      omit: 0, chain: 1, isEmpty: 1};

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  addUnderscoreMethods(Model, modelMethods, 'attributes');

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analogous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Splices `insert` into `array` at index `at`.
  var splice = function(array, insert, at) {
    at = Math.min(Math.max(at, 0), array.length);
    var tail = Array(array.length - at);
    var length = insert.length;
    var i;
    for (i = 0; i < tail.length; i++) tail[i] = array[i + at];
    for (i = 0; i < length; i++) array[i + at] = insert[i];
    for (i = 0; i < tail.length; i++) array[i + length + at] = tail[i];
  };

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model) { return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set. `models` may be Backbone
    // Models or raw JavaScript objects to be converted to Models, or any
    // combination of the two.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      options = _.extend({}, options);
      var singular = !_.isArray(models);
      models = singular ? [models] : models.slice();
      var removed = this._removeModels(models, options);
      if (!options.silent && removed.length) {
        options.changes = {added: [], merged: [], removed: removed};
        this.trigger('update', this, options);
      }
      return singular ? removed[0] : removed;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      if (models == null) return;

      options = _.extend({}, setOptions, options);
      if (options.parse && !this._isModel(models)) {
        models = this.parse(models, options) || [];
      }

      var singular = !_.isArray(models);
      models = singular ? [models] : models.slice();

      var at = options.at;
      if (at != null) at = +at;
      if (at > this.length) at = this.length;
      if (at < 0) at += this.length + 1;

      var set = [];
      var toAdd = [];
      var toMerge = [];
      var toRemove = [];
      var modelMap = {};

      var add = options.add;
      var merge = options.merge;
      var remove = options.remove;

      var sort = false;
      var sortable = this.comparator && at == null && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      var model, i;
      for (i = 0; i < models.length; i++) {
        model = models[i];

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        var existing = this.get(model);
        if (existing) {
          if (merge && model !== existing) {
            var attrs = this._isModel(model) ? model.attributes : model;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            toMerge.push(existing);
            if (sortable && !sort) sort = existing.hasChanged(sortAttr);
          }
          if (!modelMap[existing.cid]) {
            modelMap[existing.cid] = true;
            set.push(existing);
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(model, options);
          if (model) {
            toAdd.push(model);
            this._addReference(model, options);
            modelMap[model.cid] = true;
            set.push(model);
          }
        }
      }

      // Remove stale models.
      if (remove) {
        for (i = 0; i < this.length; i++) {
          model = this.models[i];
          if (!modelMap[model.cid]) toRemove.push(model);
        }
        if (toRemove.length) this._removeModels(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      var orderChanged = false;
      var replace = !sortable && add && remove;
      if (set.length && replace) {
        orderChanged = this.length !== set.length || _.some(this.models, function(m, index) {
          return m !== set[index];
        });
        this.models.length = 0;
        splice(this.models, set, 0);
        this.length = this.models.length;
      } else if (toAdd.length) {
        if (sortable) sort = true;
        splice(this.models, toAdd, at == null ? this.length : at);
        this.length = this.models.length;
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort/update events.
      if (!options.silent) {
        for (i = 0; i < toAdd.length; i++) {
          if (at != null) options.index = at + i;
          model = toAdd[i];
          model.trigger('add', model, this, options);
        }
        if (sort || orderChanged) this.trigger('sort', this, options);
        if (toAdd.length || toRemove.length || toMerge.length) {
          options.changes = {
            added: toAdd,
            removed: toRemove,
            merged: toMerge
          };
          this.trigger('update', this, options);
        }
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options = options ? _.clone(options) : {};
      for (var i = 0; i < this.models.length; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      return this.remove(model, options);
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      return this.remove(model, options);
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id, cid, model object with id or cid
    // properties, or an attributes object that is transformed through modelId.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj] ||
        this._byId[this.modelId(obj.attributes || obj)] ||
        obj.cid && this._byId[obj.cid];
    },

    // Returns `true` if the model is in the collection.
    has: function(obj) {
      return this.get(obj) != null;
    },

    // Get the model at the given index.
    at: function(index) {
      if (index < 0) index += this.length;
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      return this[first ? 'find' : 'filter'](attrs);
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      var comparator = this.comparator;
      if (!comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      var length = comparator.length;
      if (_.isFunction(comparator)) comparator = _.bind(comparator, this);

      // Run sort based on type of `comparator`.
      if (length === 1 || _.isString(comparator)) {
        this.models = this.sortBy(comparator);
      } else {
        this.models.sort(comparator);
      }
      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return this.map(attr + '');
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success.call(options.context, collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      var wait = options.wait;
      model = this._prepareModel(model, options);
      if (!model) return false;
      if (!wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(m, resp, callbackOpts) {
        if (wait) collection.add(m, callbackOpts);
        if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models, {
        model: this.model,
        comparator: this.comparator
      });
    },

    // Define how to uniquely identify models in the collection.
    modelId: function(attrs) {
      return attrs[this.model.prototype.idAttribute || 'id'];
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (this._isModel(attrs)) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options = options ? _.clone(options) : {};
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method called by both remove and set.
    _removeModels: function(models, options) {
      var removed = [];
      for (var i = 0; i < models.length; i++) {
        var model = this.get(models[i]);
        if (!model) continue;

        var index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;

        // Remove references before triggering 'remove' event to prevent an
        // infinite loop. #3693
        delete this._byId[model.cid];
        var id = this.modelId(model.attributes);
        if (id != null) delete this._byId[id];

        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }

        removed.push(model);
        this._removeReference(model, options);
      }
      return removed;
    },

    // Method for checking whether an object should be considered a model for
    // the purposes of adding to the collection.
    _isModel: function(model) {
      return model instanceof Model;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      var id = this.modelId(model.attributes);
      if (id != null) this._byId[id] = model;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      delete this._byId[model.cid];
      var id = this.modelId(model.attributes);
      if (id != null) delete this._byId[id];
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if (model) {
        if ((event === 'add' || event === 'remove') && collection !== this) return;
        if (event === 'destroy') this.remove(model, options);
        if (event === 'change') {
          var prevId = this.modelId(model.previousAttributes());
          var id = this.modelId(model.attributes);
          if (prevId !== id) {
            if (prevId != null) delete this._byId[prevId];
            if (id != null) this._byId[id] = model;
          }
        }
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var collectionMethods = {forEach: 3, each: 3, map: 3, collect: 3, reduce: 0,
      foldl: 0, inject: 0, reduceRight: 0, foldr: 0, find: 3, detect: 3, filter: 3,
      select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 3, includes: 3,
      contains: 3, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
      head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
      without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
      isEmpty: 1, chain: 1, sample: 3, partition: 3, groupBy: 3, countBy: 3,
      sortBy: 3, indexBy: 3, findIndex: 3, findLastIndex: 3};

  // Mix in each Underscore method as a proxy to `Collection#models`.
  addUnderscoreMethods(Collection, collectionMethods, 'models');

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be set as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this._removeElement();
      this.stopListening();
      return this;
    },

    // Remove this view's element from the document and all event listeners
    // attached to it. Exposed for subclasses using an alternative DOM
    // manipulation API.
    _removeElement: function() {
      this.$el.remove();
    },

    // Change the view's element (`this.el` property) and re-delegate the
    // view's events on the new element.
    setElement: function(element) {
      this.undelegateEvents();
      this._setElement(element);
      this.delegateEvents();
      return this;
    },

    // Creates the `this.el` and `this.$el` references for this view using the
    // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
    // context or an element. Subclasses can override this to utilize an
    // alternative DOM manipulation API and are only required to set the
    // `this.el` property.
    _setElement: function(el) {
      this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
      this.el = this.$el[0];
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    delegateEvents: function(events) {
      events || (events = _.result(this, 'events'));
      if (!events) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[method];
        if (!method) continue;
        var match = key.match(delegateEventSplitter);
        this.delegate(match[1], match[2], _.bind(method, this));
      }
      return this;
    },

    // Add a single event listener to the view's element (or a child element
    // using `selector`). This only works for delegate-able events: not `focus`,
    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
    delegate: function(eventName, selector, listener) {
      this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Clears all callbacks previously bound to the view by `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      if (this.$el) this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // A finer-grained `undelegateEvents` for removing a single delegated event.
    // `selector` and `listener` are both optional.
    undelegate: function(eventName, selector, listener) {
      this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Produces a DOM element to be assigned to your view. Exposed for
    // subclasses using an alternative DOM manipulation API.
    _createElement: function(tagName) {
      return document.createElement(tagName);
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        this.setElement(this._createElement(_.result(this, 'tagName')));
        this._setAttributes(attrs);
      } else {
        this.setElement(_.result(this, 'el'));
      }
    },

    // Set attributes from a hash on this view's element.  Exposed for
    // subclasses using an alternative DOM manipulation API.
    _setAttributes: function(attributes) {
      this.$el.attr(attributes);
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // Pass along `textStatus` and `errorThrown` from jQuery.
    var error = options.error;
    options.error = function(xhr, textStatus, errorThrown) {
      options.textStatus = textStatus;
      options.errorThrown = errorThrown;
      if (error) error.call(options.context, xhr, textStatus, errorThrown);
    };

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch': 'PATCH',
    'delete': 'DELETE',
    'read': 'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        if (router.execute(callback, args, name) !== false) {
          router.trigger.apply(router, ['route:' + name].concat(args));
          router.trigger('route', name, args);
          Backbone.history.trigger('route', router, name, args);
        }
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args, name) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional) {
                     return optional ? match : '([^/?]+)';
                   })
                   .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    this.checkUrl = _.bind(this.checkUrl, this);

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      var path = this.location.pathname.replace(/[^\/]$/, '$&/');
      return path === this.root && !this.getSearch();
    },

    // Does the pathname match the root?
    matchRoot: function() {
      var path = this.decodeFragment(this.location.pathname);
      var rootPath = path.slice(0, this.root.length - 1) + '/';
      return rootPath === this.root;
    },

    // Unicode characters in `location.pathname` are percent encoded so they're
    // decoded for comparison. `%25` should not be decoded since it may be part
    // of an encoded parameter.
    decodeFragment: function(fragment) {
      return decodeURI(fragment.replace(/%25/g, '%2525'));
    },

    // In IE6, the hash fragment and search params are incorrect if the
    // fragment contains `?`.
    getSearch: function() {
      var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
      return match ? match[0] : '';
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the pathname and search params, without the root.
    getPath: function() {
      var path = this.decodeFragment(
        this.location.pathname + this.getSearch()
      ).slice(this.root.length - 1);
      return path.charAt(0) === '/' ? path.slice(1) : path;
    },

    // Get the cross-browser normalized URL fragment from the path or hash.
    getFragment: function(fragment) {
      if (fragment == null) {
        if (this._usePushState || !this._wantsHashChange) {
          fragment = this.getPath();
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error('Backbone.history has already been started');
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._hasHashChange   = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
      this._useHashChange   = this._wantsHashChange && this._hasHashChange;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.history && this.history.pushState);
      this._usePushState    = this._wantsPushState && this._hasPushState;
      this.fragment         = this.getFragment();

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          var rootPath = this.root.slice(0, -1) || '/';
          this.location.replace(rootPath + '#' + this.getPath());
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot()) {
          this.navigate(this.getHash(), {replace: true});
        }

      }

      // Proxy an iframe to handle location events if the browser doesn't
      // support the `hashchange` event, HTML5 history, or the user wants
      // `hashChange` but not `pushState`.
      if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
        this.iframe = document.createElement('iframe');
        this.iframe.src = 'javascript:0';
        this.iframe.style.display = 'none';
        this.iframe.tabIndex = -1;
        var body = document.body;
        // Using `appendChild` will throw on IE < 9 if the document is not ready.
        var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
        iWindow.document.open();
        iWindow.document.close();
        iWindow.location.hash = '#' + this.fragment;
      }

      // Add a cross-platform `addEventListener` shim for older browsers.
      var addEventListener = window.addEventListener || function(eventName, listener) {
        return attachEvent('on' + eventName, listener);
      };

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._usePushState) {
        addEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        addEventListener('hashchange', this.checkUrl, false);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      // Add a cross-platform `removeEventListener` shim for older browsers.
      var removeEventListener = window.removeEventListener || function(eventName, listener) {
        return detachEvent('on' + eventName, listener);
      };

      // Remove window listeners.
      if (this._usePushState) {
        removeEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        removeEventListener('hashchange', this.checkUrl, false);
      }

      // Clean up the iframe if necessary.
      if (this.iframe) {
        document.body.removeChild(this.iframe);
        this.iframe = null;
      }

      // Some environments will throw when clearing an undefined interval.
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();

      // If the user pressed the back button, the iframe's hash will have
      // changed and we should use that for comparison.
      if (current === this.fragment && this.iframe) {
        current = this.getHash(this.iframe.contentWindow);
      }

      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      // If the root doesn't match, no routes can match either.
      if (!this.matchRoot()) return false;
      fragment = this.fragment = this.getFragment(fragment);
      return _.some(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      // Normalize the fragment.
      fragment = this.getFragment(fragment || '');

      // Don't include a trailing slash on the root.
      var rootPath = this.root;
      if (fragment === '' || fragment.charAt(0) === '?') {
        rootPath = rootPath.slice(0, -1) || '/';
      }
      var url = rootPath + fragment;

      // Strip the hash and decode for matching.
      fragment = this.decodeFragment(fragment.replace(pathStripper, ''));

      if (this.fragment === fragment) return;
      this.fragment = fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._usePushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
          var iWindow = this.iframe.contentWindow;

          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if (!options.replace) {
            iWindow.document.open();
            iWindow.document.close();
          }

          this._updateHash(iWindow.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function and add the prototype properties.
    child.prototype = _.create(parent.prototype, protoProps);
    child.prototype.constructor = child;

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error.call(options.context, model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  return Backbone;
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Atomics,
	SharedArrayBuffer,
*/

var undefined; // eslint-disable-line no-shadow-restricted-names

var $TypeError = TypeError;

var ThrowTypeError = Object.getOwnPropertyDescriptor
	? (function () { return Object.getOwnPropertyDescriptor(arguments, 'callee').get; }())
	: function () { throw new $TypeError(); };

var hasSymbols = __webpack_require__(23)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'$ %Array%': Array,
	'$ %ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'$ %ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'$ %ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'$ %ArrayPrototype%': Array.prototype,
	'$ %ArrayProto_entries%': Array.prototype.entries,
	'$ %ArrayProto_forEach%': Array.prototype.forEach,
	'$ %ArrayProto_keys%': Array.prototype.keys,
	'$ %ArrayProto_values%': Array.prototype.values,
	'$ %AsyncFromSyncIteratorPrototype%': undefined,
	'$ %AsyncFunction%': asyncFunction,
	'$ %AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'$ %AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'$ %AsyncGeneratorFunction%': asyncGenFunction,
	'$ %AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'$ %AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'$ %Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'$ %Boolean%': Boolean,
	'$ %BooleanPrototype%': Boolean.prototype,
	'$ %DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'$ %DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'$ %Date%': Date,
	'$ %DatePrototype%': Date.prototype,
	'$ %decodeURI%': decodeURI,
	'$ %decodeURIComponent%': decodeURIComponent,
	'$ %encodeURI%': encodeURI,
	'$ %encodeURIComponent%': encodeURIComponent,
	'$ %Error%': Error,
	'$ %ErrorPrototype%': Error.prototype,
	'$ %eval%': eval, // eslint-disable-line no-eval
	'$ %EvalError%': EvalError,
	'$ %EvalErrorPrototype%': EvalError.prototype,
	'$ %Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'$ %Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'$ %Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'$ %Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'$ %Function%': Function,
	'$ %FunctionPrototype%': Function.prototype,
	'$ %Generator%': generator ? getProto(generator()) : undefined,
	'$ %GeneratorFunction%': generatorFunction,
	'$ %GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'$ %Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'$ %Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'$ %Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'$ %Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'$ %Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'$ %Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'$ %isFinite%': isFinite,
	'$ %isNaN%': isNaN,
	'$ %IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'$ %JSON%': JSON,
	'$ %JSONParse%': JSON.parse,
	'$ %Map%': typeof Map === 'undefined' ? undefined : Map,
	'$ %MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'$ %MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'$ %Math%': Math,
	'$ %Number%': Number,
	'$ %NumberPrototype%': Number.prototype,
	'$ %Object%': Object,
	'$ %ObjectPrototype%': Object.prototype,
	'$ %ObjProto_toString%': Object.prototype.toString,
	'$ %ObjProto_valueOf%': Object.prototype.valueOf,
	'$ %parseFloat%': parseFloat,
	'$ %parseInt%': parseInt,
	'$ %Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'$ %PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'$ %PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'$ %Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'$ %Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'$ %Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'$ %Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'$ %RangeError%': RangeError,
	'$ %RangeErrorPrototype%': RangeError.prototype,
	'$ %ReferenceError%': ReferenceError,
	'$ %ReferenceErrorPrototype%': ReferenceError.prototype,
	'$ %Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'$ %RegExp%': RegExp,
	'$ %RegExpPrototype%': RegExp.prototype,
	'$ %Set%': typeof Set === 'undefined' ? undefined : Set,
	'$ %SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'$ %SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'$ %SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'$ %SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'$ %String%': String,
	'$ %StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'$ %StringPrototype%': String.prototype,
	'$ %Symbol%': hasSymbols ? Symbol : undefined,
	'$ %SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'$ %SyntaxError%': SyntaxError,
	'$ %SyntaxErrorPrototype%': SyntaxError.prototype,
	'$ %ThrowTypeError%': ThrowTypeError,
	'$ %TypedArray%': TypedArray,
	'$ %TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'$ %TypeError%': $TypeError,
	'$ %TypeErrorPrototype%': $TypeError.prototype,
	'$ %Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'$ %Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'$ %Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'$ %Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'$ %Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'$ %Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'$ %Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'$ %Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'$ %URIError%': URIError,
	'$ %URIErrorPrototype%': URIError.prototype,
	'$ %WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'$ %WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'$ %WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'$ %WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

var bind = __webpack_require__(7);
var $replace = bind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var key = '$ ' + name;
	if (!(key in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[key] === 'undefined' && !allowMissing) {
		throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}

	return INTRINSICS[key];
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);

	if (parts.length === 0) {
		return getBaseIntrinsic(name, allowMissing);
	}

	var value = getBaseIntrinsic('%' + parts[0] + '%', allowMissing);
	for (var i = 1; i < parts.length; i += 1) {
		if (value != null) {
			value = value[parts[i]];
		}
	}
	return value;
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GeoJSON = __webpack_require__(96);

var Utils = function () {
  function Utils() {
    _classCallCheck(this, Utils);
  }

  _createClass(Utils, null, [{
    key: 'convertToGeoJSON',
    value: function convertToGeoJSON(places) {
      places.forEach(function (data) {
        data.lat = data.geometry.location ? data.geometry.location.lat() : data.geometry[1];
        data.lng = data.geometry.location ? data.geometry.location.lng() : data.geometry[0];
      });
      return GeoJSON.parse(places, {
        Point: ['lat', 'lng']
      });
    }
  }, {
    key: 'transformDataToGeoJSON',
    value: function transformDataToGeoJSON(results, opt) {
      if (this.isGeoJSON(results)) {
        return results;
      } else {

        results.features.forEach(function (feature) {
          var featureProp = _underscore2.default.chain(feature).value();
          feature = featureProp;
          feature.id = featureProp[opt.featureId];
          var geom = featureProp[opt.geometry];
          var lon = void 0,
              lat = void 0;
          if (!geom && opt.geometry.lon && opt.geometry.lat) {
            lon = featureProp[opt.geometry.lon];
            lat = featureProp[opt.geometry.lat];
          } else if (_underscore2.default.isArray(geom)) {
            lon = geom[0];
            lat = geom[1];
          } else if (_underscore2.default.isObject(geom)) {
            lon = geom.lon;
            lat = geom.lat;
          }
          feature.geometry = [lon, lat];
        });
      }
      return this.convertToGeoJSON(results.features);
    }
  }, {
    key: 'isGeoJSON',
    value: function isGeoJSON(results) {
      var isValidGeoJson = void 0;
      results.features.forEach(function (feature) {
        if (feature.geometry && feature.type === 'Feature') {
          isValidGeoJson = true;
        } else {
          return false;
        }
      });

      return isValidGeoJson;
    }
  }, {
    key: 'convertFeaturesToLatLng',
    value: function convertFeaturesToLatLng(features) {
      var arrResults = [];
      features.forEach(function (feature) {
        arrResults.push(new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]));
      });
      return arrResults;
    }
  }, {
    key: 'getPreloadedJson',
    value: function getPreloadedJson(_path) {
      var path = _path.replace(new RegExp('.json$'), '').replace(new RegExp('^./data/'), ''),
          json = __webpack_require__(43)("./" + path + '.json');
      return json;
    }
  }, {
    key: 'getPolygonPath',
    value: function getPolygonPath(feature) {
      var coords = feature.geometry.coordinates,
          paths = void 0;
      if (coords.length > 1) {
        paths = _underscore2.default.map(coords, function (entry) {
          return _underscore2.default.reduce(entry, function (list, polygon) {
            _underscore2.default.each(_underscore2.default.map(polygon, function (point) {
              return new google.maps.LatLng(point[1], point[0]);
            }), function (point) {
              list.push(point);
            });
            return list;
          }, []);
        });
      } else {
        paths = _underscore2.default.map(coords[0], function (point) {
          return new google.maps.LatLng(point[1], point[0]);
        });
      }
      return paths;
    }
  }, {
    key: 'createPolygons',
    value: function createPolygons(feature) {
      var paths = void 0,
          polygon = void 0;
      if (feature.geometry.type === 'MultiPolygon' || feature.geometry.type === 'Polygon') {
        paths = this.getPolygonPath(feature);
      }

      polygon = new google.maps.Polygon({
        paths: paths
      });
      return polygon;
    }
  }, {
    key: 'requestUserPosition',
    value: function requestUserPosition() {
      var _this2 = this;

      var deferred = _jquery2.default.Deferred();
      if (this.userPosition) {
        deferred.resolve(this.userPosition);
      } else if (this.ieGeolocationCancelled) {
        deferred.reject();
      } else if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          _this2.userPosition = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
          deferred.resolve(_this2.userPosition);
        }, function (error) {
          deferred.reject(error);
          var browser = _this2.getBrowser();
          if (browser.name === 'IE' || browser.name === 'Edge') {
            _this2.ieGeolocationCancelled = true;
          }
        });
      } else {
        deferred.reject();
      }
      return deferred.promise();
    }
  }, {
    key: 'getDateFromString',
    value: function getDateFromString(date) {
      var dateArray = date.split('/');
      return new Date(dateArray[1] + '/' + dateArray[0] + '/' + dateArray[2]);
    }
  }, {
    key: 'getStringFromDate',
    value: function getStringFromDate(date) {
      return (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '/' + (date.getMonth() < 10 ? '0' + date.getMonth() : date.getMonth()) + '/' + date.getFullYear();
    }
  }, {
    key: 'getTimeFromDate',
    value: function getTimeFromDate(date) {
      return (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    }
  }, {
    key: 'getImgUrl',
    value: function getImgUrl(url, widget, extraFolder) {
      var _url = null;
      if (url.indexOf('http') > -1) {
        _url = url;
      } else {
        var folder = extraFolder ? extraFolder + '/' : '';
        var path = widget.config.imagesPath ? widget.config.imagesPath : '../images/';
        var suffix = widget.config.imagesSuffix ? widget.config.imagesSuffix : '';
        _url = path + folder + url + suffix;
      }
      return _url;
    }
  }, {
    key: 'getBrowser',
    value: function getBrowser() {
      var ua = navigator.userAgent,
          tem,
          M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {
          name: 'IE',
          version: tem[1] || ''
        };
      }
      if (/Edge\/\d./i.test(ua)) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {
          name: 'Edge',
          version: tem[1] || ''
        };
      }
      if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/);
        if (tem !== null) {
          return {
            name: 'Opera',
            version: tem[1]
          };
        }
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
      if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
        M.splice(1, 1, tem[1]);
      }
      return {
        name: M[0],
        version: M[1]
      };
    }
  }, {
    key: 'queryStringToObject',
    value: function queryStringToObject(qString) {
      var qProcess = qString.split('&');
      var qObject = {};
      for (var i = 0; i < qProcess.length; i++) {
        var el = qProcess[i].split('=');
        qObject[el[0]] = el[1];
      }
      return qObject;
    }
  }, {
    key: 'queryObjectToString',
    value: function queryObjectToString(qObject) {
      var qString = '';
      for (var k in qObject) {
        if (qObject.hasOwnProperty(k)) {
          qString += k + ':' + qObject[k] + '?';
        }
      }
      return qString;
    }
  }, {
    key: 'createMessage',
    value: function createMessage(type, text) {
      var autohide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var repeatable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var msgId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

      var config = {
        type: type,
        text: text,
        autohide: autohide,
        repeatable: repeatable,
        msgId: msgId
      };
      return config;
    }
  }, {
    key: 'createLinkToMessage',
    value: function createLinkToMessage(errorText, url) {
      var textResult = '',
          textComponents = errorText.split('/link/');
      textResult = textComponents[0];
      if (textComponents[1].length > 0) {
        textResult += '<a href="' + url + '" class="lmm-msg-link lmm-link" target="_blank">' + textComponents[1] + '</a>';
      }
      if (textComponents[2].length > 0) {
        textResult += textComponents[2];
      }
      return textResult;
    }
  }, {
    key: 'sortBy',
    value: function sortBy(array) {
      var _sortBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'order';

      return _underscore2.default.sortBy(_underscore2.default.map(array, function (item, key) {
        item.id = item.id || key;
        return item;
      }), _sortBy) || [];
    }

    /**
     * Formats a text to a lmm css className.
     * @param {String} text - The text to format
     */

  }, {
    key: 'formatCssClass',
    value: function formatCssClass(text) {
      var prefix = 'lmm-',
          textLowerCase = [];
      _underscore2.default.each(text.split(/(?=[A-Z])/), function (e) {
        textLowerCase.push(e.toLowerCase());
      });
      return prefix + textLowerCase.join('-');
    }

    /**
     * @param  {String} template
     * @param  {String[]} values
     * @return {String}
     */

  }, {
    key: 'stringFormat',
    value: function stringFormat(template, values) {
      return template.replace(/%s/g, function () {
        return values.shift();
      });
    }

    /**
     * Gets the distance between to points in the map.
     * @param {object} p1 - Start position for the distance calculation, as an object containing lat and lng fields
     * @param {object} p2 - End position for the distance calculation, as an object containing lat and lng fields
     * @returns {Float} The distance in meters between the two points
     */

  }, {
    key: 'getDistance',
    value: function getDistance(p1, p2) {
      var R = 6378137,
          a = void 0,
          c = void 0,
          d = void 0,
          // Earth’s mean radius in meter
      rad = function rad(x) {
        return x * Math.PI / 180;
      },
          dLat = rad(+p2.lat - +p1.lat),
          dLong = rad(+p2.lng - +p1.lng);

      a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(+p1.lat)) * Math.cos(rad(+p2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
      c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      d = R * c;
      return d; // returns the distance in meter
    }

    /**
     * Gets the bounding box from a point using a radius.
     * @param {google.maps.LatLng} point - Center point used to calculate the bounding box
     * @param {Number} radius - Distance from the point to calculate the bounding
     * @returns {google.maps.LatLngBounds} bounding box object 
     */

  }, {
    key: 'getBoundsFromPoint',
    value: function getBoundsFromPoint(point, radius) {
      var circle = new google.maps.Circle({
        center: point,
        radius: radius
      });
      return circle.getBounds();
    }
  }, {
    key: '_loadCartoLibraries',
    value: function _loadCartoLibraries() {
      var deferred = _jquery2.default.Deferred();
      var promises = [];
      promises.push(this._loadjscssfile('https://cartodb-libs.global.ssl.fastly.net/cartodb.js/v3/3.15/cartodb.js', 'js'));
      promises.push(this._loadjscssfile('https://cartodb-libs.global.ssl.fastly.net/cartodb.js/v3/3.15/themes/css/cartodb.css', 'css'));

      _jquery2.default.when.apply(_jquery2.default, promises).then(function () {
        deferred.resolve();
      }).fail(function (reason) {
        deferred.reject(reason);
      });
      return deferred.promise();
    }
  }, {
    key: '_loadjscssfile',
    value: function _loadjscssfile(filesrc, filetype) {
      this.libsPromises = this.libsPromises || {};
      if (this.libsPromises[filesrc]) {
        return this.libsPromises[filesrc];
      }
      var deferred = _jquery2.default.Deferred();
      var promise = deferred.promise();
      this.libsPromises[filesrc] = promise;
      var fileref = null;
      if (filetype === 'js') {
        fileref = document.createElement('script');
        fileref.setAttribute('type', 'text/javascript');
        fileref.setAttribute('src', filesrc);
      } else if (filetype === 'css') {
        fileref = document.createElement('link');
        fileref.setAttribute('rel', 'stylesheet');
        fileref.setAttribute('type', 'text/css');
        fileref.setAttribute('href', filesrc);
      }
      if (typeof fileref !== 'undefined') {
        fileref.onload = function () {
          deferred.resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(fileref);
      }
      return promise;
    }
  }, {
    key: 'debounce',
    value: function debounce(func, wait, immediate) {
      var timeout = void 0;
      return function () {
        var _this = this,
            args = arguments;
        var later = function later() {
          timeout = null;
          if (!immediate) {
            func.apply(_this, args);
          }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
          func.apply(_this, args);
        }
      };
    }
  }]);

  return Utils;
}();

exports.default = Utils;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(188);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.extend = extend;
exports.indexOf = indexOf;
exports.escapeExpression = escapeExpression;
exports.isEmpty = isEmpty;
exports.createFrame = createFrame;
exports.blockParams = blockParams;
exports.appendContextPath = appendContextPath;
var escape = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '=': '&#x3D;'
};

var badChars = /[&<>"'`=]/g,
    possible = /[&<>"'`=]/;

function escapeChar(chr) {
  return escape[chr];
}

function extend(obj /* , ...source */) {
  for (var i = 1; i < arguments.length; i++) {
    for (var key in arguments[i]) {
      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
        obj[key] = arguments[i][key];
      }
    }
  }

  return obj;
}

var toString = Object.prototype.toString;

exports.toString = toString;
// Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
/* eslint-disable func-style */
var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
// fallback for older versions of Chrome and Safari
/* istanbul ignore next */
if (isFunction(/x/)) {
  exports.isFunction = isFunction = function (value) {
    return typeof value === 'function' && toString.call(value) === '[object Function]';
  };
}
exports.isFunction = isFunction;

/* eslint-enable func-style */

/* istanbul ignore next */
var isArray = Array.isArray || function (value) {
  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
};

exports.isArray = isArray;
// Older IE versions do not directly support indexOf so we must implement our own, sadly.

function indexOf(array, value) {
  for (var i = 0, len = array.length; i < len; i++) {
    if (array[i] === value) {
      return i;
    }
  }
  return -1;
}

function escapeExpression(string) {
  if (typeof string !== 'string') {
    // don't escape SafeStrings, since they're already safe
    if (string && string.toHTML) {
      return string.toHTML();
    } else if (string == null) {
      return '';
    } else if (!string) {
      return string + '';
    }

    // Force a string conversion as this will be done by the append regardless and
    // the regex test will do this transparently behind the scenes, causing issues if
    // an object's to string has escaped characters in it.
    string = '' + string;
  }

  if (!possible.test(string)) {
    return string;
  }
  return string.replace(badChars, escapeChar);
}

function isEmpty(value) {
  if (!value && value !== 0) {
    return true;
  } else if (isArray(value) && value.length === 0) {
    return true;
  } else {
    return false;
  }
}

function createFrame(object) {
  var frame = extend({}, object);
  frame._parent = object;
  return frame;
}

function blockParams(params, ids) {
  params.path = ids;
  return params;
}

function appendContextPath(contextPath, id) {
  return (contextPath ? contextPath + '.' : '') + id;
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	HOTEL_DETAILS: 'hotelDetail',
	RESULTS_DESTINATION: 'resultsDestination',
	DESTINATIONS_TREE: 'destinationsTree'
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(7);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(5);

var callBind = __webpack_require__(24);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.')) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(0) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
} ( function( $ ) {

$.ui = $.ui || {};

return $.ui.version = "1.12.1";

} ) );


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _LayerModel = __webpack_require__(95);

var _LayerModel2 = _interopRequireDefault(_LayerModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseLayer = _backbone2.default.View.extend(
/**@lends core.layers.base.BaseLayer.prototype */
{
  /**
   *
   * Create a BaseLayer instance. Shouldn't be used directly as this class exists just to provide base functionality.
   * @memberof core.layers.base
   * @class BaseLayer
   * @classdesc
   * @extends Backbone.View
   * @abstract
   * @param {object} options - The needed config to draw the layer on map
   * @listens LayerModel#change:active
   */
  constructor: function constructor(options) {
    this.widget = options.widget;
    this.options = options;
    this._initModel();
    this._bindModelEvents();
    _backbone2.default.View.prototype.constructor.call(this, options);
  },
  _initModel: function _initModel() {
    var model = this.widget.handleLayers.getLayerModel(this.options.id);
    var id = this.options.id || _underscore2.default.uniqueId();
    if (_underscore2.default.isUndefined(model)) {
      var ModelClass = this.options.ModelClass || _LayerModel2.default;
      model = new ModelClass({
        id: id,
        active: this.options.active === true || false,
        visible: this.options.active && this.isAvailableZoom(),
        index: this.options.index
      });
      this.widget.handleLayers.layersCollection.add(model);
    }
    this.options.model = model;
  },
  _bindModelEvents: function _bindModelEvents() {
    var _this = this;

    this.listenTo(this.options.model, 'change:active', function (object, active) {
      if (active) {
        _this.add();
      } else {
        _this.remove();
      }
      if (_this.options.notify) {
        _this._notify(active ? 'showlayer' : 'hidelayer', {
          layer: object.id
        });
      }
    });

    this.listenTo(this.options.model, 'change:visible', function (object, visible) {
      if (visible) {
        _this.show();
      } else {
        _this.hide();
      }
    });
  },


  /**
   * This method will be overrided in order to add the layer on map
   * @function
   * @abstract
   * @throws {Error} The method needs an implementation in the extending class
   */
  add: function add() {
    throw new Error('BaseLayer::add method needs an implementation in the extending class');
  },


  /**
   * This method will be overrided in order to remove the layer from map
   * @function
   * @abstract
   * @throws {Error} The method needs an implementation in the extending class
   */
  remove: function remove() {
    throw new Error('BaseLayer::remove method needs an implementation in the extending class');
  },


  /**
   * Check if the current zoom level is bigger than the minimun zoom level of layer
   * @returns {boolean} If layer will be visible on this zoom level
   */
  isAvailableZoom: function isAvailableZoom() {
    return this.widget.map.getZoom() >= this.options.minZoom;
  }
});

exports.default = BaseLayer;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];

function Exception(message, node) {
  var loc = node && node.loc,
      line = undefined,
      column = undefined;
  if (loc) {
    line = loc.start.line;
    column = loc.start.column;

    message += ' - ' + line + ':' + column;
  }

  var tmp = Error.prototype.constructor.call(this, message);

  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
  for (var idx = 0; idx < errorProps.length; idx++) {
    this[errorProps[idx]] = tmp[errorProps[idx]];
  }

  /* istanbul ignore else */
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, Exception);
  }

  try {
    if (loc) {
      this.lineNumber = line;

      // Work around issue under safari where we can't directly set the column value
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(this, 'column', {
          value: column,
          enumerable: true
        });
      } else {
        this.column = column;
      }
    }
  } catch (nop) {
    /* Ignore if the browser is very particular */
  }
}

Exception.prototype = new Error();

exports['default'] = Exception;
module.exports = exports['default'];


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(5);

var has = __webpack_require__(10);

var $assign = GetIntrinsic('%Object%').assign;

module.exports = function assign(target, source) {
	if ($assign) {
		return $assign(target, source);
	}

	// eslint-disable-next-line no-restricted-syntax
	for (var key in source) {
		if (has(source, key)) {
			target[key] = source[key];
		}
	}
	return target;
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** 
 * Google Maps utility helper class
 * @class GoogleMapsUtils
 * @membeof core.helpers
 */
var GoogleMapsUtils = function () {
  function GoogleMapsUtils() {
    _classCallCheck(this, GoogleMapsUtils);
  }

  _createClass(GoogleMapsUtils, null, [{
    key: 'googlePositionToCSSClass',
    value: function googlePositionToCSSClass(str) {
      return str.toLowerCase().replace(/\_/, '-');
    }
  }, {
    key: 'isGoogleMapsPosition',
    value: function isGoogleMapsPosition(str) {
      return !_underscore2.default.isUndefined(this.googleMapsPosition[str]);
    }
  }, {
    key: 'getBounds',
    value: function getBounds(points) {
      if (_underscore2.default.isObject(points) && points.hasOwnProperty('neLat') && points.hasOwnProperty('neLng') && points.hasOwnProperty('swLat') && points.hasOwnProperty('swLng')) {
        return new google.maps.LatLngBounds(new google.maps.LatLng(+points.swLat, +points.swLng), new google.maps.LatLng(+points.neLat, +points.neLng));
      } else {
        return null;
      }
    }
  }, {
    key: 'getBoundsCenter',
    value: function getBoundsCenter(bounds) {
      if (_underscore2.default.isObject(bounds)) {
        return bounds.getCenter();
      } //else --> Invalid bounds argument
    }
  }, {
    key: 'setLimitsToBBox',
    value: function setLimitsToBBox(map, bbox) {
      var C, X, Y, AmaxX, AmaxY, AminX, AminY;
      if (bbox.contains(map.getCenter())) {
        return;
      }
      // It`s not OK, so find the nearest allowed point and move there
      C = map.getCenter();
      X = C.lng();
      Y = C.lat();

      AmaxX = bbox.getNorthEast().lng();
      AmaxY = bbox.getNorthEast().lat();
      AminX = bbox.getSouthWest().lng();
      AminY = bbox.getSouthWest().lat();

      if (X < AminX) {
        X = AminX;
      }
      if (X > AmaxX) {
        X = AmaxX;
      }
      if (Y < AminY) {
        Y = AminY;
      }
      if (Y > AmaxY) {
        Y = AmaxY;
      }

      map.panTo(new google.maps.LatLng(Y, X));
    }
  }, {
    key: 'containPointInBBox',
    value: function containPointInBBox(bounds, latlng) {
      return bounds.contains(latlng);
    }
  }, {
    key: 'containPointInPolygons',
    value: function containPointInPolygons(point, polygons) {
      return _underscore2.default.some(polygons, function (polygon) {
        return google.maps.geometry.poly.containsLocation(point, polygon);
      });
    }

    /**
     * @static   
     * @param {google.maps.LatLngBounds} bounds - bounding box
     * @returns GeoJSON geometry
     */

  }, {
    key: 'boundingBoxToPolygon',
    value: function boundingBoxToPolygon(bounds) {
      var polygon = [];
      polygon[0] = [bounds.getNorthEast().lng(), bounds.getNorthEast().lat()];
      polygon[1] = [bounds.getSouthWest().lng(), bounds.getNorthEast().lat()];
      polygon[2] = [bounds.getSouthWest().lng(), bounds.getSouthWest().lat()];
      polygon[3] = [bounds.getNorthEast().lng(), bounds.getSouthWest().lat()];
      polygon[4] = [bounds.getNorthEast().lng(), bounds.getNorthEast().lat()];
      return { type: 'Polygon', coordinates: polygon };
    }
  }, {
    key: 'googleMapsPosition',
    get: function get() {
      return {
        BOTTOM: 'BOTTOM',
        BOTTOM_CENTER: 'BOTTOM_CENTER',
        BOTTOM_LEFT: 'BOTTOM_LEFT',
        BOTTOM_RIGHT: 'BOTTOM_RIGHT',
        CENTER: 'CENTER',
        LEFT: 'LEFT',
        LEFT_BOTTOM: 'LEFT_BOTTOM',
        LEFT_CENTER: 'LEFT_CENTER',
        LEFT_TOP: 'LEFT_TOP',
        RIGHT: 'RIGHT',
        RIGHT_BOTTOM: 'RIGHT_BOTTOM',
        RIGHT_CENTER: 'RIGHT_CENTER',
        RIGHT_TOP: 'RIGHT_TOP',
        TOP: 'TOP',
        TOP_CENTER: 'TOP_CENTER',
        TOP_LEFT: 'TOP_LEFT',
        TOP_RIGHT: 'TOP_RIGHT'
      };
    }
  }, {
    key: 'googleControls',
    get: function get() {
      return ['mapTypeControl', 'scaleControl', 'streetViewControl', 'rotateControl', 'fullscreenControl', 'overviewMapControl', 'panControl', 'signInControl'];
    }
  }]);

  return GoogleMapsUtils;
}();

exports.default = GoogleMapsUtils;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Autocomplete = __webpack_require__(106);

var _Autocomplete2 = _interopRequireDefault(_Autocomplete);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _widgetTypes = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Autocomplete2.default.extend({
    componentClass: 'autocomplete',
    template: __webpack_require__(130),

    initialize: function initialize(config) {
        var _this2 = this;

        this.providers = [];
        _Autocomplete2.default.prototype.initialize.call(this, config);
        this._showSearchIcon();
        if (this.widget.typeWidget === _widgetTypes.DESTINATIONS_TREE) {
            this.listenTo(this.widget.bus, 'RELOAD_LIST', function (hotelUid) {
                _this2.widget.hotelMeliaList = hotelUid;
            });
            this.listenTo(this.widget.bus, 'REGION_CHANGED', function (destination) {
                _this2.widget.hotelMeliaList = [];
                _this2.widget.config.initialDestinationId = destination.regionId;
                _this2.providers[1].load(_this2.widget);
            });
        }
    },
    _initAutoComplete: function _initAutoComplete() {
        var _this3 = this;

        this.input[this.autocompleteType]({
            minLength: this._getMinKeystroke(),
            source: function source(request, response) {
                _this3._lookup(request, response);
            },
            appendTo: this.resultsPanel,
            autoFocus: this.autoFocus,
            select: function select(event, ui) {
                _this3._onSelect(ui.item);
            },
            open: function open() {
                if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
                    (0, _jquery2.default)('.ui-autocomplete').off('menufocus hover mouseover');
                }
                _this3.bus.trigger('SHOW_RESULTS_LIST');
                _this3.onOpen();
            },
            close: function close() {
                _this3.onClose();
            }
        });
        this._calculateMaxHeightAutocomplete();
    },
    _onSelect: function _onSelect(item) {
        this._reloadAutocompleteInput();
        if (item.provider === 'ListCategoriesProvider') {
            this.bus.trigger('AUTOCOMPLETE_CATEGORY_SELECTED', item, this);
        } else if (item.provider === 'ListHotelsProvider') {
            this.providerListHotel(item);
        } else {
            this._handleCoordinates(item);
        }
    },
    providerListHotel: function providerListHotel(item) {
        var _this4 = this;

        var location = new google.maps.LatLng(item.coords.lat, item.coords.lon);
        if (this.widget.typeWidget === _widgetTypes.DESTINATIONS_TREE) {
            if (!this.widget.isMobileVersion) {
                this.widget.getMainHotelData(item.code).then(function (item) {
                    _this4.bus.trigger('UPDATED_HOTEL_SELECTED_DATA', item);
                    _this4._displaceMap(location, item);
                });
            } else {
                this.widget.getMainHotelData(item.code).then(function (item) {
                    if (item.hotel) {
                        item = item.hotel;
                    }
                    item.id = item.code;
                    item.layerId = 'destinationTreeLayer';
                    _this4.widget.bus.trigger('CLICK_ON_MARKER', item);
                    _this4._displaceMap(location, item);
                });
            }
        } else {
            this._displaceMap(location, item);
        }
    },
    _handleCoordinates: function _handleCoordinates(item) {
        var _this5 = this;

        item.coordinates().done(function (coords) {
            var location = null;
            if (coords instanceof google.maps.LatLng) {
                location = coords;
            } else if (!_underscore2.default.isUndefined(coords.viewport)) {
                location = coords.location;
            }
            _this5._displaceMap(location, item);
        });
    },
    _displaceMap: function _displaceMap(location, item) {
        this.bus.trigger('SELECT_RESULT');
        if (this._canMoveMap(location)) {
            this._goToLocation(location);
            this._createPReference(location, item);
            this._showResetIcon();
            this.input.blur();
            this.input.trigger('blur');
            this.widget.trackUserAction({
                tracking: 'Autocomplete',
                selected: item.value
            });
            this.bus.trigger('AUTOCOMPLETE_RESULT_SELECTED', item, this);
        } else {
            this._resetAutocomplete();
            this.widget.messageControl.createMessage('error', this.widget.polyglot.t('panelTT.outsideBounds'), false, false);
        }
    },
    _checkInputEmpty: function _checkInputEmpty() {
        if (!this.input.val()) {
            this._hideResetIcon();
            this._showSearchIcon();
            this.errorPanel.hide();
            this._userActionReset();
        } else {
            this._showResetIcon();
            this._hideSearchIcon();
        }
    },
    _hideSearchIcon: function _hideSearchIcon() {
        this.$el.find('.search').hide();
    },
    _showSearchIcon: function _showSearchIcon() {
        this.$el.find('.search').show();
    },
    _resetAutocomplete: function _resetAutocomplete() {
        this._showSearchIcon();
        _Autocomplete2.default.prototype._resetAutocomplete.call(this);
    },
    fillAutocomplete: function fillAutocomplete(text) {
        this.input.val(text);
        this._showResetIcon();
        this._hideSearchIcon();
    },
    _lookup: function _lookup(request, response) {
        var promises = [];
        var _this = this;
        this.promisesFinished = 0;

        this.widget.trackUserAction({
            tracking: 'Autocomplete',
            text: request.term
        });

        this.providers.forEach(function (provider) {
            provider.requestIsFinished = false;

            if (provider.validate(request.term)) {
                promises.push(provider.getPredictions(request.term));
            }
        });

        _jquery2.default.when.apply(_jquery2.default, promises).then(function () {
            var totalResults = [],
                args = arguments || [],
                hasResults = false;

            function filterResults(results, totalResults) {
                totalResults.push.apply(totalResults, results.filter(function (result) {
                    return !_underscore2.default.isUndefined(result.code);
                }));
            }

            for (var i = 0; i < args.length; i++) {
                var results = args[i];
                filterResults(results, totalResults);
            }

            if (totalResults.length > 0) {
                if (totalResults.length === 1 && _underscore2.default.isEmpty(totalResults[0])) {
                    hasResults = false;
                } else {
                    hasResults = true;
                    totalResults.reverse();
                }
            } else {
                hasResults = false;
            }

            if (!hasResults) {
                _this.errorPanel.show();
            } else {
                _this.errorPanel.hide();
            }

            response(totalResults);
        }, function () {
            response([]);
        });
    }
});

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _widgetTypes = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ComponentBase2.default.extend({
	template: __webpack_require__(132),
	componentClass: 'hotel-location',
	events: {
		click: 'showLocation'
	},

	initialize: function initialize(config) {
		if (!this.templateConfig.iconClassName) {
			this.templateConfig.iconClassName = 'lmm-icon-my-location';
		}
		if (this.widget.isMobileVersion) {
			this.componentClass += '-mobile-version';
		}
		_ComponentBase2.default.prototype.initialize.call(this, config);
	},
	showLocation: function showLocation() {
		switch (this.widget.typeWidget) {
			case _widgetTypes.DESTINATIONS_TREE:
				this._moveToDestinationsRegion();
				break;
			case _widgetTypes.HOTEL_DETAILS:
				this._moveToMainHotel();
				break;
			case _widgetTypes.RESULTS_DESTINATION:
				this.widget.map.fitBounds(this.widget.initialBounds);
				break;
			default:
				break;
		}
	},
	_moveToMainHotel: function _moveToMainHotel() {
		var coords = new google.maps.LatLng({
			lat: this.widget.hotelsJson.mainHotel.position.lat,
			lng: this.widget.hotelsJson.mainHotel.position.lng
		});
		this.map.panTo(coords);
		if (this.map.getZoom() !== this.widget.config.defaultView.zoom) {
			this.map.setZoom(this.widget.config.defaultView.zoom);
		}
	},
	_moveToDestinationsRegion: function _moveToDestinationsRegion() {
		var destination = {
			regionId: this.widget.config.initialDestinationId
		};
		this.widget.bus.trigger('LOCATION_TREE', destination);
	}
});

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _index = __webpack_require__(55);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ComponentBase2.default.extend(
/**
 * @lends core.components.MainMenu
 */
{
  constructor: function constructor(options) {
    this.classPrefix = '.' + this.componentClass + '-';
    _ComponentBase2.default.prototype.constructor.call(this, options);
  },
  initialize: function initialize(options) {
    _ComponentBase2.default.prototype.initialize.call(this, options);
    this.createConfigSubcomponents();
    this._createSubcomponents(this.components);
  },
  _createSubcomponents: function _createSubcomponents(components) {
    var _this = this;

    var availableComponents = _underscore2.default.filter(components, function (component, key) {
      if (component) {
        component.identifier = key;
        return true;
      } else {
        return false;
      }
    });

    var sortedComponens = _underscore2.default.sortBy(availableComponents, 'order');
    _underscore2.default.each(sortedComponens, function (component) {
      if (_underscore2.default.isObject(_index2.default[component.componentConstructorClass])) {
        var _component = _this.components[component.identifier] = new _index2.default[component.componentConstructorClass](_underscore2.default.extend({}, component, {
          map: _this.map,
          widget: _this.widget,
          isChild: true,
          properties: component.properties || {}
        }));
        _this.append(_component.el, _component.position);
      }
    });
  },
  append: function append(element, container) {
    this.$el.find(this.classPrefix + container).append(element);
  },
  addListeners: function addListeners() {}
});
// import Utils from 'helpers/Utils';
// import jQuery from 'jquery';

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es5-shim
var has = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var slice = Array.prototype.slice;
var isArgs = __webpack_require__(190);
var isEnumerable = Object.prototype.propertyIsEnumerable;
var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
var dontEnums = [
	'toString',
	'toLocaleString',
	'valueOf',
	'hasOwnProperty',
	'isPrototypeOf',
	'propertyIsEnumerable',
	'constructor'
];
var equalsConstructorPrototype = function (o) {
	var ctor = o.constructor;
	return ctor && ctor.prototype === o;
};
var excludedKeys = {
	$applicationCache: true,
	$console: true,
	$external: true,
	$frame: true,
	$frameElement: true,
	$frames: true,
	$innerHeight: true,
	$innerWidth: true,
	$outerHeight: true,
	$outerWidth: true,
	$pageXOffset: true,
	$pageYOffset: true,
	$parent: true,
	$scrollLeft: true,
	$scrollTop: true,
	$scrollX: true,
	$scrollY: true,
	$self: true,
	$webkitIndexedDB: true,
	$webkitStorageInfo: true,
	$window: true
};
var hasAutomationEqualityBug = (function () {
	/* global window */
	if (typeof window === 'undefined') { return false; }
	for (var k in window) {
		try {
			if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
				try {
					equalsConstructorPrototype(window[k]);
				} catch (e) {
					return true;
				}
			}
		} catch (e) {
			return true;
		}
	}
	return false;
}());
var equalsConstructorPrototypeIfNotBuggy = function (o) {
	/* global window */
	if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
		return equalsConstructorPrototype(o);
	}
	try {
		return equalsConstructorPrototype(o);
	} catch (e) {
		return false;
	}
};

var keysShim = function keys(object) {
	var isObject = object !== null && typeof object === 'object';
	var isFunction = toStr.call(object) === '[object Function]';
	var isArguments = isArgs(object);
	var isString = isObject && toStr.call(object) === '[object String]';
	var theKeys = [];

	if (!isObject && !isFunction && !isArguments) {
		throw new TypeError('Object.keys called on a non-object');
	}

	var skipProto = hasProtoEnumBug && isFunction;
	if (isString && object.length > 0 && !has.call(object, 0)) {
		for (var i = 0; i < object.length; ++i) {
			theKeys.push(String(i));
		}
	}

	if (isArguments && object.length > 0) {
		for (var j = 0; j < object.length; ++j) {
			theKeys.push(String(j));
		}
	} else {
		for (var name in object) {
			if (!(skipProto && name === 'prototype') && has.call(object, name)) {
				theKeys.push(String(name));
			}
		}
	}

	if (hasDontEnumBug) {
		var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

		for (var k = 0; k < dontEnums.length; ++k) {
			if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
				theKeys.push(dontEnums[k]);
			}
		}
	}
	return theKeys;
};

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			return (Object.keys(arguments) || '').length === 2;
		}(1, 2));
		if (!keysWorksWithArguments) {
			var originalKeys = Object.keys;
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				} else {
					return originalKeys(object);
				}
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var origSymbol = global.Symbol;
var hasSymbolSham = __webpack_require__(222);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(7);

var GetIntrinsic = __webpack_require__(5);

var $Function = GetIntrinsic('%Function%');
var $apply = $Function.apply;
var $call = $Function.call;

module.exports = function callBind() {
	return bind.apply($call, arguments);
};

module.exports.apply = function applyBind() {
	return bind.apply($apply, arguments);
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseLayer = __webpack_require__(14);

var _BaseLayer2 = _interopRequireDefault(_BaseLayer);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _Utils = __webpack_require__(6);

var _Utils2 = _interopRequireDefault(_Utils);

var _ClusterHelper = __webpack_require__(99);

var _ClusterHelper2 = _interopRequireDefault(_ClusterHelper);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLUSTER_ID = 'cluster_id',
    POINT_COUNT = 'point_count';

exports.default = _BaseLayer2.default.extend({
  constructor: function constructor(options) {
    _BaseLayer2.default.prototype.constructor.call(this, options);
    this.markers = [];
    if (this.options.cluster) {
      this.clusterHelper = new _ClusterHelper2.default(options);
    }
  },
  initialize: function initialize(options) {
    _BaseLayer2.default.prototype.initialize.call(this, options);
    this._bindMarkerLayerEvents();
  },
  _bindMarkerLayerEvents: function _bindMarkerLayerEvents() {
    var _this = this;

    //The provider triggers this event with an array of feature in GeoJSON
    this.listenTo(this.options.provider, 'PROCESS_FEATURES', function (features, provider) {
      _this._processFeatures(features);
      _this.widget.bus.trigger('LAYER_LOADED', _this, features);
    });
  },


  /**
   * Process the new features loaded:
   * 1- Process pre filters
   * 2- Cluster the features
   * 3- Process post filters
   * 4- Remove old markers
   * 5- Create new markers
   * @param {GeoJSON} features features in a GeoJSON object
   */
  _processFeatures: function _processFeatures(features) {
    var _this2 = this;

    this._processFilters(this.options.preFilters, features).then(function (featuresPrefiltered) {
      if (_this2.options.cluster) {
        //Cluster the features, it returns an array of Features with an attribute named "cluster" in each feature
        //that indicates if it is a cluster or not.
        featuresPrefiltered = _this2.clusterHelper.clusterFeatures(featuresPrefiltered);
      }
      _this2._processFilters(_this2.options.postFilters, featuresPrefiltered).then(function (featuresPostfiltered, isFilterActivated) {
        _this2._removeMarkers(featuresPostfiltered, isFilterActivated);
        _this2._createMarkers(featuresPostfiltered);
        _this2.widget.bus.trigger('UPDATED_MARKERS', _this2);
      });
    });
  },


  /**
   * This method is the same to process the preFilters and the postFilters
   * @param {Filter[]} filters An array with the filters objects
   * @param {Feature[]} features An array with the features
   */
  _processFilters: function _processFilters(filters, features) {
    var deferred = _jquery2.default.Deferred(),
        promises = [];
    //If there are not filters, we return the features directly.
    //If not, we filter the features and return only the features filtered
    if (filters.length > 0) {
      for (var i = 0; i < filters.length; i++) {
        promises.push(filters[i].filterFeatures(features));
      }
      _jquery2.default.when.apply(_jquery2.default, promises).then(function (featuresFiltered, isFilterActivated) {
        deferred.resolve(featuresFiltered, isFilterActivated);
      });
    } else {
      deferred.resolve(features, false);
    }
    return deferred;
  },


  /**
   * Transform the features in markers
   * @param {Feature[]} features 
   */
  _createMarkers: function _createMarkers(features) {
    var _this3 = this;

    _underscore2.default.each(features, function (feature) {
      //We check that the marker isn't created
      var marker = _this3.getMarkerFromId(_this3._getFeatureId(feature));
      if (!marker) {
        //The marker is not created in a previous processment, so, we create the marker.
        //Once the marker is created, we add the listeners and draw it.
        marker = _this3._createMarker(feature);
        _this3._addListeners(marker);
        _this3._showMarker(marker);
        _this3.markers.push(marker);
      }
      _this3.trigger('createdMarker', marker, feature);
    });
  },


  /**
   * Create the marker from the feature
   * @param {Feature} feature The feature to transform in marker
   */
  _createMarker: function _createMarker(feature) {
    //This properties are shared for a marker and a cluster
    var marker = new google.maps.Marker({
      id: this._getFeatureId(feature),
      layerId: this.options.id,
      position: new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]),
      properties: feature.properties,
      optimized: !this.widget.config.debugEnabled,
      clickable: this.options.markersClickable,
      zIndex: this.options.markersZIndex ? this.options.markersZIndex : 1
    });
    if (feature.properties.cluster) {
      //The cluster lib create a cluster_id and point_count in the properties
      marker.setIcon(this.clusterHelper.getIconCluster(this.widget));
      marker.setLabel(this.clusterHelper.getLabelCluster(feature.properties[POINT_COUNT]));
    } else {
      marker.setIcon(this._getIconMarker(feature.properties, 'default'));
    }
    return marker;
  },


  /**
   * Get the icon of the marker according to the status 'default', 'hover' or 'selected'
   * @param {object} properties The properties of the feature
   * @param {string} status 'default', 'hover', selected'
   */
  _getIconMarker: function _getIconMarker(properties) {
    var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';

    //Get the icon if the marker changes according to a property value. If not, get the same icon for every marker
    var iconMarker = this.options.iconMarkerByType ? this._getIconMarkerByType(properties, status) : this.options.iconMarker[status];

    var icon = void 0;
    if (iconMarker.url) {
      icon = {
        url: _Utils2.default.getImgUrl(iconMarker.url, this.widget)
      };
      if (iconMarker.anchor) {
        icon.anchor = new google.maps.Point(iconMarker.anchor.x, iconMarker.anchor.y);
      }
      if (iconMarker.scaledSize) {
        icon.scaledSize = new google.maps.Size(iconMarker.scaledSize.width, iconMarker.scaledSize.height);
      }
    } else {
      icon = iconMarker;
    }
    return icon;
  },


  /**
   * Get the icon if the marker changes according to a property value
   * @param {object} properties The properties of the feature
   * @param {string} status 'default', 'hover', selected'
   */
  _getIconMarkerByType: function _getIconMarkerByType(properties, status) {
    var _this4 = this;

    var iconMarker = void 0,
        found = false;
    _underscore2.default.each(this.options.iconMarkerByType, function (config, field) {
      if (found) {
        return;
      }
      var key = properties[field];
      if (_underscore2.default.isNull(config[key]) || _underscore2.default.isUndefined(config[key]) || _underscore2.default.isNull(config[key][status]) || _underscore2.default.isUndefined(config[key][status])) {
        iconMarker = _this4.options.iconMarker[status];
      } else {
        iconMarker = config[key][status];
        found = true;
      }
    });
    return iconMarker;
  },


  /**
   * Add the listeners (click and hover) of the markers
   * @param {google.maps.Marker} marker 
   */
  _addListeners: function _addListeners(marker) {
    if (marker.clickable) {
      this._addClickListener(marker);
    }
    //The clusters don't have hover listener by default
    if (!marker.properties.cluster && this.options.iconMarker.hover) {
      this._addHoverListeners(marker);
    }
  },


  /**
   * Add click listener
   * @param {google.maps.Marker} marker the marker clicked
   */
  _addClickListener: function _addClickListener(marker) {
    var _this5 = this;

    marker.clickListener = google.maps.event.addListener(marker, 'click', function (event) {
      if (event instanceof Event) {
        event.stopPropagation();
      }

      if (marker.properties.cluster) {
        _this5._clusterClicked(marker);
      } else {
        _this5._markerClicked(marker, event);
      }
    });
  },


  /**
   * When a cluster is clicked, the cluster lib calculates the next zoom
   * @param {google.maps.Marker} cluster the cluster clicked
   */
  _clusterClicked: function _clusterClicked(cluster) {
    this.clusterHelper.setClusterExpansion(cluster.properties[CLUSTER_ID]);
  },


  /**
   * Deselect the previous marker selected, and select the new marker clicked
   * @param {google.maps.Marker} marker the marker clicked
   */
  _markerClicked: function _markerClicked(marker, e) {
    this.deselectMarker();
    this.selectMarker(marker, e);
  },


  /**
   * Added the listeners when the mouse is over the marker and out of it.
   * @param {google.maps.Marker} marker the marker hovers in/out
   */
  _addHoverListeners: function _addHoverListeners(marker) {
    var _this6 = this;

    marker.mouseoverListener = google.maps.event.addListener(marker, 'mouseover', function () {
      _this6.setHoverStatus(marker);
    });
    marker.mouseoutListener = google.maps.event.addListener(marker, 'mouseout', function () {
      _this6.setDefaultStatus(marker);
    });
  },


  /**
   * Change the icon to the hover style and add a big zIndex to show over the other markers
   * @param {google.maps.Marker} marker the marker hovers in/out
   */
  setHoverStatus: function setHoverStatus(marker) {
    if (!marker.isSelected) {
      marker.setIcon(this._getIconMarker(marker.properties, 'hover'));
      marker.setZIndex(9999);
    }
  },


  /**
   * Return to the default status
   * @param {google.maps.Marker} marker the marker
   */
  setDefaultStatus: function setDefaultStatus(marker) {
    if (!marker.isSelected) {
      marker.setIcon(this._getIconMarker(marker.properties, 'default'));
      marker.setZIndex(this.options.markersZIndex ? this.options.markersZIndex : 1);
    }
  },


  /**
   * Select a marker and change its icon if it is needed
   * @param {google.maps.Marker} marker the marker
   */
  selectMarker: function selectMarker(marker, e) {
    if (this.options.iconMarker.selected || this.options.iconMarkerByType) {
      marker.setIcon(this._getIconMarker(marker.properties, 'selected'));
    }
    marker.setZIndex(9999);
    marker.isSelected = true;
    this.currentSelectedMarker = marker;
    this.widget.bus.trigger('CLICK_ON_MARKER', marker, e);
  },


  /**
   * Deselect the marker clicked previously
   */
  deselectMarker: function deselectMarker() {
    if (this.currentSelectedMarker) {
      this.currentSelectedMarker.setIcon(this._getIconMarker(this.currentSelectedMarker.properties, 'default'));
      this.currentSelectedMarker.setZIndex(this.options.markersZIndex ? this.options.markersZIndex : 1);
      this.currentSelectedMarker.isSelected = false;
      this.currentSelectedMarker = null;
    }
  },


  /**
   * Show the marker
   * @param {google.maps.Marker} marker the marker to be shown on the map
   */
  _showMarker: function _showMarker(marker) {
    //This condition is to avoid flickering
    if (!marker.getMap() && this.options.model.isVisible()) {
      marker.setMap(this.widget.map);
    }
  },


  /**
   * Hide the marker
   * @param {google.maps.Marker} marker the marker to be hidden on the map
   */
  _hideMarker: function _hideMarker(marker) {
    marker.setMap(null);
  },


  /**
   * Remove markers on the map
   * @param {google.maps.Marker[]} markers the markers to remove
   */
  _removeAllMarkers: function _removeAllMarkers(markers) {
    for (var i = 0; i < markers.length; i++) {
      this._removeMarker(markers[i]);
      delete this.markers[i];
    }
  },


  /**
   * Remove the markers that are not in the features, if cleanMarkers is true
   * @param {Feature[]} featuresPostfiltered features that will be shown on the map
   * @param {boolean} isFilterActivated to know if the travel time filter is activated, if not, delete the labels
   */
  _removeMarkers: function _removeMarkers(featuresPostfiltered, isFilterActivated) {
    var _this7 = this;

    if (!this.options.cleanMarkers) {
      return;
    }
    var markersOnTheMap = [],
        markersToClean = [];
    if (this.markers.length === 0) {
      //If there are not markers to remove, finish this method
      return;
    } else if (featuresPostfiltered && featuresPostfiltered.length > 0) {
      //We get the features that already are shown on the map to keep them on the map and remove the others
      _underscore2.default.each(featuresPostfiltered, function (feature) {
        var featureId = _this7._getFeatureId(feature);
        var marker = _this7.getMarkerFromId(featureId);
        if (marker) {
          markersOnTheMap.push(marker);
          if (!isFilterActivated) {
            _this7.trigger('resetMarker', marker, feature);
          }
        }
      });
    } else {
      //If the features array is empty, the map will be empty, so we will remove all the markers
      markersOnTheMap = [];
    }
    //markersToClean is the markers that are not in the features loaded, so they will be removed
    markersToClean = _underscore2.default.difference(this.markers, markersOnTheMap);
    for (var i = 0; i < markersToClean.length; i++) {
      this._removeMarker(markersToClean[i]);
      delete markersToClean[i];
    }
    //The markers that remain on the map
    this.markers = markersOnTheMap;
  },


  /**
   * Remove a marker from the map
   * @param {google.maps.Marker} marker the marker to remove from the map
   */
  _removeMarker: function _removeMarker(marker) {
    marker.setMap(null);
    this.trigger('removedMarker', marker);
  },


  /**
   * Remove markers and clusters on the map
   */
  remove: function remove() {
    this._removeAllMarkers(this.markers);
    this.currentSelectedMarker = null;
    this.markers = [];
  },


  /**
   * Hide the markers
   */
  hide: function hide() {
    var _this8 = this;

    _underscore2.default.each(this.markers, function (marker) {
      marker.setMap(null);
      _this8.trigger('hiddenMarker', marker);
    });
  },


  /**
   * Show the markers only if we don't use clusters
   */
  show: function show() {
    var _this9 = this;

    //If we use clusters, the markers/clusters must be recalculated, not only show the previous markers processed
    if (!this.options.cluster) {
      _underscore2.default.each(this.markers, function (marker) {
        _this9._showMarker(marker);
        _this9.trigger('shownMarker', marker);
      });
    }
  },


  /**
   * Get a marker from id
   * @param {string} id the id of the marker
   * @return the marker and its index in the markers array
   */
  getMarkerFromId: function getMarkerFromId(id) {
    var result = null;
    for (var i = 0; i < this.markers.length; i++) {
      if (this.markers[i].id === id) {
        result = this.markers[i];
        result.index = i;
        break;
      }
    }
    return result;
  },


  /**
   * Get the feature Id, different for cluster and marker
   * @param {Feature} feature the feature
   * @return the id of the feature
   */
  _getFeatureId: function _getFeatureId(feature) {
    var id = void 0;
    if (feature.properties.cluster) {
      id = this.clusterHelper.getClusterId(feature);
    } else {
      id = feature.properties[this.options.featureId];
    }
    return id;
  }
});

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _DataProvider = __webpack_require__(27);

var _DataProvider2 = _interopRequireDefault(_DataProvider);

var _Utils = __webpack_require__(6);

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DataProvider2.default.extend({
	constructor: function constructor(options) {
		this.widget = options.widget;
		this.options = options;
		this.initialize();
	},
	initialize: function initialize() {
		this._checkVisibility();
		_DataProvider2.default.prototype.initialize.call(this);
	},
	load: function load() {
		var opt = {
			featureId: 'id',
			geometry: 'position'
		};
		var hotelList = _Utils2.default.transformDataToGeoJSON(this.widget.hotelsJson.alternativeHotelList, opt).features;

		var bounds = new google.maps.LatLngBounds();
		hotelList.forEach(function (hotel) {
			bounds.union(_Utils2.default.getBoundsFromPoint(new google.maps.LatLng({
				lat: hotel.geometry.coordinates[1],
				lng: hotel.geometry.coordinates[0]
			}), 10));
		});
		this.widget.map.fitBounds(bounds);
		this.widget.initialBounds = bounds;
		this.trigger('PROCESS_FEATURES', hotelList, this);
	}
});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _backbone2.default.View.extend(
/**
 * @lends core.layers.dataProviders.base.DataProvider.prototype
 */
{
  /**
   * @class DataProvider
   * @classdesc This is a data provider base
   * @abstract
   * @memberof core.layers.dataProviders.base 
   * @constructs
   */
  constructor: function constructor() {},


  /**
   * Check visibility in order to do or not the load
   * @private
   */
  _checkVisibility: function _checkVisibility() {
    var _this = this;

    //This event fires hide/show methods.
    this.zoomChangedEvent = google.maps.event.addListener(this.widget.map, 'zoom_changed', function () {
      if (_this.options.model.get('active')) {
        _this.options.model.set('visible', _this.isAvailableZoom(_this.options.minZoom));
      }
    });
  },


  /**
   * Check if the current zoom level is bigger than the minimun zoom level of layer
   * @returns {boolean} If layer will be visible on this zoom level
   */
  isAvailableZoom: function isAvailableZoom(zoom) {
    return this.widget.map.getZoom() >= zoom;
  },


  /**
   * Method to load the source data
   * @abstract
   * @returns {Promise}
   */
  load: function load() {
    var deferred = _jquery2.default.Deferred();
    deferred.reject('Load function must be implented');
    return deferred;
  }
});

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ListHotelsProvider = function () {
    function ListHotelsProvider(conf, widget) {
        _classCallCheck(this, ListHotelsProvider);

        this.conf = _underscore2.default.extend({
            minLength: 1,
            maxResults: 5
        }, conf);
        this.widget = widget;
        this.providerName = 'ListHotelsProvider';
        this.widget.hotelMeliaList = [];
        this.load(widget);
    }

    _createClass(ListHotelsProvider, [{
        key: 'load',
        value: function load(widget) {
            var _this = this;

            this.widget.getDestinationsTreeObject(widget.config.initialDestinationId).then(function (hotels) {
                var _hotels;

                _this.hotels = [];
                (_hotels = _this.hotels).push.apply(_hotels, _toConsumableArray(hotels));
                _this.hotelMeliaList = _this.normalizeList(_this.hotels);
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            return true;
        }
    }, {
        key: 'getPredictions',
        value: function getPredictions(text) {
            if (typeof text !== 'string') {
                throw new Error('The text is missing');
            }

            var deferred = _jquery2.default.Deferred();
            if (this.widget.hotelMeliaList.length > 1) {
                this.hotelMeliaList = this.normalizeList(this.widget.hotelMeliaList);
            }
            deferred.resolve(this.filterList(text).splice(0, this.conf.maxResults));
            return deferred.promise();
        }
    }, {
        key: 'normalizeList',
        value: function normalizeList(list) {
            var _this2 = this;

            return list.map(function (hotel) {
                return {
                    code: hotel.hotelCode,
                    uid: hotel.uid,
                    address: hotel.address,
                    name: hotel.title,
                    value: hotel.title,
                    icon: 'melia-icon-ic-alternative',
                    coords: hotel.position,
                    provider: _this2.providerName
                };
            });
        }
    }, {
        key: 'filterList',
        value: function filterList(text) {
            return this.hotelMeliaList.filter(function (hotel) {
                return hotel.value.toUpperCase().indexOf(text.toUpperCase()) > -1;
            });
        }
    }]);

    return ListHotelsProvider;
}();

exports.default = ListHotelsProvider;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _AutocompleteProviderBase = __webpack_require__(105);

var _AutocompleteProviderBase2 = _interopRequireDefault(_AutocompleteProviderBase);

var _GPlacesHelper = __webpack_require__(30);

var _GPlacesHelper2 = _interopRequireDefault(_GPlacesHelper);

var _GoogleMapsUtils = __webpack_require__(18);

var _GoogleMapsUtils2 = _interopRequireDefault(_GoogleMapsUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               This is a Google Autocomplete provider that can be used in allmost all cases. Just
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               remember that if the client need to filter the results by polygon you CANT use this provider.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */


var GoogleAutocomplete = function (_AutocompleteProvider) {
  _inherits(GoogleAutocomplete, _AutocompleteProvider);

  /**
   * Create a GoogleAutocomplete instance 
   * @class GoogleAutocomplete
   * @classdesc This is the Google autocomplete provider
   * @memberof core.components.autocomplete.providers
   * @extends core.components.autocomplete.providers.AutocompleteProviderBase
   * @constructs
   * @param {object} conf - The conf provided by json
   * @param {Widget} widget - The widget where the Autocomplete will be built
   * @example <caption>GoogleAutocomplete conf</caption>
         "icons": ["transit_station", "bus_station", "train_station"],
      "minLength": 3,
      "maxResults": 5,
      "serviceOptions": {
        "componentRestrictions": {
          "ref:country:countryRestrictionAutocomplete": "gb"
        }
      }            
   */
  function GoogleAutocomplete(conf, widget) {
    _classCallCheck(this, GoogleAutocomplete);

    var _this = _possibleConstructorReturn(this, (GoogleAutocomplete.__proto__ || Object.getPrototypeOf(GoogleAutocomplete)).call(this, conf, widget));

    _this.map = widget.map;
    _this.maxResults = conf.maxResults;
    _this.prefixTextSearch = conf.prefixTextSearch || '';
    _this._serviceOpt = conf.serviceOptions || {};
    if (_this._serviceOpt.bounds) {
      _this._serviceOpt.bounds = _GoogleMapsUtils2.default.getBounds(_this._serviceOpt.bounds);
    }
    _this.service = new google.maps.places.AutocompleteService();
    return _this;
  }

  _createClass(GoogleAutocomplete, [{
    key: '_createCoordinatesHandler',
    value: function _createCoordinatesHandler(map) {
      return function () {
        var _deferred = _jquery2.default.Deferred();
        _GPlacesHelper2.default.getDetails(map, this.code).done(function (place) {
          var location = null;
          if (!_underscore2.default.isUndefined(place[0].geometry.viewport)) {
            location = place[0].geometry;
          } else {
            location = place[0].geometry.location;
          }
          _deferred.resolve(location);
        }).fail(function () {
          _deferred.reject(status);
        });
        return _deferred.promise();
      };
    }

    /**
     * Method to search and normalize the source predictions using Google Places autocomplete service
     * @memberOf GoogleAutocomplete
     * @param {string} text - The text to search in source
     * @param {object} conf - The config provided by {@link GoogleAutocompleteAndPlaces}
     * @returns {promise}
     */

  }, {
    key: 'getPredictions',
    value: function getPredictions(text, conf) {
      var _this2 = this;

      if (typeof text !== 'string') {
        throw new Error('The text is missing');
      }
      this.maxResults = this.maxResults ? this.maxResults : conf.maxResults ? conf.maxResults : 5;
      var deferred = _jquery2.default.Deferred(),
          map = this.map,
          callback = function callback(results, status) {
        _this2.requestIsFinished = true;
        var placeID = 'place_id';
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          var normalizeResults = [];
          for (var i = 0; i < results.length; i++) {
            var result = results[i];
            if (result[placeID]) {
              var normalizeObject = {
                code: result[placeID],
                value: result.description,
                coordinates: _this2._createCoordinatesHandler(map),
                originData: result,
                icon: _this2.getIconClass(result),
                provider: GoogleAutocomplete.name
              };
              if (_this2.conf.category) {
                normalizeObject.category = _this2.conf.category;
              }
              normalizeResults.push(normalizeObject);
            }
          }
          if (normalizeResults.length > _this2.maxResults) {
            normalizeResults = normalizeResults.slice(0, _this2.maxResults);
          }
          deferred.resolve(normalizeResults);
        } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
          deferred.resolve([]);
        } else {
          deferred.resolve([]);
        }
      };

      if (text.length < this.conf.minLength) {
        this.requestIsFinished = true;
        deferred.resolve([]);
      } else {
        this.getPredictionsFunction(this.getServiceConf(text, this.conf), callback, deferred);
      }
      return deferred.promise();
    }

    /**
     * Set the method to search 
     * @memberOf GoogleAutocomplete
     * @param {AutocompletionRequest} config - The configuration of search
     * @param {function} callback - The callback after the search
     * @returns {function} the method to search
     */

  }, {
    key: 'getPredictionsFunction',
    value: function getPredictionsFunction(config, callback, deferred) {
      return this.service.getPlacePredictions(config, callback);
    }

    /**
     * Set an icon in function of the result
     * @memberOf GoogleAutocomplete
     * @param {object} result - The result of search
     * @returns {string} the class icon
     */

  }, {
    key: 'getIconClass',
    value: function getIconClass(result) {
      var availableClass = this.conf.icons;
      if (_underscore2.default.isUndefined(availableClass)) {
        return 'default';
      } else if (availableClass === false) {
        return false;
      } else {
        var iconClass = 'default';
        if (result.types) {
          for (var i = 0; i < availableClass.length; i++) {
            if (result.types.indexOf(availableClass[i]) !== -1) {
              iconClass = availableClass[i];
              break;
            }
          }
        }
        return iconClass;
      }
    }

    /**
     * Set the needed config for the Google autocomplete service. This adds to config the
     * input, location and radius to search
     * @memberOf GoogleAutocomplete
     * @param {object} result - The result of search
     * @param {object} conf - The conf to do the search
     * @returns {object} the conf object
     */

  }, {
    key: 'getServiceConf',
    value: function getServiceConf(text) {
      var conf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return _underscore2.default.extend({
        input: this.prefixTextSearch + text,
        location: this.map ? this.map.getCenter() : new google.maps.LatLng(this.conf.defaultLocation[0], this.conf.defaultLocation[1]),
        radius: 50000
      }, this._serviceOpt, conf);
    }
  }]);

  return GoogleAutocomplete;
}(_AutocompleteProviderBase2.default);

exports.default = GoogleAutocomplete;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var requestCache = {};
var maxRecursiveness = 3;

var GPlacesHelper = function () {
  function GPlacesHelper() {
    _classCallCheck(this, GPlacesHelper);
  }

  _createClass(GPlacesHelper, null, [{
    key: 'createService',
    value: function createService(map) {
      var div = document.createElement('div');
      this.service = new google.maps.places.PlacesService(div);
      return this.service;
    }
  }, {
    key: 'searchNearby',
    value: function searchNearby(map, options, i) {
      var _this2 = this;

      var indexRecursive = i || 0;
      var request = this._createRequest(options),
          service = this.service || this.createService(map),
          deferred = _jquery2.default.Deferred();
      service.nearbySearch(request, function (results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          deferred.resolve(results, status);
        } else if (status === google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT) {
          if (indexRecursive < maxRecursiveness) {
            setTimeout(function () {
              indexRecursive++;
              _this2.searchNearby(map, options, indexRecursive).then(function (results, status) {
                deferred.resolve(results, status);
              });
            }, 1000);
          } else {
            deferred.reject();
          }
        } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
          deferred.resolve([], status);
        } else {
          deferred.reject();
        }
      });
      return deferred.promise();
    }
  }, {
    key: 'searchText',
    value: function searchText(map, options, i) {
      var _this3 = this;

      var indexRecursive = i || 0;
      var deferred = _jquery2.default.Deferred(),
          request = {},
          service = this.service || this.createService(map);
      request = this._createRequest(options);
      service.textSearch(request, function (results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          deferred.resolve(results, status);
        } else if (status === google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT) {
          if (indexRecursive < maxRecursiveness) {
            setTimeout(function () {
              indexRecursive++;
              _this3.searchText(map, options, indexRecursive).then(function (results, status) {
                deferred.resolve(results, status);
              });
            }, 1000);
          } else {
            deferred.reject();
          }
        } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
          deferred.resolve([], status);
        } else {
          deferred.reject();
        }
      });
      return deferred.promise();
    }
  }, {
    key: 'getDetails',
    value: function getDetails(map, places) {
      var _this4 = this;

      var deferred = _jquery2.default.Deferred(),
          placeID = 'place_id',
          promises = [],
          arrayPlaces = [];

      arrayPlaces = this._normalizePlacesForRequest(places);

      _underscore2.default.each(arrayPlaces, function (place) {
        if (!_underscore2.default.isObject(requestCache[place[placeID]])) {
          var request = _this4._getDetails(map, place[placeID]);
          promises.push(request);
          requestCache[place[placeID]] = request;
        } else {
          promises.push(requestCache[place[placeID]]);
        }
      });
      _jquery2.default.when.apply(_jquery2.default, promises).then(function () {
        deferred.resolve(arguments);
      }).fail(function (reason) {
        deferred.reject(reason);
      });
      return deferred.promise();
    }
  }, {
    key: '_getDetails',
    value: function _getDetails(map, placeID) {
      var _this = this,
          deferred = _jquery2.default.Deferred(),
          request = {
        placeId: placeID
      },
          service = this.service || this.createService(map);

      service.getDetails(request, function (details, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          deferred.resolve(details);
        } else if (status === google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
          setTimeout(function () {
            _this._getDetails(map, placeID).done(function (_details) {
              deferred.resolve(_details);
            }).fail(function (_reason) {
              deferred.reject(_reason);
            });
          }, 200);
        } else {
          deferred.reject('Request Fail');
        }
      });
      return deferred.promise();
    }
  }, {
    key: '_normalizePlacesForRequest',
    value: function _normalizePlacesForRequest(source) {
      var placeID = 'place_id',
          arrayPlaces = [],
          arrayResult = [];

      arrayPlaces = _underscore2.default.isArray(source) ? source : [source];

      arrayResult = arrayPlaces.map(function (el) {
        var place = {};
        if (!_underscore2.default.isObject(el)) {
          place[placeID] = el;
        } else {
          place = el;
        }
        return place;
      });

      return arrayResult;
    }
  }, {
    key: '_createRequest',
    value: function _createRequest(options) {
      var commonOpt = {
        bounds: options.bounds || null,
        location: options.location || null,
        radius: options.radius || null,
        openNow: options.opennow || null,
        minPriceLevel: options.minPriceLevel || null,
        maxPriceLevel: options.maxPriceLevel || null,
        keyword: options.keyword || null,
        name: options.name || null,
        type: options.type || null,
        types: options.types || null
      },
          othersOpt = {
        query: options.query,
        rankby: options.rankby || null
      };

      return _underscore2.default.extend({}, commonOpt, othersOpt);
    }
  }]);

  return GPlacesHelper;
}();

exports.default = GPlacesHelper;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _HotelDetailPanel = __webpack_require__(52);

var _HotelDetailPanel2 = _interopRequireDefault(_HotelDetailPanel);

var _widgetTypes = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SUMMARY_PANEL_HEIGHT = 64;

var hotelSummaryMobilePanel = _ComponentBase2.default.extend({
	template: __webpack_require__(137),
	componentClass: 'hotel-resume-mobile-panel',
	events: {
		'click .collapse-visible-panel': 'onClickInSeeDetails'
	},

	initialize: function initialize(options) {
		var _this = this;

		_ComponentBase2.default.prototype.initialize.call(this, options);
		this.isResultsWidget = this.widget.typeWidget === _widgetTypes.RESULTS_DESTINATION || this.widget.typeWidget === _widgetTypes.DESTINATIONS_TREE;
		this.hide();
		if (options.properties.hotelData) {
			this.updateDataHotel(options.properties.hotelData);
		}
		google.maps.event.addDomListener(this.widget.map, 'resize', function () {
			_this.calculateSizesContainers();
		});
		this.listenTo(this.bus, 'CLICK_ON_MAIN_HOTEL_MARKER', function () {
			_this.onClickInSeeDetails();
		});
	},
	updateDataHotel: function updateDataHotel(hotelData) {
		var _hotelData$hotel$hote = hotelData.hotel.hotelSection,
		    title = _hotelData$hotel$hote.title,
		    imgDetail = _hotelData$hotel$hote.imgDetail;


		this.templateConfig = {
			title: title,
			imgDetail: imgDetail,
			isResultsWidget: this.isResultsWidget
		};

		this.$el.replaceWith(this.render().$el);
		this.createExpansivePanel(hotelData);
		this.$el.find('.uncollapse-visible-panel').append(this.expandedPanel.el);
		this.calculateSizesContainers();
		if (this.isResultsWidget) {
			this.$el.animate({
				top: 0
			});
		}
		this.show();
	},
	onClickInSeeDetails: function onClickInSeeDetails() {
		this.$el.animate({
			top: -SUMMARY_PANEL_HEIGHT
		});
	},
	calculateSizesContainers: function calculateSizesContainers() {
		var widgetHeight = this.widget.getHeight();
		var heightAllPanel = void 0;
		var heightDataPanel = void 0;
		var topPositionAllPanel = void 0;
		if (this.isResultsWidget) {
			heightAllPanel = widgetHeight;
			heightDataPanel = widgetHeight;
			topPositionAllPanel = widgetHeight;
		} else {
			heightAllPanel = widgetHeight + SUMMARY_PANEL_HEIGHT;
			topPositionAllPanel = widgetHeight - SUMMARY_PANEL_HEIGHT;
		}
		this.$el.find('.uncollapse-visible-panel').css({
			height: heightDataPanel
		});
		this.$el.css({
			height: heightAllPanel,
			top: topPositionAllPanel
		});
	},
	createExpansivePanel: function createExpansivePanel(hotelData) {
		this.expandedPanel = new _HotelDetailPanel2.default({
			position: 'hotel-detail-panel',
			componentConstructorClass: 'HotelDetailPanel',
			identifier: 'HotelDetailPanel',
			map: this.widget.map,
			widget: this.widget,
			isChild: true,
			parent: this,
			properties: {
				hotelData: hotelData ? hotelData : null
			}
		});
	},
	collapsePanel: function collapsePanel() {
		var _this2 = this;

		var positionCollapsabled = void 0;
		if (this.isResultsWidget) {
			positionCollapsabled = this.widget.getHeight();
		} else {
			positionCollapsabled = this.widget.getHeight() - SUMMARY_PANEL_HEIGHT;
		}
		this.$el.animate({
			top: positionCollapsabled
		}, {
			complete: function complete() {
				_this2.$el.hide();
			}
		});
	}
});
exports.default = hotelSummaryMobilePanel;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ComponentBase2.default.extend(
/**
 * @lends core.components.MessageControl.prototype
 */
{
  template: __webpack_require__(138),
  componentClass: 'message-control',
  events: {
    'click .lmm-icon-close': '_close'
  },
  /**
   * @class MessageControl
   * @classdesc Creates the view of the errors
   * @memberof core.components
   * @extends core.components.ComponentBase
   * @param {object} [options={}] The options provided by json
   */
  constructor: function constructor() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.widget = options.widget;
    this.position = options.position;
    this.collection = this.widget.messageControl;
    _ComponentBase2.default.prototype.constructor.call(this, options);
  },


  /**
   * Initialize the component. This overrides ComponentBase initialize in order to create the components for journey planner
   * @param {object} - The options provided by json
   */
  initialize: function initialize(config) {
    _ComponentBase2.default.prototype.initialize.call(this, config);
    this.listenTo(this.collection, 'add', this._render);
    this.listenTo(this.collection, 'remove', this._hideMessage);
  },
  _render: function _render() {
    var _this = this;

    this._clear();
    this.collection.forEach(function (item) {
      _this._createMessage(item.attributes);
    });
  },
  _createMessage: function _createMessage(config) {
    var messageEl = this._createMessageEl(config);
    this.$el.append(messageEl);
    this._showMessage(config);
  },


  /**
   * Create the template of the message
   * @private
   * @param {object} config - The conf provided in json
   * @returns {String}
   */
  _createMessageEl: function _createMessageEl(config) {
    var messageEl = (0, _jquery2.default)('<div id="' + config.id + '" class="lmm-message-control lmm-message lmm-' + config.type + '">\n      <div class="lmm-icon lmm-icon-' + config.type + '"></div>\n      <div class="lmm-message-text">' + config.text + '\n      </div>\n      <div class="lmm-icon lmm-icon-close"></div>\n    </div>');
    return messageEl;
  },


  /**
   * Set a timeout to the message
   * @private
   * @param {object} config - The conf provided in json
   */
  _showMessage: function _showMessage(config) {
    var _this2 = this;

    this.$el.find('#' + config.id).show();
    if (_underscore2.default.isNumber(config.autohide)) {
      setTimeout(function () {
        _this2._hideMessage(config.id);
        _this2.collection.removeById(config.id);
      }, config.autohide);
    }
  },


  /**
   * Remove the message by model.
   * @param {object} messageControlModel - model to delete
   */
  _hideMessage: function _hideMessage(messageControlModel) {
    this.$el.find('#' + messageControlModel.id).remove();
  },


  /**
   * Close manually the message
   * @param {object} event - The event with the message id
   */
  _close: function _close(event) {
    var id = (0, _jquery2.default)(event.target).parent().attr('id');
    this.collection.removeById(id);
  },


  /**
   * Close all messages
   */
  _clear: function _clear() {
    var _this3 = this;

    this.collection.forEach(function (item) {
      _this3.$el.find('#' + item.id).remove();
    });
  }
});

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MainMenu = __webpack_require__(139);

var _MainMenu2 = _interopRequireDefault(_MainMenu);

var _index = __webpack_require__(55);

var _index2 = _interopRequireDefault(_index);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MainMenu2.default.extend({
	template: __webpack_require__(179),

	constructor: function constructor(options) {
		this.activeMobile = false;
		this.componentClass = options.componentClass;
		_MainMenu2.default.prototype.constructor.call(this, options);
	},
	initialize: function initialize(options) {
		if (this.widget.isMobileVersion) {
			this.componentClass += '-mobile-version';
		}
		_MainMenu2.default.prototype.initialize.call(this, options);
		this.templateConfig.meliaMobileVersionClass = 'melia-mobile-version';
		this.addMainMenuListeners();
	},
	addMainMenuListeners: function addMainMenuListeners() {
		var _this = this;

		this.listenTo(this.widget.bus, 'directions_btn_event', function (active, hotelData) {
			if (active) {
				_this.hideMainBlock();
				_this.showDirectionsBox();
				if (hotelData) {
					_this.components.DirectionsBox.fillOriginWithHotel(hotelData);
				}
				if (_this.widget.isMobileVersion && !_this.activeMobile) {
					_this.activeMobile = !_this.activeMobile;
					_this.containerToFullWidth();
				}
			} else {
				_this.hideDirectionsBox();
				_this.components.DirectionsBox.close();
				_this.hideDetailsPanel();
				_this.showMainBlock();
				if (_this.widget.isMobileVersion && _this.activeMobile) {
					_this.activeMobile = !_this.activeMobile;
					_this.containerToFullWidth();
				}
			}
		});

		this.listenTo(this.widget.bus, 'CLICK_IN_DETAILS_ROUTE_BTN', function (routeData) {
			_this.components.JPRouteDetails.updateRouteDetails(routeData.route, routeData.origin, routeData.destination, routeData.travelMode, routeData.originIsMainHotel, routeData.panelCollapsed);
			_this.hideDirectionsBox();
			_this.showDetailsPanel();
		});

		this.listenTo(this.widget.bus, 'CLICK_IN_BACK_DETAILS_ROUTE', function () {
			_this.showDirectionsBox();
			_this.hideDetailsPanel();
		});
	},
	_createSubComponents: function _createSubComponents(components) {
		var _this2 = this;

		var availableComponents = _underscore2.default.filter(components, function (component, key) {
			if (component) {
				component.identifier = key;
				return true;
			} else {
				return false;
			}
		});

		var sortedComponens = _underscore2.default.sortBy(availableComponents, 'order');
		_underscore2.default.each(sortedComponens, function (component) {
			if (_underscore2.default.isObject(_index2.default[component.componentConstructorClass])) {
				var _component = _this2.components[component.identifier] = new _index2.default[component.componentConstructorClass](_underscore2.default.extend({}, component, {
					map: _this2.map,
					widget: _this2.widget,
					isChild: true,
					properties: component.properties || {}
				}));
				_this2.append(_component.el, _component.position);
			}
		});
	},
	showMainBlock: function showMainBlock() {
		this.$el.find('.melia-main-menu-class-main-box-container').show();
	},
	hideMainBlock: function hideMainBlock() {
		this.$el.find('.melia-main-menu-class-main-box-container').hide();
		this.components.MainBox.hide();
	},
	showDirectionsBox: function showDirectionsBox() {
		this.$el.find('.melia-main-menu-class-directions-box-container').show();
		this.components.DirectionsBox.open();
	},
	hideDirectionsBox: function hideDirectionsBox() {
		this.$el.find('.melia-main-menu-class-directions-box-container').hide();
	},
	showDetailsPanel: function showDetailsPanel() {
		this.$el.find('.melia-main-menu-class-route-details-container').show();
	},
	hideDetailsPanel: function hideDetailsPanel() {
		this.$el.find('.melia-main-menu-class-route-details-container').hide();
	},
	containerToFullWidth: function containerToFullWidth() {
		(0, _jquery2.default)(this.el).toggleClass('melia-mobile-full-width');
	},
	containerToRegularWidth: function containerToRegularWidth() {
		(0, _jquery2.default)(this.el).removeClass('melia-mobile-full-width');
	}
});

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (RichMarker, RichMarkerPosition) {
  if (( false ? 'undefined' : _typeof(exports)) === 'object') {
    module.exports = {
      RichMarker: RichMarker(RichMarkerPosition()),
      RichMarkerPosition: RichMarkerPosition()
    };
  } else {
    RichMarker(RichMarkerPosition(window), window);
  }
})(function RichMarker(RichMarkerPosition, _window) {
  function RichMarker(opt_options) {
    this.extend(RichMarker, google.maps.OverlayView);
    var options = opt_options || {};
    /**
     * @type {boolean}
     * @private
     */
    this.ready_ = false;

    /**
     * @type {boolean}
     * @private
     */
    this.dragging_ = false;

    if (opt_options['visible'] == undefined) {
      opt_options['visible'] = true;
    }

    if (opt_options['shadow'] == undefined) {
      opt_options['shadow'] = '7px -3px 5px rgba(88,88,88,0.7)';
    }

    if (opt_options['anchor'] == undefined) {
      opt_options['anchor'] = RichMarkerPosition['BOTTOM'];
    }

    this.setValues(options);
  }

  var setupPrototype = function setupPrototype() {
    // RichMarker.prototype = new google.maps.OverlayView();
    /**
     * Returns the current visibility state of the marker.
     *
     * @return {boolean} The visiblity of the marker.
     */
    RichMarker.prototype.getVisible = function () {
      return (/** @type {boolean} */this.get('visible')
      );
    };
    RichMarker.prototype['getVisible'] = RichMarker.prototype.getVisible;

    /**
     * Sets the visiblility state of the marker.
     *
     * @param {boolean} visible The visiblilty of the marker.
     */
    RichMarker.prototype.setVisible = function (visible) {
      this.set('visible', visible);
    };
    RichMarker.prototype['setVisible'] = RichMarker.prototype.setVisible;

    /**
     *  The visible changed event.
     */
    RichMarker.prototype.visible_changed = function () {
      if (this.ready_) {
        this.markerWrapper_.style['display'] = this.getVisible() ? '' : 'none';
        this.draw();
      }
    };
    RichMarker.prototype['visible_changed'] = RichMarker.prototype.visible_changed;

    /**
     * Sets the marker to be flat.
     *
     * @param {boolean} flat If the marker is to be flat or not.
     */
    RichMarker.prototype.setFlat = function (flat) {
      this.set('flat', !!flat);
    };
    RichMarker.prototype['setFlat'] = RichMarker.prototype.setFlat;

    /**
     * If the makrer is flat or not.
     *
     * @return {boolean} True the marker is flat.
     */
    RichMarker.prototype.getFlat = function () {
      return (/** @type {boolean} */this.get('flat')
      );
    };
    RichMarker.prototype['getFlat'] = RichMarker.prototype.getFlat;

    /**
     * Get the width of the marker.
     *
     * @return {Number} The width of the marker.
     */
    RichMarker.prototype.getWidth = function () {
      return (/** @type {Number} */this.get('width')
      );
    };
    RichMarker.prototype['getWidth'] = RichMarker.prototype.getWidth;

    /**
     * Get the height of the marker.
     *
     * @return {Number} The height of the marker.
     */
    RichMarker.prototype.getHeight = function () {
      return (/** @type {Number} */this.get('height')
      );
    };
    RichMarker.prototype['getHeight'] = RichMarker.prototype.getHeight;

    /**
     * Sets the marker's box shadow.
     *
     * @param {string} shadow The box shadow to set.
     */
    RichMarker.prototype.setShadow = function (shadow) {
      this.set('shadow', shadow);
      this.flat_changed();
    };
    RichMarker.prototype['setShadow'] = RichMarker.prototype.setShadow;

    /**
     * Gets the marker's box shadow.
     *
     * @return {string} The box shadow.
     */
    RichMarker.prototype.getShadow = function () {
      return (/** @type {string} */this.get('shadow')
      );
    };
    RichMarker.prototype['getShadow'] = RichMarker.prototype.getShadow;

    /**
     * Flat changed event.
     */
    RichMarker.prototype.flat_changed = function () {
      if (!this.ready_) {
        return;
      }

      this.markerWrapper_.style['boxShadow'] = this.markerWrapper_.style['webkitBoxShadow'] = this.markerWrapper_.style['MozBoxShadow'] = this.getFlat() ? '' : this.getShadow();
    };
    RichMarker.prototype['flat_changed'] = RichMarker.prototype.flat_changed;

    /**
     * Sets the zIndex of the marker.
     *
     * @param {Number} index The index to set.
     */
    RichMarker.prototype.setZIndex = function (index) {
      this.set('zIndex', index);
    };
    RichMarker.prototype['setZIndex'] = RichMarker.prototype.setZIndex;

    /**
     * Gets the zIndex of the marker.
     *
     * @return {Number} The zIndex of the marker.
     */
    RichMarker.prototype.getZIndex = function () {
      return (/** @type {Number} */this.get('zIndex')
      );
    };
    RichMarker.prototype['getZIndex'] = RichMarker.prototype.getZIndex;

    /**
     * zIndex changed event.
     */
    RichMarker.prototype.zIndex_changed = function () {
      if (this.getZIndex() && this.ready_) {
        this.markerWrapper_.style.zIndex = this.getZIndex();
      }
    };
    RichMarker.prototype['zIndex_changed'] = RichMarker.prototype.zIndex_changed;

    /**
     * Whether the marker is draggable or not.
     *
     * @return {boolean} True if the marker is draggable.
     */
    RichMarker.prototype.getDraggable = function () {
      return (/** @type {boolean} */this.get('draggable')
      );
    };
    RichMarker.prototype['getDraggable'] = RichMarker.prototype.getDraggable;

    /**
     * Sets the marker to be draggable or not.
     *
     * @param {boolean} draggable If the marker is draggable or not.
     */
    RichMarker.prototype.setDraggable = function (draggable) {
      this.set('draggable', !!draggable);
    };
    RichMarker.prototype['setDraggable'] = RichMarker.prototype.setDraggable;

    /**
     * Draggable property changed callback.
     */
    RichMarker.prototype.draggable_changed = function () {
      if (this.ready_) {
        if (this.getDraggable()) {
          this.addDragging_(this.markerWrapper_);
        } else {
          this.removeDragListeners_();
        }
      }
    };
    RichMarker.prototype['draggable_changed'] = RichMarker.prototype.draggable_changed;

    /**
     * Gets the postiton of the marker.
     *
     * @return {google.maps.LatLng} The position of the marker.
     */
    RichMarker.prototype.getPosition = function () {
      return (/** @type {google.maps.LatLng} */this.get('position')
      );
    };
    RichMarker.prototype['getPosition'] = RichMarker.prototype.getPosition;

    /**
     * Sets the position of the marker.
     *
     * @param {google.maps.LatLng} position The position to set.
     */
    RichMarker.prototype.setPosition = function (position) {
      this.set('position', position);
    };
    RichMarker.prototype['setPosition'] = RichMarker.prototype.setPosition;

    /**
     * Position changed event.
     */
    RichMarker.prototype.position_changed = function () {
      this.draw();
    };
    RichMarker.prototype['position_changed'] = RichMarker.prototype.position_changed;

    /**
     * Gets the anchor.
     *
     * @return {google.maps.Size} The position of the anchor.
     */
    RichMarker.prototype.getAnchor = function () {
      return (/** @type {google.maps.Size} */this.get('anchor')
      );
    };
    RichMarker.prototype['getAnchor'] = RichMarker.prototype.getAnchor;

    /**
     * Sets the anchor.
     *
     * @param {RichMarkerPosition|google.maps.Size} anchor The anchor to set.
     */
    RichMarker.prototype.setAnchor = function (anchor) {
      this.set('anchor', anchor);
    };
    RichMarker.prototype['setAnchor'] = RichMarker.prototype.setAnchor;

    /**
     * Anchor changed event.
     */
    RichMarker.prototype.anchor_changed = function () {
      this.draw();
    };
    RichMarker.prototype['anchor_changed'] = RichMarker.prototype.anchor_changed;

    /**
     * Converts a HTML string to a document fragment.
     *
     * @param {string} htmlString The HTML string to convert.
     * @return {Node} A HTML document fragment.
     * @private
     */
    RichMarker.prototype.htmlToDocumentFragment_ = function (htmlString) {
      var tempDiv = document.createElement('DIV');
      tempDiv.innerHTML = htmlString;
      if (tempDiv.childNodes.length == 1) {
        return (/** @type {!Node} */tempDiv.removeChild(tempDiv.firstChild)
        );
      } else {
        var fragment = document.createDocumentFragment();
        while (tempDiv.firstChild) {
          fragment.appendChild(tempDiv.firstChild);
        }
        return fragment;
      }
    };

    /**
     * Removes all children from the node.
     *
     * @param {Node} node The node to remove all children from.
     * @private
     */
    RichMarker.prototype.removeChildren_ = function (node) {
      if (!node) {
        return;
      }

      var child;
      while (child = node.firstChild) {
        node.removeChild(child);
      }
    };

    /**
     * Sets the content of the marker.
     *
     * @param {string|Node} content The content to set.
     */
    RichMarker.prototype.setContent = function (content) {
      this.set('content', content);
    };
    RichMarker.prototype['setContent'] = RichMarker.prototype.setContent;

    /**
     * Get the content of the marker.
     *
     * @return {string|Node} The marker content.
     */
    RichMarker.prototype.getContent = function () {
      return (/** @type {Node|string} */this.get('content')
      );
    };
    RichMarker.prototype['getContent'] = RichMarker.prototype.getContent;

    /**
     * Sets the marker content and adds loading events to images
     */
    RichMarker.prototype.content_changed = function () {
      if (!this.markerContent_) {
        // Marker content area doesnt exist.
        return;
      }

      this.removeChildren_(this.markerContent_);
      var content = this.getContent();
      if (content) {
        if (typeof content == 'string') {
          content = content.replace(/^\s*([\S\s]*)\b\s*$/, '$1');
          content = this.htmlToDocumentFragment_(content);
        }
        this.markerContent_.appendChild(content);

        var that = this;
        var images = this.markerContent_.getElementsByTagName('IMG');
        for (var i = 0, image; image = images[i]; i++) {
          // By default, a browser lets a image be dragged outside of the browser,
          // so by calling preventDefault we stop this behaviour and allow the image
          // to be dragged around the map and now out of the browser and onto the
          // desktop.
          google.maps.event.addDomListener(image, 'mousedown', function (e) {
            if (that.getDraggable()) {
              if (e.preventDefault) {
                e.preventDefault();
              }
              e.returnValue = false;
            }
          });

          // Because we don't know the size of an image till it loads, add a
          // listener to the image load so the marker can resize and reposition
          // itself to be the correct height.
          google.maps.event.addDomListener(image, 'load', function () {
            that.draw();
          });
        }

        google.maps.event.trigger(this, 'domready');
      }

      if (this.ready_) {
        this.draw();
      }
    };
    RichMarker.prototype['content_changed'] = RichMarker.prototype.content_changed;

    /**
     * Sets the cursor.
     *
     * @param {string} whichCursor What cursor to show.
     * @private
     */
    RichMarker.prototype.setCursor_ = function (whichCursor) {
      if (!this.ready_) {
        return;
      }

      var cursor = '';
      if (navigator.userAgent.indexOf('Gecko/') !== -1) {
        // Moz has some nice cursors :)
        if (whichCursor == 'dragging') {
          cursor = '-moz-grabbing';
        }

        if (whichCursor == 'dragready') {
          cursor = '-moz-grab';
        }

        if (whichCursor == 'draggable') {
          cursor = 'pointer';
        }
      } else {
        if (whichCursor == 'dragging' || whichCursor == 'dragready') {
          cursor = 'move';
        }

        if (whichCursor == 'draggable') {
          cursor = 'pointer';
        }
      }

      if (this.markerWrapper_.style.cursor != cursor) {
        this.markerWrapper_.style.cursor = cursor;
      }
    };

    /**
     * Start dragging.
     *
     * @param {Event} e The event.
     */
    RichMarker.prototype.startDrag = function (e) {
      if (!this.getDraggable()) {
        return;
      }

      if (!this.dragging_) {
        this.dragging_ = true;
        var map = this.getMap();
        this.mapDraggable_ = map.get('draggable');
        map.set('draggable', false);

        // Store the current mouse position
        this.mouseX_ = e.clientX;
        this.mouseY_ = e.clientY;

        this.setCursor_('dragready');

        // Stop the text from being selectable while being dragged
        this.markerWrapper_.style['MozUserSelect'] = 'none';
        this.markerWrapper_.style['KhtmlUserSelect'] = 'none';
        this.markerWrapper_.style['WebkitUserSelect'] = 'none';

        this.markerWrapper_['unselectable'] = 'on';
        this.markerWrapper_['onselectstart'] = function () {
          return false;
        };

        this.addDraggingListeners_();

        google.maps.event.trigger(this, 'dragstart', e);
      }
    };

    /**
     * Stop dragging.
     */
    RichMarker.prototype.stopDrag = function () {
      if (!this.getDraggable()) {
        return;
      }

      if (this.dragging_) {
        this.dragging_ = false;
        this.getMap().set('draggable', this.mapDraggable_);
        this.mouseX_ = this.mouseY_ = this.mapDraggable_ = null;

        // Allow the text to be selectable again
        this.markerWrapper_.style['MozUserSelect'] = '';
        this.markerWrapper_.style['KhtmlUserSelect'] = '';
        this.markerWrapper_.style['WebkitUserSelect'] = '';
        this.markerWrapper_['unselectable'] = 'off';
        this.markerWrapper_['onselectstart'] = function () {};

        this.removeDraggingListeners_();

        this.setCursor_('draggable');
        google.maps.event.trigger(this, 'dragend');

        this.draw();
      }
    };

    /**
     * Handles the drag event.
     *
     * @param {Event} e The event.
     */
    RichMarker.prototype.drag = function (e) {
      if (!this.getDraggable() || !this.dragging_) {
        // This object isn't draggable or we have stopped dragging
        this.stopDrag();
        return;
      }

      var dx = this.mouseX_ - e.clientX;
      var dy = this.mouseY_ - e.clientY;

      this.mouseX_ = e.clientX;
      this.mouseY_ = e.clientY;

      var left = parseInt(this.markerWrapper_.style['left'], 10) - dx;
      var top = parseInt(this.markerWrapper_.style['top'], 10) - dy;

      this.markerWrapper_.style['left'] = left + 'px';
      this.markerWrapper_.style['top'] = top + 'px';

      var offset = this.getOffset_();

      // Set the position property and adjust for the anchor offset
      var point = new google.maps.Point(left - offset.width, top - offset.height);
      var projection = this.getProjection();
      this.setPosition(projection.fromDivPixelToLatLng(point));

      this.setCursor_('dragging');
      google.maps.event.trigger(this, 'drag', e);
    };

    /**
     * Removes the drag listeners associated with the marker.
     *
     * @private
     */
    RichMarker.prototype.removeDragListeners_ = function () {
      if (this.draggableListener_) {
        google.maps.event.removeListener(this.draggableListener_);
        delete this.draggableListener_;
      }
      this.setCursor_('');
    };

    /**
     * Add dragability events to the marker.
     *
     * @param {Node} node The node to apply dragging to.
     * @private
     */
    RichMarker.prototype.addDragging_ = function (node) {
      if (!node) {
        return;
      }

      var that = this;
      this.draggableListener_ = google.maps.event.addDomListener(node, 'mousedown', function (e) {
        that.startDrag(e);
      });

      this.setCursor_('draggable');
    };

    /**
     * Add dragging listeners.
     *
     * @private
     */
    RichMarker.prototype.addDraggingListeners_ = function () {
      var that = this;
      if (this.markerWrapper_.setCapture) {
        this.markerWrapper_.setCapture(true);
        this.draggingListeners_ = [google.maps.event.addDomListener(this.markerWrapper_, 'mousemove', function (e) {
          that.drag(e);
        }, true), google.maps.event.addDomListener(this.markerWrapper_, 'mouseup', function () {
          that.stopDrag();
          that.markerWrapper_.releaseCapture();
        }, true)];
      } else {
        this.draggingListeners_ = [google.maps.event.addDomListener(window, 'mousemove', function (e) {
          that.drag(e);
        }, true), google.maps.event.addDomListener(window, 'mouseup', function () {
          that.stopDrag();
        }, true)];
      }
    };

    /**
     * Remove dragging listeners.
     *
     * @private
     */
    RichMarker.prototype.removeDraggingListeners_ = function () {
      if (this.draggingListeners_) {
        for (var i = 0, listener; listener = this.draggingListeners_[i]; i++) {
          google.maps.event.removeListener(listener);
        }
        this.draggingListeners_.length = 0;
      }
    };

    /**
     * Get the anchor offset.
     *
     * @return {google.maps.Size} The size offset.
     * @private
     */
    RichMarker.prototype.getOffset_ = function () {
      var anchor = this.getAnchor();
      if ((typeof anchor === 'undefined' ? 'undefined' : _typeof(anchor)) == 'object') {
        return (/** @type {google.maps.Size} */anchor
        );
      }

      var offset = new google.maps.Size(0, 0);
      if (!this.markerContent_) {
        return offset;
      }

      var width = this.markerContent_.offsetWidth;
      var height = this.markerContent_.offsetHeight;

      switch (anchor) {
        case RichMarkerPosition['TOP_LEFT']:
          break;
        case RichMarkerPosition['TOP']:
          offset.width = -width / 2;
          break;
        case RichMarkerPosition['TOP_RIGHT']:
          offset.width = -width;
          break;
        case RichMarkerPosition['LEFT']:
          offset.height = -height / 2;
          break;
        case RichMarkerPosition['MIDDLE']:
          offset.width = -width / 2;
          offset.height = -height / 2;
          break;
        case RichMarkerPosition['RIGHT']:
          offset.width = -width;
          offset.height = -height / 2;
          break;
        case RichMarkerPosition['BOTTOM_LEFT']:
          offset.height = -height;
          break;
        case RichMarkerPosition['BOTTOM']:
          offset.width = -width / 2;
          offset.height = -height;
          break;
        case RichMarkerPosition['BOTTOM_RIGHT']:
          offset.width = -width;
          offset.height = -height;
          break;
      }

      return offset;
    };

    /**
     * Adding the marker to a map.
     * Implementing the interface.
     */
    RichMarker.prototype.onAdd = function () {
      if (!this.markerWrapper_) {
        this.markerWrapper_ = document.createElement('DIV');
        this.markerWrapper_.style['position'] = 'absolute';
      }

      if (this.getZIndex()) {
        this.markerWrapper_.style['zIndex'] = this.getZIndex();
      }

      this.markerWrapper_.style['display'] = this.getVisible() ? '' : 'none';

      if (!this.markerContent_) {
        this.markerContent_ = document.createElement('DIV');
        this.markerWrapper_.appendChild(this.markerContent_);

        var that = this;
        google.maps.event.addDomListener(this.markerContent_, 'click', function (e) {
          google.maps.event.trigger(that, 'click', e);
        });
        google.maps.event.addDomListener(this.markerContent_, 'mouseover', function (e) {
          google.maps.event.trigger(that, 'mouseover', e);
        });
        google.maps.event.addDomListener(this.markerContent_, 'mouseout', function (e) {
          google.maps.event.trigger(that, 'mouseout', e);
        });
      }

      this.ready_ = true;
      this.content_changed();
      this.flat_changed();
      this.draggable_changed();

      var panes = this.getPanes();
      if (panes) {
        var typePane = this.get('pane');
        if (typePane === 'floatPane') {
          panes.floatPane.appendChild(this.markerWrapper_);
        } else {
          panes.overlayMouseTarget.appendChild(this.markerWrapper_);
        }
      }

      google.maps.event.trigger(this, 'ready');
    };
    RichMarker.prototype['onAdd'] = RichMarker.prototype.onAdd;

    /**
     * Impelementing the interface.
     */
    RichMarker.prototype.draw = function () {
      if (!this.ready_ || this.dragging_) {
        return;
      }

      var projection = this.getProjection();

      if (!projection) {
        // The map projection is not ready yet so do nothing
        return;
      }

      var latLng = /** @type {google.maps.LatLng} */this.get('position');
      var pos = projection.fromLatLngToDivPixel(latLng);

      var offset = this.getOffset_();
      this.markerWrapper_.style['top'] = pos.y + offset.height + 'px';
      this.markerWrapper_.style['left'] = pos.x + offset.width + 'px';

      var height = this.markerContent_.offsetHeight;
      var width = this.markerContent_.offsetWidth;

      if (width != this.get('width')) {
        this.set('width', width);
      }

      if (height != this.get('height')) {
        this.set('height', height);
      }
    };
    RichMarker.prototype['draw'] = RichMarker.prototype.draw;

    /**
     * Removing a marker from the map.
     * Implementing the interface.
     */
    RichMarker.prototype.onRemove = function () {
      if (this.markerWrapper_ && this.markerWrapper_.parentNode) {
        this.markerWrapper_.parentNode.removeChild(this.markerWrapper_);
      }
      this.removeDragListeners_();
    };
    RichMarker.prototype['onRemove'] = RichMarker.prototype.onRemove;
  };
  RichMarker.prototype.extend = function (obj1, obj2) {
    return function (object) {
      for (var property in object.prototype) {
        this.prototype[property] = object.prototype[property];
      }
      return this;
    }.apply(obj1, [obj2]);
  };

  setupPrototype();

  if (_window === window) {
    window['RichMarker'] = RichMarker;
  } else {
    return RichMarker;
  }
}, function RichMarkerPosition(_window) {
  /**
   * RichMarker Anchor positions
   * @enum {number}
   */
  var RichMarkerPosition = {
    'TOP_LEFT': 1,
    'TOP': 2,
    'TOP_RIGHT': 3,
    'LEFT': 4,
    'MIDDLE': 5,
    'RIGHT': 6,
    'BOTTOM_LEFT': 7,
    'BOTTOM': 8,
    'BOTTOM_RIGHT': 9
  };
  if (_window === window) {
    window['RichMarkerPosition'] = RichMarkerPosition;
  } else {
    return RichMarkerPosition;
  }
});

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Widget = __webpack_require__(180);

var _Widget2 = _interopRequireDefault(_Widget);

var _BaseMapLayer = __webpack_require__(213);

var _BaseMapLayer2 = _interopRequireDefault(_BaseMapLayer);

var _Utils = __webpack_require__(6);

var _Utils2 = _interopRequireDefault(_Utils);

var _MeliaServiceHelper = __webpack_require__(53);

var _MeliaServiceHelper2 = _interopRequireDefault(_MeliaServiceHelper);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _widgetTypes = __webpack_require__(9);

var _arrayPrototype = __webpack_require__(214);

var _arrayPrototype2 = _interopRequireDefault(_arrayPrototype);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

delete Array.prototype.flatMap;

/*eslint-disable */

Array.prototype.flatMap = _arrayPrototype2.default.getPolyfill();
Math.trunc = Math.trunc || function (x) {
	return x < 0 ? Math.ceil(x) : Math.floor(x);
};
/*eslint-enable */

exports.default = _Widget2.default.extend({
	validation: __webpack_require__(240),

	constructor: function constructor(containerId, config, api) {
		if (this.typeWidget !== _widgetTypes.DESTINATIONS_TREE) {
			config = this.loadConfigCenter(config);
			config = this.loadConfigPoiVisibility(config);
		}
		this.isMobileVersion = config.mobileVersion;
		this.typeWidget = config.typeWidget;
		_Widget2.default.prototype.constructor.call(this, containerId, config, api);
	},
	createIcon: function createIcon(object) {
		return {
			url: _Utils2.default.getImgUrl(object.mainHotel.iconMarker, this),
			size: new google.maps.Size(50, 50),
			scaledSize: new google.maps.Size(50, 50)
		};
	},
	initialize: function initialize() {
		_Widget2.default.prototype.initialize.call(this);
	},
	onInitialized: function onInitialized() {
		if (this.map && !this.isMobileVersion) {
			this.map.zoomControl = true;
		}
	},
	initBaseMapLayer: function initBaseMapLayer() {
		return this.addLayer(new _BaseMapLayer2.default({
			widget: this,
			id: 'BaseMapLayer'
		}));
	},
	loadConfigCenter: function loadConfigCenter(config) {
		if (config.hotels) {
			this.hotelsJson = config.hotels;
			if (config.hotels.mainHotel) {
				config.defaultView.center[0] = config.hotels.mainHotel.position.lat;
				config.defaultView.center[1] = config.hotels.mainHotel.position.lng;
			}
		}
		return config;
	},
	loadConfigPoiVisibility: function loadConfigPoiVisibility(config) {
		if (config.poiVisibility === undefined) {
			config.poiVisibility = 'on';
		} else {
			config.poiVisibility = config.poiVisibility ? 'on' : 'off';
		}
		if (!(config.mapOptions && config.mapOptions.styles)) {
			config.mapOptions = { styles: [] };
			config.mapOptions.styles = [{
				featureType: 'poi',
				stylers: [{ visibility: config.poiVisibility }]
			}];
		}

		return config;
	},
	addMarkerToLayer: function addMarkerToLayer(layerId, object, icon) {
		return this.handleLayers.layers[this.handleLayers.getLayerIndex(layerId)].addMarker(object, icon);
	},
	getHeight: function getHeight() {
		return this.$el.height();
	},
	getMainHotelData: function getMainHotelData(id) {
		var _this = this;

		var deferred = _jquery2.default.Deferred();
		var arrPromises = [_MeliaServiceHelper2.default.getHotelDetails(this.config.MeliaUrls, id, this.config.gmapLoadConfig.LANGUAGE), _MeliaServiceHelper2.default.getHotelPrices(this.config.MeliaUrls, id, this.config.currency, this.config.country)];

		_jquery2.default.when.apply(_jquery2.default, arrPromises).then(function (hotelData, hotelPrices) {
			var jQueryPricesElement = (0, _jquery2.default)(hotelPrices);
			hotelData.hotel.hotelSection.lowestPrice = jQueryPricesElement.find('LowestPrice').text();
			hotelData.hotel.hotelSection.regularPrice = jQueryPricesElement.find('RegularPrice').text();
			_this.hotelSelectedData = hotelData;
			if (_this.config.MeliaUrls.friendlyUrl) {
				_MeliaServiceHelper2.default.getHotelURL(_this.config.MeliaUrls, id, hotelData.hotel.hotelSection.name, _this.config.gmapLoadConfig.LANGUAGE).then(function (hotelFriendlyURL) {
					hotelData.hotel.hotelSection.url = hotelFriendlyURL;
				}).fail(function () {
					console.warn('FriendlyUrl FAIL');
				}).always(function () {
					deferred.resolve(hotelData);
				});
			} else {
				deferred.resolve(hotelData);
			}
		});
		return deferred.promise();
	},
	getDestinationsTreeObject: function getDestinationsTreeObject(regionID) {
		var _this2 = this;

		var deferred = _jquery2.default.Deferred();
		if (this.destinationsTree) {
			var filteredHotels = this.getHotelsByRegionID(this.destinationsTree, regionID);
			deferred.resolve(filteredHotels);
		} else {
			_MeliaServiceHelper2.default.getDestinationsTree(this.config.MeliaUrls, this.config.gmapLoadConfig.LANGUAGE).then(function (destinationsData) {
				_this2.destinationsTree = _this2.flatHotelsDestinationsTreeData(destinationsData);
				var filteredHotels = _this2.getHotelsByRegionID(_this2.destinationsTree, regionID);
				deferred.resolve(filteredHotels);
			});
		}
		return deferred.promise();
	},
	flatHotelsDestinationsTreeData: function flatHotelsDestinationsTreeData(destinationsTreeData) {
		var continentUID = void 0,
		    countryUID = void 0,
		    regionUID = void 0;
		var totalHotels = destinationsTreeData.searchData.flatMap(function (subCatContinent) {
			continentUID = subCatContinent.category.uid;
			return subCatContinent.subCategories.flatMap(function (subCat) {
				countryUID = subCat.category.uid;
				return subCat.subCategories.filter(function (subC) {
					return !!subC.hotels;
				}).flatMap(function (subCatFinale) {
					regionUID = subCatFinale.category.uid;
					return subCatFinale.hotels.map(function (hotel) {
						if (!hotel.lat || !hotel.lon) {
							console.warn(hotel.hotelCode + ' ---> lat: ' + hotel.lat + '/lng: ' + hotel.lon);
							return false;
						} else {
							hotel.position = {
								lat: parseFloat(hotel.lat),
								lon: parseFloat(hotel.lon)
							};
							hotel.parentsUID = [continentUID, countryUID, regionUID];
							return hotel;
						}
					});
				});
			});
		});
		return totalHotels;
	},
	getHotelsByRegionID: function getHotelsByRegionID(totalHotels, regID) {
		var uniqueHotelsByRegId = totalHotels.filter(function (hotel) {
			return !!hotel && hotel.parentsUID.includes(regID);
		}).filter(function (hotel, index, allHotels) {
			return allHotels.map(function (hotelsByRegId) {
				return hotelsByRegId['hotelCode'];
			}).indexOf(hotel['hotelCode']) === index;
		});
		return uniqueHotelsByRegId;
	}
});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class /;
var isES6ClassFn = function isES6ClassFn(value) {
	try {
		var fnStr = fnToStr.call(value);
		var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
		var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
		var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
		return constructorRegex.test(spaceStripped);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionObject(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var match = String.prototype.match;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;

var inspectCustom = __webpack_require__(220).custom;
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        return String(obj);
    }
    if (typeof obj === 'bigint') { // eslint-disable-line valid-typeof
        return String(obj) + 'n';
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return '[Object]';
    }

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from) {
        if (from) {
            seen = seen.slice();
            seen.push(from);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        return '[Function' + (name ? ': ' + name : '') + ']';
    }
    if (isSymbol(obj)) {
        var symString = Symbol.prototype.toString.call(obj);
        return typeof obj === 'object' ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + String(obj.nodeName).toLowerCase();
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + String(obj.nodeName).toLowerCase() + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        return '[ ' + arrObjKeys(obj, inspect).join(', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + parts.join(', ') + ' }';
    }
    if (typeof obj === 'object') {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var xs = arrObjKeys(obj, inspect);
        if (xs.length === 0) { return '{}'; }
        return '{ ' + xs.join(', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return String(s).replace(/"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]'; }
function isDate(obj) { return toStr(obj) === '[object Date]'; }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]'; }
function isError(obj) { return toStr(obj) === '[object Error]'; }
function isSymbol(obj) { return toStr(obj) === '[object Symbol]'; }
function isString(obj) { return toStr(obj) === '[object String]'; }
function isNumber(obj) { return toStr(obj) === '[object Number]'; }
function isBigInt(obj) { return toStr(obj) === '[object BigInt]'; }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]'; }

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = match.call(f, /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    // eslint-disable-next-line no-control-regex
    var s = str.replace(/(['\\])/g, '\\$1').replace(/[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b', 9: 't', 10: 'n', 12: 'f', 13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + n.toString(16);
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries) {
    return type + ' (' + size + ') {' + entries.join(', ') + '}';
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if ((/[^\w$]/).test(key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    return xs;
}


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (typeof value === 'function' && !value.prototype) { return true; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function forEach(array, callback) {
	for (var i = 0; i < array.length; i += 1) {
		callback(array[i], i, array); // eslint-disable-line callback-return
	}
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function every(array, predicate) {
	for (var i = 0; i < array.length; i += 1) {
		if (!predicate(array[i], i, array)) {
			return false;
		}
	}
	return true;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _MarkerLayer = __webpack_require__(25);

var _MarkerLayer2 = _interopRequireDefault(_MarkerLayer);

var _SecondaryHotelsProvider = __webpack_require__(26);

var _SecondaryHotelsProvider2 = _interopRequireDefault(_SecondaryHotelsProvider);

var _BaseLayer = __webpack_require__(14);

var _BaseLayer2 = _interopRequireDefault(_BaseLayer);

var _Utils = __webpack_require__(6);

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var METTERS_RADIO_BOUNDING_TARGET = 100;
var SecondaryHotelsLayer = _MarkerLayer2.default.extend({
    constructor: function constructor(options) {
        this.markers = [];
        _BaseLayer2.default.prototype.constructor.call(this, options);
    },
    initialize: function initialize(options) {
        var _this = this;

        this.options.provider = new _SecondaryHotelsProvider2.default(options);
        this.options.preFilters = [];
        this.options.postFilters = [];
        this.options.markersClickable = true;
        this.options.minZoom = options.minZoom !== undefined ? options.minZoom : 16;
        if (this.isAvailableZoom(this.options.minZoom)) {
            this.options.model.show();
        }
        this.options.model.activate();
        _MarkerLayer2.default.prototype.initialize.call(this, options);
        this.options.provider.load();
        this.listenTo(this.widget.bus, 'HOTEL_CHANGED', function (data) {
            var marker = _this.getMarkerFromId(data.hotelId);
            var newBounds = _Utils2.default.getBoundsFromPoint(marker.position, METTERS_RADIO_BOUNDING_TARGET);
            _this.widget.map.fitBounds(newBounds);
        });
        this.listenTo(this.widget.bus, 'CLICK_ON_MARKER', function (marker) {
            if (_this.widget.api.onClickInAlternativeHotel) {
                _this.widget.api.onClickInAlternativeHotel(marker.id);
            }
        });
    },
    add: function add() {},
    remove: function remove() {}
});

exports.default = SecondaryHotelsLayer;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./locales/en.json": 97,
	"./locales/es.json": 98
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ListCategoriesProvider = function () {
    function ListCategoriesProvider(conf, widget) {
        _classCallCheck(this, ListCategoriesProvider);

        this.conf = _underscore2.default.extend({
            minLength: 3
        }, conf);
        this.widget = widget;
        this.providerName = 'ListCategoriesProvider';
        this.categoryList = this.normalizeList(widget.config.categories);
    }

    _createClass(ListCategoriesProvider, [{
        key: 'validate',
        value: function validate() {
            return true;
        }
    }, {
        key: 'getPredictions',
        value: function getPredictions(text) {
            if (typeof text !== 'string') {
                throw new Error('The text is missing');
            }
            var deferred = _jquery2.default.Deferred();
            deferred.resolve(this.filterList(text));
            return deferred.promise();
        }
    }, {
        key: 'normalizeList',
        value: function normalizeList(list) {
            var _this = this;

            return list.map(function (cat) {
                return {
                    code: cat.catId,
                    catId: cat.catId,
                    name: _this.widget.polyglot.t('categories.' + cat.catId),
                    value: _this.widget.polyglot.t('categories.' + cat.catId),
                    icon: cat.iconClass,
                    provider: _this.providerName
                };
            });
        }
    }, {
        key: 'filterList',
        value: function filterList(text) {
            var _this2 = this;

            return this.categoryList.filter(function (cat) {
                if (text.length >= _this2.conf.minLength) {
                    return cat.value.substr(0, text.length).toUpperCase() === text.toUpperCase();
                } else {
                    return false;
                }
            });
        }
    }]);

    return ListCategoriesProvider;
}();

exports.default = ListCategoriesProvider;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.HandlebarsEnvironment = HandlebarsEnvironment;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(8);

var _exception = __webpack_require__(15);

var _exception2 = _interopRequireDefault(_exception);

var _helpers = __webpack_require__(108);

var _decorators = __webpack_require__(116);

var _logger = __webpack_require__(118);

var _logger2 = _interopRequireDefault(_logger);

var VERSION = '4.0.11';
exports.VERSION = VERSION;
var COMPILER_REVISION = 7;

exports.COMPILER_REVISION = COMPILER_REVISION;
var REVISION_CHANGES = {
  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
  2: '== 1.0.0-rc.3',
  3: '== 1.0.0-rc.4',
  4: '== 1.x.x',
  5: '== 2.0.0-alpha.x',
  6: '>= 2.0.0-beta.1',
  7: '>= 4.0.0'
};

exports.REVISION_CHANGES = REVISION_CHANGES;
var objectType = '[object Object]';

function HandlebarsEnvironment(helpers, partials, decorators) {
  this.helpers = helpers || {};
  this.partials = partials || {};
  this.decorators = decorators || {};

  _helpers.registerDefaultHelpers(this);
  _decorators.registerDefaultDecorators(this);
}

HandlebarsEnvironment.prototype = {
  constructor: HandlebarsEnvironment,

  logger: _logger2['default'],
  log: _logger2['default'].log,

  registerHelper: function registerHelper(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple helpers');
      }
      _utils.extend(this.helpers, name);
    } else {
      this.helpers[name] = fn;
    }
  },
  unregisterHelper: function unregisterHelper(name) {
    delete this.helpers[name];
  },

  registerPartial: function registerPartial(name, partial) {
    if (_utils.toString.call(name) === objectType) {
      _utils.extend(this.partials, name);
    } else {
      if (typeof partial === 'undefined') {
        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
      }
      this.partials[name] = partial;
    }
  },
  unregisterPartial: function unregisterPartial(name) {
    delete this.partials[name];
  },

  registerDecorator: function registerDecorator(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple decorators');
      }
      _utils.extend(this.decorators, name);
    } else {
      this.decorators[name] = fn;
    }
  },
  unregisterDecorator: function unregisterDecorator(name) {
    delete this.decorators[name];
  }
};

var log = _logger2['default'].log;

exports.log = log;
exports.createFrame = _utils.createFrame;
exports.logger = _logger2['default'];


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _en = __webpack_require__(124);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Invokes the validation function on the configuration and throws an Error 
 * if any missconfiguration was found.
 * 
 * @param {string} identifier the identifier of the instance being validated. 
 * Might by component's id, the element the widget is created on, etc.
 * @param {function} validationFn The AJV generated validation function that determines if the config 
 * is valid or not.
 * @param {object} config The configuration to be checked.
 * @return {Promise} gets resolved if the configuration is valid, rejected otherwise.
 * @throws {Error} if the configuration is rejected
 * @memberof core.helpers
 */
function assertValidConfig(identifier, validationLoader, config) {
  if (!assertValidConfig.doValidation) {
    validationLoader.progress = Promise.resolve(true);
    return validationLoader.progress;
  }

  var p = new Promise(function (resolve, reject) {
    validationLoader(function (validationFn) {
      validationFn(config);
      if (validationFn.errors) {
        (0, _en2.default)(validationFn.errors);
        validationLoader.errors = validationFn.errors;
        reject(validationFn.errors);
      } else {
        resolve(true);
      }
    });
  }).catch(function (errors) {
    // We throw the error here to prevent the validationLoader callback to fail, related to the 
    // way we are loading validations.
    var errorsStr = errors.map(function (error) {
      var extraInfo = '';
      if (error.params.additionalProperty) {
        extraInfo = '(' + error.params.additionalProperty + ')';
      }
      return ' * ' + error.dataPath + ' ' + error.message + ' ' + extraInfo;
    }).join('\n');
    throw new Error('Configuration error(s) for ' + identifier + ':\n' + errorsStr);
  });

  validationLoader.progress = p;

  return validationLoader.progress;
}

exports.default = assertValidConfig;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Keycode 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Keycode
//>>group: Core
//>>description: Provide keycodes as keynames
//>>docs: http://api.jqueryui.com/jQuery.ui.keyCode/

( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(0), __webpack_require__(12) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
} ( function( $ ) {
return $.ui.keyCode = {
	BACKSPACE: 8,
	COMMA: 188,
	DELETE: 46,
	DOWN: 40,
	END: 35,
	ENTER: 13,
	ESCAPE: 27,
	HOME: 36,
	LEFT: 37,
	PAGE_DOWN: 34,
	PAGE_UP: 33,
	PERIOD: 190,
	RIGHT: 39,
	SPACE: 32,
	TAB: 9,
	UP: 38
};

} ) );


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Position 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/position/
 */

//>>label: Position
//>>group: Core
//>>description: Positions elements relative to other elements.
//>>docs: http://api.jqueryui.com/position/
//>>demos: http://jqueryui.com/position/

( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(0), __webpack_require__(12) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}( function( $ ) {
( function() {
var cachedScrollbarWidth,
	max = Math.max,
	abs = Math.abs,
	rhorizontal = /left|center|right/,
	rvertical = /top|center|bottom/,
	roffset = /[\+\-]\d+(\.[\d]+)?%?/,
	rposition = /^\w+/,
	rpercent = /%$/,
	_position = $.fn.position;

function getOffsets( offsets, width, height ) {
	return [
		parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
		parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
	];
}

function parseCss( element, property ) {
	return parseInt( $.css( element, property ), 10 ) || 0;
}

function getDimensions( elem ) {
	var raw = elem[ 0 ];
	if ( raw.nodeType === 9 ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: 0, left: 0 }
		};
	}
	if ( $.isWindow( raw ) ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
		};
	}
	if ( raw.preventDefault ) {
		return {
			width: 0,
			height: 0,
			offset: { top: raw.pageY, left: raw.pageX }
		};
	}
	return {
		width: elem.outerWidth(),
		height: elem.outerHeight(),
		offset: elem.offset()
	};
}

$.position = {
	scrollbarWidth: function() {
		if ( cachedScrollbarWidth !== undefined ) {
			return cachedScrollbarWidth;
		}
		var w1, w2,
			div = $( "<div " +
				"style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'>" +
				"<div style='height:100px;width:auto;'></div></div>" ),
			innerDiv = div.children()[ 0 ];

		$( "body" ).append( div );
		w1 = innerDiv.offsetWidth;
		div.css( "overflow", "scroll" );

		w2 = innerDiv.offsetWidth;

		if ( w1 === w2 ) {
			w2 = div[ 0 ].clientWidth;
		}

		div.remove();

		return ( cachedScrollbarWidth = w1 - w2 );
	},
	getScrollInfo: function( within ) {
		var overflowX = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-x" ),
			overflowY = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-y" ),
			hasOverflowX = overflowX === "scroll" ||
				( overflowX === "auto" && within.width < within.element[ 0 ].scrollWidth ),
			hasOverflowY = overflowY === "scroll" ||
				( overflowY === "auto" && within.height < within.element[ 0 ].scrollHeight );
		return {
			width: hasOverflowY ? $.position.scrollbarWidth() : 0,
			height: hasOverflowX ? $.position.scrollbarWidth() : 0
		};
	},
	getWithinInfo: function( element ) {
		var withinElement = $( element || window ),
			isWindow = $.isWindow( withinElement[ 0 ] ),
			isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9,
			hasOffset = !isWindow && !isDocument;
		return {
			element: withinElement,
			isWindow: isWindow,
			isDocument: isDocument,
			offset: hasOffset ? $( element ).offset() : { left: 0, top: 0 },
			scrollLeft: withinElement.scrollLeft(),
			scrollTop: withinElement.scrollTop(),
			width: withinElement.outerWidth(),
			height: withinElement.outerHeight()
		};
	}
};

$.fn.position = function( options ) {
	if ( !options || !options.of ) {
		return _position.apply( this, arguments );
	}

	// Make a copy, we don't want to modify arguments
	options = $.extend( {}, options );

	var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
		target = $( options.of ),
		within = $.position.getWithinInfo( options.within ),
		scrollInfo = $.position.getScrollInfo( within ),
		collision = ( options.collision || "flip" ).split( " " ),
		offsets = {};

	dimensions = getDimensions( target );
	if ( target[ 0 ].preventDefault ) {

		// Force left top to allow flipping
		options.at = "left top";
	}
	targetWidth = dimensions.width;
	targetHeight = dimensions.height;
	targetOffset = dimensions.offset;

	// Clone to reuse original targetOffset later
	basePosition = $.extend( {}, targetOffset );

	// Force my and at to have valid horizontal and vertical positions
	// if a value is missing or invalid, it will be converted to center
	$.each( [ "my", "at" ], function() {
		var pos = ( options[ this ] || "" ).split( " " ),
			horizontalOffset,
			verticalOffset;

		if ( pos.length === 1 ) {
			pos = rhorizontal.test( pos[ 0 ] ) ?
				pos.concat( [ "center" ] ) :
				rvertical.test( pos[ 0 ] ) ?
					[ "center" ].concat( pos ) :
					[ "center", "center" ];
		}
		pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
		pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

		// Calculate offsets
		horizontalOffset = roffset.exec( pos[ 0 ] );
		verticalOffset = roffset.exec( pos[ 1 ] );
		offsets[ this ] = [
			horizontalOffset ? horizontalOffset[ 0 ] : 0,
			verticalOffset ? verticalOffset[ 0 ] : 0
		];

		// Reduce to just the positions without the offsets
		options[ this ] = [
			rposition.exec( pos[ 0 ] )[ 0 ],
			rposition.exec( pos[ 1 ] )[ 0 ]
		];
	} );

	// Normalize collision option
	if ( collision.length === 1 ) {
		collision[ 1 ] = collision[ 0 ];
	}

	if ( options.at[ 0 ] === "right" ) {
		basePosition.left += targetWidth;
	} else if ( options.at[ 0 ] === "center" ) {
		basePosition.left += targetWidth / 2;
	}

	if ( options.at[ 1 ] === "bottom" ) {
		basePosition.top += targetHeight;
	} else if ( options.at[ 1 ] === "center" ) {
		basePosition.top += targetHeight / 2;
	}

	atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
	basePosition.left += atOffset[ 0 ];
	basePosition.top += atOffset[ 1 ];

	return this.each( function() {
		var collisionPosition, using,
			elem = $( this ),
			elemWidth = elem.outerWidth(),
			elemHeight = elem.outerHeight(),
			marginLeft = parseCss( this, "marginLeft" ),
			marginTop = parseCss( this, "marginTop" ),
			collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) +
				scrollInfo.width,
			collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) +
				scrollInfo.height,
			position = $.extend( {}, basePosition ),
			myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

		if ( options.my[ 0 ] === "right" ) {
			position.left -= elemWidth;
		} else if ( options.my[ 0 ] === "center" ) {
			position.left -= elemWidth / 2;
		}

		if ( options.my[ 1 ] === "bottom" ) {
			position.top -= elemHeight;
		} else if ( options.my[ 1 ] === "center" ) {
			position.top -= elemHeight / 2;
		}

		position.left += myOffset[ 0 ];
		position.top += myOffset[ 1 ];

		collisionPosition = {
			marginLeft: marginLeft,
			marginTop: marginTop
		};

		$.each( [ "left", "top" ], function( i, dir ) {
			if ( $.ui.position[ collision[ i ] ] ) {
				$.ui.position[ collision[ i ] ][ dir ]( position, {
					targetWidth: targetWidth,
					targetHeight: targetHeight,
					elemWidth: elemWidth,
					elemHeight: elemHeight,
					collisionPosition: collisionPosition,
					collisionWidth: collisionWidth,
					collisionHeight: collisionHeight,
					offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
					my: options.my,
					at: options.at,
					within: within,
					elem: elem
				} );
			}
		} );

		if ( options.using ) {

			// Adds feedback as second argument to using callback, if present
			using = function( props ) {
				var left = targetOffset.left - position.left,
					right = left + targetWidth - elemWidth,
					top = targetOffset.top - position.top,
					bottom = top + targetHeight - elemHeight,
					feedback = {
						target: {
							element: target,
							left: targetOffset.left,
							top: targetOffset.top,
							width: targetWidth,
							height: targetHeight
						},
						element: {
							element: elem,
							left: position.left,
							top: position.top,
							width: elemWidth,
							height: elemHeight
						},
						horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
						vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
					};
				if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
					feedback.horizontal = "center";
				}
				if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
					feedback.vertical = "middle";
				}
				if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
					feedback.important = "horizontal";
				} else {
					feedback.important = "vertical";
				}
				options.using.call( this, props, feedback );
			};
		}

		elem.offset( $.extend( position, { using: using } ) );
	} );
};

$.ui.position = {
	fit: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
				outerWidth = within.width,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = withinOffset - collisionPosLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
				newOverRight;

			// Element is wider than within
			if ( data.collisionWidth > outerWidth ) {

				// Element is initially over the left side of within
				if ( overLeft > 0 && overRight <= 0 ) {
					newOverRight = position.left + overLeft + data.collisionWidth - outerWidth -
						withinOffset;
					position.left += overLeft - newOverRight;

				// Element is initially over right side of within
				} else if ( overRight > 0 && overLeft <= 0 ) {
					position.left = withinOffset;

				// Element is initially over both left and right sides of within
				} else {
					if ( overLeft > overRight ) {
						position.left = withinOffset + outerWidth - data.collisionWidth;
					} else {
						position.left = withinOffset;
					}
				}

			// Too far left -> align with left edge
			} else if ( overLeft > 0 ) {
				position.left += overLeft;

			// Too far right -> align with right edge
			} else if ( overRight > 0 ) {
				position.left -= overRight;

			// Adjust based on position and margin
			} else {
				position.left = max( position.left - collisionPosLeft, position.left );
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
				outerHeight = data.within.height,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = withinOffset - collisionPosTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
				newOverBottom;

			// Element is taller than within
			if ( data.collisionHeight > outerHeight ) {

				// Element is initially over the top of within
				if ( overTop > 0 && overBottom <= 0 ) {
					newOverBottom = position.top + overTop + data.collisionHeight - outerHeight -
						withinOffset;
					position.top += overTop - newOverBottom;

				// Element is initially over bottom of within
				} else if ( overBottom > 0 && overTop <= 0 ) {
					position.top = withinOffset;

				// Element is initially over both top and bottom of within
				} else {
					if ( overTop > overBottom ) {
						position.top = withinOffset + outerHeight - data.collisionHeight;
					} else {
						position.top = withinOffset;
					}
				}

			// Too far up -> align with top
			} else if ( overTop > 0 ) {
				position.top += overTop;

			// Too far down -> align with bottom edge
			} else if ( overBottom > 0 ) {
				position.top -= overBottom;

			// Adjust based on position and margin
			} else {
				position.top = max( position.top - collisionPosTop, position.top );
			}
		}
	},
	flip: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.left + within.scrollLeft,
				outerWidth = within.width,
				offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = collisionPosLeft - offsetLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
				myOffset = data.my[ 0 ] === "left" ?
					-data.elemWidth :
					data.my[ 0 ] === "right" ?
						data.elemWidth :
						0,
				atOffset = data.at[ 0 ] === "left" ?
					data.targetWidth :
					data.at[ 0 ] === "right" ?
						-data.targetWidth :
						0,
				offset = -2 * data.offset[ 0 ],
				newOverRight,
				newOverLeft;

			if ( overLeft < 0 ) {
				newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth -
					outerWidth - withinOffset;
				if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
					position.left += myOffset + atOffset + offset;
				}
			} else if ( overRight > 0 ) {
				newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset +
					atOffset + offset - offsetLeft;
				if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
					position.left += myOffset + atOffset + offset;
				}
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.top + within.scrollTop,
				outerHeight = within.height,
				offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = collisionPosTop - offsetTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
				top = data.my[ 1 ] === "top",
				myOffset = top ?
					-data.elemHeight :
					data.my[ 1 ] === "bottom" ?
						data.elemHeight :
						0,
				atOffset = data.at[ 1 ] === "top" ?
					data.targetHeight :
					data.at[ 1 ] === "bottom" ?
						-data.targetHeight :
						0,
				offset = -2 * data.offset[ 1 ],
				newOverTop,
				newOverBottom;
			if ( overTop < 0 ) {
				newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight -
					outerHeight - withinOffset;
				if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
					position.top += myOffset + atOffset + offset;
				}
			} else if ( overBottom > 0 ) {
				newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset +
					offset - offsetTop;
				if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
					position.top += myOffset + atOffset + offset;
				}
			}
		}
	},
	flipfit: {
		left: function() {
			$.ui.position.flip.left.apply( this, arguments );
			$.ui.position.fit.left.apply( this, arguments );
		},
		top: function() {
			$.ui.position.flip.top.apply( this, arguments );
			$.ui.position.fit.top.apply( this, arguments );
		}
	}
};

} )();

return $.ui.position;

} ) );


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(0), __webpack_require__(12) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
} ( function( $ ) {
return $.ui.safeActiveElement = function( document ) {
	var activeElement;

	// Support: IE 9 only
	// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
	try {
		activeElement = document.activeElement;
	} catch ( error ) {
		activeElement = document.body;
	}

	// Support: IE 9 - 11 only
	// IE may return null instead of an element
	// Interestingly, this only seems to occur when NOT in an iframe
	if ( !activeElement ) {
		activeElement = document.body;
	}

	// Support: IE 11 only
	// IE11 returns a seemingly empty object in some cases when accessing
	// document.activeElement from an <iframe>
	if ( !activeElement.nodeName ) {
		activeElement = document.body;
	}

	return activeElement;
};

} ) );


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Widget 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: http://api.jqueryui.com/jQuery.widget/
//>>demos: http://jqueryui.com/widget/

( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(0), __webpack_require__(12) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}( function( $ ) {

var widgetUuid = 0;
var widgetSlice = Array.prototype.slice;

$.cleanData = ( function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
			try {

				// Only trigger remove when necessary to save time
				events = $._data( elem, "events" );
				if ( events && events.remove ) {
					$( elem ).triggerHandler( "remove" );
				}

			// Http://bugs.jquery.com/ticket/8235
			} catch ( e ) {}
		}
		orig( elems );
	};
} )( $.cleanData );

$.widget = function( name, base, prototype ) {
	var existingConstructor, constructor, basePrototype;

	// ProxiedPrototype allows the provided prototype to remain unmodified
	// so that it can be used as a mixin for multiple widgets (#8876)
	var proxiedPrototype = {};

	var namespace = name.split( "." )[ 0 ];
	name = name.split( "." )[ 1 ];
	var fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	if ( $.isArray( prototype ) ) {
		prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
	}

	// Create selector for plugin
	$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {

		// Allow instantiation without "new" keyword
		if ( !this._createWidget ) {
			return new constructor( options, element );
		}

		// Allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	// Extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,

		// Copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),

		// Track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	} );

	basePrototype = new base();

	// We need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( !$.isFunction( value ) ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = ( function() {
			function _super() {
				return base.prototype[ prop ].apply( this, arguments );
			}

			function _superApply( args ) {
				return base.prototype[ prop ].apply( this, args );
			}

			return function() {
				var __super = this._super;
				var __superApply = this._superApply;
				var returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		} )();
	} );
	constructor.prototype = $.widget.extend( basePrototype, {

		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	} );

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// Redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
				child._proto );
		} );

		// Remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widgetSlice.call( arguments, 1 );
	var inputIndex = 0;
	var inputLength = input.length;
	var key;
	var value;

	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {

				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :

						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );

				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string";
		var args = widgetSlice.call( arguments, 1 );
		var returnValue = this;

		if ( isMethodCall ) {

			// If this is an empty collection, we need to have the instance method
			// return undefined instead of the jQuery instance
			if ( !this.length && options === "instance" ) {
				returnValue = undefined;
			} else {
				this.each( function() {
					var methodValue;
					var instance = $.data( this, fullName );

					if ( options === "instance" ) {
						returnValue = instance;
						return false;
					}

					if ( !instance ) {
						return $.error( "cannot call methods on " + name +
							" prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}

					if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name +
							" widget instance" );
					}

					methodValue = instance[ options ].apply( instance, args );

					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				} );
			}
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat( args ) );
			}

			this.each( function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			} );
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",

	options: {
		classes: {},
		disabled: false,

		// Callbacks
		create: null
	},

	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widgetUuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();
		this.classesElementLookup = {};

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			} );
			this.document = $( element.style ?

				// Element within the document
				element.ownerDocument :

				// Element is window or document
				element.document || element );
			this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();

		if ( this.options.disabled ) {
			this._setOptionDisabled( this.options.disabled );
		}

		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},

	_getCreateOptions: function() {
		return {};
	},

	_getCreateEventData: $.noop,

	_create: $.noop,

	_init: $.noop,

	destroy: function() {
		var that = this;

		this._destroy();
		$.each( this.classesElementLookup, function( key, value ) {
			that._removeClass( value, key );
		} );

		// We can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.off( this.eventNamespace )
			.removeData( this.widgetFullName );
		this.widget()
			.off( this.eventNamespace )
			.removeAttr( "aria-disabled" );

		// Clean up events and states
		this.bindings.off( this.eventNamespace );
	},

	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;
		var parts;
		var curOption;
		var i;

		if ( arguments.length === 0 ) {

			// Don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {

			// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},

	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},

	_setOption: function( key, value ) {
		if ( key === "classes" ) {
			this._setOptionClasses( value );
		}

		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this._setOptionDisabled( value );
		}

		return this;
	},

	_setOptionClasses: function( value ) {
		var classKey, elements, currentElements;

		for ( classKey in value ) {
			currentElements = this.classesElementLookup[ classKey ];
			if ( value[ classKey ] === this.options.classes[ classKey ] ||
					!currentElements ||
					!currentElements.length ) {
				continue;
			}

			// We are doing this to create a new jQuery object because the _removeClass() call
			// on the next line is going to destroy the reference to the current elements being
			// tracked. We need to save a copy of this collection so that we can add the new classes
			// below.
			elements = $( currentElements.get() );
			this._removeClass( currentElements, classKey );

			// We don't use _addClass() here, because that uses this.options.classes
			// for generating the string of classes. We want to use the value passed in from
			// _setOption(), this is the new value of the classes option which was passed to
			// _setOption(). We pass this value directly to _classes().
			elements.addClass( this._classes( {
				element: elements,
				keys: classKey,
				classes: value,
				add: true
			} ) );
		}
	},

	_setOptionDisabled: function( value ) {
		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );

		// If the widget is becoming disabled, then nothing is interactive
		if ( value ) {
			this._removeClass( this.hoverable, null, "ui-state-hover" );
			this._removeClass( this.focusable, null, "ui-state-focus" );
		}
	},

	enable: function() {
		return this._setOptions( { disabled: false } );
	},

	disable: function() {
		return this._setOptions( { disabled: true } );
	},

	_classes: function( options ) {
		var full = [];
		var that = this;

		options = $.extend( {
			element: this.element,
			classes: this.options.classes || {}
		}, options );

		function processClassString( classes, checkOption ) {
			var current, i;
			for ( i = 0; i < classes.length; i++ ) {
				current = that.classesElementLookup[ classes[ i ] ] || $();
				if ( options.add ) {
					current = $( $.unique( current.get().concat( options.element.get() ) ) );
				} else {
					current = $( current.not( options.element ).get() );
				}
				that.classesElementLookup[ classes[ i ] ] = current;
				full.push( classes[ i ] );
				if ( checkOption && options.classes[ classes[ i ] ] ) {
					full.push( options.classes[ classes[ i ] ] );
				}
			}
		}

		this._on( options.element, {
			"remove": "_untrackClassesElement"
		} );

		if ( options.keys ) {
			processClassString( options.keys.match( /\S+/g ) || [], true );
		}
		if ( options.extra ) {
			processClassString( options.extra.match( /\S+/g ) || [] );
		}

		return full.join( " " );
	},

	_untrackClassesElement: function( event ) {
		var that = this;
		$.each( that.classesElementLookup, function( key, value ) {
			if ( $.inArray( event.target, value ) !== -1 ) {
				that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
			}
		} );
	},

	_removeClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, false );
	},

	_addClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, true );
	},

	_toggleClass: function( element, keys, extra, add ) {
		add = ( typeof add === "boolean" ) ? add : extra;
		var shift = ( typeof element === "string" || element === null ),
			options = {
				extra: shift ? keys : extra,
				keys: shift ? element : keys,
				element: shift ? this.element : element,
				add: add
			};
		options.element.toggleClass( this._classes( options ), add );
		return this;
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement;
		var instance = this;

		// No suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// No element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {

				// Allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
						$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// Copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ );
			var eventName = match[ 1 ] + instance.eventNamespace;
			var selector = match[ 2 ];

			if ( selector ) {
				delegateElement.on( eventName, selector, handlerProxy );
			} else {
				element.on( eventName, handlerProxy );
			}
		} );
	},

	_off: function( element, eventName ) {
		eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.off( eventName ).off( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
			},
			mouseleave: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
			}
		} );
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
			},
			focusout: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
			}
		} );
	},

	_trigger: function( type, event, data ) {
		var prop, orig;
		var callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();

		// The original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// Copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( $.isFunction( callback ) &&
			callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}

		var hasOptions;
		var effectName = !options ?
			method :
			options === true || typeof options === "number" ?
				defaultEffect :
				options.effect || defaultEffect;

		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		}

		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;

		if ( options.delay ) {
			element.delay( options.delay );
		}

		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue( function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			} );
		}
	};
} );

return $.widget;

} ) );


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ComponentBase2.default.extend({
	template: __webpack_require__(131),
	events: {
		click: 'onClickDirectionsCTA'
	},
	active: false,
	constructor: function constructor(options) {
		this.componentClass = options.componentClass;
		_ComponentBase2.default.prototype.constructor.call(this, options);
	},
	initialize: function initialize(options) {
		var _this = this;

		_ComponentBase2.default.prototype.initialize.call(this, options);
		this.listenTo(this.widget.bus, 'directions_btn_event', function (active) {
			_this.active = active;
			if (_this.active) {
				(0, _jquery2.default)(_this.el).addClass('active');
			} else {
				(0, _jquery2.default)(_this.el).removeClass('active');
			}
		});
	},
	onClickDirectionsCTA: function onClickDirectionsCTA() {
		this.active = !this.active;
		this.bus.trigger('directions_btn_event', this.active);
	}
});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _runtime = __webpack_require__(13);

var _runtime2 = _interopRequireDefault(_runtime);

var _clipboard = __webpack_require__(133);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _MeliaServiceHelper = __webpack_require__(53);

var _MeliaServiceHelper2 = _interopRequireDefault(_MeliaServiceHelper);

var _HotelPricesButtons = __webpack_require__(134);

var _HotelPricesButtons2 = _interopRequireDefault(_HotelPricesButtons);

var _widgetTypes = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var TYPE_NAME_STARS_SELECTOR = 'Establecimiento';

var HotelDetailPanel = _ComponentBase2.default.extend({
	template: __webpack_require__(136),
	componentClass: 'mainBox-hotel-detail-panel',

	events: {
		'click .cta-see-more-text': 'onClickSeeMoreTextDescription',
		'click .cta-see-less-text': 'onClickSeeLessTextDescription',
		'click .hotel-detail-close-icon': 'onClickOnClose',
		'click .directions-btn': 'onClickDirectionsCTA'
	},

	initialize: function initialize(options) {
		var _this = this;

		this.onClose = false;
		this.registerHelperTruncateText();
		if (options.properties.hotelData) {
			this.updateDataHotel(options.properties.hotelData);
		} else {
			this.listenTo(this.bus, 'UPDATED_HOTEL_SELECTED_DATA', function (hotelData) {
				_this.updateDataHotel(hotelData);
			});
		}
		google.maps.event.addDomListener(this.widget.map, 'resize', function () {
			_this.setHeight();
		});
		this.clipboardObj = new _clipboard2.default('.share-btn', {
			text: function text() {
				_this.createMessageControl();
				return _this.templateConfig.completeUrl;
			}
		});
		this.listenTo(this.widget.bus, 'HOTEL_CHANGED', function (data) {
			if (_this.widget.isMobileVersion && _this.hotelData.hotelCode !== data.hotelId) {
				_this.parentComponent.collapsePanel();
			}
		});
		this.listenTo(this.widget.bus, 'CURRENCY_CHANGED', function (currencyData) {
			if (_this.hotelData) {
				_this.widget.config.currency = currencyData.currency;
				_this.widget.config.currencySign = currencyData.currencySign;
				_this.widget.config.currencyPrefix = currencyData.currencyPrefix;
				if (currencyData.newPrices && currencyData.newPrices.lowestPrice && currencyData.newPrices.regularPrice) {
					_this.hotelData.lowestPrice = currencyData.newPrices.lowestPrice;
					_this.hotelData.regularPrice = currencyData.newPrices.regularPrice;
					if (_this.isCorrectsPrices(_this.hotelData)) {
						_this.generatePricesButtons();
					}
				} else {
					_MeliaServiceHelper2.default.getHotelPrices(_this.widget.config.MeliaUrls, _this.hotelData.hotelCode, _this.widget.config.currency, _this.widget.config.country).then(function (hotelPrices) {
						var jQueryPricesElement = (0, _jquery2.default)(hotelPrices);
						var lowestPrice = jQueryPricesElement.find('LowestPrice').text();
						var regularPrice = jQueryPricesElement.find('RegularPrice').text();
						_this.hotelData.lowestPrice = lowestPrice;
						_this.hotelData.regularPrice = regularPrice;
						if (_this.isCorrectsPrices(_this.hotelData)) {
							_this.generatePricesButtons();
						}
					});
				}
			}
		});
	},
	updateDataHotel: function updateDataHotel(hotelData) {
		this.bus.trigger('SELECT_RESULT');
		this.onClose = false;
		if (!hotelData.code || hotelData.hotel) {
			var coordinates = {
				lat: hotelData.hotel.hotelSection.latitudeCoordinates,
				lon: hotelData.hotel.hotelSection.longitudeCoordinates
			};
			if (this.widget.hotelsJson.mainHotel && this.widget.hotelsJson.mainHotel.id !== hotelData.hotel.code) {
				this.centerHotelSelected(coordinates);
			}
			this.hotelData = hotelData.hotel.hotelSection;
		} else {
			this.bus.trigger('UPDATED_HOTEL_SELECTED_DATA', hotelData);
		}
		this.buildData(this.hotelData);
		this.$el.replaceWith(this.render().$el);
		if (this.isCorrectsPrices(this.hotelData)) {
			this.generatePricesButtons();
		}
		this.setHeight();
		this._hideElemByWidget();
		this.bus.trigger('UPDATED_MARKERS', this);
	},
	isCorrectsPrices: function isCorrectsPrices(hotelData) {
		var pricesAreNull = hotelData.lowestPrice === null || hotelData.regularPrice === null;
		var pricesAreUndefined = hotelData.lowestPrice === undefined || hotelData.regularPrice === undefined;
		var pricesAreZeroNumber = hotelData.lowestPrice === 0 || hotelData.regularPrice === 0;
		var pricesAreZeroString = hotelData.lowestPrice === '0' || hotelData.regularPrice === '0';
		var pricesAreEmptyString = hotelData.lowestPrice === '' || hotelData.regularPrice === '';
		return !pricesAreNull && !pricesAreUndefined && !pricesAreZeroNumber && !pricesAreZeroString && !pricesAreEmptyString;
	},
	generatePricesButtons: function generatePricesButtons() {
		if (this.pricesButtons) {
			this.pricesButtons.updateContent(this.hotelData);
		} else {
			this.pricesButtons = new _HotelPricesButtons2.default({
				position: 'hotel-prices-buttons',
				componentConstructorClass: 'HotelPricesButtons',
				identifier: 'HotelPricesButtons',
				map: this.widget.map,
				widget: this.widget,
				isChild: true,
				parent: this,
				properties: {
					hotelData: this.hotelData,
					isMobile: this.widget.isMobileVersion
				}
			});
		}
		this.$el.find('.hotel-prices').append(this.pricesButtons.el);
	},
	_hideElemByWidget: function _hideElemByWidget() {
		if (this.widget.typeWidget === _widgetTypes.RESULTS_DESTINATION && this.widget.isMobileVersion) {
			this.$el.find('.hotel-prices').addClass('price-detail-disabled');
		}
	},
	_createRefHotel: function _createRefHotel(pos, item) {
		var bus = this.bus;
		var config = {
			position: pos,
			sender: this,
			properties: item
		};

		var icon = 'secondary-hotel-marker.svg';
		this.widget.config.genericIconMarker = icon;
		bus.trigger('CREATE_POINT_REFERENCE', config);
	},
	buildData: function buildData(hotelData) {
		var description = hotelData.description,
		    address = hotelData.address,
		    title = hotelData.title,
		    imgDetail = hotelData.imgDetail,
		    categories = hotelData.categories,
		    url = hotelData.url;


		this.templateConfig = {
			address: address,
			descriptionToTruncate: this.combineParagraph(description),
			allDescription: description,
			title: title,
			imgDetail: imgDetail,
			stars: this.getArrayNumberOfStars(categories),
			isMobile: this.widget.isMobileVersion,
			completeUrl: '' + (this.widget.config.MeliaUrls.baseUrl || 'https://www.melia.com') + url,
			showCloseBtn: this.widget.isMobileVersion || this.widget.typeWidget !== _widgetTypes.HOTEL_DETAILS,
			showDirectionsBTN: [_widgetTypes.HOTEL_DETAILS, _widgetTypes.RESULTS_DESTINATION].includes(this.widget.typeWidget)
		};
	},
	centerHotelSelected: function centerHotelSelected(item) {
		var location = new google.maps.LatLng(item.lat, item.lon);
		if (this.map.getZoom() !== this.widget.config.defaultView.zoom) {
			this.map.setZoom(this.widget.config.defaultView.zoom);
		}
		this.map.setCenter(location);
		if (this.widget.typeWidget !== _widgetTypes.RESULTS_DESTINATION) {
			this.map.setZoom(15);
		}
	},
	onClickSeeMoreTextDescription: function onClickSeeMoreTextDescription() {
		this.$el.find('.description-text').show();
		this.$el.find('.description-truncate').hide();
		this.$el.find('.cta-see-more-text').hide();
		this.$el.find('.cta-see-less-text').show();
	},
	onClickSeeLessTextDescription: function onClickSeeLessTextDescription() {
		this.$el.find('.description-text').hide();
		this.$el.find('.description-truncate').show();
		this.$el.find('.cta-see-more-text').show();
		this.$el.find('.cta-see-less-text').hide();
	},
	combineParagraph: function combineParagraph(description) {
		var text = '';
		(0, _jquery2.default)(description).each(function (index, element) {
			text += (0, _jquery2.default)(element).text();
		});
		return text;
	},
	setHeight: function setHeight() {
		if (!this.onClose) {
			var widgetHeight = this.widget.getHeight();
			var heightAutocomplete = 50;
			var marginTopMainPanel = 10;
			var googleLogoHeight = 28;
			if (!this.widget.isMobileVersion) {
				this.$el.css('max-height', widgetHeight - heightAutocomplete - marginTopMainPanel - googleLogoHeight + 'px');
			}
		}
	},
	onClickOnClose: function onClickOnClose() {
		this.onClose = true;
		if (this.widget.isMobileVersion) {
			this.parentComponent.collapsePanel();
		} else {
			this.hide();
		}
	},
	onClickDirectionsCTA: function onClickDirectionsCTA() {
		if (this.widget.isMobileVersion) {
			this.parentComponent.collapsePanel();
		}
		var openDirectionBox = true;
		this.bus.trigger('directions_btn_event', openDirectionBox, this.hotelData);
	},
	registerHelperTruncateText: function registerHelperTruncateText() {
		_runtime2.default.registerHelper('trimString', function (passedString, start, length) {
			if (passedString) {
				var mlength = length,
				    preS = '',
				    tailS = '';
				if (start > 0 && passedString.length > 3) {
					preS = '...';
					mlength = length - 3;
				}
				if (passedString.length > start + length) {
					tailS = '...';
					mlength = mlength - 3;
				}
				var theString = preS + passedString.substr(start, mlength) + tailS;
				return new _runtime2.default.SafeString(theString);
			}
		});
	},
	createMessageControl: function createMessageControl() {
		var typeIcon = 'success';
		var text = this.widget.polyglot.t('hotelDetail.successCopy');
		var autoHideTime = 2500;
		var canRepeat = false;
		this.widget.messageControl.createMessage(typeIcon, text, autoHideTime, canRepeat);
	},
	getArrayNumberOfStars: function getArrayNumberOfStars(categories) {
		var starsObj = categories.find(function (e) {
			return e.type === TYPE_NAME_STARS_SELECTOR;
		});
		var nStars = starsObj ? parseInt(starsObj.description.substr(0, 1)) : 0;
		return [].concat(_toConsumableArray(Array(nStars)));
	}
});
exports.default = HotelDetailPanel;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MeliaServiceHelper = function () {
	function MeliaServiceHelper() {
		_classCallCheck(this, MeliaServiceHelper);
	}

	_createClass(MeliaServiceHelper, null, [{
		key: 'getHotelDetails',
		value: function getHotelDetails(meliaURLs, hotelID, lang) {
			var deferred = _jquery2.default.Deferred();
			var hotelIDParamURL = 'hotelId';
			var langParamURL = 'lang';
			var url = meliaURLs.HotelSheet.replace('{' + hotelIDParamURL + '}', hotelID).replace('{' + langParamURL + '}', lang);
			this.getMethod(deferred, url);
			return deferred.promise();
		}
	}, {
		key: 'getHotelsByDestinationCode',
		value: function getHotelsByDestinationCode(meliaURLs, destinationCode, lang) {
			var deferred = _jquery2.default.Deferred();
			var langParamURL = 'lang';
			var destCodeParamURL = 'dest_code';
			var url = meliaURLs.SearchDataDestination.replace('{' + destCodeParamURL + '}', destinationCode).replace('{' + langParamURL + '}', lang);
			this.getMethod(deferred, url);
			return deferred.promise();
		}
	}, {
		key: 'getDestinationsTree',
		value: function getDestinationsTree(meliaURLs, lang) {
			var deferred = _jquery2.default.Deferred();
			var langParamURL = 'lang';
			var url = meliaURLs.DestinationsTree.replace('{' + langParamURL + '}', lang);
			this.getMethod(deferred, url);
			return deferred.promise();
		}
	}, {
		key: 'getHotelPrices',
		value: function getHotelPrices(meliaURLs, hotelId, currency, countryId) {
			var deferred = _jquery2.default.Deferred();
			var countryIdParamURL = 'countryId';
			var hotelIDParamURL = 'hotelId';
			var currencyParamURL = 'currency';
			var url = meliaURLs.HotelPrices.replace('{' + countryIdParamURL + '}', countryId).replace('{' + hotelIDParamURL + '}', hotelId).replace('{' + currencyParamURL + '}', currency);
			this.getMethod(deferred, url);
			return deferred.promise();
		}
	}, {
		key: 'getHotelURL',
		value: function getHotelURL(meliaURLs, hotelId, hotelTitle, lang) {
			var deferred = _jquery2.default.Deferred();
			var hotelIDParamURL = 'hotelId';
			var hotelTitleParamURL = 'hotelTitle';
			var langParamURL = 'lang';
			var url = meliaURLs.friendlyUrl.replace('{' + hotelTitleParamURL + '}', hotelTitle).replace('{' + hotelIDParamURL + '}', hotelId).replace('{' + langParamURL + '}', lang);
			this.getMethod(deferred, url);
			return deferred.promise();
		}
	}, {
		key: 'getMethod',
		value: function getMethod(deferred, url) {
			_jquery2.default.ajax({
				url: url,
				type: 'GET',
				success: function success(responseData) {
					deferred.resolve(responseData);
				},
				error: function error(responseData) {
					deferred.reject(responseData);
				}
			});
		}
	}]);

	return MeliaServiceHelper;
}();

exports.default = MeliaServiceHelper;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @namespace components
 * @memberof core
 */


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Autocomplete = __webpack_require__(19);

var _Autocomplete2 = _interopRequireDefault(_Autocomplete);

var _ToggleBtn = __webpack_require__(141);

var _ToggleBtn2 = _interopRequireDefault(_ToggleBtn);

var _DirectionsBox = __webpack_require__(145);

var _DirectionsBox2 = _interopRequireDefault(_DirectionsBox);

var _MainBox = __webpack_require__(157);

var _MainBox2 = _interopRequireDefault(_MainBox);

var _BlockAutocomplete = __webpack_require__(159);

var _BlockAutocomplete2 = _interopRequireDefault(_BlockAutocomplete);

var _transportModes = __webpack_require__(161);

var _transportModes2 = _interopRequireDefault(_transportModes);

var _JPList = __webpack_require__(163);

var _JPList2 = _interopRequireDefault(_JPList);

var _JPRouteDetails = __webpack_require__(165);

var _JPRouteDetails2 = _interopRequireDefault(_JPRouteDetails);

var _JPTransitGeneralInfo = __webpack_require__(59);

var _JPTransitGeneralInfo2 = _interopRequireDefault(_JPTransitGeneralInfo);

var _JPNonTransitGeneralInfo = __webpack_require__(58);

var _JPNonTransitGeneralInfo2 = _interopRequireDefault(_JPNonTransitGeneralInfo);

var _JPNonTransitStepsInfo = __webpack_require__(60);

var _JPNonTransitStepsInfo2 = _interopRequireDefault(_JPNonTransitStepsInfo);

var _JPTransitStepsInfo = __webpack_require__(61);

var _JPTransitStepsInfo2 = _interopRequireDefault(_JPTransitStepsInfo);

var _HotelLocation = __webpack_require__(20);

var _HotelLocation2 = _interopRequireDefault(_HotelLocation);

var _CategoriesPanel = __webpack_require__(173);

var _CategoriesPanel2 = _interopRequireDefault(_CategoriesPanel);

var _HotelDetailPanel = __webpack_require__(52);

var _HotelDetailPanel2 = _interopRequireDefault(_HotelDetailPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Components = {
    Autocomplete: _Autocomplete2.default,
    ToggleBtn: _ToggleBtn2.default,
    DirectionsBox: _DirectionsBox2.default,
    MainBox: _MainBox2.default,
    BlockAutocomplete: _BlockAutocomplete2.default,
    JPList: _JPList2.default,
    HotelLocation: _HotelLocation2.default,
    TransportModes: _transportModes2.default,
    JPRouteDetails: _JPRouteDetails2.default,
    JPTransitGeneralInfo: _JPTransitGeneralInfo2.default,
    JPNonTransitGeneralInfo: _JPNonTransitGeneralInfo2.default,
    JPNonTransitStepsInfo: _JPNonTransitStepsInfo2.default,
    JPTransitStepsInfo: _JPTransitStepsInfo2.default,
    CategoriesPanel: _CategoriesPanel2.default,
    HotelDetailPanel: _HotelDetailPanel2.default
}; /**
    * Please add the project custom components to this folder
    * @namespace project.components
    */
exports.default = Components;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouteModel = _backbone2.default.Model.extend({
  /** 
   * @memberOf module:Layers
   * @class RouteModel
   * @extends Backbone.Model
   * @classdesc This model controls the attributes focus and empty for origin and destination autocompletes
   * */
  initialize: function initialize() {
    this.setVisibility(true);
  },

  /**
   * Change the 'highlighted' state
   * @memberOf module:Layers.RouteModel
   * @function
   */
  toggleHover: function toggleHover() {
    this.set('highlighted', !this.get('highlighted'));
  },

  /**
   * Set 'highlighted' as true
   * @memberOf module:Layers.RouteModel
   * @function
   */
  onHover: function onHover() {
    this.set('highlighted', true);
  },

  /**
   * Set 'highlighted' as false
   * @memberOf @memberOf module:Layers.RouteModel
   * @function
   */
  onLeave: function onLeave() {
    this.set('highlighted', false);
  },

  /**
   * Get 'highlighted' state
   * @memberOf @memberOf module:Layers.RouteModel
   * @function
   */
  isHovered: function isHovered() {
    return this.get('highlighted');
  },
  /**
   * Change the 'selected' state
   * @memberOf module:Layers.RouteModel
   * @function
   */
  toggleSelect: function toggleSelect() {
    this.set('selected', !this.get('selected'));
  },

  /**
   * Set 'selected' as true
   * @memberOf module:Layers.RouteModel
   * @function
   */
  onSelect: function onSelect() {
    this.set('selected', true);
  },

  /**
   * Set 'selected' as false
   * @memberOf @memberOf module:Layers.RouteModel
   * @function
   */
  onDeselect: function onDeselect() {
    this.set('selected', false);
  },

  /**
   * Get 'selected' state
   * @memberOf @memberOf module:Layers.RouteModel
   * @function
   */
  isSelected: function isSelected() {
    return this.get('selected');
  },
  /** Set 'style' by type (default or basic) 
   *   @memberOf module:Layers.RouteModel
   * @function
   */
  setStyle: function setStyle(type) {
    this.set('style', type);
  },
  /** Get 'style' value
   *  @memberOf module:Layers.RouteModel
   * @function
   */
  getStyle: function getStyle() {
    return this.get('style');
  },
  /** Set 'agency' 
   *   @memberOf module:Layers.RouteModel
   * @function
   */
  setAgency: function setAgency(agency) {
    this.set('agency', agency);
  },
  /** Get 'agency' value
   *  @memberOf module:Layers.RouteModel
   * @function
   */
  getAgency: function getAgency() {
    return this.get('agency');
  },
  /** Set 'visibility' 
   *   @memberOf module:Layers.RouteModel
   * @function
   */
  setVisibility: function setVisibility(isVisible) {
    this.set('visibility', isVisible);
  },

  /** Get 'visibility' value
   *  @memberOf module:Layers.RouteModel
   * @function
   */
  getVisibility: function getVisibility() {
    return this.get('visibility');
  }

});

exports.default = RouteModel;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var JPRouteHelper = function () {
    function JPRouteHelper() {
        _classCallCheck(this, JPRouteHelper);
    }

    _createClass(JPRouteHelper, null, [{
        key: "printStep",
        value: function printStep(params) {
            var args = Array.prototype.slice.call(params, 0, -1);
            var stepIndex = args[0];
            var stepsLength = args[1];
            var elementsBeforeDots = args[2];
            return stepIndex <= elementsBeforeDots || stepIndex === stepsLength - 1;
        }
    }, {
        key: "printDots",
        value: function printDots(params) {
            var args = Array.prototype.slice.call(params, 0, -1);
            var stepIndex = args[0];
            var stepsLength = args[1];
            var elementsBeforeDots = args[2];
            return stepIndex === elementsBeforeDots && stepsLength !== elementsBeforeDots + 1;
        }
    }]);

    return JPRouteHelper;
}();

exports.default = JPRouteHelper;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JPNonTransitGeneralInfo = _ComponentBase2.default.extend({
    template: __webpack_require__(166),

    componentClass: 'jp-non-transit-general',

    identifier: 'jp-non-transit-general',

    constructor: function constructor(options) {
        options.identifier = this.identifier;
        _ComponentBase2.default.prototype.constructor.call(this, options);
        this.widget = options.widget;
        this.componentConstructorClass = options.componentConstructorClass;
        this.travelMode = options.properties.travelMode;
        this.route = options.properties.route;
        this.summary = options.properties.summary;
    },
    initialize: function initialize() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this.templateConfig = _underscore2.default.extend(options, {
            componentClass: 'jp-non-transit-general',
            travelMode: options.properties.travelMode,
            route: options.properties.route,
            summary: options.properties.summary
        });
        _backbone2.default.View.prototype.initialize.call(this, options);
        this.render();
    }
});
exports.default = JPNonTransitGeneralInfo;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _runtime = __webpack_require__(13);

var _runtime2 = _interopRequireDefault(_runtime);

var _JPRouteHelper = __webpack_require__(57);

var _JPRouteHelper2 = _interopRequireDefault(_JPRouteHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JPTransitGeneralInfo = _ComponentBase2.default.extend({
    template: __webpack_require__(167),

    componentClass: 'jp-transit-general',

    identifier: 'jp-transit-general',

    stepsShownPerRoute: 2,

    constructor: function constructor(options) {
        options.identifier = this.identifier;
        _ComponentBase2.default.prototype.constructor.call(this, options);
        this.widget = options.widget;
        this.componentConstructorClass = options.componentConstructorClass;
        this.travelMode = options.properties.travelMode;
        this.route = options.properties.route;
    },
    initialize: function initialize() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this.loadHelpers();
        var route = this.normalizeTransitRoute(options.properties.route);
        this.templateConfig = _underscore2.default.extend(options, {
            componentClass: 'jp-transit-general',
            travelMode: options.properties.travelMode,
            route: route,
            stepsShownPerRoute: this.stepsShownPerRoute
        });
        _backbone2.default.View.prototype.initialize.call(this, options);
        this.render();
    },
    normalizeTransitRoute: function normalizeTransitRoute(route) {
        var totalWalking = 0;
        route.steps.forEach(function (step) {
            if (step.travel_mode === 'WALKING') {
                totalWalking += step.duration.value;
            }
        });
        return {
            departureTime: route.departure_time ? route.departure_time.text : '',
            arrivalTime: route.arrival_time ? route.arrival_time.text : '',
            time: route.duration.text,
            walkingTime: (totalWalking / 60).toFixed(0),
            steps: route.steps.map(function (step) {
                if (step.travel_mode === 'WALKING') {
                    return {
                        travelMode: step.travel_mode.toLowerCase()
                    };
                } else {
                    return {
                        travelMode: step.travel_mode.toLowerCase(),
                        lineName: step.transit.line.short_name,
                        icon: step.transit.line.vehicle.local_icon,
                        color: step.transit.line.color
                    };
                }
            })
        };
    },
    loadHelpers: function loadHelpers() {
        _runtime2.default.registerHelper('printStep', function () {
            return _JPRouteHelper2.default.printStep(arguments);
        });

        _runtime2.default.registerHelper('printDots', function () {
            return _JPRouteHelper2.default.printDots(arguments);
        });
    }
});
exports.default = JPTransitGeneralInfo;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _widgetTypes = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JPNonTransitStepsInfo = _ComponentBase2.default.extend({
    template: __webpack_require__(168),

    componentClass: 'jp-non-transit-steps-info',

    identifier: 'jp-non-transit-steps-info',

    constructor: function constructor(options) {
        options.identifier = this.identifier;
        _ComponentBase2.default.prototype.constructor.call(this, options);
        this.widget = options.widget;
        this.componentConstructorClass = options.componentConstructorClass;
        this.travelMode = options.properties.travelMode;
        this.route = options.properties.route;
        this.summary = options.properties.summary;
    },
    initialize: function initialize() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var componentClass = 'jp-non-transit-steps-info';
        this.templateConfig = _underscore2.default.extend(options, {
            componentClass: componentClass,
            originText: options.properties.originText,
            destinationText: options.properties.destinationText,
            route: options.properties.route,
            isDetailHotelWidget: this.widget.typeWidget === _widgetTypes.HOTEL_DETAILS,
            originIsMainHotel: this.widget.typeWidget === _widgetTypes.HOTEL_DETAILS && options.properties.originIsMainHotel,
            destinationIsMainHotel: this.widget.typeWidget === _widgetTypes.HOTEL_DETAILS && !options.properties.originIsMainHotel
        });
        _backbone2.default.View.prototype.initialize.call(this, options);
        this.render();
    }
});
exports.default = JPNonTransitStepsInfo;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JPTransitStepsInfo = _ComponentBase2.default.extend({
    template: __webpack_require__(169),

    componentClass: 'jp-transit-steps',

    identifier: 'jp-transit-steps',

    events: {
        'click .jp-transit-step-walking-steps-clickable': '_clickArrowWalk'
    },

    constructor: function constructor(options) {
        options.identifier = this.identifier;
        _ComponentBase2.default.prototype.constructor.call(this, options);
        this.widget = options.widget;
        this.componentConstructorClass = options.componentConstructorClass;
        this.travelMode = options.properties.travelMode;
        this.route = options.properties.route;
        this.summary = options.properties.summary;
    },
    initialize: function initialize() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var componentClass = 'jp-transit-steps-info';
        this.templateConfig = _underscore2.default.extend(options, {
            componentClass: componentClass,
            originText: options.properties.originText,
            destinationText: options.properties.destinationText,
            route: options.properties.route,
            summary: options.properties.summary
        });
        _backbone2.default.View.prototype.initialize.call(this, options);
        this.render();
    },
    _clickArrowWalk: function _clickArrowWalk(e) {
        var arrowComponent = (0, _jquery2.default)(e.target);
        var stepsContainer = arrowComponent.parent().parent().find('.jp-transit-step-walking-steps-container');
        if (e.target.className.indexOf('lmm-icon-ic_keyboard_arrow_down_black_24px') > -1) {
            arrowComponent.removeClass('lmm-icon-ic_keyboard_arrow_down_black_24px');
            arrowComponent.addClass('lmm-icon-ic_keyboard_arrow_up_black_24px');
            stepsContainer.slideDown(500);
        } else {
            arrowComponent.removeClass('lmm-icon-ic_keyboard_arrow_up_black_24px');
            arrowComponent.addClass('lmm-icon-ic_keyboard_arrow_down_black_24px');
            stepsContainer.slideUp(500);
        }
    }
});
exports.default = JPTransitStepsInfo;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(22);
var foreach = __webpack_require__(191);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

var toStr = Object.prototype.toString;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
        /* eslint-disable no-unused-vars, no-restricted-syntax */
        for (var _ in obj) { return false; }
        /* eslint-enable no-unused-vars, no-restricted-syntax */
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		Object.defineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = props.concat(Object.getOwnPropertySymbols(map));
	}
	foreach(props, function (name) {
		defineProperty(object, name, map[name], predicates[name]);
	});
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(7);
var ES = __webpack_require__(192);
var replace = bind.call(Function.call, String.prototype.replace);

var leftWhitespace = /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;

module.exports = function trim() {
	var S = ES.ToString(ES.CheckObjectCoercible(this));
	return replace(replace(S, leftWhitespace, ''), rightWhitespace, '');
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(63);

var zeroWidthSpace = '\u200b';

module.exports = function getPolyfill() {
	if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace) {
		return String.prototype.trim;
	}
	return implementation;
};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = {"autocomplete.placeholder":"Type here to search","autocomplete.notResultFound":"We haven't found any place matching searched criteria! Try adding a city, street or post code.","mylocation.notfound":"We could not determine your precise location. /link/Click here!/link/","mylocation.notinallowedarea":"The location is out of the allowed area","mylocation.help":"Help","loadingWarning.mainMsg":"Still loading","streetview.notAvailable":"Street View not available at this location.","carousel.noImages":"There are not images to display.","mylocation.linkText":"Click here","mylocation.helpMobile":"https://support.google.com/maps/answer/1250066?p=ml_location_help&hl=en&rd=1","mylocation.helpDesktop":"https://support.google.com/maps/answer/2839911?hl=es&visit_id=1-636149094206978280-3844184764&rd=1","placesCard.website":"See website","travelTime.turnOn":"Turn on filter","travelTime.turnOff":"Turn off filter","travelTime.info":"You can drag & drop the pin anywhere on the map. Choose a transport mode and maximum time from the point of reference to filter the properties.","calculateTravelTime.turnOn":"Turn on Calculate time","calculateTravelTime.turnOff":"Turn off Calculate time","calculateTravelTime.placeholder":"Look for a place...","calculateTravelTime.info":"Look for a place to calculate travel time from a property.","calculateTravelTime.placeholderLimitReached":"Delete some POI to search","calculateTravelTime.infoMessage":"You can now click on a property and we will calculate the travel time for you.","calculateTravelTime.poiAddedMessage":"Point of interest succesfully added.","calculateTravelTime.poisLimitMessage":"No more POIs are available. You have reached the maximum number of points.","calculateTravelTime.noRouteMessage":"Sorry, we haven't found a route. Try another, please.","calculateTravelTime.errorMessage":"Sorry, an error occurred. Please try again.","calculateTravelTime.noRouteLabel":"No route","calculateTravelTime.hoursLabel":"hours","calculateTravelTime.hourLabel":"hour","drawingTool.enabled":"Click on the map to draw the search area. Close the area with double-click or joining nodes","transitStops.departure":"Departure","transitStops.arrival":"Arrival","transitStops.headsign":"Headsign","transitStops.line":"Line","transitStops.stops":"stops","panelTT.outsideBounds":"Our services aren’t available in these places."}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(22);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES = __webpack_require__(215);

module.exports = function flatMap(mapperFunction) {
	var O = ES.ToObject(this);
	var sourceLen = ES.ToLength(ES.Get(O, 'length'));

	if (!ES.IsCallable(mapperFunction)) {
		throw new TypeError('mapperFunction must be a function');
	}

	var T;
	if (arguments.length > 1) {
		T = arguments[1];
	}

	var A = ES.ArraySpeciesCreate(O, 0);
	ES.FlattenIntoArray(A, O, sourceLen, 0, 1, mapperFunction, T);
	return A;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(22);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(7);
var replace = bind.call(Function.call, String.prototype.replace);

/* eslint-disable no-control-regex */
var leftWhitespace = /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]*/;
/* eslint-enable no-control-regex */

module.exports = function trimLeft() {
	return replace(this, leftWhitespace, '');
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(69);

module.exports = function getPolyfill() {
	if (!String.prototype.trimLeft) {
		return implementation;
	}
	var zeroWidthSpace = '\u200b';
	if (zeroWidthSpace.trimLeft() !== zeroWidthSpace) {
		return implementation;
	}
	return String.prototype.trimLeft;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(22);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(7);
var replace = bind.call(Function.call, String.prototype.replace);

/* eslint-disable no-control-regex */
var rightWhitespace = /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]*$/;
/* eslint-enable no-control-regex */

module.exports = function trimRight() {
	return replace(this, rightWhitespace, '');
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(72);

module.exports = function getPolyfill() {
	if (!String.prototype.trimRight) {
		return implementation;
	}
	var zeroWidthSpace = '\u200b';
	if (zeroWidthSpace.trimRight() !== zeroWidthSpace) {
		return implementation;
	}
	return String.prototype.trimRight;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(75);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(223);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(5);

var $TypeError = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');

var has = __webpack_require__(10);

var predicates = {
	// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	'Property Descriptor': function isPropertyDescriptor(ES, Desc) {
		if (ES.Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	}
};

module.exports = function assertRecord(ES, recordType, argumentName, value) {
	var predicate = predicates[recordType];
	if (typeof predicate !== 'function') {
		throw new $SyntaxError('unknown record type: ' + recordType);
	}
	if (!predicate(ES, value)) {
		throw new $TypeError(argumentName + ' must be a ' + recordType);
	}
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(5);

var $Math = GetIntrinsic('%Math%');
var $Number = GetIntrinsic('%Number%');

module.exports = $Number.MAX_SAFE_INTEGER || $Math.pow(2, 53) - 1;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(5);

var has = __webpack_require__(10);
var $TypeError = GetIntrinsic('%TypeError%');

module.exports = function IsPropertyDescriptor(ES, Desc) {
	if (ES.Type(Desc) !== 'Object') {
		return false;
	}
	var allowed = {
		'[[Configurable]]': true,
		'[[Enumerable]]': true,
		'[[Get]]': true,
		'[[Set]]': true,
		'[[Value]]': true,
		'[[Writable]]': true
	};

    for (var key in Desc) { // eslint-disable-line
		if (has(Desc, key) && !allowed[key]) {
			return false;
		}
	}

	if (ES.IsDataDescriptor(Desc) && ES.IsAccessorDescriptor(Desc)) {
		throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
	}
	return true;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(5);

var $test = GetIntrinsic('RegExp.prototype.test');

var callBind = __webpack_require__(24);

module.exports = function regexTester(regex) {
	return callBind($test, regex);
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(23)();
var GetIntrinsic = __webpack_require__(5);
var callBound = __webpack_require__(11);

var $iterator = GetIntrinsic('%Symbol.iterator%', true);
var $arraySlice = callBound('Array.prototype.slice');
var $arrayJoin = callBound('Array.prototype.join');

module.exports = function getIteratorMethod(ES, iterable) {
	var usingIterator;
	if (hasSymbols) {
		usingIterator = ES.GetMethod(iterable, $iterator);
	} else if (ES.IsArray(iterable)) {
		usingIterator = function () {
			var i = -1;
			var arr = this; // eslint-disable-line no-invalid-this
			return {
				next: function () {
					i += 1;
					return {
						done: i >= arr.length,
						value: arr[i]
					};
				}
			};
		};
	} else if (ES.Type(iterable) === 'String') {
		usingIterator = function () {
			var i = 0;
			return {
				next: function () {
					var nextIndex = ES.AdvanceStringIndex(iterable, i, true);
					var value = $arrayJoin($arraySlice(iterable, i, nextIndex), '');
					i = nextIndex;
					return {
						done: nextIndex > iterable.length,
						value: value
					};
				}
			};
		};
	}
	return usingIterator;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(5);

var originalSetProto = GetIntrinsic('%Object.setPrototypeOf%', true);
var $ArrayProto = GetIntrinsic('%Array.prototype%');

module.exports = originalSetProto || (
	// eslint-disable-next-line no-proto, no-negated-condition
	[].__proto__ !== $ArrayProto
		? null
		: function (O, proto) {
			O.__proto__ = proto; // eslint-disable-line no-proto
			return O;
		}
);


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $strSlice = __webpack_require__(11)('String.prototype.slice');

module.exports = function isPrefixOf(prefix, string) {
	if (prefix === string) {
		return true;
	}
	if (prefix.length > string.length) {
		return false;
	}
	return $strSlice(string, 0, prefix.length) === prefix;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(67);

module.exports = function getPolyfill() {
	return Array.prototype.flatMap || implementation;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _DataProvider = __webpack_require__(27);

var _DataProvider2 = _interopRequireDefault(_DataProvider);

var _Utils = __webpack_require__(6);

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DataProvider2.default.extend({
	constructor: function constructor(options) {
		this.widget = options.widget;
		this.options = options;
		this.initialize();
	},
	initialize: function initialize() {
		this._checkVisibility();
		_DataProvider2.default.prototype.initialize.call(this);
	},
	load: function load(destinationId) {
		var _this = this;

		var opt = {
			featureId: 'hotelCode',
			geometry: 'position'
		};
		this.widget.getDestinationsTreeObject(destinationId).then(function (hotelsData) {
			var bounds = new google.maps.LatLngBounds();
			hotelsData.forEach(function (hotel) {
				bounds.union(_Utils2.default.getBoundsFromPoint(new google.maps.LatLng({
					lat: hotel.position.lat,
					lng: hotel.position.lon
				}), 10));
			});
			_this.widget.map.fitBounds(bounds);
			_this.trigger('PROCESS_FEATURES', _Utils2.default.transformDataToGeoJSON({ features: hotelsData }, opt).features, _this);
		});
		this.widget.$el.find('.lmm-main-box-hotel-detail-panel').hide();
		this.widget.$el.find('.lmm-hotel-resume-mobile-panel').hide();
	}
});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _MeliaLetMeMap = __webpack_require__(90);

var _MeliaLetMeMap2 = _interopRequireDefault(_MeliaLetMeMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Import and set here a Widget subclass to define 
// custom widget behaviour, components and layers for the project
// Rename SeedWidget to something more project related too, please;)
module.exports = new _MeliaLetMeMap2.default();

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _LetMeMap2 = __webpack_require__(91);

var _LetMeMap3 = _interopRequireDefault(_LetMeMap2);

var _HotelDetailsWidget = __webpack_require__(94);

var _HotelDetailsWidget2 = _interopRequireDefault(_HotelDetailsWidget);

var _DestinationResultsDate = __webpack_require__(242);

var _DestinationResultsDate2 = _interopRequireDefault(_DestinationResultsDate);

var _DestinationsTreeWidget = __webpack_require__(244);

var _DestinationsTreeWidget2 = _interopRequireDefault(_DestinationsTreeWidget);

var _widgetTypes = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MeliaLetMeMap = function (_LetMeMap) {
	_inherits(MeliaLetMeMap, _LetMeMap);

	function MeliaLetMeMap() {
		_classCallCheck(this, MeliaLetMeMap);

		return _possibleConstructorReturn(this, (MeliaLetMeMap.__proto__ || Object.getPrototypeOf(MeliaLetMeMap)).call(this, true));
	}

	_createClass(MeliaLetMeMap, [{
		key: 'createWidget',
		value: function createWidget(containerId, config, api) {
			this._chooseWidget(config);
			return _get(MeliaLetMeMap.prototype.__proto__ || Object.getPrototypeOf(MeliaLetMeMap.prototype), 'createWidget', this).call(this, containerId, config, api);
		}
	}, {
		key: '_chooseWidget',
		value: function _chooseWidget(config) {
			if (config.typeWidget === _widgetTypes.HOTEL_DETAILS) {
				this.widgetClass = _HotelDetailsWidget2.default;
			} else if (config.typeWidget === _widgetTypes.RESULTS_DESTINATION) {
				this.widgetClass = _DestinationResultsDate2.default;
			} else if (config.typeWidget === _widgetTypes.DESTINATIONS_TREE) {
				this.widgetClass = _DestinationsTreeWidget2.default;
			} else {
				throw new Error('LetMeMap::createWidget: typeWidget wrong');
			}
		}
	}]);

	return MeliaLetMeMap;
}(_LetMeMap3.default);

exports.default = MeliaLetMeMap;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _googleMaps = __webpack_require__(92);

var _googleMaps2 = _interopRequireDefault(_googleMaps);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

if (false) {
  _jquery2.default.noConflict(true);
}

/**
 *  LetMeMap class instances are exposed to the portal to create and manage widgets.
 *  @memberof core
 */

var LetMeMap = function () {
  _createClass(LetMeMap, [{
    key: '_version',
    get: function get() {
      console.log('The current widget version is: ' + "0.1.0");
    }

    /**
     * Creates an instance of LetMeMap.
     * @param {function} widgetClass The constructor function of the Widget subclass that will be created.
     */

  }]);

  function LetMeMap(widgetClass) {
    _classCallCheck(this, LetMeMap);

    if (!widgetClass) {
      throw new Error('The widget class parameter must exist');
    }
    this.widgetClass = widgetClass;
  }

  /**
   * @typedef {object} GoogleMapsLoadConfig
   * @desc Configuration related to the load of Google Maps API JS Library
   * @memberof core.Config
   * @see https://developers.google.com/maps/documentation/javascript/tutorial#Loading_the_Maps_API
   * @property {string} [LANGUAGE='en'] The language to load the GoogleMaps libary in
   * @property {string[]} [LIBRARIES=['places']] The libraries to load with Google Maps
   * @property {string} [VERSION='3'] The Google Maps JS API version to use
   * @property {string} [CLIENT=null] The Google Maps JS API client id to use to load the API. 
   * If not present the KEY property value will be used.
   * @property {string} [KEY=null] The Google Maps JS API key to be used to load the API. 
   * If not present and CLIENT is also not present an error will be thrown upon widget creation.
   */

  /**
   * @typedef {object} GoogleMapsOptions
   * @extends google.maps.MapOptions
   * @memberof core.Config
   * @see https://developers.google.com/maps/documentation/javascript/reference#MapOptions
   */

  /**
   * @typedef {object} ConfigBounds A bounding box JSON representation
   * @property {number} bounds.neLat bounding box's north east point latitude
   * @property {number} bounds.neLng bounding box's north east point longitude
   * @property {number} bounds.swLat bounding box's south west point latitude
   * @property {number} bounds.swLng bounding box's south west point longitude
   * @memberof core.Config
   */

  /**
   * @typedef {object} DefaultView
   * @property {core.Config.ConfigBounds} [bounds=null] The bounding box to which center the map's initial view
   * @property {boolean|core.Config.ConfigBounds} [limitBounds=null] The bounding box outside of which the map view cannot be set.
   * @property {number[]} [center=null] An array containing [latitude,longitude] values to be set as map center. 
   * Ignored if bounds exist. Overrides the  mapOptions.center property if set. {@see core.Config.GoogleMapsOptions}.
   * @property {number} [zoom=null] The initial zoom level of the map. 
   * Overrides mapOptions.zoom property if set. {@see core.Config.GoogleMapsOptions}.
   * @memberof core.Config
   */

  /**
   * @typedef {object} Breakpoints 
   * @property {string} [maxMobile=null] The max widget container width for being in mobile responsive mode 
   * @property {string} [maxTablet=null] The max widget container width for being in  tablet responsive mode 
   * @memberof core.Config 
   */

  /**
   * @typedef {object} Layer
   * @desc Configuration for a given layer. Configuration must include at least a "type" property.
   * Other properties existence depend on the particular core.config.BaseLayer extending class being used.
   * This configuration will be sent to layer classes' constructors as the source property.
   * 
   * @property {string} type The type of the layer to create as defined in the project's src/layers/index.js file 
   * @property {string} provider the registered name of the provider class that will be instantiated for the layer.
   * @memberof core.Config
   */

  /**
   * @typedef {object<string, core.Config.Layer>} Layers
   * @desc A definition of layers in which keys are layer identifiers and values are their configurations.
   * @memberof core.Config
   */

  /**
   * @typedef Component
   * @desc Component configuration.
   * 
   * @property {string} componentConstructorClass The registered class name for the component
   * @property {string} position The position of the component in the map or its parent component
   * @property {object<string,any>} properties Configuration properties for the component
   * @memberof core.Config
   */

  /**
   * @typedef {object<string, core.Config.Component>} Components
   * @memberof core.Config
   */

  /**
   * @class 
   * @name Config 
   * @classdesc Not an actual class but used to document the configuration for the Widgets created with LMM. 
   * Extend this type to add project related configuration.
   * @property {boolean} debugEnabled If the widget will be created in debug mode that easis debugging and testing
   * by e.g. unoptimizing the markers.
   * @property {boolean} doValidation If the widget and its components will perform validation of the configurations received. 
   * Set it to true when developing and testing.
   * @property {core.Config.GoogleMapsLoadConfig} gmapLoadConfig Google Maps library configuration
   * @property {core.Config.GoogleMapsOptions} mapOptions Google Maps initialization options 
   * @property {core.Config.DefaultView} defaultView The default view for the map
   * @property {core.Config.Breakpoints} breakpoints The responsive breakpoints for the widget
   * @property {core.Config.LayerDefaults} layerDefaults The default configuration for layers added to the widget.
   * @property {core.Config.Layers} propertyLayers The property layers configured for the widget,
   *  i.e. those showing elements related to the client's business such as hotels, houses etc.
   * @property {core.Config.Layers} layers The non-property layers configured for the widget
   * @property {core.Config.Components} components The components to be added to the map.
   * @memberof core
   */

  /**
   * Creates a map widget
   * @param {string} containerId - The id of the DOM element where the map will be created.
   * @param {core.Config} config - The config provided by json
   * @param {core.APIObject} api - The object that allows the widget to interact with the portal.
   * @example <caption>Example to create a new widget</caption>
   *  lmmMapsWidget.createWidget('map-container', config, apiObject)
   * @returns {Promise<core.widget.Widget>}
   */


  _createClass(LetMeMap, [{
    key: 'createWidget',
    value: function createWidget(containerId, config, api) {
      var _this = this;

      var deferred = _jquery2.default.Deferred();
      var promise = deferred.promise();
      this.widgets = this.widgets || {};
      if (this.widgets[containerId]) {
        deferred.reject('Duplicated Widget');
      } else {
        this.widgets[containerId] = promise;
        this._gmapPromise(config.gmapLoadConfig).done(function () {
          deferred.resolve(new _this.widgetClass(containerId, config, api));
        }).fail(function (reason) {
          deferred.reject(reason);
        });
      }
      return promise;
    }

    /**
     * Get the widget by id
     * @function
     * @param {string} containerId - The id of the DOM element where the widget is embedded.
     * @returns {core.widget.Widget}
     */

  }, {
    key: 'getWidget',
    value: function getWidget(containerId) {
      return this.widgets[containerId];
    }

    /**
     * Destroys the widget instance linked to a container DOM element id.
     * 
     * @param {string} containerId The container ID that the widget to be removed is attached to.
     */

  }, {
    key: 'destroyWidget',
    value: function destroyWidget(containerId) {
      var widget = this.widgets[containerId];
      widget.destroy();
      delete this.widgets[containerId];
    }
  }, {
    key: '_gmapPromise',
    value: function _gmapPromise(config) {
      var deferred = _jquery2.default.Deferred(),
          defaults = {};
      _googleMaps2.default.release(function () {
        defaults = {
          LANGUAGE: 'en',
          SENSOR: false,
          LIBRARIES: ['places'],
          VERSION: '3'
        };
        // jQuery extend true parameter makes it a deep extend, which is useful for this.
        _jquery2.default.extend(true, _googleMaps2.default, defaults, config);

        if (_underscore2.default.isEmpty(config.CLIENT) && _underscore2.default.isEmpty(config.KEY)) {
          throw new Error('Google Map loaded without apikey or clientid.');
        }
        //clear before load
        _googleMaps2.default.load(function () {
          deferred.resolve();
        });
      });
      return deferred.promise();
    }
  }]);

  return LetMeMap;
}();

exports.default = LetMeMap;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {

	if (root === null) {
		throw new Error('Google-maps package can be used only in browser');
	}

	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		module.exports = factory();
	} else {
		root.GoogleMapsLoader = factory();
	}

})(typeof window !== 'undefined' ? window : null, function() {


	'use strict';


	var googleVersion = '3.31';

	var script = null;

	var google = null;

	var loading = false;

	var callbacks = [];

	var onLoadEvents = [];

	var originalCreateLoaderMethod = null;


	var GoogleMapsLoader = {};


	GoogleMapsLoader.URL = 'https://maps.googleapis.com/maps/api/js';

	GoogleMapsLoader.KEY = null;

	GoogleMapsLoader.LIBRARIES = [];

	GoogleMapsLoader.CLIENT = null;

	GoogleMapsLoader.CHANNEL = null;

	GoogleMapsLoader.LANGUAGE = null;

	GoogleMapsLoader.REGION = null;

	GoogleMapsLoader.VERSION = googleVersion;

	GoogleMapsLoader.WINDOW_CALLBACK_NAME = '__google_maps_api_provider_initializator__';


	GoogleMapsLoader._googleMockApiObject = {};


	GoogleMapsLoader.load = function(fn) {
		if (google === null) {
			if (loading === true) {
				if (fn) {
					callbacks.push(fn);
				}
			} else {
				loading = true;

				window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] = function() {
					ready(fn);
				};

				GoogleMapsLoader.createLoader();
			}
		} else if (fn) {
			fn(google);
		}
	};


	GoogleMapsLoader.createLoader = function() {
		script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = GoogleMapsLoader.createUrl();

		document.body.appendChild(script);
	};


	GoogleMapsLoader.isLoaded = function() {
		return google !== null;
	};


	GoogleMapsLoader.createUrl = function() {
		var url = GoogleMapsLoader.URL;

		url += '?callback=' + GoogleMapsLoader.WINDOW_CALLBACK_NAME;

		if (GoogleMapsLoader.KEY) {
			url += '&key=' + GoogleMapsLoader.KEY;
		}

		if (GoogleMapsLoader.LIBRARIES.length > 0) {
			url += '&libraries=' + GoogleMapsLoader.LIBRARIES.join(',');
		}

		if (GoogleMapsLoader.CLIENT) {
			url += '&client=' + GoogleMapsLoader.CLIENT;
		}

		if (GoogleMapsLoader.CHANNEL) {
			url += '&channel=' + GoogleMapsLoader.CHANNEL;
		}

		if (GoogleMapsLoader.LANGUAGE) {
			url += '&language=' + GoogleMapsLoader.LANGUAGE;
		}

		if (GoogleMapsLoader.REGION) {
			url += '&region=' + GoogleMapsLoader.REGION;
		}

		if (GoogleMapsLoader.VERSION) {
			url += '&v=' + GoogleMapsLoader.VERSION;
		}

		return url;
	};


	GoogleMapsLoader.release = function(fn) {
		var release = function() {
			GoogleMapsLoader.KEY = null;
			GoogleMapsLoader.LIBRARIES = [];
			GoogleMapsLoader.CLIENT = null;
			GoogleMapsLoader.CHANNEL = null;
			GoogleMapsLoader.LANGUAGE = null;
			GoogleMapsLoader.REGION = null;
			GoogleMapsLoader.VERSION = googleVersion;

			google = null;
			loading = false;
			callbacks = [];
			onLoadEvents = [];

			if (typeof window.google !== 'undefined') {
				delete window.google;
			}

			if (typeof window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] !== 'undefined') {
				delete window[GoogleMapsLoader.WINDOW_CALLBACK_NAME];
			}

			if (originalCreateLoaderMethod !== null) {
				GoogleMapsLoader.createLoader = originalCreateLoaderMethod;
				originalCreateLoaderMethod = null;
			}

			if (script !== null) {
				script.parentElement.removeChild(script);
				script = null;
			}

			if (fn) {
				fn();
			}
		};

		if (loading) {
			GoogleMapsLoader.load(function() {
				release();
			});
		} else {
			release();
		}
	};


	GoogleMapsLoader.onLoad = function(fn) {
		onLoadEvents.push(fn);
	};


	GoogleMapsLoader.makeMock = function() {
		originalCreateLoaderMethod = GoogleMapsLoader.createLoader;

		GoogleMapsLoader.createLoader = function() {
			window.google = GoogleMapsLoader._googleMockApiObject;
			window[GoogleMapsLoader.WINDOW_CALLBACK_NAME]();
		};
	};


	var ready = function(fn) {
		var i;

		loading = false;

		if (google === null) {
			google = window.google;
		}

		for (i = 0; i < onLoadEvents.length; i++) {
			onLoadEvents[i](google);
		}

		if (fn) {
			fn(google);
		}

		for (i = 0; i < callbacks.length; i++) {
			callbacks[i](google);
		}

		callbacks = [];
	};


	return GoogleMapsLoader;

});


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _SecondaryHotelsLayer = __webpack_require__(42);

var _SecondaryHotelsLayer2 = _interopRequireDefault(_SecondaryHotelsLayer);

var _SecondaryHotelsProvider = __webpack_require__(26);

var _SecondaryHotelsProvider2 = _interopRequireDefault(_SecondaryHotelsProvider);

var _ListHotelsProvider = __webpack_require__(28);

var _ListHotelsProvider2 = _interopRequireDefault(_ListHotelsProvider);

var _ListCategoriesProvider = __webpack_require__(44);

var _ListCategoriesProvider2 = _interopRequireDefault(_ListCategoriesProvider);

var _GoogleAutocomplete = __webpack_require__(29);

var _GoogleAutocomplete2 = _interopRequireDefault(_GoogleAutocomplete);

var _Autocomplete = __webpack_require__(19);

var _Autocomplete2 = _interopRequireDefault(_Autocomplete);

var _DirectionsMobileCTA = __webpack_require__(51);

var _DirectionsMobileCTA2 = _interopRequireDefault(_DirectionsMobileCTA);

var _HotelLocation = __webpack_require__(20);

var _HotelLocation2 = _interopRequireDefault(_HotelLocation);

var _hotelSummaryMobilePanel = __webpack_require__(31);

var _hotelSummaryMobilePanel2 = _interopRequireDefault(_hotelSummaryMobilePanel);

var _MessageControl = __webpack_require__(32);

var _MessageControl2 = _interopRequireDefault(_MessageControl);

var _MeliaMainMenu = __webpack_require__(33);

var _MeliaMainMenu2 = _interopRequireDefault(_MeliaMainMenu);

var _MeliaWidget = __webpack_require__(35);

var _MeliaWidget2 = _interopRequireDefault(_MeliaWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MeliaWidget2.default.extend({
	validation: __webpack_require__(241),

	constructor: function constructor(containerId, config, api) {
		_MeliaWidget2.default.prototype.constructor.call(this, containerId, config, api);
	},
	initialize: function initialize() {
		_MeliaWidget2.default.prototype.initialize.call(this);
	},
	onInitialized: function onInitialized() {
		var _this = this;

		_MeliaWidget2.default.prototype.onInitialized.call(this);
		this.initializeBaseLayer();
		this.addComponent(new _MeliaMainMenu2.default({
			identifier: 'main-menu',
			widget: this,
			componentClass: 'melia-main-menu-class',
			classPrefix: '.melia-main-menu-class-',
			position: 'TOP_LEFT',
			visible: true,
			properties: {
				components: {
					MainBox: {
						position: 'main-box-container',
						componentConstructorClass: 'MainBox',
						properties: {
							maxResults: 10
						}
					},
					DirectionsBox: {
						position: 'directions-box-container',
						componentConstructorClass: 'DirectionsBox',
						componentClass: 'directions-box',
						properties: {
							blockHotelInput: true
						}
					},
					JPRouteDetails: {
						position: 'route-details-container',
						componentConstructorClass: 'JPRouteDetails',
						componentClass: 'jp-route-details',
						properties: {}
					}
				}
			}
		}));
		this.addComponent(new _MessageControl2.default({
			identifier: 'message-control' + (this.isMobileVersion ? '-mobile' : ''),
			position: 'TOP_RIGHT',
			widget: this
		}));

		this.addComponent(new _HotelLocation2.default({
			identifier: 'main-menu',
			widget: this,
			componentClass: 'melia-main-menu-class',
			classPrefix: '.melia-main-menu-class-',
			position: 'RIGHT_BOTTOM',
			visible: true,
			properties: {}
		}));

		if (this.isMobileVersion) {
			this.addMobileComponents();
		}

		this.getMainHotelData(this.hotelsJson.mainHotel.id).then(function (hotelData) {
			_this.bus.trigger('UPDATED_HOTEL_SELECTED_DATA', hotelData);
			if (_this.isMobileVersion) {
				_this.addComponent(new _hotelSummaryMobilePanel2.default({
					identifier: 'hotel-summary-panel',
					widget: _this,
					componentClass: 'hotel-summary-panel',
					classPrefix: 'hotel-summary-panel',
					position: 'BOTTOM_CENTER',
					visible: true,
					properties: {
						hotelData: hotelData
					}
				}));
			}
		});
	},
	addMobileComponents: function addMobileComponents() {
		this.addComponent(new _DirectionsMobileCTA2.default({
			identifier: 'directions-mobile-cta',
			widget: this,
			componentClass: 'directions-mobile-cta',
			classPrefix: 'directions-mobile-cta',
			position: 'RIGHT_BOTTOM',
			visible: true
		}));
	},
	registerConfigClasses: function registerConfigClasses(registerComponent, registerLayer, registerLayerProvider) {
		if (this.hotelsJson.alternativeHotelList) {
			registerLayer('SecondaryHotelsLayer', _SecondaryHotelsLayer2.default);
			registerLayerProvider('SecondaryHotelsProvider', _SecondaryHotelsProvider2.default);
		}
		_Autocomplete2.default.registerProviderClass('GPlacesAutocomplete', _GoogleAutocomplete2.default);
		_Autocomplete2.default.registerProviderClass('ListCategoriesProvider', _ListCategoriesProvider2.default);
		_Autocomplete2.default.registerProviderClass('ListHotelsProvider', _ListHotelsProvider2.default);
		registerComponent('MessageControl', _MessageControl2.default);
		registerComponent('MeliaMainMenu', _MeliaMainMenu2.default);
		registerComponent('DirectionsMobileCTA', _DirectionsMobileCTA2.default);
		registerComponent('HotelLocation', _HotelLocation2.default);
		registerComponent('hotelSummaryMobilePanel', _hotelSummaryMobilePanel2.default);
	},
	initializeBaseLayer: function initializeBaseLayer() {
		this.initBaseMapLayer();
		if (this.hotelsJson.alternativeHotelList) {
			this.addLayer(new _SecondaryHotelsLayer2.default({
				widget: this,
				provider: _SecondaryHotelsProvider2.default,
				id: 'SecondaryHotelsLayer',
				iconMarker: {
					default: {
						url: this.hotelsJson.alternativeHotelList.iconMarker
					},
					hover: {
						url: this.hotelsJson.alternativeHotelList.iconMarker
					},
					selected: {
						url: this.hotelsJson.alternativeHotelList.iconMarker
					}
				},
				featureId: 'id',
				minZoom: this.config.minZoom
			}));
		}
		if (this.hotelsJson && this.hotelsJson.mainHotel) {
			var icon = this.createIcon(this.hotelsJson);
			this.addMarkerToLayer('BaseMapLayer', this.hotelsJson.mainHotel, icon);
			var location = new google.maps.LatLng(this.hotelsJson.mainHotel.position.lat, this.hotelsJson.mainHotel.position.lng);
			this.map.setCenter(location);
		}
	}
});

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LayerModel = _backbone2.default.Model.extend(
/**
 * @lends LayerModel */
{
  /**
   * @memberOf module:Layers 
   * @class LayerModel
   * @classdesc A Backbone model for layers. Handle layer properties: active, visible, loading
   * @extends Backbone.Model
   */
  initialize: function initialize() {
    this.bindEvents();
  },

  /**
   * Bind the events to listen
   * @function
   * @fires LayerModel#change:active
   */
  bindEvents: function bindEvents() {
    var _this = this;

    this.on('change:active', function (model) {
      if (model.get('active') === false) {
        _this.set('visible', false);
      }
    });
  },

  /**
   * Change the property 'active' 
   * @function
   */
  toggle: function toggle() {
    this.set('active', !this.get('active'));
  },

  /**
   * Set true the property 'active' 
   * @function
   */
  activate: function activate() {
    this.set('active', true);
  },

  /**
   * Set false the property 'active' 
   * @function
   */
  deactivate: function deactivate() {
    this.set('active', false);
  },
  /**
   * Get the property 'active' 
   * @function
   *  @returns {boolean} If layer is active
   */
  isActive: function isActive() {
    return this.get('active');
  },

  /**
   * Get the property 'visible' 
   * @function
   *  @returns {boolean} If layer is visible
   */
  isVisible: function isVisible() {
    return this.get('visible');
  },

  /**
   * Set false the property 'visible' 
   * @function
   */
  hide: function hide() {
    this.set('visible', false);
  },


  /**
   * Set true the property 'visible' 
   * @function
   */
  show: function show() {
    this.set('visible', true);
  }
});

exports.default = LayerModel;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

(function(GeoJSON) {
  GeoJSON.version = '0.4.1';

  // Allow user to specify default parameters
  GeoJSON.defaults = {};

  // The one and only public function.
  // Converts an array of objects into a GeoJSON feature collection
  GeoJSON.parse = function(objects, params, callback) {

    var geojson,
        settings = applyDefaults(params, this.defaults),
        propFunc;

    geomAttrs.length = 0; // Reset the list of geometry fields
    setGeom(settings);
    propFunc = getPropFunction(settings);

    if (Array.isArray(objects)) {
      geojson = {"type": "FeatureCollection", "features": []};
      objects.forEach(function(item){
        geojson.features.push(getFeature(item, settings, propFunc));
      });
      addOptionals(geojson, settings);
    } else {
      geojson = getFeature(objects, settings, propFunc);
    }

    if (callback && typeof callback === 'function') {
      callback(geojson);
    } else {
      return geojson;
    }
  };

  // Helper functions
  var geoms = ['Point', 'MultiPoint', 'LineString', 'MultiLineString', 'Polygon', 'MultiPolygon', 'GeoJSON'],
      geomAttrs = [];

  // Adds default settings to user-specified params
  // Does not overwrite any settings--only adds defaults
  // the the user did not specify
  function applyDefaults(params, defaults) {
    var settings = params || {};

    for(var setting in defaults) {
      if(defaults.hasOwnProperty(setting) && !settings[setting]) {
        settings[setting] = defaults[setting];
      }
    }

    return settings;
  }

  // Adds the optional GeoJSON properties crs and bbox
  // if they have been specified
  function addOptionals(geojson, settings){
    if(settings.crs && checkCRS(settings.crs)) {
      geojson.crs = settings.crs;
    }
    if (settings.bbox) {
      geojson.bbox = settings.bbox;
    }
    if (settings.extraGlobal) {
      geojson.properties = {};
      for (var key in settings.extraGlobal) {
        geojson.properties[key] = settings.extraGlobal[key];
      }
    }
  }

  // Verify that the structure of CRS object is valid
  function checkCRS(crs) {
    if (crs.type === 'name') {
        if (crs.properties && crs.properties.name) {
            return true;
        } else {
            throw new Error('Invalid CRS. Properties must contain "name" key');
        }
    } else if (crs.type === 'link') {
        if (crs.properties && crs.properties.href && crs.properties.type) {
            return true;
        } else {
            throw new Error('Invalid CRS. Properties must contain "href" and "type" key');
        }
    } else {
        throw new Error('Invald CRS. Type attribute must be "name" or "link"');
    }
  }

  // Moves the user-specified geometry parameters
  // under the `geom` key in param for easier access
  function setGeom(params) {
    params.geom = {};

    for(var param in params) {
      if(params.hasOwnProperty(param) && geoms.indexOf(param) !== -1){
        params.geom[param] = params[param];
        delete params[param];
      }
    }

    setGeomAttrList(params.geom);
  }

  // Adds fields which contain geometry data
  // to geomAttrs. This list is used when adding
  // properties to the features so that no geometry
  // fields are added the properties key
  function setGeomAttrList(params) {
    for(var param in params) {
      if(params.hasOwnProperty(param)) {
        if(typeof params[param] === 'string') {
          geomAttrs.push(params[param]);
        } else if (typeof params[param] === 'object') { // Array of coordinates for Point
          geomAttrs.push(params[param][0]);
          geomAttrs.push(params[param][1]);
        }
      }
    }

    if(geomAttrs.length === 0) { throw new Error('No geometry attributes specified'); }
  }

  // Creates a feature object to be added
  // to the GeoJSON features array
  function getFeature(item, params, propFunc) {
    var feature = { "type": "Feature" };

    feature.geometry = buildGeom(item, params);
    feature.properties = propFunc.call(item);

    return feature;
  }

  // Assembles the `geometry` property
  // for the feature output
  function buildGeom(item, params) {
    var geom = {},
        attr;

    for(var gtype in params.geom) {
      var val = params.geom[gtype];

      // Geometry parameter specified as: {Point: 'coords'}
      if(typeof val === 'string' && item.hasOwnProperty(val)) {
        if(gtype === 'GeoJSON') {
          geom = item[val];
        } else {
          geom.type = gtype;
          geom.coordinates = item[val];
        }
      }

      // Geometry parameter specified as: {Point: ['lat', 'lng']}
      else if(Array.isArray(val) && item.hasOwnProperty(val[0]) && item.hasOwnProperty(val[1])){
        geom.type = gtype;
        geom.coordinates = [Number(item[val[1]]), Number(item[val[0]])];
      }
    }

    return geom;
  }

  // Returns the function to be used to
  // build the properties object for each feature
  function getPropFunction(params) {
    var func;

    if(!params.exclude && !params.include) {
      func = function(properties) {
        for(var attr in this) {
          if(this.hasOwnProperty(attr) && (geomAttrs.indexOf(attr) === -1)) {
            properties[attr] = this[attr];
          }
        }
      };
    } else if(params.include) {
      func = function(properties) {
        params.include.forEach(function(attr){
          properties[attr] = this[attr];
        }, this);
      };
    } else if(params.exclude) {
      func = function(properties) {
        for(var attr in this) {
          if(this.hasOwnProperty(attr) && (geomAttrs.indexOf(attr) === -1) && (params.exclude.indexOf(attr) === -1)) {
            properties[attr] = this[attr];
          }
        }
      };
    }

    return function() {
      var properties = {};

      func.call(this, properties);

      if(params.extra) { addExtra(properties, params.extra); }
      return properties;
    };
  }

  // Adds data contained in the `extra`
  // parameter if it has been specified
  function addExtra(properties, extra) {
    for(var key in extra){
      if(extra.hasOwnProperty(key)) {
        properties[key] = extra[key];
      }
    }

    return properties;
  }

}( true ? module.exports : window.GeoJSON = {}));


/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = {"journeyPlanner.via":"Via","routeLabel.mins":"mins","routeDetails.from":"From","routeDetails.to":"To","routeLabel.noRoute":"Sorry, we could not calculate transit routes for the given directions.","routeLabel.via":"via","routeLabel.message":"These directions are for planning purposes only. You may find that construction projects, traffic, weather, or other events may cause conditions to differ from the map results, and you should plan your route accordingly. You must obey all signs or notices regarding your route.","categories.bar":"Bar","categories.night_club":"Night club","categories.cafe":"Cafe","categories.restaurant":"Restaurant","categories.casino":"Casino","categories.stadium":"Stadium","categories.airport":"Airport","categories.bus_station":"Bus station","categories.subway_station":"Subway station","categories.train_station":"Train station","categories.taxi_stand":"Taxi stand","categories.transit_station":"Transit station","categories.atm":"ATM","categories.car_rental":"Car rental","categories.parking":"Parking","categories.shopping_mall":"Shopping mall","categories.museum":"Museum","categories.church":"Church","categories.city_hall":"City hall","categories.art_gallery":"Art gallery","categories.aquarium":"Aquarium","categories.park":"Park","categories.amusement_park":"Amusement park","categories.zoo":"Zoo","categories.doctor":"Doctor","categories.pharmacy":"Pharmacy","categories.hospital":"Hospital","routeLabel.viewMap":"View Map","routeDetails.details":"Details","hotelDetail.seeMore":"See more","hotelDetail.seeLess":"See less","hotelDetail.offertMelia":"Offert MeliáRewards","hotelDetail.standardPrice":"Standard price","hotelDetail.fromPrice":"From","hotelDetail.night":"night","hotelDetail.successCopy":"Link copied to clipboard","hotelSummary.seeDetails":"See details"}

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = {"journeyPlanner.via":"Via","routeDetails.from":"Desde","routeDetails.to":"hasta","routeLabel.mins":"min","routeLabel.noRoute":"No hemos podido calcular las indicaciones en transporte público para las direcciones introducidas.","routeLabel.via":"por","routeLabel.message":"Estas indicaciones se ofrecen solo a modo de planificación. Es posible que las obras, el tiempo, el tráfico u otros factores hagan variar el estado de las carreteras respecto a los resultados del mapa, por lo que deberías tener en cuenta estos aspectos al planificar la ruta. Debes respetar todas las señales y los avisos relacionados con la ruta.","categories.bar":"Bar","categories.night_club":"Club nocturno","categories.cafe":"Cafetería","categories.restaurant":"Restaurante","categories.casino":"Casino","categories.stadium":"Estadio","categories.airport":"Aeropuerto","categories.bus_station":"Estación de autobuses","categories.subway_station":"Estación de metro","categories.train_station":"Estación de trenes","categories.taxi_stand":"Parada de taxis","categories.transit_station":"Estación de tránsito","categories.atm":"Cajero","categories.car_rental":"Alquiler de coches","categories.parking":"Parking","categories.shopping_mall":"Centro comercial","categories.museum":"Museo","categories.church":"Iglesia","categories.city_hall":"Ayuntamiento","categories.art_gallery":"Galería de arte","categories.aquarium":"Acuario","categories.park":"Parque","categories.amusement_park":"Parque de atracciones","categories.zoo":"Zoo","categories.doctor":"Doctor","categories.pharmacy":"Farmacia","categories.hospital":"Hospital","routeLabel.viewMap":"Ver Mapa","routeDetails.details":"Detalles","hotelDetail.seeMore":"Ver más","hotelDetail.seeLess":"Ver menos","hotelDetail.offertMelia":"OFERTA MeliáRewards","hotelDetail.standardPrice":"Precio estándar","hotelDetail.fromPrice":"Desde","hotelDetail.night":"noche","hotelDetail.successCopy":"Link copiado en el portapapeles","hotelSummary.seeDetails":"Ver detalles"}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _supercluster = __webpack_require__(100);

var _supercluster2 = _interopRequireDefault(_supercluster);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _Utils = __webpack_require__(6);

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultIcon = {
  scale: 15,
  fillOpacity: 1,
  fillColor: 'orange',
  strokeWeight: 0
},
    defaultLabel = {
  color: 'black',
  fontFamily: 'Arial',
  fontSize: '10px',
  fontWeight: 'bold'
},
    POINT_COUNT = 'point_count';

/**  
 * @lends core.helpers.ClusterHelper.prototype
 * @class ClusterHelper 
 * @example <caption>Cluster/caption>
    "options": {
      "radius": 150,
      "maxZoom": 13,
      "minZoom": 0,
      "extend": 512,
      "nodeSize": 64,
      "log": false
    },
    "iconStyles": {
      "url": "cluster_orange.png",
      "anchor": { "x": 17, "y": 17 }
    }
   */

var ClusterHelper = function () {

  /**
   * @param {core.Config.Cluster} options The options of the clusters
   */
  function ClusterHelper(options) {
    _classCallCheck(this, ClusterHelper);

    this.options = options;
    this.widget = options.widget;
    this.createClusterService();
  }

  /**
   * @typedef {object} Cluster 
   * @property {core.Config.SuperClusterOptions} options The type of the layer. Must be APILayer
   * @property {google.maps.Icon} iconStyles To activate the layer by default
   * @memberof core.Config 
   */

  /**
   * @typedef {object} SuperClusterOptions 
   * @property {number} [radius=40] Cluster radius, in pixels.
   * @property {number} [minZoom=0] Minimum zoom level at which clusters are generated.
   * @property {number} [maxZoom=16] Maximum zoom level at which clusters are generated.
   * @property {number} [extent=512] (Tiles) Tile extent. Radius is calculated relative to this value.
   * @property {number} [nodeSize=64] Size of the KD-tree leaf node. Affects performance.
   * @property {boolean} [log=false] Whether timing info should be logged.
   * @memberof core.Config 
   */

  /**
   * Create the cluster service
   */


  _createClass(ClusterHelper, [{
    key: 'createClusterService',
    value: function createClusterService() {
      this.clusterConf = _underscore2.default.isObject(this.options.cluster) ? this.options.cluster : {};
      this.cluster = (0, _supercluster2.default)(this.clusterConf.options);
    }

    /**
     * This method cluster features
     * @param {Feature[]} features 
     * @return Return the features clustered
     */

  }, {
    key: 'clusterFeatures',
    value: function clusterFeatures(features) {
      this.cluster.load(features);
      var bboxJSON = void 0;
      if (this.options.filterByBBox) {
        bboxJSON = this.widget.map.getBounds().toJSON();
      } else {
        bboxJSON = { west: -180, south: -90, east: 180, north: 90 };
      }
      var superclusterBBox = [bboxJSON.west, bboxJSON.south, bboxJSON.east, bboxJSON.north];
      return this.cluster.getClusters(superclusterBBox, this.widget.map.getZoom());
    }

    /**
     * Fit bounds of the features clustered
     * @param {string} clusterId The cluster id
     * @param {number} zoom Zoom the cluster was from
     * @param {object} map The map
     */

  }, {
    key: 'setClusterExpansion',
    value: function setClusterExpansion(clusterId) {
      var features = this.cluster.getLeaves(clusterId, this.widget.map.getZoom(), Infinity);
      var boundingBox = new google.maps.LatLngBounds();
      features.forEach(function (feature) {
        var featurePosition = new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
        boundingBox.extend(featurePosition);
      });
      this.widget.map.fitBounds(boundingBox);
    }

    /**
     * Get the icon of the cluster 
     * @param {Widget} widget The widget
     */

  }, {
    key: 'getIconCluster',
    value: function getIconCluster(widget) {
      if (this.clusterConf.iconStyles) {
        var iconStyles = _underscore2.default.extend({}, this.clusterConf.iconStyles);
        iconStyles.url = _Utils2.default.getImgUrl(this.clusterConf.iconStyles.url, widget);
        return iconStyles;
      } else {
        return _underscore2.default.extend(defaultIcon, {
          path: google.maps.SymbolPath.CIRCLE
        });
      }
    }

    /**
     * Get the label of the cluster
     * @param {number} numFeatures 
     */

  }, {
    key: 'getLabelCluster',
    value: function getLabelCluster(numFeatures) {
      var labelStyles = this.clusterConf.labelStyles ? this.clusterConf.labelStyles : defaultLabel;
      return _underscore2.default.extend(labelStyles, { text: numFeatures.toString() });
    }

    /**
     * Create a unique id of a cluster
     * @param {Feature} feature 
     */

  }, {
    key: 'getClusterId',
    value: function getClusterId(feature) {
      return String(feature.geometry.coordinates[0]) + String(feature.geometry.coordinates[1]) + String(feature.properties[POINT_COUNT]);
    }
  }]);

  return ClusterHelper;
}();

exports.default = ClusterHelper;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var kdbush = __webpack_require__(101);

module.exports = supercluster;

function supercluster(options) {
    return new SuperCluster(options);
}

function SuperCluster(options) {
    this.options = extend(Object.create(this.options), options);
    this.trees = new Array(this.options.maxZoom + 1);
}

SuperCluster.prototype = {
    options: {
        minZoom: 0,   // min zoom to generate clusters on
        maxZoom: 16,  // max zoom level to cluster the points on
        radius: 40,   // cluster radius in pixels
        extent: 512,  // tile extent (radius is calculated relative to it)
        nodeSize: 64, // size of the KD-tree leaf node, affects performance
        log: false,   // whether to log timing info

        // a reduce function for calculating custom cluster properties
        reduce: null, // function (accumulated, props) { accumulated.sum += props.sum; }

        // initial properties of a cluster (before running the reducer)
        initial: function () { return {}; }, // function () { return {sum: 0}; },

        // properties to use for individual points when running the reducer
        map: function (props) { return props; } // function (props) { return {sum: props.my_value}; },
    },

    load: function (points) {
        var log = this.options.log;

        if (log) console.time('total time');

        var timerId = 'prepare ' + points.length + ' points';
        if (log) console.time(timerId);

        this.points = points;

        // generate a cluster object for each point
        var clusters = points.map(createPointCluster);
        if (log) console.timeEnd(timerId);

        // cluster points on max zoom, then cluster the results on previous zoom, etc.;
        // results in a cluster hierarchy across zoom levels
        for (var z = this.options.maxZoom; z >= this.options.minZoom; z--) {
            var now = +Date.now();

            // index input points into a KD-tree
            this.trees[z + 1] = kdbush(clusters, getX, getY, this.options.nodeSize, Float32Array);

            clusters = this._cluster(clusters, z); // create a new set of clusters for the zoom

            if (log) console.log('z%d: %d clusters in %dms', z, clusters.length, +Date.now() - now);
        }

        // index top-level clusters
        this.trees[this.options.minZoom] = kdbush(clusters, getX, getY, this.options.nodeSize, Float32Array);

        if (log) console.timeEnd('total time');

        return this;
    },

    getClusters: function (bbox, zoom) {
        var tree = this.trees[this._limitZoom(zoom)];
        var ids = tree.range(lngX(bbox[0]), latY(bbox[3]), lngX(bbox[2]), latY(bbox[1]));
        var clusters = [];
        for (var i = 0; i < ids.length; i++) {
            var c = tree.points[ids[i]];
            clusters.push(c.numPoints ? getClusterJSON(c) : this.points[c.id]);
        }
        return clusters;
    },

    getChildren: function (clusterId, clusterZoom) {
        var origin = this.trees[clusterZoom + 1].points[clusterId];
        var r = this.options.radius / (this.options.extent * Math.pow(2, clusterZoom));
        var points = this.trees[clusterZoom + 1].within(origin.x, origin.y, r);
        var children = [];
        for (var i = 0; i < points.length; i++) {
            var c = this.trees[clusterZoom + 1].points[points[i]];
            if (c.parentId === clusterId) {
                children.push(c.numPoints ? getClusterJSON(c) : this.points[c.id]);
            }
        }
        return children;
    },

    getLeaves: function (clusterId, clusterZoom, limit, offset) {
        limit = limit || 10;
        offset = offset || 0;

        var leaves = [];
        this._appendLeaves(leaves, clusterId, clusterZoom, limit, offset, 0);

        return leaves;
    },

    getTile: function (z, x, y) {
        var tree = this.trees[this._limitZoom(z)];
        var z2 = Math.pow(2, z);
        var extent = this.options.extent;
        var r = this.options.radius;
        var p = r / extent;
        var top = (y - p) / z2;
        var bottom = (y + 1 + p) / z2;

        var tile = {
            features: []
        };

        this._addTileFeatures(
            tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom),
            tree.points, x, y, z2, tile);

        if (x === 0) {
            this._addTileFeatures(
                tree.range(1 - p / z2, top, 1, bottom),
                tree.points, z2, y, z2, tile);
        }
        if (x === z2 - 1) {
            this._addTileFeatures(
                tree.range(0, top, p / z2, bottom),
                tree.points, -1, y, z2, tile);
        }

        return tile.features.length ? tile : null;
    },

    getClusterExpansionZoom: function (clusterId, clusterZoom) {
        while (clusterZoom < this.options.maxZoom) {
            var children = this.getChildren(clusterId, clusterZoom);
            clusterZoom++;
            if (children.length !== 1) break;
            clusterId = children[0].properties.cluster_id;
        }
        return clusterZoom;
    },

    _appendLeaves: function (result, clusterId, clusterZoom, limit, offset, skipped) {
        var children = this.getChildren(clusterId, clusterZoom);

        for (var i = 0; i < children.length; i++) {
            var props = children[i].properties;

            if (props.cluster) {
                if (skipped + props.point_count <= offset) {
                    // skip the whole cluster
                    skipped += props.point_count;
                } else {
                    // enter the cluster
                    skipped = this._appendLeaves(
                        result, props.cluster_id, clusterZoom + 1, limit, offset, skipped);
                    // exit the cluster
                }
            } else if (skipped < offset) {
                // skip a single point
                skipped++;
            } else {
                // add a single point
                result.push(children[i]);
            }
            if (result.length === limit) break;
        }

        return skipped;
    },

    _addTileFeatures: function (ids, points, x, y, z2, tile) {
        for (var i = 0; i < ids.length; i++) {
            var c = points[ids[i]];
            tile.features.push({
                type: 1,
                geometry: [[
                    Math.round(this.options.extent * (c.x * z2 - x)),
                    Math.round(this.options.extent * (c.y * z2 - y))
                ]],
                tags: c.numPoints ? getClusterProperties(c) : this.points[c.id].properties
            });
        }
    },

    _limitZoom: function (z) {
        return Math.max(this.options.minZoom, Math.min(z, this.options.maxZoom + 1));
    },

    _cluster: function (points, zoom) {
        var clusters = [];
        var r = this.options.radius / (this.options.extent * Math.pow(2, zoom));

        // loop through each point
        for (var i = 0; i < points.length; i++) {
            var p = points[i];
            // if we've already visited the point at this zoom level, skip it
            if (p.zoom <= zoom) continue;
            p.zoom = zoom;

            // find all nearby points
            var tree = this.trees[zoom + 1];
            var neighborIds = tree.within(p.x, p.y, r);

            var numPoints = p.numPoints || 1;
            var wx = p.x * numPoints;
            var wy = p.y * numPoints;

            var clusterProperties = null;

            if (this.options.reduce) {
                clusterProperties = this.options.initial();
                this._accumulate(clusterProperties, p);
            }

            for (var j = 0; j < neighborIds.length; j++) {
                var b = tree.points[neighborIds[j]];
                // filter out neighbors that are too far or already processed
                if (zoom < b.zoom) {
                    var numPoints2 = b.numPoints || 1;
                    b.zoom = zoom; // save the zoom (so it doesn't get processed twice)
                    wx += b.x * numPoints2; // accumulate coordinates for calculating weighted center
                    wy += b.y * numPoints2;
                    numPoints += numPoints2;
                    b.parentId = i;

                    if (this.options.reduce) {
                        this._accumulate(clusterProperties, b);
                    }
                }
            }

            if (numPoints === 1) {
                clusters.push(p);
            } else {
                p.parentId = i;
                clusters.push(createCluster(wx / numPoints, wy / numPoints, numPoints, i, clusterProperties));
            }
        }

        return clusters;
    },

    _accumulate: function (clusterProperties, point) {
        var properties = point.numPoints ?
            point.properties :
            this.options.map(this.points[point.id].properties);

        this.options.reduce(clusterProperties, properties);
    }
};

function createCluster(x, y, numPoints, id, properties) {
    return {
        x: x, // weighted cluster center
        y: y,
        zoom: Infinity, // the last zoom the cluster was processed at
        id: id, // index of the first child of the cluster in the zoom level tree
        properties: properties,
        parentId: -1, // parent cluster id
        numPoints: numPoints
    };
}

function createPointCluster(p, id) {
    var coords = p.geometry.coordinates;
    return {
        x: lngX(coords[0]), // projected point coordinates
        y: latY(coords[1]),
        zoom: Infinity, // the last zoom the point was processed at
        id: id, // index of the source feature in the original input array
        parentId: -1 // parent cluster id
    };
}

function getClusterJSON(cluster) {
    return {
        type: 'Feature',
        properties: getClusterProperties(cluster),
        geometry: {
            type: 'Point',
            coordinates: [xLng(cluster.x), yLat(cluster.y)]
        }
    };
}

function getClusterProperties(cluster) {
    var count = cluster.numPoints;
    var abbrev = count >= 10000 ? Math.round(count / 1000) + 'k' :
                 count >= 1000 ? (Math.round(count / 100) / 10) + 'k' : count;
    return extend(extend({}, cluster.properties), {
        cluster: true,
        cluster_id: cluster.id,
        point_count: count,
        point_count_abbreviated: abbrev
    });
}

// longitude/latitude to spherical mercator in [0..1] range
function lngX(lng) {
    return lng / 360 + 0.5;
}
function latY(lat) {
    var sin = Math.sin(lat * Math.PI / 180),
        y = (0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI);
    return y < 0 ? 0 :
           y > 1 ? 1 : y;
}

// spherical mercator to longitude/latitude
function xLng(x) {
    return (x - 0.5) * 360;
}
function yLat(y) {
    var y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}

function extend(dest, src) {
    for (var id in src) dest[id] = src[id];
    return dest;
}

function getX(p) {
    return p.x;
}
function getY(p) {
    return p.y;
}


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sort = __webpack_require__(102);
var range = __webpack_require__(103);
var within = __webpack_require__(104);

module.exports = kdbush;

function kdbush(points, getX, getY, nodeSize, ArrayType) {
    return new KDBush(points, getX, getY, nodeSize, ArrayType);
}

function KDBush(points, getX, getY, nodeSize, ArrayType) {
    getX = getX || defaultGetX;
    getY = getY || defaultGetY;
    ArrayType = ArrayType || Array;

    this.nodeSize = nodeSize || 64;
    this.points = points;

    this.ids = new ArrayType(points.length);
    this.coords = new ArrayType(points.length * 2);

    for (var i = 0; i < points.length; i++) {
        this.ids[i] = i;
        this.coords[2 * i] = getX(points[i]);
        this.coords[2 * i + 1] = getY(points[i]);
    }

    sort(this.ids, this.coords, this.nodeSize, 0, this.ids.length - 1, 0);
}

KDBush.prototype = {
    range: function (minX, minY, maxX, maxY) {
        return range(this.ids, this.coords, minX, minY, maxX, maxY, this.nodeSize);
    },

    within: function (x, y, r) {
        return within(this.ids, this.coords, x, y, r, this.nodeSize);
    }
};

function defaultGetX(p) { return p[0]; }
function defaultGetY(p) { return p[1]; }


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = sortKD;

function sortKD(ids, coords, nodeSize, left, right, depth) {
    if (right - left <= nodeSize) return;

    var m = Math.floor((left + right) / 2);

    select(ids, coords, m, left, right, depth % 2);

    sortKD(ids, coords, nodeSize, left, m - 1, depth + 1);
    sortKD(ids, coords, nodeSize, m + 1, right, depth + 1);
}

function select(ids, coords, k, left, right, inc) {

    while (right > left) {
        if (right - left > 600) {
            var n = right - left + 1;
            var m = k - left + 1;
            var z = Math.log(n);
            var s = 0.5 * Math.exp(2 * z / 3);
            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            select(ids, coords, k, newLeft, newRight, inc);
        }

        var t = coords[2 * k + inc];
        var i = left;
        var j = right;

        swapItem(ids, coords, left, k);
        if (coords[2 * right + inc] > t) swapItem(ids, coords, left, right);

        while (i < j) {
            swapItem(ids, coords, i, j);
            i++;
            j--;
            while (coords[2 * i + inc] < t) i++;
            while (coords[2 * j + inc] > t) j--;
        }

        if (coords[2 * left + inc] === t) swapItem(ids, coords, left, j);
        else {
            j++;
            swapItem(ids, coords, j, right);
        }

        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}

function swapItem(ids, coords, i, j) {
    swap(ids, i, j);
    swap(coords, 2 * i, 2 * j);
    swap(coords, 2 * i + 1, 2 * j + 1);
}

function swap(arr, i, j) {
    var tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = range;

function range(ids, coords, minX, minY, maxX, maxY, nodeSize) {
    var stack = [0, ids.length - 1, 0];
    var result = [];
    var x, y;

    while (stack.length) {
        var axis = stack.pop();
        var right = stack.pop();
        var left = stack.pop();

        if (right - left <= nodeSize) {
            for (var i = left; i <= right; i++) {
                x = coords[2 * i];
                y = coords[2 * i + 1];
                if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[i]);
            }
            continue;
        }

        var m = Math.floor((left + right) / 2);

        x = coords[2 * m];
        y = coords[2 * m + 1];

        if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[m]);

        var nextAxis = (axis + 1) % 2;

        if (axis === 0 ? minX <= x : minY <= y) {
            stack.push(left);
            stack.push(m - 1);
            stack.push(nextAxis);
        }
        if (axis === 0 ? maxX >= x : maxY >= y) {
            stack.push(m + 1);
            stack.push(right);
            stack.push(nextAxis);
        }
    }

    return result;
}


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = within;

function within(ids, coords, qx, qy, r, nodeSize) {
    var stack = [0, ids.length - 1, 0];
    var result = [];
    var r2 = r * r;

    while (stack.length) {
        var axis = stack.pop();
        var right = stack.pop();
        var left = stack.pop();

        if (right - left <= nodeSize) {
            for (var i = left; i <= right; i++) {
                if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
            }
            continue;
        }

        var m = Math.floor((left + right) / 2);

        var x = coords[2 * m];
        var y = coords[2 * m + 1];

        if (sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);

        var nextAxis = (axis + 1) % 2;

        if (axis === 0 ? qx - r <= x : qy - r <= y) {
            stack.push(left);
            stack.push(m - 1);
            stack.push(nextAxis);
        }
        if (axis === 0 ? qx + r >= x : qy + r >= y) {
            stack.push(m + 1);
            stack.push(right);
            stack.push(nextAxis);
        }
    }

    return result;
}

function sqDist(ax, ay, bx, by) {
    var dx = ax - bx;
    var dy = ay - by;
    return dx * dx + dy * dy;
}


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleAutocomplete = function () {
  /**
   * @class AutocompleteProviderBase
   * @classdesc This is an autocomplete provider base
   * @memberof core.components.autocomplete.providers
   * @abstract
   * @constructs
   * @param {object} conf - The conf provided by json
   * @param {Widget} widget - The widget where the Autocomplete will be built
   */
  function GoogleAutocomplete(conf, widget) {
    _classCallCheck(this, GoogleAutocomplete);

    this.conf = _underscore2.default.extend({
      minLength: 1
    }, conf);
  }
  /**
   * Override this method if we don't want to use the provider in a specific case
   * @memberOf AutocompleteProviderBase
   */


  _createClass(GoogleAutocomplete, [{
    key: 'validate',
    value: function validate() {
      return true;
    }

    /**
     * Method to search the source predictions
     * @abstract
     * @memberOf AutocompleteProviderBase
     * @param {string} text - The text to search in source
     */

  }, {
    key: 'getPredictions',
    value: function getPredictions(text) {
      throw new Error('This method must be implemented');
    }

    /**
     * Set an icon in function of the result
     * @abstract
     * @memberOf AutocompleteProviderBase
     * @param {object} result - The result of search
     */

  }, {
    key: 'getIconClass',
    value: function getIconClass(result) {
      return false;
    }
  }]);

  return GoogleAutocomplete;
}();

exports.default = GoogleAutocomplete;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(126);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _GoogleMapsUtils = __webpack_require__(18);

var _GoogleMapsUtils2 = _interopRequireDefault(_GoogleMapsUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @namespace core.components.autocomplete
 */

var Autocomplete = _ComponentBase2.default.extend(
/**
 * @lends core.components.autocomplete.Autocomplete.prototype
 * @fires Widget#USER_ACTION_TRACKING
 */
{
  componentClass: 'autocomplete',
  template: __webpack_require__(129),

  /**
   * The providers used by the autocomplete
   * @protected
   * @type {core.components.autocomplete.providers.AutocompleteProviderBase[]}
   */
  providers: [],

  /**
   * Initialize the component.
   * @class Autocomplete
   * @classdesc
   * @extends core.components.ComponentBase
   * @memberof core.components.autocomplete
   * @param {Object} options - The config provided by json
   * @example <caption>Autocomplete options</caption>
   * "order": 1,
   * "componentConstructorClass": "Autocomplete",
   * "position": "header",
   * "properties": {
   *         "categorized": false,
   *         "providers": {
   *           "GoogleAutocomplete": {
   *             "icons": ["transit_station", "bus_station", "train_station"],
   *             "minLength": 3,
   *              "maxResults": 5,
   *              "serviceOptions": {
   *               "componentRestrictions": {
   *                 "ref:country:countryRestrictionAutocomplete": "gb"
   *               }
   *             }
   *           }
   *         },
   *         "ref:closeOtherPanels:autocompleteCloseOtherPanels": true,
   *         "ref:selectedMode:autocompleteSelectedMode": "both",
   *         "ref:zoomLevel:autocompleteZoom": 15
   * }
   * @listens {@link Widget#CREATE_POINT_REFERENCE}
   * @listens {@link Widget#CHANGE_POINT_TO_AUTOCOMPLETE}
   */
  initialize: function initialize(options) {
    var _this2 = this;

    this.templateConfig.placeholderText = options.properties.placeholderText || this.widget.polyglot.t('autocomplete.placeholder');
    _ComponentBase2.default.prototype.initialize.call(this, options);
    this.prepareConf();
    this.categorized = _underscore2.default.isUndefined(this.properties.categorized) || this.properties.categorized ? true : false;
    this.autocompleteType = this.categorized ? 'catcomplete' : 'autocomplete';
    this.input = this.$el.find('input');
    this.promisesFinished = 0;
    this.zoomTarget = options.properties.zoomTarget || 13;
    this._initProviders();
    this.autoFocus = options.autoFocus === undefined ? true : false;
    if (this.categorized) {
      this._prepareCategoryAutocomplete();
    } else {
      this._prepareAutocomplete();
    }
    this.resultsPanel = options.resultsPanel || this.$el.find('.results');
    this.errorPanel = options.errorPanel || this.$el.find('.error-search-panel');
    this._initAutoComplete();
    if (this.overridable) {
      this.listenTo(this.bus, 'CREATE_POINT_REFERENCE', function (configPRef) {
        _this2._manageEventCreatePOI(configPRef);
      });
    }
    this.listenTo(this.bus, 'CHANGE_POINT_TO_AUTOCOMPLETE', function () {
      _this2._checkInputEmpty();
    });
  },
  _manageEventCreatePOI: function _manageEventCreatePOI(configPRef) {
    if (configPRef.sender !== this) {
      this._resetAutocomplete();
    }
  },


  events: {
    'click .reset': '_resetAutocomplete',
    'keyup input': '_checkInputEmpty'
  },

  _initProviders: function _initProviders() {
    var _this3 = this;

    var _providers = this.properties.providers;
    if (_providers) {
      _underscore2.default.each(_providers, function (conf, name) {
        _this3.providers.push(new Autocomplete.providerClasses[name](conf, _this3.widget));
      });
    }
  },
  _checkInputEmpty: function _checkInputEmpty() {
    if (!this.input.val()) {
      this._hideResetIcon();
      this.errorPanel.hide();
      this._userActionReset();
    } else {
      this._showResetIcon();
    }
  },
  _getMinKeystroke: function _getMinKeystroke() {
    var min = null;
    _underscore2.default.each(this.providers, function (provider) {
      if (_underscore2.default.isObject(provider._sources)) {
        _underscore2.default.each(provider._sources, function (source) {
          if (min === null || min > source.minLength) {
            min = source.minLength;
          }
        });
      } else {
        if (min === null || min > provider.conf.minLength) {
          min = provider.conf.minLength;
        }
      }
    });
    return min;
  },
  _initAutoComplete: function _initAutoComplete() {
    var _this4 = this;

    this.input[this.autocompleteType]({
      minLength: this._getMinKeystroke(),
      source: function source(request, response) {
        _this4._lookup(request, response);
      },
      appendTo: this.resultsPanel,
      autoFocus: this.autoFocus,
      select: function select(event, ui) {
        _this4._onSelect(ui.item);
      },
      open: function open(event, ui) {
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
          (0, _jquery2.default)('.ui-autocomplete').off('menufocus hover mouseover');
        }
        _this4.onOpen();
      },
      close: function close() {
        _this4.onClose();
      }
    });
    this._calculateMaxHeightAutocomplete();
  },
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  _calculateMaxHeightAutocomplete: function _calculateMaxHeightAutocomplete() {
    //calculate max height in order to autocomplete doesnt overlap the Google logo which is 90px height
    var height = this.widget.$el.find('.lmm-maps-widget-container').height() - 90 + 'px';
    this.resultsPanel.find('ul').css('max-height', height);
  },
  _lookup: function _lookup(request, response) {
    var _this5 = this;

    var promises = [];
    var _this = this;
    this.promisesFinished = 0;

    this.widget.trackUserAction({
      tracking: 'Autocomplete',
      text: request.term
    });

    this.providers.forEach(function (provider) {
      provider.requestIsFinished = false;
      //This condition is true by default, but it could be that in a specific case we don't want to use the provider
      if (provider.validate(request.term)) {
        promises.push(provider.getPredictions(request.term));
      }
    });

    //If we have two or more providers and a provider finishes first
    //then we show results and loading icon in unfinished providers
    _underscore2.default.each(promises, function (promise) {
      promise.then(function (resultData) {
        _this5.promisesFinished++;
        if (_this5.promisesFinished < promises.length) {
          //If only this promise is finished we show results
          var totalResults = [];
          totalResults.push.apply(totalResults, resultData.filter(function (result) {
            return !_underscore2.default.isUndefined(result.code);
          }));
          if (totalResults.length > 0) {
            _this5.errorPanel.hide();
            response(totalResults);
          } else {
            //Response with an empty item to trigger _renderMenu
            response([{}]);
          }
        }
      });
    });

    _jquery2.default.when.apply(_jquery2.default, promises).then(function () {
      var totalResults = [],
          args = arguments || [],
          hasResults = false;

      function filterResults(results, totalResults) {
        totalResults.push.apply(totalResults, results.filter(function (result) {
          return !_underscore2.default.isUndefined(result.code);
        }));
      }

      for (var i = 0; i < args.length; i++) {
        var results = args[i];
        filterResults(results, totalResults);
      }

      if (totalResults.length > 0) {
        if (totalResults.length === 1 && _underscore2.default.isEmpty(totalResults[0])) {
          hasResults = false;
        } else {
          hasResults = true;
        }
      } else {
        hasResults = false;
      }

      if (!hasResults) {
        _this.errorPanel.show();
      } else {
        _this.errorPanel.hide();
      }

      response(totalResults);
    }, function (e) {
      response([]);
    });
  },
  _reloadAutocompleteInput: function _reloadAutocompleteInput() {
    var inputValue = this.input.val();
    this.input.val('');
    this._userActionReset();
    this.input.val(inputValue);
  },
  _onSelect: function _onSelect(item) {
    var _this6 = this;

    this._reloadAutocompleteInput();
    item.coordinates().done(function (coords) {
      var location = null;
      if (coords instanceof google.maps.LatLng) {
        location = coords;
      } else if (!_underscore2.default.isUndefined(coords.viewport)) {
        location = coords.location;
      }
      if (_this6._canMoveMap(location)) {
        _this6._goToLocation(coords);
        _this6._createPReference(location, item);
        _this6._showResetIcon();
        _this6.input.blur();
        _this6.input.trigger('blur');
        _this6.widget.trackUserAction({
          tracking: 'Autocomplete',
          selected: item.value
        });
        /**
         * Event triggered when a result of autcomplete is selected
         * @event Widget#AUTOCOMPLETE_RESULT_SELECTED
         * @param {Autocomplete} autocompleteComponent - The instace of autocomplete
         */
        _this6.bus.trigger('AUTOCOMPLETE_RESULT_SELECTED', item, _this6);
      } else {
        _this6._resetAutocomplete();
        _this6.widget.messageControl.createMessage('error', _this6.widget.polyglot.t('panelTT.outsideBounds'), false, false);
      }
    });
  },
  _canMoveMap: function _canMoveMap(location) {
    return !this.widget.config.defaultView.limitBounds || this.widget.config.defaultView.limitBounds && _GoogleMapsUtils2.default.containPointInBBox(_GoogleMapsUtils2.default.getBounds(this.widget.config.defaultView.bounds), location);
  },
  _resetAutocomplete: function _resetAutocomplete() {
    this._hideResetIcon();
    this.errorPanel.hide();
    this.input.val('');
    this._userActionReset();
  },
  _showResetIcon: function _showResetIcon() {
    this.$el.find('.reset').show();
  },
  _hideResetIcon: function _hideResetIcon() {
    this.$el.find('.reset').hide();
  },
  _userActionReset: function _userActionReset() {
    /**
     * Event triggered when the autocomplete content is deleted
     * @event Widget#RESET_AUTOCOMPLETE
     * @param {core.component.autocomplete.Autocomplete} autocompleteComponent - The instace of autocomplete
     */
    this.bus.trigger('RESET_AUTOCOMPLETE', this);
  },
  _goToLocation: function _goToLocation(coords) {
    if (coords instanceof google.maps.LatLng) {
      this.map.panTo(coords);
      this.map.setZoom(this.zoomTarget);
    } else if (!_underscore2.default.isUndefined(coords.viewport)) {
      this.map.panTo(coords.location);
      this.map.fitBounds(coords.viewport);
    }
  },
  _createPReference: function _createPReference(pos, item) {
    var bus = this.bus;
    var config = {
      position: pos,
      sender: this,
      properties: item
    };
    bus.trigger('CREATE_POINT_REFERENCE', config);
  },
  _prepareCategoryAutocomplete: function _prepareCategoryAutocomplete() {
    _jquery2.default.widget('custom.catcomplete', _jquery2.default.ui.autocomplete, {
      _create: function _create() {
        this._super();
        this.widget().menu('option', 'items', '> :not(.ui-autocomplete-category)');
      },
      _renderItem: function _renderItem(ul, item) {
        var icon = _underscore2.default.isUndefined(item.icon) ? false : item.icon;
        var li = (0, _jquery2.default)('<li></li>');
        if (icon) {
          li.append('<i class="autocomplete-ui-icon ' + icon + '"></i> <span>' + item.label + '</span>');
        } else {
          li.append('<span>' + item.label + '</span>');
        }
        return li.appendTo(ul);
      },
      _renderMenu: function _renderMenu(ul, items) {
        var _this = this,
            currentCategory = '';

        //Loading icon if provider request is not finished
        _underscore2.default.each(_this.providers, function (provider) {
          if (_this.promisesFinished < _this.providers.length && !provider.requestIsFinished) {
            ul.append('<li class="ui-autocomplete-category"><span>' + provider.conf.category + '</span><div class="loading-data categorized"></div></li>');
          }
        });

        _jquery2.default.each(items, function (index, item) {
          var li;
          if (item.category) {
            if (item.category !== currentCategory) {
              ul.append('<li class="ui-autocomplete-category">' + item.category + '</li>');
              currentCategory = item.category;
            }
            li = _this._renderItemData(ul, item);
            if (item.category) {
              li.attr('aria-label', item.category + ' : ' + item.label);
            }
          } else {
            _this._renderItemData(ul, item);
          }
        });
      }
    });
  },
  _prepareAutocomplete: function _prepareAutocomplete() {
    _jquery2.default.widget('custom.autocomplete', _jquery2.default.ui.autocomplete, {
      _create: function _create() {
        this._super();
        this.widget().menu('option', 'items', '> :not(.ui-autocomplete-loading)');
      },
      _renderMenu: function _renderMenu(ul, items) {
        var _this = this,
            renderLoading = false;
        //Loading icon if provider request is not finished
        _underscore2.default.each(_this.providers, function (provider) {
          if (_this.promisesFinished < _this.providers.length && !provider.requestIsFinished) {
            renderLoading = true;
          }
        });
        if (renderLoading) {
          ul.append('<li class="ui-autocomplete-loading"><div class="loading-data uncategorized"></div></li>');
        }
        _jquery2.default.each(items, function (index, item) {
          _this._renderItemData(ul, item);
        });
      },
      _renderItem: function _renderItem(ul, item) {
        var icon = _underscore2.default.isUndefined(item.icon) ? false : item.icon;
        var li = (0, _jquery2.default)('<li class="' + item.type + '"></li>');
        var content = item.content ? item.content : item.label ? '<span>' + item.label + '</span>' : '';
        if (icon) {
          li.append('<i class="autocomplete-ui-icon ' + icon + '"></i>' + content + ' ');
        } else {
          li.append(content);
        }
        return li.appendTo(ul);
      }
    });
  },
  prepareConf: function prepareConf() {
    if (this.properties.icons === false) {
      _underscore2.default.each(this.properties.providers, function (provider) {
        provider.icons = false;
      });
    }
  }
});

/**
 * The provider classes available to Autocomplete instances.
 * @name providerClasses
 * @type {Object<string, function>}
 * @static
 * @protected
 * @memberof core.components.autocomplete.Autocomplete
 */
Autocomplete.providerClasses = {};

/**
 * Registers a provider class so it can be instantiated from configuration. This method must be called
 * when registering the Autocomplete class as component to be used in the Widget's config in the Widget
 * extending class registerConfigClasses method.
 * @name registerProviderClass
 * @function
 * @static
 * @param {string} providerName the name of the registered provider class as will appear in the configuration.
 * @param {function} providerConstructor the class (i.e. its JS constructor) that will be created 
 * when the provierName appears in the config.
 * @memberof core.components.autocomplete.Autocomplete
 * @example <caption>Method use</caption>
 * export default Widget.extend({
 *   ...
 *   registerConfigClasses(registerComponent, registerLayer, registerLayerProvider, registerService) {
 *     ...
 *     AutocompleteComponent.registerProvider('GPlacesAutocomplete', GooglePlacesAutocomplete);
 *     registerComponent('Autocomplete', AutocompleteComponent);
 *     ...
 *   },
 *    ...
 * });  
 */
Autocomplete.registerProviderClass = function (providerName, providerConstructor) {
  Autocomplete.providerClasses[providerName] = providerConstructor;
};

exports.default = Autocomplete;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _handlebarsBase = __webpack_require__(45);

var base = _interopRequireWildcard(_handlebarsBase);

// Each of these augment the Handlebars object. No need to setup here.
// (This is done to easily share code between commonjs and browse envs)

var _handlebarsSafeString = __webpack_require__(119);

var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);

var _handlebarsException = __webpack_require__(15);

var _handlebarsException2 = _interopRequireDefault(_handlebarsException);

var _handlebarsUtils = __webpack_require__(8);

var Utils = _interopRequireWildcard(_handlebarsUtils);

var _handlebarsRuntime = __webpack_require__(120);

var runtime = _interopRequireWildcard(_handlebarsRuntime);

var _handlebarsNoConflict = __webpack_require__(121);

var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

// For compatibility and usage outside of module systems, make the Handlebars object a namespace
function create() {
  var hb = new base.HandlebarsEnvironment();

  Utils.extend(hb, base);
  hb.SafeString = _handlebarsSafeString2['default'];
  hb.Exception = _handlebarsException2['default'];
  hb.Utils = Utils;
  hb.escapeExpression = Utils.escapeExpression;

  hb.VM = runtime;
  hb.template = function (spec) {
    return runtime.template(spec, hb);
  };

  return hb;
}

var inst = create();
inst.create = create;

_handlebarsNoConflict2['default'](inst);

inst['default'] = inst;

exports['default'] = inst;
module.exports = exports['default'];


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.registerDefaultHelpers = registerDefaultHelpers;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _helpersBlockHelperMissing = __webpack_require__(109);

var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);

var _helpersEach = __webpack_require__(110);

var _helpersEach2 = _interopRequireDefault(_helpersEach);

var _helpersHelperMissing = __webpack_require__(111);

var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);

var _helpersIf = __webpack_require__(112);

var _helpersIf2 = _interopRequireDefault(_helpersIf);

var _helpersLog = __webpack_require__(113);

var _helpersLog2 = _interopRequireDefault(_helpersLog);

var _helpersLookup = __webpack_require__(114);

var _helpersLookup2 = _interopRequireDefault(_helpersLookup);

var _helpersWith = __webpack_require__(115);

var _helpersWith2 = _interopRequireDefault(_helpersWith);

function registerDefaultHelpers(instance) {
  _helpersBlockHelperMissing2['default'](instance);
  _helpersEach2['default'](instance);
  _helpersHelperMissing2['default'](instance);
  _helpersIf2['default'](instance);
  _helpersLog2['default'](instance);
  _helpersLookup2['default'](instance);
  _helpersWith2['default'](instance);
}


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(8);

exports['default'] = function (instance) {
  instance.registerHelper('blockHelperMissing', function (context, options) {
    var inverse = options.inverse,
        fn = options.fn;

    if (context === true) {
      return fn(this);
    } else if (context === false || context == null) {
      return inverse(this);
    } else if (_utils.isArray(context)) {
      if (context.length > 0) {
        if (options.ids) {
          options.ids = [options.name];
        }

        return instance.helpers.each(context, options);
      } else {
        return inverse(this);
      }
    } else {
      if (options.data && options.ids) {
        var data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
        options = { data: data };
      }

      return fn(context, options);
    }
  });
};

module.exports = exports['default'];


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(8);

var _exception = __webpack_require__(15);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('each', function (context, options) {
    if (!options) {
      throw new _exception2['default']('Must pass iterator to #each');
    }

    var fn = options.fn,
        inverse = options.inverse,
        i = 0,
        ret = '',
        data = undefined,
        contextPath = undefined;

    if (options.data && options.ids) {
      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
    }

    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    if (options.data) {
      data = _utils.createFrame(options.data);
    }

    function execIteration(field, index, last) {
      if (data) {
        data.key = field;
        data.index = index;
        data.first = index === 0;
        data.last = !!last;

        if (contextPath) {
          data.contextPath = contextPath + field;
        }
      }

      ret = ret + fn(context[field], {
        data: data,
        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
      });
    }

    if (context && typeof context === 'object') {
      if (_utils.isArray(context)) {
        for (var j = context.length; i < j; i++) {
          if (i in context) {
            execIteration(i, i, i === context.length - 1);
          }
        }
      } else {
        var priorKey = undefined;

        for (var key in context) {
          if (context.hasOwnProperty(key)) {
            // We're running the iterations one step out of sync so we can detect
            // the last iteration without have to scan the object twice and create
            // an itermediate keys array.
            if (priorKey !== undefined) {
              execIteration(priorKey, i - 1);
            }
            priorKey = key;
            i++;
          }
        }
        if (priorKey !== undefined) {
          execIteration(priorKey, i - 1, true);
        }
      }
    }

    if (i === 0) {
      ret = inverse(this);
    }

    return ret;
  });
};

module.exports = exports['default'];


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _exception = __webpack_require__(15);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('helperMissing', function () /* [args, ]options */{
    if (arguments.length === 1) {
      // A missing field in a {{foo}} construct.
      return undefined;
    } else {
      // Someone is actually trying to call something, blow up.
      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
    }
  });
};

module.exports = exports['default'];


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(8);

exports['default'] = function (instance) {
  instance.registerHelper('if', function (conditional, options) {
    if (_utils.isFunction(conditional)) {
      conditional = conditional.call(this);
    }

    // Default behavior is to render the positive path if the value is truthy and not empty.
    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  instance.registerHelper('unless', function (conditional, options) {
    return instance.helpers['if'].call(this, conditional, { fn: options.inverse, inverse: options.fn, hash: options.hash });
  });
};

module.exports = exports['default'];


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('log', function () /* message, options */{
    var args = [undefined],
        options = arguments[arguments.length - 1];
    for (var i = 0; i < arguments.length - 1; i++) {
      args.push(arguments[i]);
    }

    var level = 1;
    if (options.hash.level != null) {
      level = options.hash.level;
    } else if (options.data && options.data.level != null) {
      level = options.data.level;
    }
    args[0] = level;

    instance.log.apply(instance, args);
  });
};

module.exports = exports['default'];


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('lookup', function (obj, field) {
    return obj && obj[field];
  });
};

module.exports = exports['default'];


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(8);

exports['default'] = function (instance) {
  instance.registerHelper('with', function (context, options) {
    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    var fn = options.fn;

    if (!_utils.isEmpty(context)) {
      var data = options.data;
      if (options.data && options.ids) {
        data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
      }

      return fn(context, {
        data: data,
        blockParams: _utils.blockParams([context], [data && data.contextPath])
      });
    } else {
      return options.inverse(this);
    }
  });
};

module.exports = exports['default'];


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.registerDefaultDecorators = registerDefaultDecorators;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _decoratorsInline = __webpack_require__(117);

var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);

function registerDefaultDecorators(instance) {
  _decoratorsInline2['default'](instance);
}


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(8);

exports['default'] = function (instance) {
  instance.registerDecorator('inline', function (fn, props, container, options) {
    var ret = fn;
    if (!props.partials) {
      props.partials = {};
      ret = function (context, options) {
        // Create a new partials stack frame prior to exec.
        var original = container.partials;
        container.partials = _utils.extend({}, original, props.partials);
        var ret = fn(context, options);
        container.partials = original;
        return ret;
      };
    }

    props.partials[options.args[0]] = options.fn;

    return ret;
  });
};

module.exports = exports['default'];


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(8);

var logger = {
  methodMap: ['debug', 'info', 'warn', 'error'],
  level: 'info',

  // Maps a given level value to the `methodMap` indexes above.
  lookupLevel: function lookupLevel(level) {
    if (typeof level === 'string') {
      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
      if (levelMap >= 0) {
        level = levelMap;
      } else {
        level = parseInt(level, 10);
      }
    }

    return level;
  },

  // Can be overridden in the host environment
  log: function log(level) {
    level = logger.lookupLevel(level);

    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
      var method = logger.methodMap[level];
      if (!console[method]) {
        // eslint-disable-line no-console
        method = 'log';
      }

      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        message[_key - 1] = arguments[_key];
      }

      console[method].apply(console, message); // eslint-disable-line no-console
    }
  }
};

exports['default'] = logger;
module.exports = exports['default'];


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Build out our basic SafeString type


exports.__esModule = true;
function SafeString(string) {
  this.string = string;
}

SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
  return '' + this.string;
};

exports['default'] = SafeString;
module.exports = exports['default'];


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.checkRevision = checkRevision;
exports.template = template;
exports.wrapProgram = wrapProgram;
exports.resolvePartial = resolvePartial;
exports.invokePartial = invokePartial;
exports.noop = noop;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _utils = __webpack_require__(8);

var Utils = _interopRequireWildcard(_utils);

var _exception = __webpack_require__(15);

var _exception2 = _interopRequireDefault(_exception);

var _base = __webpack_require__(45);

function checkRevision(compilerInfo) {
  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
      currentRevision = _base.COMPILER_REVISION;

  if (compilerRevision !== currentRevision) {
    if (compilerRevision < currentRevision) {
      var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
          compilerVersions = _base.REVISION_CHANGES[compilerRevision];
      throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
    } else {
      // Use the embedded version info since the runtime doesn't know about this revision yet
      throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
    }
  }
}

function template(templateSpec, env) {
  /* istanbul ignore next */
  if (!env) {
    throw new _exception2['default']('No environment passed to template');
  }
  if (!templateSpec || !templateSpec.main) {
    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
  }

  templateSpec.main.decorator = templateSpec.main_d;

  // Note: Using env.VM references rather than local var references throughout this section to allow
  // for external users to override these as psuedo-supported APIs.
  env.VM.checkRevision(templateSpec.compiler);

  function invokePartialWrapper(partial, context, options) {
    if (options.hash) {
      context = Utils.extend({}, context, options.hash);
      if (options.ids) {
        options.ids[0] = true;
      }
    }

    partial = env.VM.resolvePartial.call(this, partial, context, options);
    var result = env.VM.invokePartial.call(this, partial, context, options);

    if (result == null && env.compile) {
      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
      result = options.partials[options.name](context, options);
    }
    if (result != null) {
      if (options.indent) {
        var lines = result.split('\n');
        for (var i = 0, l = lines.length; i < l; i++) {
          if (!lines[i] && i + 1 === l) {
            break;
          }

          lines[i] = options.indent + lines[i];
        }
        result = lines.join('\n');
      }
      return result;
    } else {
      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
    }
  }

  // Just add water
  var container = {
    strict: function strict(obj, name) {
      if (!(name in obj)) {
        throw new _exception2['default']('"' + name + '" not defined in ' + obj);
      }
      return obj[name];
    },
    lookup: function lookup(depths, name) {
      var len = depths.length;
      for (var i = 0; i < len; i++) {
        if (depths[i] && depths[i][name] != null) {
          return depths[i][name];
        }
      }
    },
    lambda: function lambda(current, context) {
      return typeof current === 'function' ? current.call(context) : current;
    },

    escapeExpression: Utils.escapeExpression,
    invokePartial: invokePartialWrapper,

    fn: function fn(i) {
      var ret = templateSpec[i];
      ret.decorator = templateSpec[i + '_d'];
      return ret;
    },

    programs: [],
    program: function program(i, data, declaredBlockParams, blockParams, depths) {
      var programWrapper = this.programs[i],
          fn = this.fn(i);
      if (data || depths || blockParams || declaredBlockParams) {
        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
      } else if (!programWrapper) {
        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
      }
      return programWrapper;
    },

    data: function data(value, depth) {
      while (value && depth--) {
        value = value._parent;
      }
      return value;
    },
    merge: function merge(param, common) {
      var obj = param || common;

      if (param && common && param !== common) {
        obj = Utils.extend({}, common, param);
      }

      return obj;
    },
    // An empty object to use as replacement for null-contexts
    nullContext: Object.seal({}),

    noop: env.VM.noop,
    compilerInfo: templateSpec.compiler
  };

  function ret(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var data = options.data;

    ret._setup(options);
    if (!options.partial && templateSpec.useData) {
      data = initData(context, data);
    }
    var depths = undefined,
        blockParams = templateSpec.useBlockParams ? [] : undefined;
    if (templateSpec.useDepths) {
      if (options.depths) {
        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
      } else {
        depths = [context];
      }
    }

    function main(context /*, options*/) {
      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
    }
    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
    return main(context, options);
  }
  ret.isTop = true;

  ret._setup = function (options) {
    if (!options.partial) {
      container.helpers = container.merge(options.helpers, env.helpers);

      if (templateSpec.usePartial) {
        container.partials = container.merge(options.partials, env.partials);
      }
      if (templateSpec.usePartial || templateSpec.useDecorators) {
        container.decorators = container.merge(options.decorators, env.decorators);
      }
    } else {
      container.helpers = options.helpers;
      container.partials = options.partials;
      container.decorators = options.decorators;
    }
  };

  ret._child = function (i, data, blockParams, depths) {
    if (templateSpec.useBlockParams && !blockParams) {
      throw new _exception2['default']('must pass block params');
    }
    if (templateSpec.useDepths && !depths) {
      throw new _exception2['default']('must pass parent depths');
    }

    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
  };
  return ret;
}

function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
  function prog(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var currentDepths = depths;
    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
      currentDepths = [context].concat(depths);
    }

    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
  }

  prog = executeDecorators(fn, prog, container, depths, data, blockParams);

  prog.program = i;
  prog.depth = depths ? depths.length : 0;
  prog.blockParams = declaredBlockParams || 0;
  return prog;
}

function resolvePartial(partial, context, options) {
  if (!partial) {
    if (options.name === '@partial-block') {
      partial = options.data['partial-block'];
    } else {
      partial = options.partials[options.name];
    }
  } else if (!partial.call && !options.name) {
    // This is a dynamic partial that returned a string
    options.name = partial;
    partial = options.partials[partial];
  }
  return partial;
}

function invokePartial(partial, context, options) {
  // Use the current closure context to save the partial-block if this partial
  var currentPartialBlock = options.data && options.data['partial-block'];
  options.partial = true;
  if (options.ids) {
    options.data.contextPath = options.ids[0] || options.data.contextPath;
  }

  var partialBlock = undefined;
  if (options.fn && options.fn !== noop) {
    (function () {
      options.data = _base.createFrame(options.data);
      // Wrapper function to get access to currentPartialBlock from the closure
      var fn = options.fn;
      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

        // Restore the partial-block from the closure for the execution of the block
        // i.e. the part inside the block of the partial call.
        options.data = _base.createFrame(options.data);
        options.data['partial-block'] = currentPartialBlock;
        return fn(context, options);
      };
      if (fn.partials) {
        options.partials = Utils.extend({}, options.partials, fn.partials);
      }
    })();
  }

  if (partial === undefined && partialBlock) {
    partial = partialBlock;
  }

  if (partial === undefined) {
    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
  } else if (partial instanceof Function) {
    return partial(context, options);
  }
}

function noop() {
  return '';
}

function initData(context, data) {
  if (!data || !('root' in data)) {
    data = data ? _base.createFrame(data) : {};
    data.root = context;
  }
  return data;
}

function executeDecorators(fn, prog, container, depths, data, blockParams) {
  if (fn.decorator) {
    var props = {};
    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
    Utils.extend(prog, props);
  }
  return prog;
}


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* global window */


exports.__esModule = true;

exports['default'] = function (Handlebars) {
  /* istanbul ignore next */
  var root = typeof global !== 'undefined' ? global : window,
      $Handlebars = root.Handlebars;
  /* istanbul ignore next */
  Handlebars.noConflict = function () {
    if (root.Handlebars === Handlebars) {
      root.Handlebars = $Handlebars;
    }
    return Handlebars;
  };
};

module.exports = exports['default'];

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Formats a text to a lmm css className.
 * @memberof core.helpers
 * @param {String} text - The text to format
 */
function formatCssClass(text) {
  var prefix = 'lmm-',
      textLowerCase = [];
  _underscore2.default.each(text.split(/(?=[A-Z])/), function (e) {
    textLowerCase.push(e.toLowerCase());
  });
  return prefix + textLowerCase.join('-');
}

exports.default = formatCssClass;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Gets the browser name and version.
 * @memberof core.helper
 * @returns {object} An object with name and version properties.
 */
function getBrowser() {
  var ua = navigator.userAgent,
      tem,
      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return {
      name: 'IE',
      version: tem[1] || ''
    };
  }
  if (/Edge\/\d./i.test(ua)) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return {
      name: 'Edge',
      version: tem[1] || ''
    };
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\bOPR\/(\d+)/);
    if (tem !== null) {
      return {
        name: 'Opera',
        version: tem[1]
      };
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
    M.splice(1, 1, tem[1]);
  }
  return {
    name: M[0],
    version: M[1]
  };
}

exports.default = getBrowser;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function localize_en(errors) {
  if (!(errors && errors.length)) return;
  for (var i = 0; i < errors.length; i++) {
    var e = errors[i];
    var out;
    switch (e.keyword) {
      case '$ref':
        out = 'can\\\'t resolve reference ' + (e.params.ref);
        break;
      case 'additionalItems':
        out = '';
        var n = e.params.limit;
        out += 'should not have more than ' + (n) + ' item';
        if (n != 1) {
          out += 's';
        }
        break;
      case 'additionalProperties':
        out = 'should not have additional properties';
        break;
      case 'anyOf':
        out = 'should match some schema in "anyOf"';
        break;
      case 'const':
        out = 'should be equal to constant';
        break;
      case 'constant':
        out = 'should be equal to constant';
        break;
      case 'contains':
        out = 'should contain a valid item';
        break;
      case 'custom':
        out = 'should pass "' + (e.keyword) + '" keyword validation';
        break;
      case 'dependencies':
        out = '';
        var n = e.params.depsCount;
        out += 'should have propert';
        if (n == 1) {
          out += 'y';
        } else {
          out += 'ies';
        }
        out += ' ' + (e.params.deps) + ' when property ' + (e.params.property) + ' is present';
        break;
      case 'enum':
        out = 'should be equal to one of predefined values';
        break;
      case 'exclusiveMaximum':
        out = '';
        var cond = e.params.comparison + " " + e.params.limit;
        out += 'should be ' + (cond);
        break;
      case 'exclusiveMinimum':
        out = '';
        var cond = e.params.comparison + " " + e.params.limit;
        out += 'should be ' + (cond);
        break;
      case 'false schema':
        out = 'boolean schema is false';
        break;
      case 'format':
        out = 'should match format "' + (e.params.format) + '"';
        break;
      case 'formatExclusiveMaximum':
        out = 'formatExclusiveMaximum should be boolean';
        break;
      case 'formatExclusiveMinimum':
        out = 'formatExclusiveMinimum should be boolean';
        break;
      case 'formatMaximum':
        out = '';
        var cond = e.params.comparison + " " + e.params.limit;
        out += 'should be ' + (cond);
        break;
      case 'formatMinimum':
        out = '';
        var cond = e.params.comparison + " " + e.params.limit;
        out += 'should be ' + (cond);
        break;
      case 'maximum':
        out = '';
        var cond = e.params.comparison + " " + e.params.limit;
        out += 'should be ' + (cond);
        break;
      case 'maxItems':
        out = '';
        var n = e.params.limit;
        out += 'should not have more than ' + (n) + ' item';
        if (n != 1) {
          out += 's';
        }
        break;
      case 'maxLength':
        out = '';
        var n = e.params.limit;
        out += 'should not be longer than ' + (n) + ' character';
        if (n != 1) {
          out += 's';
        }
        break;
      case 'maxProperties':
        out = '';
        var n = e.params.limit;
        out += 'should not have more than ' + (n) + ' propert';
        if (n == 1) {
          out += 'y';
        } else {
          out += 'ies';
        }
        break;
      case 'minimum':
        out = '';
        var cond = e.params.comparison + " " + e.params.limit;
        out += 'should be ' + (cond);
        break;
      case 'minItems':
        out = '';
        var n = e.params.limit;
        out += 'should not have less than ' + (n) + ' item';
        if (n != 1) {
          out += 's';
        }
        break;
      case 'minLength':
        out = '';
        var n = e.params.limit;
        out += 'should not be shorter than ' + (n) + ' character';
        if (n != 1) {
          out += 's';
        }
        break;
      case 'minProperties':
        out = '';
        var n = e.params.limit;
        out += 'should not have less than ' + (n) + ' propert';
        if (n == 1) {
          out += 'y';
        } else {
          out += 'ies';
        }
        break;
      case 'multipleOf':
        out = 'should be a multiple of ' + (e.params.multipleOf);
        break;
      case 'not':
        out = 'should not be valid according to schema in "not"';
        break;
      case 'oneOf':
        out = 'should match exactly one schema in "oneOf"';
        break;
      case 'pattern':
        out = 'should match pattern "' + (e.params.pattern) + '"';
        break;
      case 'patternGroups':
        out = '';
        var n = e.params.limit;
        out += 'should have ' + (e.params.reason) + ' ' + (n) + ' propert';
        if (n == 1) {
          out += 'y';
        } else {
          out += 'ies';
        }
        out += ' matching pattern "' + (e.params.pattern) + '"';
        break;
      case 'patternRequired':
        out = 'should have property matching pattern "' + (e.params.missingPattern) + '"';
        break;
      case 'propertyNames':
        out = 'property name \'' + (e.params.propertyName) + '\' is invalid';
        break;
      case 'required':
        out = 'should have required property ' + (e.params.missingProperty);
        break;
      case 'switch':
        out = 'should pass "switch" keyword validation, case ' + (e.params.caseIndex) + ' fails';
        break;
      case 'type':
        out = 'should be ' + (e.params.type);
        break;
      case 'uniqueItems':
        out = 'should not have duplicate items (items ## ' + (e.params.j) + ' and ' + (e.params.i) + ' are identical)';
        break;
      default:
        continue;
    }
    e.message = out;
  }
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(0).then((function(require) {
		cb(__webpack_require__(247));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Autocomplete 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Autocomplete
//>>group: Widgets
//>>description: Lists suggested words as the user is typing.
//>>docs: http://api.jqueryui.com/autocomplete/
//>>demos: http://jqueryui.com/autocomplete/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/autocomplete.css
//>>css.theme: ../../themes/base/theme.css

( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(0),
			__webpack_require__(127),
			__webpack_require__(47),
			__webpack_require__(48),
			__webpack_require__(49),
			__webpack_require__(12),
			__webpack_require__(50)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}( function( $ ) {

$.widget( "ui.autocomplete", {
	version: "1.12.1",
	defaultElement: "<input>",
	options: {
		appendTo: null,
		autoFocus: false,
		delay: 300,
		minLength: 1,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		source: null,

		// Callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		response: null,
		search: null,
		select: null
	},

	requestIndex: 0,
	pending: 0,

	_create: function() {

		// Some browsers only repeat keydown events, not keypress events,
		// so we use the suppressKeyPress flag to determine if we've already
		// handled the keydown event. #7269
		// Unfortunately the code for & in keypress is the same as the up arrow,
		// so we use the suppressKeyPressRepeat flag to avoid handling keypress
		// events when we know the keydown event was used to modify the
		// search term. #7799
		var suppressKeyPress, suppressKeyPressRepeat, suppressInput,
			nodeName = this.element[ 0 ].nodeName.toLowerCase(),
			isTextarea = nodeName === "textarea",
			isInput = nodeName === "input";

		// Textareas are always multi-line
		// Inputs are always single-line, even if inside a contentEditable element
		// IE also treats inputs as contentEditable
		// All other element types are determined by whether or not they're contentEditable
		this.isMultiLine = isTextarea || !isInput && this._isContentEditable( this.element );

		this.valueMethod = this.element[ isTextarea || isInput ? "val" : "text" ];
		this.isNewMenu = true;

		this._addClass( "ui-autocomplete-input" );
		this.element.attr( "autocomplete", "off" );

		this._on( this.element, {
			keydown: function( event ) {
				if ( this.element.prop( "readOnly" ) ) {
					suppressKeyPress = true;
					suppressInput = true;
					suppressKeyPressRepeat = true;
					return;
				}

				suppressKeyPress = false;
				suppressInput = false;
				suppressKeyPressRepeat = false;
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					suppressKeyPress = true;
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					suppressKeyPress = true;
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					suppressKeyPress = true;
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					suppressKeyPress = true;
					this._keyEvent( "next", event );
					break;
				case keyCode.ENTER:

					// when menu is open and has focus
					if ( this.menu.active ) {

						// #6055 - Opera still allows the keypress to occur
						// which causes forms to submit
						suppressKeyPress = true;
						event.preventDefault();
						this.menu.select( event );
					}
					break;
				case keyCode.TAB:
					if ( this.menu.active ) {
						this.menu.select( event );
					}
					break;
				case keyCode.ESCAPE:
					if ( this.menu.element.is( ":visible" ) ) {
						if ( !this.isMultiLine ) {
							this._value( this.term );
						}
						this.close( event );

						// Different browsers have different default behavior for escape
						// Single press can mean undo or clear
						// Double press in IE means clear the whole form
						event.preventDefault();
					}
					break;
				default:
					suppressKeyPressRepeat = true;

					// search timeout should be triggered before the input value is changed
					this._searchTimeout( event );
					break;
				}
			},
			keypress: function( event ) {
				if ( suppressKeyPress ) {
					suppressKeyPress = false;
					if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
						event.preventDefault();
					}
					return;
				}
				if ( suppressKeyPressRepeat ) {
					return;
				}

				// Replicate some key handlers to allow them to repeat in Firefox and Opera
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					this._keyEvent( "next", event );
					break;
				}
			},
			input: function( event ) {
				if ( suppressInput ) {
					suppressInput = false;
					event.preventDefault();
					return;
				}
				this._searchTimeout( event );
			},
			focus: function() {
				this.selectedItem = null;
				this.previous = this._value();
			},
			blur: function( event ) {
				if ( this.cancelBlur ) {
					delete this.cancelBlur;
					return;
				}

				clearTimeout( this.searching );
				this.close( event );
				this._change( event );
			}
		} );

		this._initSource();
		this.menu = $( "<ul>" )
			.appendTo( this._appendTo() )
			.menu( {

				// disable ARIA support, the live region takes care of that
				role: null
			} )
			.hide()
			.menu( "instance" );

		this._addClass( this.menu.element, "ui-autocomplete", "ui-front" );
		this._on( this.menu.element, {
			mousedown: function( event ) {

				// prevent moving focus out of the text field
				event.preventDefault();

				// IE doesn't prevent moving focus even with event.preventDefault()
				// so we set a flag to know when we should ignore the blur event
				this.cancelBlur = true;
				this._delay( function() {
					delete this.cancelBlur;

					// Support: IE 8 only
					// Right clicking a menu item or selecting text from the menu items will
					// result in focus moving out of the input. However, we've already received
					// and ignored the blur event because of the cancelBlur flag set above. So
					// we restore focus to ensure that the menu closes properly based on the user's
					// next actions.
					if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
						this.element.trigger( "focus" );
					}
				} );
			},
			menufocus: function( event, ui ) {
				var label, item;

				// support: Firefox
				// Prevent accidental activation of menu items in Firefox (#7024 #9118)
				if ( this.isNewMenu ) {
					this.isNewMenu = false;
					if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
						this.menu.blur();

						this.document.one( "mousemove", function() {
							$( event.target ).trigger( event.originalEvent );
						} );

						return;
					}
				}

				item = ui.item.data( "ui-autocomplete-item" );
				if ( false !== this._trigger( "focus", event, { item: item } ) ) {

					// use value to match what will end up in the input, if it was a key event
					if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
						this._value( item.value );
					}
				}

				// Announce the value in the liveRegion
				label = ui.item.attr( "aria-label" ) || item.value;
				if ( label && $.trim( label ).length ) {
					this.liveRegion.children().hide();
					$( "<div>" ).text( label ).appendTo( this.liveRegion );
				}
			},
			menuselect: function( event, ui ) {
				var item = ui.item.data( "ui-autocomplete-item" ),
					previous = this.previous;

				// Only trigger when focus was lost (click on menu)
				if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
					this.element.trigger( "focus" );
					this.previous = previous;

					// #6109 - IE triggers two focus events and the second
					// is asynchronous, so we need to reset the previous
					// term synchronously and asynchronously :-(
					this._delay( function() {
						this.previous = previous;
						this.selectedItem = item;
					} );
				}

				if ( false !== this._trigger( "select", event, { item: item } ) ) {
					this._value( item.value );
				}

				// reset the term after the select event
				// this allows custom select handling to work properly
				this.term = this._value();

				this.close( event );
				this.selectedItem = item;
			}
		} );

		this.liveRegion = $( "<div>", {
			role: "status",
			"aria-live": "assertive",
			"aria-relevant": "additions"
		} )
			.appendTo( this.document[ 0 ].body );

		this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );

		// Turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		} );
	},

	_destroy: function() {
		clearTimeout( this.searching );
		this.element.removeAttr( "autocomplete" );
		this.menu.element.remove();
		this.liveRegion.remove();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "source" ) {
			this._initSource();
		}
		if ( key === "appendTo" ) {
			this.menu.element.appendTo( this._appendTo() );
		}
		if ( key === "disabled" && value && this.xhr ) {
			this.xhr.abort();
		}
	},

	_isEventTargetInWidget: function( event ) {
		var menuElement = this.menu.element[ 0 ];

		return event.target === this.element[ 0 ] ||
			event.target === menuElement ||
			$.contains( menuElement, event.target );
	},

	_closeOnClickOutside: function( event ) {
		if ( !this._isEventTargetInWidget( event ) ) {
			this.close();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element || !element[ 0 ] ) {
			element = this.element.closest( ".ui-front, dialog" );
		}

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_initSource: function() {
		var array, url,
			that = this;
		if ( $.isArray( this.options.source ) ) {
			array = this.options.source;
			this.source = function( request, response ) {
				response( $.ui.autocomplete.filter( array, request.term ) );
			};
		} else if ( typeof this.options.source === "string" ) {
			url = this.options.source;
			this.source = function( request, response ) {
				if ( that.xhr ) {
					that.xhr.abort();
				}
				that.xhr = $.ajax( {
					url: url,
					data: request,
					dataType: "json",
					success: function( data ) {
						response( data );
					},
					error: function() {
						response( [] );
					}
				} );
			};
		} else {
			this.source = this.options.source;
		}
	},

	_searchTimeout: function( event ) {
		clearTimeout( this.searching );
		this.searching = this._delay( function() {

			// Search if the value has changed, or if the user retypes the same value (see #7434)
			var equalValues = this.term === this._value(),
				menuVisible = this.menu.element.is( ":visible" ),
				modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;

			if ( !equalValues || ( equalValues && !menuVisible && !modifierKey ) ) {
				this.selectedItem = null;
				this.search( null, event );
			}
		}, this.options.delay );
	},

	search: function( value, event ) {
		value = value != null ? value : this._value();

		// Always save the actual value, not the one passed as an argument
		this.term = this._value();

		if ( value.length < this.options.minLength ) {
			return this.close( event );
		}

		if ( this._trigger( "search", event ) === false ) {
			return;
		}

		return this._search( value );
	},

	_search: function( value ) {
		this.pending++;
		this._addClass( "ui-autocomplete-loading" );
		this.cancelSearch = false;

		this.source( { term: value }, this._response() );
	},

	_response: function() {
		var index = ++this.requestIndex;

		return $.proxy( function( content ) {
			if ( index === this.requestIndex ) {
				this.__response( content );
			}

			this.pending--;
			if ( !this.pending ) {
				this._removeClass( "ui-autocomplete-loading" );
			}
		}, this );
	},

	__response: function( content ) {
		if ( content ) {
			content = this._normalize( content );
		}
		this._trigger( "response", null, { content: content } );
		if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
			this._suggest( content );
			this._trigger( "open" );
		} else {

			// use ._close() instead of .close() so we don't cancel future searches
			this._close();
		}
	},

	close: function( event ) {
		this.cancelSearch = true;
		this._close( event );
	},

	_close: function( event ) {

		// Remove the handler that closes the menu on outside clicks
		this._off( this.document, "mousedown" );

		if ( this.menu.element.is( ":visible" ) ) {
			this.menu.element.hide();
			this.menu.blur();
			this.isNewMenu = true;
			this._trigger( "close", event );
		}
	},

	_change: function( event ) {
		if ( this.previous !== this._value() ) {
			this._trigger( "change", event, { item: this.selectedItem } );
		}
	},

	_normalize: function( items ) {

		// assume all items have the right format when the first item is complete
		if ( items.length && items[ 0 ].label && items[ 0 ].value ) {
			return items;
		}
		return $.map( items, function( item ) {
			if ( typeof item === "string" ) {
				return {
					label: item,
					value: item
				};
			}
			return $.extend( {}, item, {
				label: item.label || item.value,
				value: item.value || item.label
			} );
		} );
	},

	_suggest: function( items ) {
		var ul = this.menu.element.empty();
		this._renderMenu( ul, items );
		this.isNewMenu = true;
		this.menu.refresh();

		// Size and position menu
		ul.show();
		this._resizeMenu();
		ul.position( $.extend( {
			of: this.element
		}, this.options.position ) );

		if ( this.options.autoFocus ) {
			this.menu.next();
		}

		// Listen for interactions outside of the widget (#6642)
		this._on( this.document, {
			mousedown: "_closeOnClickOutside"
		} );
	},

	_resizeMenu: function() {
		var ul = this.menu.element;
		ul.outerWidth( Math.max(

			// Firefox wraps long text (possibly a rounding bug)
			// so we add 1px to avoid the wrapping (#7513)
			ul.width( "" ).outerWidth() + 1,
			this.element.outerWidth()
		) );
	},

	_renderMenu: function( ul, items ) {
		var that = this;
		$.each( items, function( index, item ) {
			that._renderItemData( ul, item );
		} );
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
	},

	_renderItem: function( ul, item ) {
		return $( "<li>" )
			.append( $( "<div>" ).text( item.label ) )
			.appendTo( ul );
	},

	_move: function( direction, event ) {
		if ( !this.menu.element.is( ":visible" ) ) {
			this.search( null, event );
			return;
		}
		if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
				this.menu.isLastItem() && /^next/.test( direction ) ) {

			if ( !this.isMultiLine ) {
				this._value( this.term );
			}

			this.menu.blur();
			return;
		}
		this.menu[ direction ]( event );
	},

	widget: function() {
		return this.menu.element;
	},

	_value: function() {
		return this.valueMethod.apply( this.element, arguments );
	},

	_keyEvent: function( keyEvent, event ) {
		if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
			this._move( keyEvent, event );

			// Prevents moving cursor to beginning/end of the text field in some browsers
			event.preventDefault();
		}
	},

	// Support: Chrome <=50
	// We should be able to just use this.element.prop( "isContentEditable" )
	// but hidden elements always report false in Chrome.
	// https://code.google.com/p/chromium/issues/detail?id=313082
	_isContentEditable: function( element ) {
		if ( !element.length ) {
			return false;
		}

		var editable = element.prop( "contentEditable" );

		if ( editable === "inherit" ) {
		  return this._isContentEditable( element.parent() );
		}

		return editable === "true";
	}
} );

$.extend( $.ui.autocomplete, {
	escapeRegex: function( value ) {
		return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
	},
	filter: function( array, term ) {
		var matcher = new RegExp( $.ui.autocomplete.escapeRegex( term ), "i" );
		return $.grep( array, function( value ) {
			return matcher.test( value.label || value.value || value );
		} );
	}
} );

// Live region extension, adding a `messages` option
// NOTE: This is an experimental API. We are still investigating
// a full solution for string manipulation and internationalization.
$.widget( "ui.autocomplete", $.ui.autocomplete, {
	options: {
		messages: {
			noResults: "No search results.",
			results: function( amount ) {
				return amount + ( amount > 1 ? " results are" : " result is" ) +
					" available, use up and down arrow keys to navigate.";
			}
		}
	},

	__response: function( content ) {
		var message;
		this._superApply( arguments );
		if ( this.options.disabled || this.cancelSearch ) {
			return;
		}
		if ( content && content.length ) {
			message = this.options.messages.results( content.length );
		} else {
			message = this.options.messages.noResults;
		}
		this.liveRegion.children().hide();
		$( "<div>" ).text( message ).appendTo( this.liveRegion );
	}
} );

return $.ui.autocomplete;

} ) );


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Menu 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Menu
//>>group: Widgets
//>>description: Creates nestable menus.
//>>docs: http://api.jqueryui.com/menu/
//>>demos: http://jqueryui.com/menu/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/menu.css
//>>css.theme: ../../themes/base/theme.css

( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(0),
			__webpack_require__(47),
			__webpack_require__(48),
			__webpack_require__(49),
			__webpack_require__(128),
			__webpack_require__(12),
			__webpack_require__(50)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}( function( $ ) {

return $.widget( "ui.menu", {
	version: "1.12.1",
	defaultElement: "<ul>",
	delay: 300,
	options: {
		icons: {
			submenu: "ui-icon-caret-1-e"
		},
		items: "> *",
		menus: "ul",
		position: {
			my: "left top",
			at: "right top"
		},
		role: "menu",

		// Callbacks
		blur: null,
		focus: null,
		select: null
	},

	_create: function() {
		this.activeMenu = this.element;

		// Flag used to prevent firing of the click handler
		// as the event bubbles up through nested menus
		this.mouseHandled = false;
		this.element
			.uniqueId()
			.attr( {
				role: this.options.role,
				tabIndex: 0
			} );

		this._addClass( "ui-menu", "ui-widget ui-widget-content" );
		this._on( {

			// Prevent focus from sticking to links inside menu after clicking
			// them (focus should always stay on UL during navigation).
			"mousedown .ui-menu-item": function( event ) {
				event.preventDefault();
			},
			"click .ui-menu-item": function( event ) {
				var target = $( event.target );
				var active = $( $.ui.safeActiveElement( this.document[ 0 ] ) );
				if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
					this.select( event );

					// Only set the mouseHandled flag if the event will bubble, see #9469.
					if ( !event.isPropagationStopped() ) {
						this.mouseHandled = true;
					}

					// Open submenu on click
					if ( target.has( ".ui-menu" ).length ) {
						this.expand( event );
					} else if ( !this.element.is( ":focus" ) &&
							active.closest( ".ui-menu" ).length ) {

						// Redirect focus to the menu
						this.element.trigger( "focus", [ true ] );

						// If the active item is on the top level, let it stay active.
						// Otherwise, blur the active item since it is no longer visible.
						if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
							clearTimeout( this.timer );
						}
					}
				}
			},
			"mouseenter .ui-menu-item": function( event ) {

				// Ignore mouse events while typeahead is active, see #10458.
				// Prevents focusing the wrong item when typeahead causes a scroll while the mouse
				// is over an item in the menu
				if ( this.previousFilter ) {
					return;
				}

				var actualTarget = $( event.target ).closest( ".ui-menu-item" ),
					target = $( event.currentTarget );

				// Ignore bubbled events on parent items, see #11641
				if ( actualTarget[ 0 ] !== target[ 0 ] ) {
					return;
				}

				// Remove ui-state-active class from siblings of the newly focused menu item
				// to avoid a jump caused by adjacent elements both having a class with a border
				this._removeClass( target.siblings().children( ".ui-state-active" ),
					null, "ui-state-active" );
				this.focus( event, target );
			},
			mouseleave: "collapseAll",
			"mouseleave .ui-menu": "collapseAll",
			focus: function( event, keepActiveItem ) {

				// If there's already an active item, keep it active
				// If not, activate the first item
				var item = this.active || this.element.find( this.options.items ).eq( 0 );

				if ( !keepActiveItem ) {
					this.focus( event, item );
				}
			},
			blur: function( event ) {
				this._delay( function() {
					var notContained = !$.contains(
						this.element[ 0 ],
						$.ui.safeActiveElement( this.document[ 0 ] )
					);
					if ( notContained ) {
						this.collapseAll( event );
					}
				} );
			},
			keydown: "_keydown"
		} );

		this.refresh();

		// Clicks outside of a menu collapse any open menus
		this._on( this.document, {
			click: function( event ) {
				if ( this._closeOnDocumentClick( event ) ) {
					this.collapseAll( event );
				}

				// Reset the mouseHandled flag
				this.mouseHandled = false;
			}
		} );
	},

	_destroy: function() {
		var items = this.element.find( ".ui-menu-item" )
				.removeAttr( "role aria-disabled" ),
			submenus = items.children( ".ui-menu-item-wrapper" )
				.removeUniqueId()
				.removeAttr( "tabIndex role aria-haspopup" );

		// Destroy (sub)menus
		this.element
			.removeAttr( "aria-activedescendant" )
			.find( ".ui-menu" ).addBack()
				.removeAttr( "role aria-labelledby aria-expanded aria-hidden aria-disabled " +
					"tabIndex" )
				.removeUniqueId()
				.show();

		submenus.children().each( function() {
			var elem = $( this );
			if ( elem.data( "ui-menu-submenu-caret" ) ) {
				elem.remove();
			}
		} );
	},

	_keydown: function( event ) {
		var match, prev, character, skip,
			preventDefault = true;

		switch ( event.keyCode ) {
		case $.ui.keyCode.PAGE_UP:
			this.previousPage( event );
			break;
		case $.ui.keyCode.PAGE_DOWN:
			this.nextPage( event );
			break;
		case $.ui.keyCode.HOME:
			this._move( "first", "first", event );
			break;
		case $.ui.keyCode.END:
			this._move( "last", "last", event );
			break;
		case $.ui.keyCode.UP:
			this.previous( event );
			break;
		case $.ui.keyCode.DOWN:
			this.next( event );
			break;
		case $.ui.keyCode.LEFT:
			this.collapse( event );
			break;
		case $.ui.keyCode.RIGHT:
			if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
				this.expand( event );
			}
			break;
		case $.ui.keyCode.ENTER:
		case $.ui.keyCode.SPACE:
			this._activate( event );
			break;
		case $.ui.keyCode.ESCAPE:
			this.collapse( event );
			break;
		default:
			preventDefault = false;
			prev = this.previousFilter || "";
			skip = false;

			// Support number pad values
			character = event.keyCode >= 96 && event.keyCode <= 105 ?
				( event.keyCode - 96 ).toString() : String.fromCharCode( event.keyCode );

			clearTimeout( this.filterTimer );

			if ( character === prev ) {
				skip = true;
			} else {
				character = prev + character;
			}

			match = this._filterMenuItems( character );
			match = skip && match.index( this.active.next() ) !== -1 ?
				this.active.nextAll( ".ui-menu-item" ) :
				match;

			// If no matches on the current filter, reset to the last character pressed
			// to move down the menu to the first item that starts with that character
			if ( !match.length ) {
				character = String.fromCharCode( event.keyCode );
				match = this._filterMenuItems( character );
			}

			if ( match.length ) {
				this.focus( event, match );
				this.previousFilter = character;
				this.filterTimer = this._delay( function() {
					delete this.previousFilter;
				}, 1000 );
			} else {
				delete this.previousFilter;
			}
		}

		if ( preventDefault ) {
			event.preventDefault();
		}
	},

	_activate: function( event ) {
		if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
			if ( this.active.children( "[aria-haspopup='true']" ).length ) {
				this.expand( event );
			} else {
				this.select( event );
			}
		}
	},

	refresh: function() {
		var menus, items, newSubmenus, newItems, newWrappers,
			that = this,
			icon = this.options.icons.submenu,
			submenus = this.element.find( this.options.menus );

		this._toggleClass( "ui-menu-icons", null, !!this.element.find( ".ui-icon" ).length );

		// Initialize nested menus
		newSubmenus = submenus.filter( ":not(.ui-menu)" )
			.hide()
			.attr( {
				role: this.options.role,
				"aria-hidden": "true",
				"aria-expanded": "false"
			} )
			.each( function() {
				var menu = $( this ),
					item = menu.prev(),
					submenuCaret = $( "<span>" ).data( "ui-menu-submenu-caret", true );

				that._addClass( submenuCaret, "ui-menu-icon", "ui-icon " + icon );
				item
					.attr( "aria-haspopup", "true" )
					.prepend( submenuCaret );
				menu.attr( "aria-labelledby", item.attr( "id" ) );
			} );

		this._addClass( newSubmenus, "ui-menu", "ui-widget ui-widget-content ui-front" );

		menus = submenus.add( this.element );
		items = menus.find( this.options.items );

		// Initialize menu-items containing spaces and/or dashes only as dividers
		items.not( ".ui-menu-item" ).each( function() {
			var item = $( this );
			if ( that._isDivider( item ) ) {
				that._addClass( item, "ui-menu-divider", "ui-widget-content" );
			}
		} );

		// Don't refresh list items that are already adapted
		newItems = items.not( ".ui-menu-item, .ui-menu-divider" );
		newWrappers = newItems.children()
			.not( ".ui-menu" )
				.uniqueId()
				.attr( {
					tabIndex: -1,
					role: this._itemRole()
				} );
		this._addClass( newItems, "ui-menu-item" )
			._addClass( newWrappers, "ui-menu-item-wrapper" );

		// Add aria-disabled attribute to any disabled menu item
		items.filter( ".ui-state-disabled" ).attr( "aria-disabled", "true" );

		// If the active item has been removed, blur the menu
		if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
			this.blur();
		}
	},

	_itemRole: function() {
		return {
			menu: "menuitem",
			listbox: "option"
		}[ this.options.role ];
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			var icons = this.element.find( ".ui-menu-icon" );
			this._removeClass( icons, null, this.options.icons.submenu )
				._addClass( icons, null, value.submenu );
		}
		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", String( value ) );
		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	focus: function( event, item ) {
		var nested, focused, activeParent;
		this.blur( event, event && event.type === "focus" );

		this._scrollIntoView( item );

		this.active = item.first();

		focused = this.active.children( ".ui-menu-item-wrapper" );
		this._addClass( focused, null, "ui-state-active" );

		// Only update aria-activedescendant if there's a role
		// otherwise we assume focus is managed elsewhere
		if ( this.options.role ) {
			this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
		}

		// Highlight active parent menu item, if any
		activeParent = this.active
			.parent()
				.closest( ".ui-menu-item" )
					.children( ".ui-menu-item-wrapper" );
		this._addClass( activeParent, null, "ui-state-active" );

		if ( event && event.type === "keydown" ) {
			this._close();
		} else {
			this.timer = this._delay( function() {
				this._close();
			}, this.delay );
		}

		nested = item.children( ".ui-menu" );
		if ( nested.length && event && ( /^mouse/.test( event.type ) ) ) {
			this._startOpening( nested );
		}
		this.activeMenu = item.parent();

		this._trigger( "focus", event, { item: item } );
	},

	_scrollIntoView: function( item ) {
		var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
		if ( this._hasScroll() ) {
			borderTop = parseFloat( $.css( this.activeMenu[ 0 ], "borderTopWidth" ) ) || 0;
			paddingTop = parseFloat( $.css( this.activeMenu[ 0 ], "paddingTop" ) ) || 0;
			offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
			scroll = this.activeMenu.scrollTop();
			elementHeight = this.activeMenu.height();
			itemHeight = item.outerHeight();

			if ( offset < 0 ) {
				this.activeMenu.scrollTop( scroll + offset );
			} else if ( offset + itemHeight > elementHeight ) {
				this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
			}
		}
	},

	blur: function( event, fromFocus ) {
		if ( !fromFocus ) {
			clearTimeout( this.timer );
		}

		if ( !this.active ) {
			return;
		}

		this._removeClass( this.active.children( ".ui-menu-item-wrapper" ),
			null, "ui-state-active" );

		this._trigger( "blur", event, { item: this.active } );
		this.active = null;
	},

	_startOpening: function( submenu ) {
		clearTimeout( this.timer );

		// Don't open if already open fixes a Firefox bug that caused a .5 pixel
		// shift in the submenu position when mousing over the caret icon
		if ( submenu.attr( "aria-hidden" ) !== "true" ) {
			return;
		}

		this.timer = this._delay( function() {
			this._close();
			this._open( submenu );
		}, this.delay );
	},

	_open: function( submenu ) {
		var position = $.extend( {
			of: this.active
		}, this.options.position );

		clearTimeout( this.timer );
		this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
			.hide()
			.attr( "aria-hidden", "true" );

		submenu
			.show()
			.removeAttr( "aria-hidden" )
			.attr( "aria-expanded", "true" )
			.position( position );
	},

	collapseAll: function( event, all ) {
		clearTimeout( this.timer );
		this.timer = this._delay( function() {

			// If we were passed an event, look for the submenu that contains the event
			var currentMenu = all ? this.element :
				$( event && event.target ).closest( this.element.find( ".ui-menu" ) );

			// If we found no valid submenu ancestor, use the main menu to close all
			// sub menus anyway
			if ( !currentMenu.length ) {
				currentMenu = this.element;
			}

			this._close( currentMenu );

			this.blur( event );

			// Work around active item staying active after menu is blurred
			this._removeClass( currentMenu.find( ".ui-state-active" ), null, "ui-state-active" );

			this.activeMenu = currentMenu;
		}, this.delay );
	},

	// With no arguments, closes the currently active menu - if nothing is active
	// it closes all menus.  If passed an argument, it will search for menus BELOW
	_close: function( startMenu ) {
		if ( !startMenu ) {
			startMenu = this.active ? this.active.parent() : this.element;
		}

		startMenu.find( ".ui-menu" )
			.hide()
			.attr( "aria-hidden", "true" )
			.attr( "aria-expanded", "false" );
	},

	_closeOnDocumentClick: function( event ) {
		return !$( event.target ).closest( ".ui-menu" ).length;
	},

	_isDivider: function( item ) {

		// Match hyphen, em dash, en dash
		return !/[^\-\u2014\u2013\s]/.test( item.text() );
	},

	collapse: function( event ) {
		var newItem = this.active &&
			this.active.parent().closest( ".ui-menu-item", this.element );
		if ( newItem && newItem.length ) {
			this._close();
			this.focus( event, newItem );
		}
	},

	expand: function( event ) {
		var newItem = this.active &&
			this.active
				.children( ".ui-menu " )
					.find( this.options.items )
						.first();

		if ( newItem && newItem.length ) {
			this._open( newItem.parent() );

			// Delay so Firefox will not hide activedescendant change in expanding submenu from AT
			this._delay( function() {
				this.focus( event, newItem );
			} );
		}
	},

	next: function( event ) {
		this._move( "next", "first", event );
	},

	previous: function( event ) {
		this._move( "prev", "last", event );
	},

	isFirstItem: function() {
		return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
	},

	isLastItem: function() {
		return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
	},

	_move: function( direction, filter, event ) {
		var next;
		if ( this.active ) {
			if ( direction === "first" || direction === "last" ) {
				next = this.active
					[ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
					.eq( -1 );
			} else {
				next = this.active
					[ direction + "All" ]( ".ui-menu-item" )
					.eq( 0 );
			}
		}
		if ( !next || !next.length || !this.active ) {
			next = this.activeMenu.find( this.options.items )[ filter ]();
		}

		this.focus( event, next );
	},

	nextPage: function( event ) {
		var item, base, height;

		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isLastItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.nextAll( ".ui-menu-item" ).each( function() {
				item = $( this );
				return item.offset().top - base - height < 0;
			} );

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.find( this.options.items )
				[ !this.active ? "first" : "last" ]() );
		}
	},

	previousPage: function( event ) {
		var item, base, height;
		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isFirstItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.prevAll( ".ui-menu-item" ).each( function() {
				item = $( this );
				return item.offset().top - base + height > 0;
			} );

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.find( this.options.items ).first() );
		}
	},

	_hasScroll: function() {
		return this.element.outerHeight() < this.element.prop( "scrollHeight" );
	},

	select: function( event ) {

		// TODO: It should never be possible to not have an active item at this
		// point, but the tests don't trigger mouseenter before click.
		this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
		var ui = { item: this.active };
		if ( !this.active.has( ".ui-menu" ).length ) {
			this.collapseAll( event, true );
		}
		this._trigger( "select", event, ui );
	},

	_filterMenuItems: function( character ) {
		var escapedCharacter = character.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" ),
			regex = new RegExp( "^" + escapedCharacter, "i" );

		return this.activeMenu
			.find( this.options.items )

				// Only match on items, not dividers or other content (#10571)
				.filter( ".ui-menu-item" )
					.filter( function() {
						return regex.test(
							$.trim( $( this ).children( ".ui-menu-item-wrapper" ).text() ) );
					} );
	}
} );

} ) );


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Unique ID 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: uniqueId
//>>group: Core
//>>description: Functions to generate and remove uniqueId's
//>>docs: http://api.jqueryui.com/uniqueId/

( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(0), __webpack_require__(12) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
} ( function( $ ) {

return $.fn.extend( {
	uniqueId: ( function() {
		var uuid = 0;

		return function() {
			return this.each( function() {
				if ( !this.id ) {
					this.id = "ui-id-" + ( ++uuid );
				}
			} );
		};
	} )(),

	removeUniqueId: function() {
		return this.each( function() {
			if ( /^ui-id-\d+$/.test( this.id ) ) {
				$( this ).removeAttr( "id" );
			}
		} );
	}
} );

} ) );


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3=container.escapeExpression;

  return "<div>\n	<div class=\"search-section\">\n		<input type=\"text\" placeholder=\""
    + alias3(((helper = (helper = helpers.placeholderText || (depth0 != null ? depth0.placeholderText : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"placeholderText","hash":{},"data":data}) : helper)))
    + "\" />\n		<i class=\"icon-ic_search_black_24px\"></i>\n		<i class=\"icon-ic_close_black_24px reset\"></i>\n	</div>\n	<div class=\"results\"></div>\n	<div class=\"error-search-panel\">"
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"autocomplete.notResultFound",{"name":"t","hash":{},"data":data}))
    + "</div>\n</div>";
},"useData":true});

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"widget-hotel-details-autocomplete\">\n    <div class=\"lmm-search-section\">\n        <!--<div class=\"hotel-details-autocomplete-arrow-icon \"></div>-->\n        <input "
    + alias4(((helper = (helper = helpers.isDisabled || (depth0 != null ? depth0.isDisabled : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"isDisabled","hash":{},"data":data}) : helper)))
    + " type=\"text\" class=\"lmm-search-text-input\" placeholder=\""
    + alias4(((helper = (helper = helpers.placeholderText || (depth0 != null ? depth0.placeholderText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"placeholderText","hash":{},"data":data}) : helper)))
    + "\"/>\n        <div class=\"lmm-close_icon autocomplete-icon reset\"></div>\n        <div class=\"lmm-search_icon autocomplete-icon search\"></div>\n        <div class=\"lmm-dropdown\">\n            <div class=\"lmm-dropdown-image\"></div>\n        </div>\n    </div>\n    <div class=\"results\"></div>\n    <div class=\"error-search-panel\">"
    + alias4((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"autocomplete.notResultFound",{"name":"t","hash":{},"data":data}))
    + "</div>\n</div>";
},"useData":true});

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div>\n    <div class=\"melia-icon melia-icon-ic_directions\"></div>\n</div>\n";
},"useData":true});

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"lmm-center-map\">\n    <div class=\"melia-icon "
    + container.escapeExpression(((helper = (helper = helpers.iconClassName || (depth0 != null ? depth0.iconClassName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"iconClassName","hash":{},"data":data}) : helper)))
    + "\"></div>\n</div>\n";
},"useData":true});

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * clipboard.js v2.0.4
 * https://zenorocha.github.io/clipboard.js
 * 
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ClipboardJS"] = factory();
	else
		root["ClipboardJS"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboardAction = __webpack_require__(1);

var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

var _tinyEmitter = __webpack_require__(3);

var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

var _goodListener = __webpack_require__(4);

var _goodListener2 = _interopRequireDefault(_goodListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */
var Clipboard = function (_Emitter) {
    _inherits(Clipboard, _Emitter);

    /**
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     * @param {Object} options
     */
    function Clipboard(trigger, options) {
        _classCallCheck(this, Clipboard);

        var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

        _this.resolveOptions(options);
        _this.listenClick(trigger);
        return _this;
    }

    /**
     * Defines if attributes would be resolved using internal setter functions
     * or custom functions that were passed in the constructor.
     * @param {Object} options
     */


    _createClass(Clipboard, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
            this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
            this.text = typeof options.text === 'function' ? options.text : this.defaultText;
            this.container = _typeof(options.container) === 'object' ? options.container : document.body;
        }

        /**
         * Adds a click event listener to the passed trigger.
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         */

    }, {
        key: 'listenClick',
        value: function listenClick(trigger) {
            var _this2 = this;

            this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                return _this2.onClick(e);
            });
        }

        /**
         * Defines a new `ClipboardAction` on each click event.
         * @param {Event} e
         */

    }, {
        key: 'onClick',
        value: function onClick(e) {
            var trigger = e.delegateTarget || e.currentTarget;

            if (this.clipboardAction) {
                this.clipboardAction = null;
            }

            this.clipboardAction = new _clipboardAction2.default({
                action: this.action(trigger),
                target: this.target(trigger),
                text: this.text(trigger),
                container: this.container,
                trigger: trigger,
                emitter: this
            });
        }

        /**
         * Default `action` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultAction',
        value: function defaultAction(trigger) {
            return getAttributeValue('action', trigger);
        }

        /**
         * Default `target` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultTarget',
        value: function defaultTarget(trigger) {
            var selector = getAttributeValue('target', trigger);

            if (selector) {
                return document.querySelector(selector);
            }
        }

        /**
         * Returns the support of the given action, or all actions if no action is
         * given.
         * @param {String} [action]
         */

    }, {
        key: 'defaultText',


        /**
         * Default `text` lookup function.
         * @param {Element} trigger
         */
        value: function defaultText(trigger) {
            return getAttributeValue('text', trigger);
        }

        /**
         * Destroy lifecycle.
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            this.listener.destroy();

            if (this.clipboardAction) {
                this.clipboardAction.destroy();
                this.clipboardAction = null;
            }
        }
    }], [{
        key: 'isSupported',
        value: function isSupported() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

            var actions = typeof action === 'string' ? [action] : action;
            var support = !!document.queryCommandSupported;

            actions.forEach(function (action) {
                support = support && !!document.queryCommandSupported(action);
            });

            return support;
        }
    }]);

    return Clipboard;
}(_tinyEmitter2.default);

/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */


function getAttributeValue(suffix, element) {
    var attribute = 'data-clipboard-' + suffix;

    if (!element.hasAttribute(attribute)) {
        return;
    }

    return element.getAttribute(attribute);
}

module.exports = Clipboard;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _select = __webpack_require__(2);

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Inner class which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 */
var ClipboardAction = function () {
    /**
     * @param {Object} options
     */
    function ClipboardAction(options) {
        _classCallCheck(this, ClipboardAction);

        this.resolveOptions(options);
        this.initSelection();
    }

    /**
     * Defines base properties passed from constructor.
     * @param {Object} options
     */


    _createClass(ClipboardAction, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = options.action;
            this.container = options.container;
            this.emitter = options.emitter;
            this.target = options.target;
            this.text = options.text;
            this.trigger = options.trigger;

            this.selectedText = '';
        }

        /**
         * Decides which selection strategy is going to be applied based
         * on the existence of `text` and `target` properties.
         */

    }, {
        key: 'initSelection',
        value: function initSelection() {
            if (this.text) {
                this.selectFake();
            } else if (this.target) {
                this.selectTarget();
            }
        }

        /**
         * Creates a fake textarea element, sets its value from `text` property,
         * and makes a selection on it.
         */

    }, {
        key: 'selectFake',
        value: function selectFake() {
            var _this = this;

            var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

            this.removeFake();

            this.fakeHandlerCallback = function () {
                return _this.removeFake();
            };
            this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

            this.fakeElem = document.createElement('textarea');
            // Prevent zooming on iOS
            this.fakeElem.style.fontSize = '12pt';
            // Reset box model
            this.fakeElem.style.border = '0';
            this.fakeElem.style.padding = '0';
            this.fakeElem.style.margin = '0';
            // Move element out of screen horizontally
            this.fakeElem.style.position = 'absolute';
            this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
            // Move element to the same position vertically
            var yPosition = window.pageYOffset || document.documentElement.scrollTop;
            this.fakeElem.style.top = yPosition + 'px';

            this.fakeElem.setAttribute('readonly', '');
            this.fakeElem.value = this.text;

            this.container.appendChild(this.fakeElem);

            this.selectedText = (0, _select2.default)(this.fakeElem);
            this.copyText();
        }

        /**
         * Only removes the fake element after another click event, that way
         * a user can hit `Ctrl+C` to copy because selection still exists.
         */

    }, {
        key: 'removeFake',
        value: function removeFake() {
            if (this.fakeHandler) {
                this.container.removeEventListener('click', this.fakeHandlerCallback);
                this.fakeHandler = null;
                this.fakeHandlerCallback = null;
            }

            if (this.fakeElem) {
                this.container.removeChild(this.fakeElem);
                this.fakeElem = null;
            }
        }

        /**
         * Selects the content from element passed on `target` property.
         */

    }, {
        key: 'selectTarget',
        value: function selectTarget() {
            this.selectedText = (0, _select2.default)(this.target);
            this.copyText();
        }

        /**
         * Executes the copy operation based on the current selection.
         */

    }, {
        key: 'copyText',
        value: function copyText() {
            var succeeded = void 0;

            try {
                succeeded = document.execCommand(this.action);
            } catch (err) {
                succeeded = false;
            }

            this.handleResult(succeeded);
        }

        /**
         * Fires an event based on the copy operation result.
         * @param {Boolean} succeeded
         */

    }, {
        key: 'handleResult',
        value: function handleResult(succeeded) {
            this.emitter.emit(succeeded ? 'success' : 'error', {
                action: this.action,
                text: this.selectedText,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
            });
        }

        /**
         * Moves focus away from `target` and back to the trigger, removes current selection.
         */

    }, {
        key: 'clearSelection',
        value: function clearSelection() {
            if (this.trigger) {
                this.trigger.focus();
            }

            window.getSelection().removeAllRanges();
        }

        /**
         * Sets the `action` to be performed which can be either 'copy' or 'cut'.
         * @param {String} action
         */

    }, {
        key: 'destroy',


        /**
         * Destroy lifecycle.
         */
        value: function destroy() {
            this.removeFake();
        }
    }, {
        key: 'action',
        set: function set() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

            this._action = action;

            if (this._action !== 'copy' && this._action !== 'cut') {
                throw new Error('Invalid "action" value, use either "copy" or "cut"');
            }
        }

        /**
         * Gets the `action` property.
         * @return {String}
         */
        ,
        get: function get() {
            return this._action;
        }

        /**
         * Sets the `target` property using an element
         * that will be have its content copied.
         * @param {Element} target
         */

    }, {
        key: 'target',
        set: function set(target) {
            if (target !== undefined) {
                if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                    if (this.action === 'copy' && target.hasAttribute('disabled')) {
                        throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                    }

                    if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                        throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                    }

                    this._target = target;
                } else {
                    throw new Error('Invalid "target" value, use a valid Element');
                }
            }
        }

        /**
         * Gets the `target` property.
         * @return {String|HTMLElement}
         */
        ,
        get: function get() {
            return this._target;
        }
    }]);

    return ClipboardAction;
}();

module.exports = ClipboardAction;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(5);
var delegate = __webpack_require__(6);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(7);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ })
/******/ ]);
});

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HotelPricesButtons = _ComponentBase2.default.extend({
  template: __webpack_require__(135),
  componentClass: 'mainBox-hotel-detail-panel-prices',

  events: {
    'click .lowest-price': 'onClickInLowestPrice',
    'click .regular-price': 'onClickInRegularPrice'
  },
  initialize: function initialize(options) {
    this.widget = options.widget;
    this.renderData(options.properties.hotelData);
  },
  updateContent: function updateContent(hotelData) {
    return this.renderData(hotelData);
  },
  renderData: function renderData(hotelData) {
    var currencySign = this.widget.config.currencySign;

    var lowestPrice = Math.trunc(hotelData.lowestPrice);
    var regularPrice = Math.trunc(hotelData.regularPrice);
    this.hotelData = hotelData;
    this.templateConfig = {
      lowestPrice: lowestPrice,
      regularPrice: regularPrice,
      currencySign: currencySign,
      currencyPrefix: this.widget.config.currencyPrefix,
      currencyPostfix: !this.widget.config.currencyPrefix
    };
    this.$el.replaceWith(this.render().$el);
    return this.el;
  },
  onClickInLowestPrice: function onClickInLowestPrice(event) {
    this.widget.api.onClickInLowestPrice(event, this.hotelData.hotelCode);
  },
  onClickInRegularPrice: function onClickInRegularPrice(event) {
    this.widget.api.onClickInRegularPrice(event, this.hotelData.hotelCode);
  }
});
exports.default = HotelPricesButtons;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return " hotel-detail-mobile";
},"3":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "            <span class=\"currencyText\">"
    + alias4(((helper = (helper = helpers.lowestPrice || (depth0 != null ? depth0.lowestPrice : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lowestPrice","hash":{},"data":data}) : helper)))
    + alias4(((helper = (helper = helpers.currencySign || (depth0 != null ? depth0.currencySign : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"currencySign","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "            <span class=\"currencyText\">"
    + alias4(((helper = (helper = helpers.currencySign || (depth0 != null ? depth0.currencySign : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"currencySign","hash":{},"data":data}) : helper)))
    + alias4(((helper = (helper = helpers.lowestPrice || (depth0 != null ? depth0.lowestPrice : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lowestPrice","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "            <span class=\"currencyText\">"
    + alias4(((helper = (helper = helpers.regularPrice || (depth0 != null ? depth0.regularPrice : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"regularPrice","hash":{},"data":data}) : helper)))
    + alias4(((helper = (helper = helpers.currencySign || (depth0 != null ? depth0.currencySign : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"currencySign","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"9":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "            <span class=\"currencyText\">"
    + alias4(((helper = (helper = helpers.currencySign || (depth0 != null ? depth0.currencySign : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"currencySign","hash":{},"data":data}) : helper)))
    + alias4(((helper = (helper = helpers.regularPrice || (depth0 != null ? depth0.regularPrice : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"regularPrice","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3=container.escapeExpression;

  return "<div class=\""
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isMobile : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n    <div class=\"lowest-price\">\n        <p>"
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"hotelDetail.offertMelia",{"name":"t","hash":{},"data":data}))
    + "</p>\n        <p>"
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"hotelDetail.fromPrice",{"name":"t","hash":{},"data":data}))
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.currencyPrefix : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.currencyPostfix : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            <span class=\"separator\">/</span>\n            <span>"
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"hotelDetail.night",{"name":"t","hash":{},"data":data}))
    + "</span>\n        </p>\n    </div>\n    <div class=\"regular-price\">\n        <p>"
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"hotelDetail.standardPrice",{"name":"t","hash":{},"data":data}))
    + "</p>\n        <p>"
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"hotelDetail.fromPrice",{"name":"t","hash":{},"data":data}))
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.currencyPrefix : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.currencyPostfix : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            <span class=\"separator\">/</span>\n            <span>"
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"hotelDetail.night",{"name":"t","hash":{},"data":data}))
    + "</span>\n        </p>\n    </div>\n</div>";
},"useData":true});

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return " hotel-detail-mobile";
},"3":function(container,depth0,helpers,partials,data) {
    return "    <div class=\"close-container\">\n        <div class=\"lmm-icon-close hotel-detail-close-icon\"></div>\n    </div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "                <div class=\"directions-btn melia-icon-ic_directions\"></div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    return "        <i class=\"lmm-icon lmm-md-icon-star-full\"></i>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\""
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isMobile : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n    <div class=\"hotel-image\">\n        <img src=\""
    + alias4(((helper = (helper = helpers.imgDetail || (depth0 != null ? depth0.imgDetail : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"imgDetail","hash":{},"data":data}) : helper)))
    + "\" alt=\"\">\n    </div>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showCloseBtn : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    <div class=\"hotel-title-row\">\n        <div class=\"title-text\"><a href=\""
    + alias4(((helper = (helper = helpers.completeUrl || (depth0 != null ? depth0.completeUrl : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"completeUrl","hash":{},"data":data}) : helper)))
    + "\" target=\"_top\">"
    + alias4(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper)))
    + "</a></div>\n        <div class=\"buttons-box\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showDirectionsBTN : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            <div class=\"share-btn melia-icon-ic-share\"></div>\n        </div>\n    </div>\n    <div class=\"hotel-stars\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.stars : depth0),{"name":"each","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n    <div class=\"hotel-description\">\n        <div class=\"description-truncate\">\n            <p>"
    + ((stack1 = (helpers.trimString || (depth0 && depth0.trimString) || alias2).call(alias1,(depth0 != null ? depth0.descriptionToTruncate : depth0),0,150,{"name":"trimString","hash":{},"data":data})) != null ? stack1 : "")
    + "</p>\n        </div>\n        <div class=\"description-text\">"
    + ((stack1 = ((helper = (helper = helpers.allDescription || (depth0 != null ? depth0.allDescription : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"allDescription","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n\n        <div class=\"cta-see-more-text\">"
    + alias4((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"hotelDetail.seeMore",{"name":"t","hash":{},"data":data}))
    + "</div>\n        <div class=\"cta-see-less-text\">"
    + alias4((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"hotelDetail.seeLess",{"name":"t","hash":{},"data":data}))
    + "</div>\n    </div>\n    <div class=\"hotel-prices\">\n    </div>\n</div>";
},"useData":true});

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "    <div class=\"collapse-visible-panel\">\n        <div class=\"hotel-summary-arrow-up\">\n            <i class=\"lmm-icon-chevron-up\"></i>\n            <i class=\"lmm-icon-chevron-up\"></i>\n        </div>\n        <div class=\"hotel-summary-image\">\n            <img src=\""
    + alias4(((helper = (helper = helpers.imgDetail || (depth0 != null ? depth0.imgDetail : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"imgDetail","hash":{},"data":data}) : helper)))
    + "\" alt=\"\">\n        </div>\n        <div class=\"hotel-summary-title\">\n            <div class=\"hotel-name\">"
    + alias4(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper)))
    + "</div>\n        </div>\n        <div class=\"hotel-summary-see-details\">\n            <div class=\"hotel-summary-see-details-text\">\n                "
    + alias4((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"hotelSummary.seeDetails",{"name":"t","hash":{},"data":data}))
    + "\n            </div>\n        </div>\n    </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div>\n"
    + ((stack1 = helpers.unless.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isResultsWidget : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    <div class=\"uncollapse-visible-panel\">\n    </div>\n</div>";
},"useData":true});

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\""
    + alias4(((helper = (helper = helpers.identifier || (depth0 != null ? depth0.identifier : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"identifier","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + " lmm-message-control\">\n</div>\n";
},"useData":true});

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _components = __webpack_require__(54);

var _components2 = _interopRequireDefault(_components);

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _Utils = __webpack_require__(6);

var _Utils2 = _interopRequireDefault(_Utils);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ComponentBase2.default.extend(
/**
 * @lends core.components.MainMenu
 */
{

  template: __webpack_require__(140),

  /**
   * Create a mainMenu instance.
   * @class MainMenu
   * @classdesc This is the main component on which the menu will be built. 
   * @memberof core.components
   * @extends ComponentBase
   * @constructs
   * @param {Object} options - The config provided by json
   */
  constructor: function constructor(options) {
    this.components = {};
    this.lastElementIn = {};
    this.classPrefix = options.classPrefix || '.lmm-main-menu-';
    this.visible = options.visible ? true : false;
    _ComponentBase2.default.prototype.constructor.call(this, options);
  },


  /**
   * Initialize the component 
   * @function
   * @param {Object} options - The config provided by json
   * @listens  Widget#SELECTED_TOOL
   */
  initialize: function initialize(options) {
    _ComponentBase2.default.prototype.initialize.call(this, options);
    this.initPanel();
    this.listenTo(this.bus, 'TOGGLE_MAIN_MENU', this.togglePanel);
    this.listenTo(this.bus, 'SELECTED_TOOL', this.selectTool);
    var components = options.properties.components;
    if (_underscore2.default.isObject(options.properties.components.Categories)) {
      components = _underscore2.default.extend(components, options.properties.components.Categories);
    }

    if (_underscore2.default.isObject(components)) {
      this._createSubComponents(components);
      this._activateComponents(options.properties);
    }
    //BUG IE-11
    var _this = this;
    this._bugIE11MaxHeight(this);
    (0, _jquery2.default)(window).resize(function () {
      _this._bugIE11MaxHeight(_this);
    });
  },


  // Deactivates any default events of ComponentBase Class
  events: {},

  _activateComponents: function _activateComponents(properties) {
    var _this2 = this;

    if (_underscore2.default.isObject(properties)) {
      if (!_underscore2.default.isEmpty(properties.defaultActive)) {
        var defaultActive = _underscore2.default.isString(properties.defaultActive) ? [properties.defaultActive] : properties.defaultActive;
        defaultActive.forEach(function (element) {
          _this2.components[element].activate();
        });
      }
      if (_underscore2.default.isString(properties.defaultSelected)) {
        var defaultSelected = properties.defaultSelected;
        if (_underscore2.default.isObject(this.components[defaultSelected])) {
          this.components[defaultSelected].select();
        }
      }
    }
  },
  _createSubComponents: function _createSubComponents(components) {
    var _this3 = this;

    var availableComponents = _underscore2.default.filter(components, function (component, key) {
      if (component) {
        component.identifier = key;
        return true;
      } else {
        return false;
      }
    });

    var sortedComponens = _underscore2.default.sortBy(availableComponents, 'order');
    _underscore2.default.each(sortedComponens, function (component) {
      if (_underscore2.default.isObject(_components2.default[component.componentConstructorClass])) {
        var _component = _this3.components[component.identifier] = new _components2.default[component.componentConstructorClass](_underscore2.default.extend({}, component, {
          map: _this3.map,
          widget: _this3.widget,
          isChild: true,
          properties: component.properties || {}
        }));
        _this3.append(_component.el, _component.position);
      }
    });
  },

  /**
   * Initialize the visibility of the panel
   * @function
   */
  initPanel: function initPanel() {
    if (!this.visible) {
      this.hide();
    }
  },

  /**
   * Toggle the visibility of the panel  
   */
  togglePanel: function togglePanel() {
    if (this.visible) {
      this.hide();
    } else {
      this.show();
    }
    this.visible = !this.visible;
  },

  /**
   * Select a specified component of MainMenu
   * @function 
   * @param {object} myObj
   * @param {string} myObj.identifier - Indicates the id of the tool to select
   * @param {object} myObj.subView- The subview of the component
   * @param {ComposedComponentBase} myObj.instanceObj - The instance of component
   */
  selectTool: function selectTool(eventData) {
    var sender = eventData.objInstance;
    var subView = eventData.subView;
    if (this._isOwnCompontent(sender)) {
      var container = sender.childPosition || 'container';
      if (_underscore2.default.isObject(subView)) {
        if (this.lastElementIn[container] !== subView.el) {
          this.append(subView.el, container);
          this.lastElementIn[container] = subView.el;
        }
      }

      _underscore2.default.each(this.components, function (component, identifier) {
        if (identifier !== eventData.identifier && component.childPosition === container && component.selectable && component.isActivated) {
          component.unSelect();
        }
      });
    }
  },


  /**
   * Append an element into the Main Menu container
   * @param {object} element - The jQuery element to append
   * @param {string} container - The jQuery selector of container
   */
  append: function append(element, container) {
    this.$el.find(this.classPrefix + container).append(element);
  },
  _isOwnCompontent: function _isOwnCompontent(component) {
    var found = _underscore2.default.find(this.components, function (_component) {
      return _component === component;
    });
    return component === found;
  },
  _bugIE11MaxHeight: function _bugIE11MaxHeight(_this) {
    var name = _Utils2.default.getBrowser().name;
    if (name === 'IE' || name === 'Edge') {
      var height = _this.widget.$el.find('.lmm-maps-widget-container').height() - 125 + 'px';
      _this.$el.find('.main-menu-container').css('max-height', height);
      _this.$el.find('.main-menu-fluid-container').css('max-height', height);
      _this.$el.find('.main-menu-fluid-panel').css('max-height', height);
    }
  }
});

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div>\n  <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-header\"></div>\n  <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-fluid-panel\"></div>\n  <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-toolbox\"></div>\n  <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-fluid-container\"></div>\n  <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-container\"></div>\n</div>";
},"useData":true});

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ToggleBtn = __webpack_require__(142);

var _ToggleBtn2 = _interopRequireDefault(_ToggleBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ToggleBtn2.default.extend({
    template: __webpack_require__(144),
    componentClass: 'toggleBtn'

});

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class ToggleBtn
 * @memberof core.components
 * 
 * @fires Widget#TOGGLE_PANEL_MENU
 * @fires Widget#TOGGLE_MAIN_MENU
 * @fires Widget#TOGGLE_DRAW_TOOL
 */
var ToggleBtn = _ComponentBase2.default.extend(
/**
 * @lends core.components.ToggleBtn.prototype
 */
{

  template: __webpack_require__(143),

  events: {
    'click': 'toggleBtn'
  },

  /**
   * Initialize the component
   * @function
   * @param {Object} options - The config provided by json
   */
  initialize: function initialize(config) {
    this.bus = this.widget.bus;
    _ComponentBase2.default.prototype.initialize.call(this, config);
  },


  /**
   * Fires the event and toggle class
   * @private
   */
  toggleBtn: function toggleBtn(event) {
    this.bus.trigger(this.properties.event, this);
    (0, _jquery2.default)(this.el).toggleClass('lmm-active');
  }
});

exports.default = ToggleBtn;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div>\n    <div class=\"lmm-icon "
    + container.escapeExpression(((helper = (helper = helpers.iconClassName || (depth0 != null ? depth0.iconClassName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"iconClassName","hash":{},"data":data}) : helper)))
    + "\"></div>\n</div>\n";
},"useData":true});

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div>\n    <div class=\"melia-icon-"
    + container.escapeExpression(((helper = (helper = helpers.iconClassName || (depth0 != null ? depth0.iconClassName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"iconClassName","hash":{},"data":data}) : helper)))
    + "\"></div>\n</div>\n";
},"useData":true});

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MainMenuBlock = __webpack_require__(21);

var _MainMenuBlock2 = _interopRequireDefault(_MainMenuBlock);

var _GoogleDirectionsHelper = __webpack_require__(146);

var _GoogleDirectionsHelper2 = _interopRequireDefault(_GoogleDirectionsHelper);

var _MeliaHandleRoutes = __webpack_require__(147);

var _MeliaHandleRoutes2 = _interopRequireDefault(_MeliaHandleRoutes);

var _Utils = __webpack_require__(6);

var _Utils2 = _interopRequireDefault(_Utils);

var _widgetTypes = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MainMenuBlock2.default.extend({
	template: __webpack_require__(156),
	componentClass: 'directions-box',
	events: {
		'click .melia-close-icon': 'onClickClose',
		'click .melia-swap-icon': 'swap'
	},
	travelMode: 'driving',
	originIsMainHotel: true,
	autocompleteResultPosition: null,
	mainHotelPosition: null,
	directionsPoints: {
		from: null,
		to: null
	},

	directionsStrings: {
		from: null,
		to: null
	},

	constructor: function constructor(options) {
		_MainMenuBlock2.default.prototype.constructor.call(this, options);
	},
	createConfigSubcomponents: function createConfigSubcomponents() {
		this.components = {
			AutocompleteTo: {
				position: 'to',
				componentConstructorClass: 'Autocomplete',
				identifier: 'Autocomplete',
				resultsPanel: this.$el.find('.lmm-autocomplete-results'),
				properties: {
					jpPosition: 'to',
					providers: {
						GPlacesAutocomplete: {
							icons: ['transit_station', 'bus_station', 'train_station'],
							minLength: 3,
							maxResults: 5
						},
						ListHotelsProvider: {
							minLength: 1,
							maxResults: 5
						}
					}
				},
				errorPanel: this.$el.find('.directionsBox-no-results-container')

			},
			JPList: {
				position: 'jp-list-results',
				identifier: 'JPList',
				componentConstructorClass: 'JPList',
				parent: this
			},
			TransportModes: {
				position: 'transport-modes',
				componentConstructorClass: 'TransportModes',
				identifier: 'TransportModes',
				properties: {
					event: 'TRANSPORT_MODE_SELECTED',
					defaultMode: 'driving'
				}
			}
		};
		if (!this.blockHotelInput) {
			this.components.AutocompleteFrom = {
				position: 'from',
				componentConstructorClass: 'Autocomplete',
				identifier: 'Autocomplete',
				resultsPanel: this.$el.find('.lmm-autocomplete-results'),
				properties: {
					jpPosition: 'from',
					providers: {
						GPlacesAutocomplete: {
							icons: ['transit_station', 'bus_station', 'train_station'],
							minLength: 3,
							maxResults: 5
						},
						ListHotelsProvider: {
							minLength: 1,
							maxResults: 5
						}
					}
				},
				errorPanel: this.$el.find('.directionsBox-no-results-container')
			};
		}
	},
	initialize: function initialize(options) {
		this.blockHotelInput = options.properties.blockHotelInput;
		this.templateConfig.blockHotelInput = this.blockHotelInput;
		if (this.blockHotelInput) {
			this.directionsPoints.from = new google.maps.LatLng({
				lat: this.widget.hotelsJson.mainHotel.position.lat,
				lng: this.widget.hotelsJson.mainHotel.position.lng
			});
			this.templateConfig.inputMainHotelName = this.widget.hotelsJson.mainHotel.name;
			this.directionsStrings.from = this.widget.hotelsJson.mainHotel.name;
		}
		_MainMenuBlock2.default.prototype.initialize.call(this, options);
		this._configHandleRoute();
		if (this.widget.isMobileVersion) {
			this.$el.addClass('directions-box-mobile-version');
		}
	},
	_configHandleRoute: function _configHandleRoute() {
		var meliaCeruleanColor = '#0075c0';
		var meliaDarkGreen = '#26735B';
		var meliaDarkGray = '#A3A3A3';
		this.handleRoutes = new _MeliaHandleRoutes2.default(this.widget, {
			drawLabel: {
				zoomControl: 15
			},
			routeStyles: {
				type: 'modesStyle',
				defaultStyle: {
					DRIVING: {
						strokeWeight: 5,
						strokeColor: meliaCeruleanColor,
						icons: false,
						zIndex: 20
					},
					BICYCLING: {
						strokeWeight: 5,
						strokeColor: meliaCeruleanColor,
						icons: false,
						zIndex: 20
					},
					TRANSIT: {
						strokeWeight: 5,
						strokeColor: meliaDarkGreen,
						icons: false,
						zIndex: 20
					}
				},
				basicStyle: {
					strokeWeight: 2,
					strokeColor: meliaDarkGray,
					strokeOpacity: 0.8,
					icons: false,
					zIndex: 10
				},
				highlightStyle: {
					strokeOpacity: 1,
					strokeWeight: 5,
					zIndex: 40
				},
				selectedStyle: {
					strokeWeight: 5,
					zIndex: 30
				}
			}
		});
	},
	addListeners: function addListeners() {
		var _this = this;

		this.listenTo(this.bus, 'RESET_AUTOCOMPLETE', function (autocompleteComponent) {
			_this.directionsPoints[autocompleteComponent.properties.jpPosition] = null;
			_this._hideJPList();
			_this.handleRoutes.removeRoutes();
			_this._removeOriginDestinationMarkers();
			_this.autocompleteResultPosition = null;
		});

		this.listenTo(this.bus, 'AUTOCOMPLETE_RESULT_SELECTED', function (item, autocompleteComponent) {
			_this.directionsStrings[autocompleteComponent.properties.jpPosition] = item.value;
			if (_this.widget.typeWidget === _widgetTypes.HOTEL_DETAILS && _this.widget.isMobileVersion) {
				_this.widget.$el.find('.lmm-hotel-resume-mobile-panel').hide();
			}
			if (item.address) {
				item.coordinates = new google.maps.LatLng(item.coords.lat, item.coords.lon);
				_this.directionsPoints[autocompleteComponent.properties.jpPosition] = item.coordinates;
				_this.autocompleteResultPosition = item.coordinates;
				_this.getDirections();
			} else {
				item.coordinates().done(function (coords) {
					_this.directionsPoints[autocompleteComponent.properties.jpPosition] = coords.location;
					_this.autocompleteResultPosition = coords.location;
					_this.getDirections();
				});
			}
		});

		this.listenTo(this.bus, 'TRANSPORT_MODE_SELECTED', function (item) {
			_this.travelMode = item.transportTypeEvent;
			_this.getDirections();
		});
	},
	fillOriginWithHotel: function fillOriginWithHotel(hotelData) {
		this.directionsStrings.from = hotelData.title;
		if (this.components.AutocompleteFrom) {
			this.components.AutocompleteFrom.fillAutocomplete(hotelData.title);
		}
		this.directionsPoints.from = new google.maps.LatLng({
			lat: parseFloat(hotelData.latitudeCoordinates),
			lng: parseFloat(hotelData.longitudeCoordinates)
		});
	},
	getDirections: function getDirections() {
		var _this2 = this;

		if (this.directionsPoints.from && this.directionsPoints.to) {
			var origin = void 0;
			var destination = void 0;

			if (this.originIsMainHotel) {
				origin = this.directionsPoints.from;
				destination = this.directionsPoints.to;
			} else {
				origin = this.directionsPoints.to;
				destination = this.directionsPoints.from;
			}

			_GoogleDirectionsHelper2.default.getJourney({ value: origin }, { value: destination }, { travelMode: this.travelMode }).then(function (routeResults) {
				_this2._removeOriginDestinationMarkers();
				if (routeResults.routes.length && !_this2.directionsPoints.from.equals(_this2.directionsPoints.to)) {
					_this2.handleRoutes.updateRoutes(routeResults.routes);
					if (!_this2.blockHotelInput) {
						_this2._createOriginDestinationMarkers(routeResults.request.origin, routeResults.request.destination);
					}
				} else {
					_this2.handleRoutes.removeRoutes();
					routeResults.routes = [];
				}
				_this2._showJPList();
				_this2.components.JPList.updateRoute(routeResults, _this2.handleRoutes);
			});
		}
	},
	onClickClose: function onClickClose() {
		var closeDirectionsBox = false;
		this.bus.trigger('directions_btn_event', closeDirectionsBox);
	},
	close: function close() {
		this._hideJPList();
		this.handleRoutes.removeRoutes();
		this.components.AutocompleteTo._resetAutocomplete();
		this.directionsPoints.to = null;
		if (!this.blockHotelInput) {
			this.components.AutocompleteFrom._resetAutocomplete();
			this.directionsPoints.from = null;
		}
		this.autocompleteResultPosition = null;
		this.stopListening();
	},
	open: function open() {
		this.show();
		this.addListeners();
		this.components.JPList.setIsDetailsPanelOpened(false);
	},
	getOriginText: function getOriginText() {
		return this.originIsMainHotel ? this.directionsStrings.from : this.directionsStrings.to;
	},
	getDestinationText: function getDestinationText() {
		return this.originIsMainHotel ? this.directionsStrings.to : this.directionsStrings.from;
	},
	_hideJPList: function _hideJPList() {
		this.$el.find('.directions-box-jp-list-results').hide();
	},
	_showJPList: function _showJPList() {
		this.$el.find('.directions-box-jp-list-results').show();
	},
	swap: function swap() {
		var toDirection = this.$el.find('.to-direction');
		var fromDirection = this.$el.find('.from-direction');

		this.originIsMainHotel = !this.originIsMainHotel;
		if (this.originIsMainHotel) {
			fromDirection.after(toDirection);
		} else {
			fromDirection.before(toDirection);
		}
		if (this.$el.find('.lmm-search-text-input')[0].value) {
			this.getDirections();
		}
	},
	getOriginIsMainHotel: function getOriginIsMainHotel() {
		return this.originIsMainHotel;
	},
	_removeOriginDestinationMarkers: function _removeOriginDestinationMarkers() {
		if (this.originMarker && this.destinationMarker) {
			this.originMarker.setMap(null);
			this.destinationMarker.setMap(null);
			this.originMarker = null;
			this.destinationMarker = null;
		}
	},
	_createOriginDestinationMarkers: function _createOriginDestinationMarkers(originPosition, destinationPosition) {
		this.bus.trigger('DELETE_POINT_REFERENCE');
		this.originMarker = this.widget.addMarkerToLayer('BaseMapLayer', { position: originPosition.location }, {
			url: _Utils2.default.getImgUrl(this.widget.config.directionsOriginDestinationIcons.origin, this.widget),
			size: new google.maps.Size(25, 25),
			scaledSize: new google.maps.Size(25, 25)
		});
		this.destinationMarker = this.widget.addMarkerToLayer('BaseMapLayer', { position: destinationPosition.location }, {
			url: _Utils2.default.getImgUrl(this.widget.config.directionsOriginDestinationIcons.destination, this.widget),
			size: new google.maps.Size(25, 25),
			scaledSize: new google.maps.Size(25, 25)
		});
	}
});

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class GoogleDirectionsHelper
 * @classdesc Service to calculate the journeys
 */
var GoogleDirectionsHelper = function () {
  function GoogleDirectionsHelper() {
    _classCallCheck(this, GoogleDirectionsHelper);
  }

  _createClass(GoogleDirectionsHelper, null, [{
    key: '_createService',
    value: function _createService() {
      this.service = new google.maps.DirectionsService();
      return this.service;
    }

    /**
     * Returns a journey from Google directions API.
     * @param {string} from - The origin address to calculate the journey.
     * @param {string} to - The destination address to calculate the journey.
     * @param {object} options - Extra parameters to calculate the journey.
     * @returns The promise to handler the result.
     */

  }, {
    key: 'getJourney',
    value: function getJourney(from, to, options) {
      var deferred = _jquery2.default.Deferred();
      var service = this.service || this._createService();
      var directionsRequest = this._setRequest(from, to, options);
      service.route(directionsRequest, function (result, status) {
        deferred.resolve(result);
      });

      return deferred.promise();
    }

    //Create the directions request

  }, {
    key: '_setRequest',
    value: function _setRequest(from, to, options) {
      var TRAVELMODE = {
        transit: google.maps.TravelMode.TRANSIT,
        driving: google.maps.TravelMode.DRIVING,
        walking: google.maps.TravelMode.WALKING,
        bicycling: google.maps.TravelMode.BICYCLING
      },
          TRANSITMODE = {
        bus: google.maps.TransitMode.BUS,
        rail: google.maps.TransitMode.RAIL,
        subway: google.maps.TransitMode.SUBWAY,
        train: google.maps.TransitMode.TRAIN,
        tram: google.maps.TransitMode.TRAM
      },
          ROUTINGPREFERENCE = {
        lesswalking: google.maps.TransitRoutePreference.LESS_WALKING,
        fewertransfers: google.maps.TransitRoutePreference.FEWER_TRANSFERS
      },
          TRAFFICMODEL = {
        pessimistic: google.maps.TrafficModel.PESSIMISTIC,
        bestguess: google.maps.TrafficModel.BEST_GUESS,
        optimistic: google.maps.TrafficModel.OPTIMISTIC
      },
          directionsRequest = {
        origin: null,
        destination: null,
        waypoints: null,
        travelMode: null,
        avoidHighways: null,
        avoidTolls: null
      },
          transitOptions = {
        modes: []
      },
          i,
          j,
          mode,
          preference;
      if (!!from && !!to) {
        directionsRequest.origin = from.marker ? from.marker.getPosition() : from.value;
        directionsRequest.destination = to.marker ? to.marker.getPosition() : to.value;
        directionsRequest.travelMode = options && options.travelMode ? TRAVELMODE[options.travelMode] : TRAVELMODE.transit;
        directionsRequest.provideRouteAlternatives = true;
        directionsRequest.region = options && options.region ? options.region : 'uk';
        directionsRequest.avoidTolls = options && options.avoidTolls ? options.avoidTolls : false;
        directionsRequest.avoidHighways = options && options.avoidHighways ? options.avoidHighways : false;
      }
      // Optional parameters
      if (options) {
        if (options.waypoints) {
          directionsRequest.waypoints = options.waypoints;
        }
        if (options.departureTime) {
          transitOptions.departureTime = options.departureTime;
        }
        if (options.arrivalTime) {
          transitOptions.arrivalTime = options.arrivalTime;
        }
        if (options.modes) {
          for (i = 0; i < options.modes.length; i++) {
            mode = options.modes[i].toLowerCase();
            transitOptions.modes.push(TRANSITMODE[mode]);
          }
        }
        if (options.routingPreference) {
          for (j = 0; j < options.routingPreference.length; j++) {
            preference = options.routingPreference[j].toLowerCase();
            transitOptions.routingPreference = ROUTINGPREFERENCE[preference];
          }
        }
        if (options.unitSystem) {
          directionsRequest.unitSystem = options.unitSystem.toUpperCase() === 'METRIC' ? google.maps.UnitSystem.METRIC : google.maps.UnitSystem.IMPERIAL;
        }
        if (options.drivingOptions) {
          directionsRequest.drivingOptions = {
            departureTime: options.drivingOptions.departureTime ? options.drivingOptions.departureTime : new Date(),
            trafficModel: TRAFFICMODEL[options.drivingOptions.trafficModel]
          };
        }
      }
      directionsRequest.transitOptions = transitOptions;
      return directionsRequest;
    }
  }]);

  return GoogleDirectionsHelper;
}();

exports.default = GoogleDirectionsHelper;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HandleRoutes2 = __webpack_require__(148);

var _HandleRoutes3 = _interopRequireDefault(_HandleRoutes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MeliaHandleRoutes = function (_HandleRoutes) {
    _inherits(MeliaHandleRoutes, _HandleRoutes);

    function MeliaHandleRoutes() {
        _classCallCheck(this, MeliaHandleRoutes);

        return _possibleConstructorReturn(this, (MeliaHandleRoutes.__proto__ || Object.getPrototypeOf(MeliaHandleRoutes)).apply(this, arguments));
    }

    _createClass(MeliaHandleRoutes, [{
        key: 'updateRoutes',
        value: function updateRoutes(providedRoutes) {
            this.routes = providedRoutes;
            this.removeRoutes();
            this.createRoutes(providedRoutes);
            this.drawRoutes();
            this._bindEvents();
            if (this.drawLabel) {
                this._drawLabels();
            }
        }
    }]);

    return MeliaHandleRoutes;
}(_HandleRoutes3.default);

exports.default = MeliaHandleRoutes;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _RouteLayer = __webpack_require__(149);

var _RouteLayer2 = _interopRequireDefault(_RouteLayer);

var _RouteModel = __webpack_require__(56);

var _RouteModel2 = _interopRequireDefault(_RouteModel);

var _RoutesCollection = __webpack_require__(153);

var _RoutesCollection2 = _interopRequireDefault(_RoutesCollection);

var _RouteLabels = __webpack_require__(154);

var _RouteLabels2 = _interopRequireDefault(_RouteLabels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HandleRoutes = function () {
  /**
   * @class HandleRoutes
   * @classdesc Create and handle the routes on map
   * @param {Widget} widget - The widget where the routes will be loaded
   */
  function HandleRoutes(widget, opt) {
    _classCallCheck(this, HandleRoutes);

    this.map = widget.map;
    this.routes = [];
    this.routesView = [];
    this.widget = widget;
    this.routeStyles = opt.routeStyles;
    this.backgroundRoute = opt.backgroundRoute;
    this.drawLabel = opt.drawLabel;
    this.fitBoundsToRoutes = opt.routeStyles && opt.routeStyles.fitBoundsToRoutes ? opt.routeStyles.fitBoundsToRoutes : true;
    this.routeClickable = !_underscore2.default.isUndefined(opt.routeClickable) ? opt.routeClickable : true;
    this.goBoundingInAlternativeRouteClick = !_underscore2.default.isUndefined(opt.goBoundingInAlternativeRouteClick) ? opt.goBoundingInAlternativeRouteClick : false;
    this.routeHoverable = !_underscore2.default.isUndefined(opt.routeHoverable) ? opt.routeHoverable : true;
    this.routesCollection = new _RoutesCollection2.default();
    this.transitStops = opt.transitStops;
    if (this.drawLabel) {
      this.labelView = new _RouteLabels2.default({
        widget: this.widget,
        config: opt.drawLabel
      });
    }
  }

  _createClass(HandleRoutes, [{
    key: 'updateRoutes',
    value: function updateRoutes(providedRoutes) {
      this.removeRoutes();
      this.createRoutes(providedRoutes);
      this.drawRoutes();
      this._bindEvents();
      if (this.drawLabel) {
        this._drawLabels();
      }
    }
  }, {
    key: '_drawLabels',
    value: function _drawLabels() {
      this.labelView.removeLabels();
      var selectedRoute = this.getSelectedRoute();
      this.labelView.createLabel(selectedRoute[0]);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      var _this = this;

      //deselect other routes
      this.routesCollection.on('change:selected', function (model) {
        if (model.isSelected()) {
          _this.routesCollection.selectModel(model);
          if (_this.drawLabel) {
            _this._drawLabels();
          }
        }
      });
    }
  }, {
    key: 'createRoutes',
    value: function createRoutes(providedRoutes) {
      var _this2 = this;

      var i = 0;
      var bounds = new google.maps.LatLngBounds();
      providedRoutes.forEach(function (providedRoute, index) {
        var routeModel = void 0;
        routeModel = new _RouteModel2.default({ 'selected': index === 0 }); //REVISAR ESTO
        _this2.routesCollection.add(routeModel);
        var routeView = new _RouteLayer2.default(providedRoute, {
          widget: _this2.widget,
          routeStyles: _this2.routeStyles,
          transitStops: _this2.transitStops,
          model: routeModel,
          index: index,
          routeClickable: _this2.routeClickable,
          routeHoverable: _this2.routeHoverable,
          backgroundRoute: _this2.backgroundRoute
        });
        if (routeModel.getAgency() && routeModel.getAgency().length > 0) {
          routeView.setLimitToAgencies(i);
          i++;
        }
        routeView.routeModel.on('change:selected', function (model) {
          if (model.isSelected()) {
            _this2.widget.bus.trigger('SELECT_ROUTE', routeView.providedRoute);
            _this2.legendItems = [];
            _this2.addRouteToLegend(routeView);
            if (_this2.goBoundingInAlternativeRouteClick) {
              _this2.changeBoundsMap(bounds);
            }
          }
        }, routeView.routeModel);
        _this2.routesView.push(routeView);
        bounds.union(routeView.getBounds());
        _this2.changeBoundsMap(bounds);
      });
    }
  }, {
    key: 'drawRoutes',
    value: function drawRoutes() {
      var _this3 = this;

      this.legendItems = [];
      _underscore2.default.each(this.routesView, function (routeView) {
        routeView.draw();
        _this3.addRouteToLegend(routeView);
      });
    }
  }, {
    key: 'addRouteToLegend',
    value: function addRouteToLegend(routeView) {
      if (routeView.styles.legend && (routeView.routeModel.getStyle() === 'defaultStyle' || routeView.routeModel.isSelected())) {
        this.legendItems = this.legendItems.concat(routeView.getLegend());
        if (this.legendItems.length > 0) {
          this.widget.bus.trigger('UPDATE_LEGEND', this.legendItems);
        }
      }
    }
  }, {
    key: 'removeRoutes',
    value: function removeRoutes() {
      if (this.labelView) {
        this.labelView.removeLabels();
      }
      _underscore2.default.each(this.routesView, function (routeView) {
        routeView.remove();
      });
      this.routesView = [];
    }
  }, {
    key: 'changeBoundsMap',
    value: function changeBoundsMap(bounds) {
      if (this.fitBoundsToRoutes) {
        this.map.fitBounds(bounds);
      }
    }
  }, {
    key: 'getSelectedRoute',
    value: function getSelectedRoute() {
      return this.routesView.filter(function (routeView) {
        return routeView.routeModel.isSelected();
      });
    }
  }, {
    key: 'hideAlternativeRoutes',
    value: function hideAlternativeRoutes() {
      var selectedRoute = this.getSelectedRoute();
      this.routesView.forEach(function (r, i) {
        if (i !== selectedRoute[0].index) {
          r.hide();
        }
      });
    }
  }, {
    key: 'showAlternativeRoutes',
    value: function showAlternativeRoutes() {
      this.routesView.forEach(function (r, i) {
        r.show();
      });
    }
  }]);

  return HandleRoutes;
}();

exports.default = HandleRoutes;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseLayer = __webpack_require__(14);

var _BaseLayer2 = _interopRequireDefault(_BaseLayer);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _TransitStopsLayer = __webpack_require__(150);

var _TransitStopsLayer2 = _interopRequireDefault(_TransitStopsLayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BaseLayer2.default.extend({
  /**
   * Create a new RouteLayer instance
   * @memberOf module:Layers
   * @class RouteLayer
   * @classdesc The polyline layer to draw routes on map
   * @extends BaseLayer
   *  @param {object} options - The needed config to draw the routes on map
   */
  constructor: function constructor(providedRoute) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options.featureId = 'RouteLayer';
    options.source = {
      id: 'RouteLayer'
    };
    this.map = options.widget.map;
    this.providedRoute = providedRoute; //the data provided by api
    this.geoRoute = []; // the geometry route by steps
    this.optRoute = []; // the styles for each step
    this.styles = this._mergeStyles(options.routeStyles);
    this.routeModel = options.model;
    this.index = options.index;
    this.transitStops = options.transitStops;
    this.routeClickable = !_underscore2.default.isUndefined(options.routeClickable) ? options.routeClickable : true;
    this.routeHoverable = !_underscore2.default.isUndefined(options.routeHoverable) ? options.routeHoverable : true;
    if (this.styles.type !== 'agencyStyle' && (this.styles.applyTo === 'all' || options.index < this.styles.applyTo)) {
      this.initialStyle = 'defaultStyle';
    } else {
      this.initialStyle = 'basicStyle';
    }
    if (this.styles.legend) {
      this.legend = [];
    }
    if (options.backgroundRoute) {
      this.backgroundRoute = [];
      if (this.routeModel.isSelected()) {
        this._createBackgroundRoute();
      }
    }
    _BaseLayer2.default.prototype.constructor.call(this, options);
  },

  /**
   * Initialize the route
   * @memberOf module:Layers.RouteLayer
   * @function
   */
  initialize: function initialize() {
    this._createRoute();
  },
  _addElementToLegend: function _addElementToLegend(text, style) {
    if (this.legend) {
      this.legend.push({ text: text, type: 'Polyline', style: style });
    }
  },
  getLegend: function getLegend() {
    return this.legend;
  },

  //Combine external styles with default ones
  _mergeStyles: function _mergeStyles(externalStyle) {
    var style = externalStyle;
    var internalStyle = this._defaultStyles();
    _underscore2.default.each(internalStyle, function (value, name) {
      if (_underscore2.default.isObject(value)) {
        style[name] = _underscore2.default.extend({}, internalStyle[name], externalStyle[name]);
      } else {
        //In order to add properties thar arent in external style
        style[name] = _underscore2.default.isUndefined(externalStyle[name]) ? internalStyle[name] : externalStyle[name];
      }
    });
    return style;
  },

  //Set default styles
  _defaultStyles: function _defaultStyles(configStyle) {
    return {
      type: 'googleStyle', // 'uniqueColors', 'modesStyle', 'agencyStyle' or 'googleStyle'
      defaultStyle: {
        WALKING: {
          strokeOpacity: 0,
          strokeWeight: 0,
          icons: [{
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              fillColor: '#009afd',
              strokeColor: '#009afd',
              fillOpacity: 1,
              strokeOpacity: 1,
              scale: 2,
              zIndex: 20,
              iconClassLegend: 'circle'
            },
            offset: '0',
            repeat: '10px'
          }],
          zIndex: 20
        },
        TRANSIT: {
          strokeWeight: 2,
          strokeColor: '#0000CC',
          icons: false,
          zIndex: 20
        },
        DRIVING: {
          strokeWeight: 2,
          strokeColor: '#808080',
          icons: false,
          zIndex: 20
        },
        BICYCLING: {
          strokeWeight: 2,
          strokeColor: '#808080',
          icons: false,
          zIndex: 20
        },
        strokeWeight: 2,
        strokeColor: '#808080',
        icons: false,
        zIndex: 20
      },
      applyTo: 1, //apply the styles by default. Number indicates the first number routes, 'all', 'agency'
      basicStyle: {
        strokeWeight: 2,
        strokeColor: '#a0a0a0',
        strokeOpacity: 0.8,
        icons: false,
        zIndex: 10
      },
      highlightStyle: {
        strokeOpacity: 1,
        strokeWeight: 5,
        zIndex: 40
      },
      selectedStyle: {
        strokeWeight: 2,
        zIndex: 30
      },
      deselectClickingOut: true,
      legend: false
    };
  },

  //Create the route with its posible styles and properties
  _createRoute: function _createRoute() {
    var _this = this;

    //there is one leg for each waypoint
    // presently, we only will have one leg
    var legs = this.providedRoute.legs;
    this.providedRoute.transitStops = [];
    _underscore2.default.each(legs, function (leg) {
      _underscore2.default.each(leg.steps, function (step) {
        _this.optRoute.push(_this._createOptStep(step));
        _this._handleAgencyOption(step);
        _this.providedRoute.transitStops.push(step);
      });
    });
    if (this.transitStops) {
      this.transitStopsLayer = new _TransitStopsLayer2.default(this.providedRoute.transitStops, {
        widget: this.widget
      });
    }
    this._createTransparentRoute();
  },

  //If is an array of agencies, check if this route belongs to one of them
  _handleAgencyOption: function _handleAgencyOption(step) {
    var stepAgency = step.transit ? _underscore2.default.pluck(step.transit.line.agencies, 'name') : false;
    var agencies = this.styles.agencies || [];
    if (stepAgency) {
      if (agencies.length > 0 && _underscore2.default.intersection(agencies, stepAgency).length > 0) {
        this.routeModel.setAgency(stepAgency);
      }
    }
  },


  /**
   * Check if this route is inside of agency limit
   * @memberOf module:Layers.RouteLayer
   * @function
   * @param {number} i - The index of route in the list of routes that belong to agencies array
   */
  setLimitToAgencies: function setLimitToAgencies(i) {
    if (this.styles.type === 'agencyStyle' && typeof this.styles.applyTo === 'number' && i < this.styles.applyTo || typeof this.styles.applyTo === 'string' || this.styles.applyTo === 'agency') {
      this.initialStyle = 'defaultStyle';
    }
  },


  //Create a transparentRoute with wide weight in order to handle click and hover events
  _createTransparentRoute: function _createTransparentRoute() {
    var completeGeom = 'overview_path';
    this.transparentRoute = new google.maps.Polyline({
      options: {
        strokeOpacity: 0,
        strokeWeight: 15
      },
      geodesic: true,
      clickable: true,
      path: this.providedRoute[completeGeom]
    });
    this._bindListeners(this.transparentRoute);
  },
  _createBackgroundRoute: function _createBackgroundRoute() {
    var _this2 = this;

    if (this.backgroundRoute.length) {
      this.removeBackgroundRoute();
    }
    var path = 'path',
        travelmode = 'travel_mode',
        options = {
      strokeWeight: 10,
      strokeColor: '#585858'
    };
    this.providedRoute.legs[0].steps.forEach(function (step) {
      if (step[travelmode] === 'TRANSIT') {
        _this2.backgroundRoute.push(new google.maps.Polyline({
          options: options,
          path: step[path],
          map: _this2.map
        }));
      }
    });
  },
  removeBackgroundRoute: function removeBackgroundRoute() {
    this.backgroundRoute.forEach(function (poly) {
      poly.setMap(null);
    });
    this.backgroundRoute = [];
  },


  /**
   * Get bounding box from route
   * @memberOf module:Layers.RouteLayer
   * @function
   * @returns {LatLngBounds} The bounds
   */
  getBounds: function getBounds() {
    var bounds = new google.maps.LatLngBounds();
    var path = this.transparentRoute.getPath();
    for (var i = 0; i < path.getLength(); i++) {
      bounds.extend(path.getAt(i));
    }
    return bounds;
  },

  //Create a polyline for a determinated step
  _createGeoStep: function _createGeoStep(path, opt) {
    var geoStep = new google.maps.Polyline({
      path: path,
      options: opt
    });
    return geoStep;
  },

  //Create the options to the possible status a determinated step
  _createOptStep: function _createOptStep(step) {
    var optStep = {
      defaultStyle: this._setStyleByType(step),
      basicStyle: this._normalizeOpt(this.styles.basicStyle),
      highlightStyle: this._normalizeOpt(this.styles.highlightStyle),
      selectedStyle: this._normalizeOpt(this.styles.selectedStyle)
    };

    return { path: step.path, options: optStep };
  },

  //Normalize the style checking if is a possible google option and adding common options
  _normalizeOpt: function _normalizeOpt(style) {
    var _this3 = this;

    var normalizedOpt = {
      geodesic: true,
      map: this.map
    };
    _underscore2.default.each(style, function (value, name) {
      if (_this3._isPolylineOption(name)) {
        normalizedOpt[name] = value;
      }
    });
    return normalizedOpt;
  },

  // Check if is a possible google option
  _isPolylineOption: function _isPolylineOption(name) {
    var polOpt = ['clickable', 'draggable', 'editable', 'geodesic', 'icons', 'map', 'path', 'strokeColor', 'strokeOpacity', 'strokeWeight', 'visible', 'zIndex'];
    if (polOpt.indexOf(name) !== -1) {
      return true;
    } else {
      return false;
    }
  },


  //Set default style for a step by type
  _setStyleByType: function _setStyleByType(step) {
    switch (this.styles.type) {
      case 'uniqueColors':
        return this._applyUniqueColors(step);
      case 'agencyStyle':
        return this._applyAgencyStyle(step);
      case 'googleStyle':
        return this._applyGoogleStyle(step);
      case 'modesStyle':
        return this._applyModesStyle(step);
    }
  },


  //Set style to option 'uniqueColors':  list of colors that will apply for each route displayed on the map.
  _applyUniqueColors: function _applyUniqueColors(step) {
    this.styles.defaultStyle.strokeColor = this.styles.defaultStyle.colorsList[this.index];
    var normalizedOpt = this._normalizeOpt(this.styles.defaultStyle);
    var legendText = this.widget.polyglot.t('legend.routeName') + ' ' + (this.index + 1);
    this._addElementToLegend(legendText, normalizedOpt);
    return normalizedOpt;
  },


  //Set style to option 'agencyStyle': Color for specified travel company (agencies)
  _applyAgencyStyle: function _applyAgencyStyle(step) {
    var normalizedOpt = this._normalizeOpt(this.styles.defaultStyle);
    var legendText = this.routeModel.getAgency();
    if (legendText) {
      this._addElementToLegend(legendText.toString(), normalizedOpt);
    }
    return normalizedOpt;
  },


  //Set style to option 'modesStyle':  list of colors that will apply for each transport mode (it can be styles for general modes
  _applyModesStyle: function _applyModesStyle(step) {
    var modeStyle = void 0,
        legendText = void 0;
    var modeField = 'travel_mode';
    if (step[modeField] === 'TRANSIT') {
      if (_underscore2.default.isUndefined(this.styles.defaultStyle[step.transit.line.vehicle.type])) {
        modeStyle = this.styles.defaultStyle.TRANSIT;
      } else {
        modeStyle = this.styles.defaultStyle[step.transit.line.vehicle.type];
      }
      legendText = step.transit.line.vehicle.name;
    } else {
      modeStyle = this.styles.defaultStyle[step[modeField]];
      legendText = step[modeField];
    }
    var normalizedOpt = this._normalizeOpt(modeStyle);
    this._addElementToLegend(legendText, normalizedOpt);
    return normalizedOpt;
  },

  //Set style to option 'googleStyle': colors that are provided by api (only transit so the rest are combined with 'modesStyle')
  _applyGoogleStyle: function _applyGoogleStyle(step) {
    var modeField = 'travel_mode';
    var modeStyle = this.styles.defaultStyle[step[modeField]];
    var legendText = step[modeField];
    if (step[modeField] === 'TRANSIT') {
      modeStyle.strokeColor = step.transit.line.color || '#000';
      legendText = step.transit.line.agencies[0].name;
    }
    var normalizedOpt = this._normalizeOpt(modeStyle);
    this._addElementToLegend(legendText, normalizedOpt);
    return normalizedOpt;
  },

  /**
   * Draw the routes on map
   * @memberOf module:Layers.RouteLayer
   * @function
   */
  draw: function draw() {
    var routeStep = void 0,
        zIndex = void 0;
    for (routeStep = 0; routeStep < this.optRoute.length; routeStep++) {
      var step = this._createGeoStep(this.optRoute[routeStep].path, this.optRoute[routeStep].options[this.initialStyle]);
      this.geoRoute.push(step);
      //save the zIndex in order to apply it to transparentRoute
      zIndex = this.optRoute[routeStep].options[this.initialStyle].zIndex;
    }
    this.transparentRoute.setOptions({
      map: this.map,
      zIndex: zIndex + 999
    });
    this.routeModel.setStyle(this.initialStyle);
  },

  /**
   * Remove the routes from map and its related events
   * @memberOf module:Layers.RouteLayer
   * @function
   */
  remove: function remove() {
    var routeStep = void 0;
    for (routeStep = 0; routeStep < this.geoRoute.length; routeStep++) {
      this.geoRoute[routeStep].setMap(null);
    }
    this.transparentRoute.setMap(null);
    google.maps.event.removeListener(this.clickOnMapListener);
    this.routeModel.off('change:selected');
    this.routeModel.off('change:style');
    if (this.transitStopsLayer) {
      this.transitStopsLayer.remove();
    }
    if (this.backgroundRoute && this.backgroundRoute.length) {
      this.removeBackgroundRoute();
    }
  },
  hide: function hide() {
    this.routeModel.setVisibility(false);
  },
  show: function show() {
    this.routeModel.setVisibility(true);
  },
  setVisibilityStyle: function setVisibilityStyle(visibility) {
    var routeStep = void 0;
    if (visibility) {
      for (routeStep = 0; routeStep < this.geoRoute.length; routeStep++) {
        this.geoRoute[routeStep].setMap(this.map);
      }
      this.transparentRoute.setMap(this.map);
    } else {
      for (routeStep = 0; routeStep < this.geoRoute.length; routeStep++) {
        this.geoRoute[routeStep].setMap(null);
      }
      this.transparentRoute.setMap(null);
    }
  },


  //Append 'hover', 'leave', 'click', 'select' and 'unselect' events to transparent Route
  _bindListeners: function _bindListeners(route) {
    var _this4 = this;

    if (this.routeHoverable) {
      google.maps.event.addListener(route, 'mouseover', function () {
        _this4.routeModel.onHover();
      });
      google.maps.event.addListener(route, 'mouseout', function () {
        _this4.routeModel.onLeave();
      });
    }
    if (this.routeClickable) {
      google.maps.event.addListener(route, 'click', function () {
        _this4.selectRoute();
      });
    }
    if (this.styles.deselectClickingOut) {
      this.clickOnMapListener = google.maps.event.addListener(this.map, 'click', function () {
        if (_this4.routeModel.isSelected()) {
          _this4.mapClick = true;
          _this4.deselectRoute();
        }
      });
    }
    this.routeModel.on('change:selected', function (model) {
      if (_this4.mapClick) {
        _this4.mapClick = false;
        return;
      }
      if (!model.isSelected()) {
        _this4.deselectRoute('basicStyle');
      } else {
        _this4.selectRoute();
      }
    }, this.routeModel);

    this.routeModel.on('change:style', function (model) {
      if (!model.isSelected()) {
        _this4._applyStyle(model.getStyle());
      }
    });

    this.routeModel.on('change:highlighted', function (model) {
      if (model.isHovered()) {
        _this4.highlightRoute();
      } else {
        _this4.leaveRoute();
      }
    });
    this.routeModel.on('change:visibility', function (model) {
      _this4.setVisibilityStyle(model.getVisibility());
    });
  },


  //Change the icons from a style in order to increase its size
  _getStyleWithIcons: function _getStyleWithIcons(icons) {
    var iconsStyle = {};
    if (icons) {
      var biggerIcons = [];
      for (var i = 0; i < icons.length; i++) {
        var scale = icons[i].icon.scale + 1;
        var icon = _underscore2.default.extend({}, icons[i].icon, { scale: scale });
        var repeat = parseInt(icons[i].repeat.split('px')[0]) + 2 + 'px';
        var newIcon = _underscore2.default.extend({}, icons[i], { icon: icon, repeat: repeat });
        biggerIcons.push(newIcon);
      }
      iconsStyle = {
        strokeWeight: 0,
        strokeOpacity: 0,
        icons: biggerIcons
      };
    }
    return iconsStyle;
  },

  /**
   * Highlight the hovered route combining the highlightStyle and the previous style
   * @memberOf module:Layers.RouteLayer
   * @function
   */
  highlightRoute: function highlightRoute() {
    var currentStyle = this.routeModel.getStyle();
    var isSelected = this.routeModel.isSelected();
    if (!isSelected) {
      this._applyEventStyle('highlightStyle', currentStyle);
    }
  },

  /**
   * Set the previous style to the leaved route
   * @memberOf module:Layers.RouteLayer
   * @function
   */
  leaveRoute: function leaveRoute() {
    var currentStyle = this.routeModel.getStyle();
    var isSelected = this.routeModel.isSelected();
    if (!isSelected) {
      this._applyStyle(currentStyle);
    }
  },

  /**
   * Select the route combining the defaultStyle and the selectedStyle
   * @memberOf module:Layers.RouteLayer
   * @function
   */
  selectRoute: function selectRoute() {
    this._applyEventStyle('selectedStyle', 'defaultStyle');
    this.routeModel.onSelect();
    if (this.transitStopsLayer) {
      this.transitStopsLayer.add();
    }

    if (this.backgroundRoute) {
      this._createBackgroundRoute();
    }
  },

  /**
   * Deselect the route and set its style like the previous (basic or default) or the specified on param
   * @memberOf module:Layers.RouteLayer
   * @function
   * @param {string} style - The style that will apply ('defaultStyle' or 'basicStyle').
   *  It's optional and if it's empty it'll apply the previous one
   */
  deselectRoute: function deselectRoute(style) {
    var prevStyle = style || this.routeModel.getStyle();
    this._applyStyle(prevStyle);
    this.routeModel.onDeselect();
    if (this.transitStopsLayer) {
      this.transitStopsLayer.remove();
    }
    if (this.backgroundRoute && this.backgroundRoute.length) {
      this.removeBackgroundRoute();
    }
  },

  //Apply a determinated style
  _applyStyle: function _applyStyle(style) {
    var routeStep = void 0;
    for (routeStep = 0; routeStep < this.optRoute.length; routeStep++) {
      var opt = this.optRoute[routeStep].options[style];
      delete opt.map;
      this.geoRoute[routeStep].setOptions(opt);
    }
  },

  //Apply a determinated style combining it with another
  //this style is applied for click and hover event because in these cases the style should be merge with currentStyle
  _applyEventStyle: function _applyEventStyle(eventStyle, currentStyle) {
    var routeStep = void 0;
    for (routeStep = 0; routeStep < this.optRoute.length; routeStep++) {
      var appliedStyle = this.optRoute[routeStep].options[currentStyle];
      var iconsStyle = this._getStyleWithIcons(appliedStyle.icons); //when the applied style has dots or another icon
      var opt = _underscore2.default.extend({}, appliedStyle, this.optRoute[routeStep].options[eventStyle], iconsStyle);
      delete opt.map;
      this.geoRoute[routeStep].setOptions(opt);
    }
  }
});

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseLayer = __webpack_require__(14);

var _BaseLayer2 = _interopRequireDefault(_BaseLayer);

var _transitStopsIW = __webpack_require__(151);

var _transitStopsIW2 = _interopRequireDefault(_transitStopsIW);

var _richmarker = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BaseLayer2.default.extend({
  /**
   * Create a new TransitStopsLayer instance
   * @memberOf module:Layers
   * @class TransitStopsLayer
   * @classdesc Stops identify on the transit routes.
   * @extends BaseLayer
   * @param {object} options - The needed config to draw the routes on map
   */
  constructor: function constructor(providedTransitStops) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options.featureId = 'TransitStopsLayer';
    options.source = {
      id: 'TransitStopsLayer'
    };
    this.providedTransitStops = providedTransitStops;
    _BaseLayer2.default.prototype.constructor.call(this, options);
  },


  /**
   * Initialize the layer
   * @memberOf module:Layers.TransitStopsLayer
   * @function
   */
  initialize: function initialize() {
    this.transitStopsMarkers = [];
    for (var i = 0; i < this.providedTransitStops.length; i++) {
      var departureStop = void 0,
          arrivalStop = void 0;
      var beforeStep = this.providedTransitStops[i - 1];
      var currentStep = this.providedTransitStops[i];
      var nextStep = this.providedTransitStops[i + 1];

      if (currentStep.transit && beforeStep && !beforeStep.transit && nextStep && !nextStep.transit) {
        // Current step is a transit step
        // Departure stop
        departureStop = this._getStopInfo(currentStep.transit, 'departure');
        this.transitStopsMarkers.push(this._addMarkerStop(departureStop));
        // Arrival stop
        arrivalStop = this._getStopInfo(currentStep.transit, 'arrival');
        this.transitStopsMarkers.push(this._addMarkerStop(arrivalStop));
      } else if (currentStep.transit && beforeStep && !beforeStep.transit && nextStep && nextStep.transit) {
        // Current and next steps are transit steps
        // Departure stop
        departureStop = this._getStopInfo(currentStep.transit, 'departure');
        this.transitStopsMarkers.push(this._addMarkerStop(departureStop));
        // Commute stop
        arrivalStop = this._getStopInfo(currentStep.transit, 'stop', nextStep.transit);
        this.transitStopsMarkers.push(this._addMarkerStop(arrivalStop));
      } else if (currentStep.transit && beforeStep && beforeStep.transit) {
        // Current and before steps are transit steps
        // Arrival
        arrivalStop = this._getStopInfo(currentStep.transit, 'arrival');
        this.transitStopsMarkers.push(this._addMarkerStop(arrivalStop));
      }
    }
  },


  /**
   * Add the layer
   * @function
   */
  add: function add() {
    for (var i = 0; i < this.transitStopsMarkers.length; i++) {
      this.transitStopsMarkers[i].setMap(this.widget.map);
    }
  },


  /**
   * Deactivate the layer
   * @function
   */
  remove: function remove() {
    if (this.transitStopsMarkers.length > 0) {
      this.widget.bus.trigger('CLOSE_INFOWINDOW');
      for (var i = 0; i < this.transitStopsMarkers.length; i++) {
        this.transitStopsMarkers[i].setMap(null);
      }
    }
  },
  _clickHandlerFunction: function _clickHandlerFunction(infowindowProperties, layer) {
    return function (e) {
      e.stopPropagation();
      e.preventDefault();
      layer._clickHandler(infowindowProperties, this);
    };
  },
  _clickHandler: function _clickHandler(infowindowProperties, marker) {
    var infowindowContent = new _transitStopsIW2.default(infowindowProperties);
    this.widget.bus.trigger('OPEN_INFOWINDOW', marker, this.widget.map, infowindowContent.$el.html());
  },
  _getStopInfo: function _getStopInfo(stop, type, nextStop) {
    var departureStop = 'departure_stop';
    var arrivalStop = 'arrival_stop';
    var departureTime = 'departure_time';
    var arrivalTime = 'arrival_time';
    var numStops = 'num_stops';
    var stopInfo = {
      type: type,
      stopName: type === 'departure' ? stop[departureStop].name : stop[arrivalStop].name,
      departureTime: type === 'departure' ? stop[departureTime] : type === 'arrival' ? false : nextStop[departureTime],
      arrivalTime: type === 'arrival' ? stop[arrivalTime] : type === 'departure' ? false : stop[arrivalTime],
      headsign: type === 'departure' ? stop.headsign : type === 'arrival' ? false : nextStop.headsign,
      line: type === 'departure' ? stop.line : type === 'arrival' ? false : nextStop.line,
      totalStops: type === 'departure' ? stop[numStops] : type === 'arrival' ? false : nextStop[numStops],
      location: type === 'departure' ? stop[departureStop].location : stop[arrivalStop].location
    };

    if (stopInfo.departureTime) {
      var startTimeOffset = this._getTimeOffset(stopInfo.departureTime.value, stopInfo.departureTime.text);
      stopInfo.departureTime = this._normalizeTime(this._getTimeInLocalGMT(stopInfo.departureTime.value, startTimeOffset));
    }
    if (stopInfo.arrivalTime) {
      var endTimeOffset = this._getTimeOffset(stopInfo.arrivalTime.value, stopInfo.arrivalTime.text);
      stopInfo.arrivalTime = this._normalizeTime(this._getTimeInLocalGMT(stopInfo.arrivalTime.value, endTimeOffset));
    }

    return stopInfo;
  },
  _getTimeOffset: function _getTimeOffset(time, text) {
    var hour = parseInt(text.split(':')[0]);
    if (text.split(':')[1].substring(2, 4) === 'pm' && hour !== 12) {
      hour += 12;
      if (hour === 24) {
        hour = 0;
      }
    }
    return (hour - time.getHours()) * 60;
  },
  _getTimeInLocalGMT: function _getTimeInLocalGMT(time, timezoneOffset) {
    var newTime = time.valueOf() + timezoneOffset * 60000;
    return new Date(newTime);
  },
  _normalizeTime: function _normalizeTime(time) {
    return time.getHours() + ':' + (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes());
  },
  _addMarkerStop: function _addMarkerStop(stopInfo) {
    var marker = new _richmarker.RichMarker({
      shadow: 'none',
      content: '<div class="lmm-marker-transit-stop ' + stopInfo.type + '"></div>',
      position: stopInfo.location,
      zIndex: 10
    });

    google.maps.event.addListener(marker, 'click', this._clickHandlerFunction(stopInfo, this));

    return marker;
  }
});

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _backbone2.default.View.extend({

  template: __webpack_require__(152),

  /**
   * Create a new TransitStopsIW instance
   * @memberOf module:Views
   * @class TransitStopsIW
   * @classdesc Infowindow to chow all information related to the transit stops.
   * @extends Backbone.View
   * @param {object} options - The needed config to fill the template
   */
  constructor: function constructor() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.options = options;
    this.templateConfig = {};
    _backbone2.default.View.prototype.constructor.call(this);
  },


  /**
   * Initialize the infowindow
   * @memberOf module:Views.TransitStopsIW
   * @function
   */
  initialize: function initialize(config) {
    _backbone2.default.View.prototype.initialize.call(this, config);
    _underscore2.default.extend(this.templateConfig, this.options);
    this.render();
  },


  /**
   * Render the template
   * @memberOf module:Views.TransitStopsIW
   * @function
   * @returns {TransitStopsIW} the instance
   */
  render: function render() {
    this.setElement(this.template(this.templateConfig));
    return this;
  }
});

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3=container.escapeExpression;

  return "        <table>\n            <tbody>\n                <tr class=\"lmm-data-item\">\n                    <td>"
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"transitStops.arrival",{"name":"t","hash":{},"data":data}))
    + ":</td>\n                    <td class=\"lmm-data-value\">"
    + alias3(((helper = (helper = helpers.arrivalTime || (depth0 != null ? depth0.arrivalTime : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"arrivalTime","hash":{},"data":data}) : helper)))
    + "</td>\n                </tr>\n            </tbody>\n        </table>\n        ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3=container.escapeExpression, alias4="function", alias5=container.lambda;

  return "\n        <table>\n            <tbody>\n                <tr class=\"lmm-data-item\">\n                    <td>"
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"transitStops.departure",{"name":"t","hash":{},"data":data}))
    + ":</td>\n                    <td class=\"lmm-data-value\">"
    + alias3(((helper = (helper = helpers.departureTime || (depth0 != null ? depth0.departureTime : depth0)) != null ? helper : alias2),(typeof helper === alias4 ? helper.call(alias1,{"name":"departureTime","hash":{},"data":data}) : helper)))
    + "</td>\n                </tr>\n                <tr class=\"lmm-data-item\">\n                    <td>"
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"transitStops.headsign",{"name":"t","hash":{},"data":data}))
    + ":</td>\n                    <td class=\"lmm-data-value\">"
    + alias3(((helper = (helper = helpers.headsign || (depth0 != null ? depth0.headsign : depth0)) != null ? helper : alias2),(typeof helper === alias4 ? helper.call(alias1,{"name":"headsign","hash":{},"data":data}) : helper)))
    + "</td>\n                </tr>\n                <tr class=\"lmm-data-item\">\n                    <td>"
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"transitStops.line",{"name":"t","hash":{},"data":data}))
    + ":</td>\n                    <td class=\"lmm-data-value\">\n                        <img class=\"icon\" src=\""
    + alias3(alias5(((stack1 = ((stack1 = (depth0 != null ? depth0.line : depth0)) != null ? stack1.vehicle : stack1)) != null ? stack1.icon : stack1), depth0))
    + "\" title=\""
    + alias3(alias5(((stack1 = ((stack1 = (depth0 != null ? depth0.line : depth0)) != null ? stack1.vehicle : stack1)) != null ? stack1.name : stack1), depth0))
    + "\">\n                        <span class=\"line\" title=\""
    + alias3(alias5(((stack1 = (depth0 != null ? depth0.line : depth0)) != null ? stack1.name : stack1), depth0))
    + "\">"
    + alias3(alias5(((stack1 = (depth0 != null ? depth0.line : depth0)) != null ? stack1.short_name : stack1), depth0))
    + "</span>\n                        <span>("
    + alias3(((helper = (helper = helpers.totalStops || (depth0 != null ? depth0.totalStops : depth0)) != null ? helper : alias2),(typeof helper === alias4 ? helper.call(alias1,{"name":"totalStops","hash":{},"data":data}) : helper)))
    + " "
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"transitStops.stops",{"name":"t","hash":{},"data":data}))
    + ")</span>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"lmm-ts-iw\">\n    <div class=\"lmm-ts-iw-title\">"
    + container.escapeExpression(((helper = (helper = helpers.stopName || (depth0 != null ? depth0.stopName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"stopName","hash":{},"data":data}) : helper)))
    + "</div>\n    <div class=\"lmm-ts-iw-content\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.arrivalTime : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.departureTime : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n</div>";
},"useData":true});

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

var _RouteModel = __webpack_require__(56);

var _RouteModel2 = _interopRequireDefault(_RouteModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _backbone2.default.Collection.extend({
  model: _RouteModel2.default,
  /**
   * @memberOf module:Layers
   * @class RoutesCollection
   * @classdesc This component controls the {@link DirectionModel} elements
   * @extends Backbone.Collection
   */
  initialize: function initialize() {},


  /**
   * When a  {@link RouteModel} is selected, the rest of models of the collection are deselected
   * @memberOf module:Layers.RoutesCollection
   * @function
   * @param {RouteModel} selectedModel - The selected model
   */
  selectModel: function selectModel(selectedModel) {
    this.each(function (model) {
      if (model !== selectedModel) {
        model.onDeselect();
        model.setStyle('basicStyle');
      } else {
        model.setStyle('defaultStyle');
      }
    });
  },


  /**
   * Add a new {@link RouteModel} to the collection
   * @memberOf module:Layers.RoutesCollection
   * @function
   * @param {RouteModel} model - The new model instance
   */
  add: function add(model) {
    _backbone2.default.Collection.prototype.add.call(this, model);
  }
});

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _richmarker = __webpack_require__(34);

var _richmarker2 = _interopRequireDefault(_richmarker);

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var MAX_ICONS = 3;
exports.default = _backbone2.default.View.extend({

  template: __webpack_require__(155),

  constructor: function constructor(options) {
    this.labels = [];
    this.widget = options.widget;
    this.map = this.widget.map;
    this.totalTime = 0;
    this.totalDistanceMeters = 0;
    this.minZoom = 11;
    this.zoomControl = options.config.zoomControl;
    if (this.zoomControl) {
      this._addListener();
    }
  },
  _addListener: function _addListener() {
    var _this = this;

    google.maps.event.addListener(this.map, 'zoom_changed', function () {
      _this.evaluateZoom();
    });
  },
  evaluateZoom: function evaluateZoom() {
    if (this.zoomControl && this.map.getZoom() < this.minZoom) {
      this.hideLabels();
    } else {
      if (this.route) {
        this.showLabels();
      }
    }
  },
  createLabel: function createLabel(route) {
    this.route = route;
    var optRoute = route.optRoute;
    this.templateConfig = this._parseData(route.providedRoute);
    var resultantPath = {
      path: [],
      options: optRoute[0].options //get the first because all be equals
    };
    optRoute.forEach(function (opt) {
      var _resultantPath$path;

      (_resultantPath$path = resultantPath.path).push.apply(_resultantPath$path, _toConsumableArray(opt.path));
    });
    resultantPath.dataDistance = this._calculateDistances(resultantPath.path);
    this.label = this._addLabel(resultantPath, this.map);
  },
  _addLabel: function _addLabel(opt, map) {
    var pos = void 0,
        label = void 0,
        middlePosition = this._calculatePosition(opt.path, opt.dataDistance);
    pos = middlePosition;
    this.templateConfig = Object.assign({
      direction: pos.direction
    }, this.templateConfig);

    this.render();
    var labelContent = this.$el[0];
    label = new _richmarker2.default.RichMarker({
      position: pos.position,
      content: labelContent,
      flat: true,
      anchor: _richmarker2.default.RichMarkerPosition[pos.direction.markerPosition],
      height: '15px',
      draggable: false,
      map: this.map
    });
    label.setZIndex(1000);
    this.labels.push(label);
    this.evaluateZoom();
    return label;
  },
  _calculateDistances: function _calculateDistances(path) {
    var i = void 0;
    var distances = [];
    var distance = void 0;
    var distancesObject = {};
    var totalDistance = 0;
    for (i = 1; i < path.length; i++) {
      distance = google.maps.geometry.spherical.computeDistanceBetween(path[i - 1], path[i]);
      distances.push(distance);
      distancesObject[distance] = i;
      totalDistance += distance;
    }
    return {
      distancesForSteps: distances,
      distancesObject: distancesObject,
      totalDistance: totalDistance
    };
  },
  _calculatePosition: function _calculatePosition(path, dataDistance) {
    var posiblePositions = void 0;
    posiblePositions = this._getPosiblePositions(dataDistance.distancesForSteps, dataDistance.distancesObject, path);
    var newGroups = {};
    var nameAux = '';
    posiblePositions.forEach(function (pos, index, allPos) {
      if (index === 0 || index > 0 && pos.direction.arrow !== allPos[index - 1].direction.arrow) {
        nameAux = pos.direction.arrow + '-' + index;
        newGroups[nameAux] = [];
        newGroups[nameAux].push(pos);
      }
      newGroups[nameAux].push(pos);
    });
    var newGroupsValues = Object.keys(newGroups).map(function (key) {
      return newGroups[key];
    });
    var max = newGroupsValues.reduce(function (prev, current) {
      return prev.length > current.length ? prev : current;
    });
    var middlePosition = max[Math.floor(max.length / 2)];
    return middlePosition;
  },
  _getPosiblePositions: function _getPosiblePositions(distances, distancesObject, path) {
    var posiblePositions = [];
    var i = void 0;
    var index = void 0;
    var start = void 0;
    var end = void 0;
    var midpoint = void 0;

    for (i = 0; i < distances.length; i++) {
      index = distances[i];
      start = path[distancesObject[index] - 1];
      end = path[distancesObject[index]];
      midpoint = this._getMidpoint(start, end);
      posiblePositions.push({
        position: midpoint,
        direction: this._getDirectionPosition(start, end)
      });
    }
    return posiblePositions;
  },
  _getMidpoint: function _getMidpoint(start, end) {
    return google.maps.geometry.spherical.interpolate(start, end, 0.5);
  },
  _sortNumber: function _sortNumber(a, b) {
    return a - b;
  },
  _getDirectionPosition: function _getDirectionPosition(start, end) {
    var arrow = void 0;
    var markerPosition = void 0;
    var angle = google.maps.geometry.spherical.computeHeading(start, end);
    if (angle > 0 && angle <= 45) {
      arrow = 'left';
      markerPosition = 'TOP_LEFT';
    } else if (angle > 45 && angle <= 90) {
      arrow = 'up-left';
      markerPosition = 'TOP_LEFT';
    } else if (angle > 90 && angle <= 135) {
      arrow = 'down-left';
      markerPosition = 'BOTTOM_LEFT';
    } else if (angle > 135) {
      arrow = 'left';
      markerPosition = 'BOTTOM_LEFT';
    } else if (angle < 0 && angle >= -45) {
      arrow = 'right';
      markerPosition = 'TOP_RIGHT';
    } else if (angle < -45 && angle >= -90) {
      arrow = 'up-right';
      markerPosition = 'TOP_RIGHT';
    } else if (angle < -90 && angle >= -135) {
      arrow = 'down-right';
      markerPosition = 'BOTTOM_RIGHT';
    } else if (angle < -135) {
      arrow = 'right';
      markerPosition = 'BOTTOM_RIGHT';
    }

    return {
      arrow: arrow,
      markerPosition: markerPosition
    };
  },
  removeLabels: function removeLabels() {
    this.labels.forEach(function (label) {
      label.setMap(null);
    });
    this.labels = [];
  },
  hideLabels: function hideLabels() {
    this.labels.forEach(function (label) {
      label.setMap(null);
    });
  },
  showLabels: function showLabels() {
    var _this2 = this;

    this.labels.forEach(function (label) {
      label.setMap(_this2.map);
    });
  },
  render: function render() {
    this.setElement(this.template(this.templateConfig));
    return this;
  },
  _parseData: function _parseData(route) {
    var travelModeIcons = this._parseDataTransportIconds(route);
    return {
      distance: route.legs[0].distance.text,
      totalTimeFormatedString: route.legs[0].duration.text,
      travelModeIcons: travelModeIcons,
      onlyOneIcon: travelModeIcons.length === 1
    };
  },
  _parseDataTransportIconds: function _parseDataTransportIconds(route) {
    var steps = route.legs[0].steps;
    var TRAVEL_MODE = 'travel_mode';
    var travelmodes = [];
    var stepsLength = steps.length;
    var firstTransitValue = steps[0][TRAVEL_MODE];
    var isTheSameTransitValue = steps.every(function (element) {
      return element[TRAVEL_MODE] === firstTransitValue;
    });
    if (isTheSameTransitValue) {
      travelmodes.push('lmm-icon-' + steps[0][TRAVEL_MODE].toLowerCase());
    } else {
      for (var i = 0; i < stepsLength; i++) {
        if (i < MAX_ICONS - 1 || i === stepsLength - 1) {
          travelmodes.push('lmm-icon-' + steps[i][TRAVEL_MODE].toLowerCase());
        } else {
          travelmodes.push('lmm-md-icon-dots');
          travelmodes.push('lmm-icon-' + steps[stepsLength - 1][TRAVEL_MODE].toLowerCase());
          return travelmodes;
        }
      }
    }
    return travelmodes;
  }
});

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "onlyOneIcon";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "      <span class=\"transport-icon "
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"></span>\n"
    + ((stack1 = helpers.unless.call(depth0 != null ? depth0 : (container.nullContext || {}),(data && data.last),{"name":"unless","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    return "        <span class=\"transport-icon lmm-label-arrow\"></span>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=helpers.helperMissing, alias4="function";

  return "<div class='lmm-label label-"
    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.direction : depth0)) != null ? stack1.arrow : stack1), depth0))
    + " "
    + ((stack1 = helpers["if"].call(alias2,(depth0 != null ? depth0.onlyOneIcon : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "'>\n  <div class=\"lmm-label-steps-icons\">\n"
    + ((stack1 = helpers.each.call(alias2,(depth0 != null ? depth0.travelModeIcons : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "  </div>\n  <div class=\"lmm-label-duration\">\n    <span class=\"lmm-label-text\">"
    + alias1(((helper = (helper = helpers.totalTimeFormatedString || (depth0 != null ? depth0.totalTimeFormatedString : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"totalTimeFormatedString","hash":{},"data":data}) : helper)))
    + "</span>\n  </div>\n  <div class=\"lmm-label-distance\">\n    <span class=\"lmm-label-text\">"
    + alias1(((helper = (helper = helpers.distance || (depth0 != null ? depth0.distance : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"distance","hash":{},"data":data}) : helper)))
    + "</span>\n  </div>\n</div>";
},"useData":true});

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-input "
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-from from-direction hotel-disabled-input\">\n                    <input type=\"text\" value=\""
    + alias4(((helper = (helper = helpers.inputMainHotelName || (depth0 != null ? depth0.inputMainHotelName : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"inputMainHotelName","hash":{},"data":data}) : helper)))
    + "\" disabled>\n                </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var helper;

  return "                <div class=\"directions-box-autocomplete "
    + container.escapeExpression(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-from from-direction\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div>\n    <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-transport-modes melia-jp-transportsmodes\"></div>\n    <div class=\"lmm-close_icon melia-close-icon\"></div>\n    <div class=\"directions-search-container\">\n        <div class=\"lmm-lateral-icons-origin-destination\">\n            <div class=\"directions-graphics-icons\"></div>\n        </div>\n        <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-inputs-container\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.blockHotelInput : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "            <div class=\"directions-box-autocomplete "
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-to to-direction\"></div>\n        </div>\n        <div class=\"lmm-lateral-right-icons melia-swap-icon\"></div>\n    </div>\n    <div class=\"lmm-autocomplete-results\"></div>\n    <div class=\"directionsBox-no-results-container\">\n        <div class=\"directionsBox-no-result error-search-panel\">"
    + alias4((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"autocomplete.notResultFound",{"name":"t","hash":{},"data":data}))
    + "</div>\n    </div>\n    <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-jp-list-results\"></div>\n</div>";
},"useData":true});

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MainMenuBlock = __webpack_require__(21);

var _MainMenuBlock2 = _interopRequireDefault(_MainMenuBlock);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _widgetTypes = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TIME_TO_WAIT_ON_KEY_MS = 500;

exports.default = _MainMenuBlock2.default.extend(
/**
 * @lends core.components.MainMenu
 */
{
	template: __webpack_require__(158),
	componentClass: 'mainBox',

	events: {
		'focusin .lmm-search-text-input': 'onFocusAutoComplete',
		'keyup .lmm-search-text-input': 'onInputKeyUp',
		'blur .lmm-search-text-input': 'onBlurAutoComplete',
		'click .reset': 'openPanelHotelDetail',
		'click .mainBox-arrow-back': 'clickInBackBtn'
	},

	constructor: function constructor(options) {
		var _this = this;

		_MainMenuBlock2.default.prototype.constructor.call(this, options);
		this.classPrefix = '.mainBox-';
		this.widget.map.addListener('click', function () {
			_this.$el.find('.lmm-search-text-input').blur();
			_this.closeCategoriesPanel();
		});
	},
	createConfigSubcomponents: function createConfigSubcomponents() {
		this.components = {
			Autocomplete: {
				position: 'autocomplete',
				componentConstructorClass: 'Autocomplete',
				identifier: 'Autocomplete',
				properties: {
					providers: {
						ListCategoriesProvider: {
							minLength: 3,
							maxResults: 5
						},
						GPlacesAutocomplete: {
							minLength: 3,
							maxResults: 5
						},
						ListHotelsProvider: {
							minLength: 1,
							maxResults: 5
						}
					}
				},
				resultsPanel: this.$el.find('.mainBox-result'),
				errorPanel: this.$el.find('.mainBox-no-result')
			},
			CategoriesPanel: {
				position: 'categories-panel',
				componentConstructorClass: 'CategoriesPanel',
				identifier: 'CategoriesPanel',
				parent: this
			}
		};
		if (!this.widget.isMobileVersion) {
			this.components.ToggleBtn = {
				position: 'directions',
				componentConstructorClass: 'ToggleBtn',
				properties: {
					event: 'directions_btn_event',
					iconClassName: 'ic_directions'
				}
			};

			this.components.HotelDetailPanel = {
				position: 'hotel-detail-panel',
				componentConstructorClass: 'HotelDetailPanel',
				identifier: 'HotelDetailPanel',
				parent: this
			};
		}
	},
	initialize: function initialize(options) {
		var _this2 = this;

		this.templateConfig.resultHeight = this.widget.getHeight();
		this.templateConfig.isMobileVersion = this.widget.isMobileVersion;
		_MainMenuBlock2.default.prototype.initialize.call(this, options);
		this.timer = null;
		this.listenTo(this.bus, 'SHOW_RESULTS_LIST', function () {
			_this2.$el.find('.lmm-main-box-hotel-detail-panel').hide();
		});
		this.listenTo(this.bus, 'RESET_AUTOCOMPLETE', function () {
			_this2.$el.find('.mainBox-hotel-detail-panel').show();
			if (_this2.widget.typeWidget === _widgetTypes.HOTEL_DETAILS && _this2.widget.isMobileVersion) {
				_this2.widget.$el.find('.lmm-hotel-resume-mobile-panel-hotel-summary-panel').show();
			}
		});
		this.listenTo(this.bus, 'SELECT_RESULT', function () {
			_this2.openPanelHotelDetail();
			_this2.closeCategoriesPanel();
		});
	},
	onFocusAutoComplete: function onFocusAutoComplete() {
		if (!this.components.Autocomplete.input.val()) {
			this.$el.find('.mainBox-categories-panel').show();
			this.closePanelHotelDetail();
		}
	},
	openPanelHotelDetail: function openPanelHotelDetail() {
		if (this.widget.typeWidget !== _widgetTypes.DESTINATIONS_TREE && this.widget.isMobileVersion || !this.components.HotelDetailPanel.onClose) {
			this.$el.find('.mainBox-hotel-detail-panel').show();
			this.$el.find('.lmm-main-box-hotel-detail-panel').show();
		}
	},
	closePanelHotelDetail: function closePanelHotelDetail() {
		this.$el.find('.mainBox-hotel-detail-panel').hide();
		this.$el.find('.lmm-main-box-hotel-detail-panel').hide();
	},
	openCategoriesPanel: function openCategoriesPanel() {
		if (!this.components.Autocomplete.input.val()) {
			this.$el.find('.mainBox-categories-panel').show();
		}
		this.closePanelHotelDetail();
	},
	closeCategoriesPanel: function closeCategoriesPanel() {
		if (!this.components.Autocomplete.input.val()) {
			this.openPanelHotelDetail();
		}
		this.$el.find('.mainBox-categories-panel').hide();
	},
	onInputKeyUp: function onInputKeyUp() {
		if (!this.components.Autocomplete.input.val()) {
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
			this.timer = setTimeout(_underscore2.default.bind(this.openCategoriesPanel, this), TIME_TO_WAIT_ON_KEY_MS);
		} else {
			this.closeCategoriesPanel();
			//clearTimeout(this.timer);
		}
	},
	caregorySelected: function caregorySelected(catText) {
		this.components.Autocomplete.fillAutocomplete(catText);
		this.closeCategoriesPanel();
	},
	hide: function hide() {
		this.closeCategoriesPanel();
	},
	clickInBackBtn: function clickInBackBtn(event) {
		this.widget.api.onClickBackMobile(event);
	}
});

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "            <div class=\"mainBox-separator-line\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3=container.escapeExpression;

  return "<div>\n    <div class=\"mainBox-container\">\n        <div class=\"mainBox-autocomplete\"></div>\n"
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.isMobileVersion : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "        <div class=\"mainBox-directions\"></div>\n    </div>\n    <div class=\"mainBox-result melia-autocomplete-result\" style=\"max-height: calc("
    + alias3(((helper = (helper = helpers.resultHeight || (depth0 != null ? depth0.resultHeight : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"resultHeight","hash":{},"data":data}) : helper)))
    + "px - 50px - 38px)\"></div>\n    <div class=\"mainBox-hotel-detail-panel\"></div>\n    <div class=\"mainBox-categories-panel\"></div>\n    <div class=\"melia-autocomplete-no-result-container mainBox-no-result error-search-panel\">\n        <div class=\"blockAutocomplete-no-result error-search-panel\">\n            "
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"autocomplete.notResultFound",{"name":"t","hash":{},"data":data}))
    + "\n        </div>\n    </div>\n</div>";
},"useData":true});

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _MainMenuBlock = __webpack_require__(21);

var _MainMenuBlock2 = _interopRequireDefault(_MainMenuBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MainMenuBlock2.default.extend({

    template: __webpack_require__(160),
    componentClass: 'blockAutocomplete',
    constructor: function constructor(options) {
        this.classPrefix = '.blockAutocomplete-';
        _MainMenuBlock2.default.prototype.constructor.call(this, options);
    },
    createConfigSubcomponents: function createConfigSubcomponents() {
        this.components = {
            Autocomplete: {
                position: 'autocomplete',
                componentConstructorClass: 'Autocomplete',
                identifier: 'Autocomplete',
                properties: {
                    providers: {
                        GPlacesAutocomplete: {
                            icons: ['transit_station', 'bus_station', 'train_station'],
                            minLength: 3,
                            maxResults: 5
                        },
                        ListHotelsProvider: {
                            minLength: 1,
                            maxResults: 5
                        }
                    }
                },
                resultsPanel: this.$el.find('.blockAutocomplete-result'),
                errorPanel: this.$el.find('.blockAutocomplete-no-result-container')
            }
        };
        if (!this.widget.isMobileVersion) {
            this.components.HotelDetailPanel = {
                position: 'hotel-detail-panel',
                componentConstructorClass: 'HotelDetailPanel',
                identifier: 'HotelDetailPanel',
                parent: this
            };
        }
    },
    initialize: function initialize(options) {
        var _this = this;

        this.templateConfig.resultHeight = this.widget.getHeight();
        this.templateConfig.isMobileVersion = this.widget.isMobileVersion;
        _MainMenuBlock2.default.prototype.initialize.call(this, options);
        if (!this.widget.isMobileVersion) {
            this.listenTo(this.bus, 'SHOW_RESULTS_LIST', function () {
                _this.$el.find('.blockAutocomplete-hotel-detail-panel').hide();
            });
            this.listenTo(this.bus, 'RESET_AUTOCOMPLETE', function () {
                _this.$el.find('.blockAutocomplete-hotel-detail-panel').show();
            });
            this.listenTo(this.bus, 'SELECT_RESULT', function () {
                if (!_this.components.HotelDetailPanel.onClose) {
                    _this.$el.find('.blockAutocomplete-hotel-detail-panel').show();
                    _this.$el.find('.lmm-main-box-hotel-detail-panel').show();
                }
            });
        }
    },


    events: {}
});

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3=container.escapeExpression;

  return "<div>\n    <div class=\"blockAutocomplete-container\">\n        <div class=\"blockAutocomplete-arrow-back\"></div>\n        <div class=\"blockAutocomplete-autocomplete\"></div>\n    </div>\n    <div class=\"blockAutocomplete-result melia-autocomplete-result\" style=\"max-height: calc("
    + alias3(((helper = (helper = helpers.resultHeight || (depth0 != null ? depth0.resultHeight : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"resultHeight","hash":{},"data":data}) : helper)))
    + "px - 50px - 38px)\"></div>\n    <div class=\"melia-autocomplete-no-result-container blockAutocomplete-no-result-container error-search-panel-container\">\n        <div class=\"blockAutocomplete-no-result error-search-panel\">\n            "
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"autocomplete.notResultFound",{"name":"t","hash":{},"data":data}))
    + "\n        </div>\n    </div>\n    <div class=\"blockAutocomplete-hotel-detail-panel\"></div>\n</div>";
},"useData":true});

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _runtime = __webpack_require__(13);

var _runtime2 = _interopRequireDefault(_runtime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class ToggleBtn
 * @memberof core.components
 *
 * @fires Widget#TOGGLE_PANEL_MENU
 * @fires Widget#TOGGLE_MAIN_MENU
 * @fires Widget#TOGGLE_DRAW_TOOL
 */
var TransportModes = _ComponentBase2.default.extend(
/**
 * @lends core.components.ToggleBtn.prototype
 */
{

    template: __webpack_require__(162),

    componentClass: 'transport-modes',

    transportTypes: ['transit', 'driving', 'bicycling', 'walking'],

    events: {
        'click': 'toggleBtn'
    },

    /**
     * Initialize the component
     * @function
     * @param {Object} options - The config provided by json
     */
    initialize: function initialize(config) {
        this.bus = this.widget.bus;
        this.templateConfig.transportTypes = this.transportTypes;
        this.templateConfig.activeTransportType = this.properties.defaultMode;
        this.loadHelpers();
        _ComponentBase2.default.prototype.initialize.call(this, config);
    },


    /**
     * Fires the event and toggle class
     * @private
     */
    toggleBtn: function toggleBtn(event) {
        this.transportTypeEvent = event.target.dataset.transportmode;
        if (this.templateConfig.activeTransportType !== this.transportTypeEvent) {
            this.templateConfig.activeTransportType = this.transportTypeEvent;
            this.$el.replaceWith(this.render().$el);
            this.bus.trigger(this.properties.event, this);
            (0, _jquery2.default)(this.el).toggleClass('lmm-active');
        }
    },
    loadHelpers: function loadHelpers() {
        _runtime2.default.registerHelper('transportModeActive', function () {
            var args = Array.prototype.slice.call(arguments, 0, -1);
            return args.every(function (expression) {
                return args[0] === expression;
            });
        });
    }
});

exports.default = TransportModes;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers["if"].call(alias1,(helpers.transportModeActive || (depth0 && depth0.transportModeActive) || helpers.helperMissing).call(alias1,depth0,(depths[1] != null ? depths[1].activeTransportType : depths[1]),{"name":"transportModeActive","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.program(4, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var helper, alias1=container.lambda, alias2=container.escapeExpression;

  return "            <div data-transportMode=\""
    + alias2(alias1(depth0, depth0))
    + "\"\n                 class=\"melia-jp-transportmode lmm-icon-"
    + alias2(alias1(depth0, depth0))
    + " "
    + alias2(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"componentClass","hash":{},"data":data}) : helper)))
    + " active\"></div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var helper, alias1=container.lambda, alias2=container.escapeExpression;

  return "            <div data-transportMode=\""
    + alias2(alias1(depth0, depth0))
    + "\"\n                 class=\"melia-jp-transportmode lmm-icon-"
    + alias2(alias1(depth0, depth0))
    + " "
    + alias2(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "<div>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.transportTypes : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true,"useDepths":true});

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _runtime = __webpack_require__(13);

var _runtime2 = _interopRequireDefault(_runtime);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _JPRouteHelper = __webpack_require__(57);

var _JPRouteHelper2 = _interopRequireDefault(_JPRouteHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JPList = _ComponentBase2.default.extend({

    template: __webpack_require__(164),
    componentClass: 'directions-box-jp-list-route',

    events: {
        'click .jp-list-element': 'onClickRouteElement',
        'click .view-details-cta': 'onClickViewDetails',
        'click .view-map-cta': 'onClickViewMap'
    },

    routeSelectedIndex: 0,

    stepsShownPerRoute: 2,

    isDetailsPanelOpened: false,

    initialize: function initialize(config) {
        this.bus = this.widget.bus;
        this.loadHelpers();
        _ComponentBase2.default.prototype.initialize.call(this, config);
    },
    updateRoute: function updateRoute(route, handleRoutes) {
        var _this = this;

        this.routes = route.routes;
        this.handleRoutes = handleRoutes;
        this.routeSelectedIndex = 0;
        this.isDetailsPanelOpened = false;
        this.travelMode = route.request.travelMode.toLowerCase();
        if (this.routes.length) {
            var normalizeRoutes = [];
            this.routes.forEach(function (route) {
                if (_this.isTransitRoute(route)) {
                    normalizeRoutes.push(_this.normalizeTransitRoute(route));
                } else {
                    normalizeRoutes.push(_this.normalizeNonTransitRoute(route));
                }
            });
            this._bindListeners(handleRoutes);
            this.templateConfig = {
                stepsShownPerRoute: this.stepsShownPerRoute,
                normalizeRoutes: normalizeRoutes,
                selectedRouteIndex: this.selectedRouteIndex
            };
        } else {
            this.templateConfig = {
                noResults: true
            };
        }
        this.show();
        this.$el.replaceWith(this.render().$el);
    },
    _bindListeners: function _bindListeners(handleRoutes) {
        var _this2 = this;

        handleRoutes.routesView.forEach(function (routeView) {
            var routeModel = routeView.routeModel;
            routeModel.on('change:selected', function (model) {
                if (model.isSelected()) {
                    _this2.selectRoute(routeView);
                    if (_this2.isDetailsPanelOpened) {
                        _this2.triggerDetailsPanel();
                    }
                }
            });
        });
    },
    selectRoute: function selectRoute(route) {
        this._removeSelectedClassInCurrentRoute();
        this.routeSelectedIndex = route.index;
        this._addSelectedClassInRoute();
    },
    normalizeNonTransitRoute: function normalizeNonTransitRoute(route) {
        var legs = route.legs[0];
        return {
            icon: this.isWalkingRoute(route) ? 'walking' : this.travelMode,
            via: '' + route.summary,
            time: legs.duration.text,
            distance: legs.distance.text
        };
    },
    normalizeTransitRoute: function normalizeTransitRoute(route) {
        var legs = route.legs[0];
        var totalWalking = 0;
        legs.steps.forEach(function (step) {
            if (step.travel_mode === 'WALKING') {
                totalWalking += step.duration.value;
            }
        });
        return {
            icon: this.travelMode,
            departureTime: legs.departure_time ? legs.departure_time.text : '',
            arrivalTime: legs.arrival_time ? legs.arrival_time.text : '',
            time: legs.duration.text,
            walkingTime: (totalWalking / 60).toFixed(0),
            steps: legs.steps.map(function (step) {
                if (step.travel_mode === 'WALKING') {
                    return {
                        travelMode: step.travel_mode.toLowerCase()
                    };
                } else {
                    return {
                        travelMode: step.travel_mode.toLowerCase(),
                        lineName: step.transit.line.short_name,
                        icon: step.transit.line.vehicle.local_icon,
                        color: step.transit.line.color
                    };
                }
            })
        };
    },
    onClickRouteElement: function onClickRouteElement(event) {
        var indexRoute = (0, _jquery2.default)(event.currentTarget).data('route-index');
        this._selectedRouteLayerModel(indexRoute);
    },
    _removeSelectedClassInCurrentRoute: function _removeSelectedClassInCurrentRoute() {
        var lastRouteSelectedDomElement = this.$el.find('#jp-list-element-' + this.routeSelectedIndex);
        lastRouteSelectedDomElement.removeClass('route-selected');
    },
    _addSelectedClassInRoute: function _addSelectedClassInRoute() {
        var newRouteSelected = this.$el.find('#jp-list-element-' + this.routeSelectedIndex);
        newRouteSelected.addClass('route-selected');
    },
    _selectedRouteLayerModel: function _selectedRouteLayerModel(index) {
        this.handleRoutes.routesView[index].routeModel.onSelect();
    },
    loadHelpers: function loadHelpers() {
        _runtime2.default.registerHelper('printStep', function () {
            return _JPRouteHelper2.default.printStep(arguments);
        });

        _runtime2.default.registerHelper('printDots', function () {
            return _JPRouteHelper2.default.printDots(arguments);
        });
    },
    onClickViewDetails: function onClickViewDetails() {
        this.triggerDetailsPanel(false);
    },
    onClickViewMap: function onClickViewMap() {
        this.triggerDetailsPanel(true);
    },
    triggerDetailsPanel: function triggerDetailsPanel(collapsed) {
        this.isDetailsPanelOpened = true;
        this.bus.trigger('CLICK_IN_DETAILS_ROUTE_BTN', {
            route: this.routes[this.routeSelectedIndex],
            origin: this.parentComponent.getOriginText(),
            destination: this.parentComponent.getDestinationText(),
            travelMode: this.travelMode,
            originIsMainHotel: this.parentComponent.getOriginIsMainHotel(),
            panelCollapsed: collapsed
        });
    },
    setIsDetailsPanelOpened: function setIsDetailsPanelOpened(isDetailsPanelOpened) {
        this.isDetailsPanelOpened = isDetailsPanelOpened;
    },
    isTransitRoute: function isTransitRoute(route) {
        return route.legs[0].steps.some(function (step) {
            return step.travel_mode === 'TRANSIT';
        });
    },
    isWalkingRoute: function isWalkingRoute(route) {
        return route.legs[0].steps.every(function (step) {
            return step.travel_mode === 'WALKING';
        });
    }
});

exports.default = JPList;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda;

  return "        <div id=\"jp-list-element-"
    + alias4(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" \n            class=\"jp-list-element"
    + ((stack1 = helpers["if"].call(alias1,(data && data.first),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\"\n            data-route-index=\""
    + alias4(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + "\">\n            <div class=\"melia-trasnport-icon lmm-icon-"
    + alias4(alias5((depth0 != null ? depth0.icon : depth0), depth0))
    + "\"></div>\n            <div class=\"route-container\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.via : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.program(6, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "                <div class=\"jp-transit-steps\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.steps : depth0),{"name":"each","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                </div>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.walkingTime : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            </div>\n\n            <div class=\"block-time-distance\">\n                <div class=\"route-time\">"
    + alias4(alias5((depth0 != null ? depth0.time : depth0), depth0))
    + "</div>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.distance : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            </div>\n            <div class=\"jp-list-element-buttons-box\">\n                <div class=\"jp-list-element-btn view-details-cta\">"
    + alias4((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"routeDetails.details",{"name":"t","hash":{},"data":data}))
    + "</div>\n                <div class=\"jp-list-element-btn view-map-cta\">"
    + alias4((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"routeLabel.viewMap",{"name":"t","hash":{},"data":data}))
    + "</div>\n            </div>\n        </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return " route-selected";
},"4":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression;

  return "                    <div class=\"lmm-route-via\">\n                        "
    + alias1((helpers.t || (depth0 && depth0.t) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"journeyPlanner.via",{"name":"t","hash":{},"data":data}))
    + " "
    + alias1(container.lambda((depth0 != null ? depth0.via : depth0), depth0))
    + "\n                    </div>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "                    <div class=\"lmm-route-via\">"
    + alias2(alias1((depth0 != null ? depth0.departureTime : depth0), depth0))
    + " - "
    + alias2(alias1((depth0 != null ? depth0.arrivalTime : depth0), depth0))
    + "</div>\n";
},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "                        <div class=\"jp-transit-step-container\">\n"
    + ((stack1 = helpers["if"].call(alias1,(helpers.printStep || (depth0 && depth0.printStep) || helpers.helperMissing).call(alias1,(data && data.index),((stack1 = (depths[1] != null ? depths[1].steps : depths[1])) != null ? stack1.length : stack1),(depths[2] != null ? depths[2].stepsShownPerRoute : depths[2]),{"name":"printStep","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n                        </div>\n";
},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers["if"].call(alias1,(helpers.printDots || (depth0 && depth0.printDots) || helpers.helperMissing).call(alias1,(data && data.index),((stack1 = (depths[1] != null ? depths[1].steps : depths[1])) != null ? stack1.length : stack1),(depths[2] != null ? depths[2].stepsShownPerRoute : depths[2]),{"name":"printDots","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.program(12, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"10":function(container,depth0,helpers,partials,data) {
    return "                                    ...\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.program(15, data, 0),"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.lineName : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(alias1,(data && data.last),{"name":"unless","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data) {
    return "                                        <img class=\"jp-transit-image\" src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.icon : depth0), depth0))
    + "\">\n";
},"15":function(container,depth0,helpers,partials,data) {
    return "                                        <i class=\"lmm-icon-"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.travelMode : depth0), depth0))
    + " jp-transit-icon\"></i>\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                                        <div class=\"jp-transit-line\"\n                                             "
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.color : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.lineName : depth0), depth0))
    + "</div>\n";
},"18":function(container,depth0,helpers,partials,data) {
    return "style=\"background: "
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.color : depth0), depth0))
    + "\"";
},"20":function(container,depth0,helpers,partials,data) {
    return "                                        <div class=\"lmm-icon-chevron-right jp-transit-icon\"></div>\n";
},"22":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression;

  return "                    <div class=\"jp-transit-walking-time\">\n                        <i class=\"lmm-icon-walking\"></i>\n                        "
    + alias1(container.lambda((depth0 != null ? depth0.walkingTime : depth0), depth0))
    + " "
    + alias1((helpers.t || (depth0 && depth0.t) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"routeLabel.mins",{"name":"t","hash":{},"data":data}))
    + "\n                    </div>\n";
},"24":function(container,depth0,helpers,partials,data) {
    return "                    <div class=\"route-distance\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.distance : depth0), depth0))
    + "</div>\n";
},"26":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.noResults : depth0),{"name":"if","hash":{},"fn":container.program(27, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"27":function(container,depth0,helpers,partials,data) {
    return "            <div class=\"jp-list-no-route\">\n                "
    + container.escapeExpression((helpers.t || (depth0 && depth0.t) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"routeLabel.noRoute",{"name":"t","hash":{},"data":data}))
    + "\n            </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "<div class=\"jp-list-route\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.normalizeRoutes : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(26, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true,"useDepths":true});

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MainMenuBlock = __webpack_require__(21);

var _MainMenuBlock2 = _interopRequireDefault(_MainMenuBlock);

var _JPNonTransitGeneralInfo = __webpack_require__(58);

var _JPNonTransitGeneralInfo2 = _interopRequireDefault(_JPNonTransitGeneralInfo);

var _JPTransitGeneralInfo = __webpack_require__(59);

var _JPTransitGeneralInfo2 = _interopRequireDefault(_JPTransitGeneralInfo);

var _JPNonTransitStepsInfo = __webpack_require__(60);

var _JPNonTransitStepsInfo2 = _interopRequireDefault(_JPNonTransitStepsInfo);

var _JPTransitStepsInfo = __webpack_require__(61);

var _JPTransitStepsInfo2 = _interopRequireDefault(_JPTransitStepsInfo);

var _SeeMapAndDetailsBtn = __webpack_require__(170);

var _SeeMapAndDetailsBtn2 = _interopRequireDefault(_SeeMapAndDetailsBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MainMenuBlock2.default.extend({
	template: __webpack_require__(172),
	componentClass: 'jp-route-details',
	events: {
		'click .jp-route-details-go-back': 'onClickGoBack',
		'click .jp-route-details-close': 'onClickClose'
	},

	panelCollapsed: undefined,

	createConfigSubcomponents: function createConfigSubcomponents() {},
	addListeners: function addListeners() {
		var _this = this;

		google.maps.event.addDomListener(this.widget.map, 'resize', function () {
			_this.setHeight();
		});
	},
	setHeight: function setHeight() {
		var widgetHeight = this.widget.getHeight();
		var heightDetailsHeader = 160;
		var marginTopMainPanel = 10;
		var googleLogoHeight = 28;
		var stepsInfoContainerDomElement = this.$el.find('.jp-route-details-steps-info-container');
		if (this.widget.isMobileVersion) {
			stepsInfoContainerDomElement.css('height', widgetHeight - heightDetailsHeader + 'px');
		} else {
			stepsInfoContainerDomElement.css('max-height', widgetHeight - heightDetailsHeader - marginTopMainPanel - googleLogoHeight + 'px');
		}
	},
	updateRouteDetails: function updateRouteDetails(route, originText, destinationText, travelMode, originIsMainHotel, panelCollapsed) {
		if (panelCollapsed !== undefined) {
			// if this param not exists, the panel use the last state
			this.panelCollapsed = panelCollapsed;
		}
		this.addListeners();
		this.templateConfig = {
			route: route,
			fromDataStr: originText,
			toDataStr: destinationText,
			mobileClass: this.widget.isMobileVersion ? 'lmm-jp-route-details-mobile-version' : ''
		};
		var generalInfoComponent = void 0;
		var stepsInfoComponent = void 0;
		if (this.isTransitLeg(route.legs[0])) {
			generalInfoComponent = this.createTransitGeneralInfo(route, travelMode);
			stepsInfoComponent = this.createTransitStepsInfo(route, originText, destinationText);
		} else {
			generalInfoComponent = this.createNonTransitGeneralInfo(route, travelMode);
			stepsInfoComponent = this.createNonTransitStepsInfo(route, originText, destinationText, originIsMainHotel);
		}
		this.show();
		this.$el.replaceWith(this.render().$el);
		if (this.panelCollapsed) {
			this.$el.addClass('jp-route-details-collapse');
		}
		this.$el.find('.' + this.componentClass + '-general-info').append(generalInfoComponent.$el);
		var seeMapAndDetailsBtnComponent = this.createSeeMapAndDetailsBtnComponent(this.panelCollapsed);
		generalInfoComponent.$el.find('.see-map-details-btn').append(seeMapAndDetailsBtnComponent.$el);
		this.$el.find('.' + this.componentClass + '-steps-info-container').append(stepsInfoComponent.$el);
		this.setHeight();
	},
	isTransitLeg: function isTransitLeg(leg) {
		return leg.steps.some(function (step) {
			return step.travel_mode === 'TRANSIT';
		});
	},
	createNonTransitGeneralInfo: function createNonTransitGeneralInfo(route, travelMode) {
		var jpNonTransitGeneralInfo = new _JPNonTransitGeneralInfo2.default({
			componentClass: 'jp-non-transit-general-info',
			widget: this.widget,
			bus: this.widget.bus,
			componentConstructorClass: 'JPNonTransitGeneralInfo',
			properties: {
				travelMode: travelMode,
				route: route.legs[0],
				summary: route.summary
			}
		});
		return jpNonTransitGeneralInfo;
	},
	createNonTransitStepsInfo: function createNonTransitStepsInfo(route, originText, destinationText, originIsMainHotel) {
		var jpNonTransitStepsInfo = new _JPNonTransitStepsInfo2.default({
			componentClass: 'jp-non-transit-steps-info',
			widget: this.widget,
			bus: this.widget.bus,
			componentConstructorClass: 'JPNonTransitStepsInfo',
			properties: {
				route: route.legs[0],
				originText: originText,
				destinationText: destinationText,
				originIsMainHotel: originIsMainHotel
			}
		});
		return jpNonTransitStepsInfo;
	},
	createTransitGeneralInfo: function createTransitGeneralInfo(route, travelMode) {
		var jpTransitGeneralInfo = new _JPTransitGeneralInfo2.default({
			componentClass: 'jp-transit-general-info',
			widget: this.widget,
			bus: this.widget.bus,
			componentConstructorClass: 'JPTransitGeneralInfo',
			properties: {
				travelMode: travelMode,
				route: route.legs[0]
			}
		});
		return jpTransitGeneralInfo;
	},
	createTransitStepsInfo: function createTransitStepsInfo(route, originText, destinationText) {
		var jpTransitStepsInfo = new _JPTransitStepsInfo2.default({
			componentClass: 'jp-transit-steps-info',
			widget: this.widget,
			bus: this.widget.bus,
			componentConstructorClass: 'JPTransitStepsInfo',
			properties: {
				route: route.legs[0],
				originText: originText,
				destinationText: destinationText
			}
		});
		return jpTransitStepsInfo;
	},
	onClickGoBack: function onClickGoBack() {
		this.hide();
		this.bus.trigger('CLICK_IN_BACK_DETAILS_ROUTE');
	},
	onClickClose: function onClickClose() {
		this.hide();
		var closeDirectionsBox = false;
		this.bus.trigger('directions_btn_event', closeDirectionsBox);
		this.stopListening();
	},
	createSeeMapAndDetailsBtnComponent: function createSeeMapAndDetailsBtnComponent(collapsed) {
		return new _SeeMapAndDetailsBtn2.default({
			componentClass: 'jp-see-map-and-details-btn',
			widget: this.widget,
			bus: this.widget.bus,
			componentConstructorClass: 'SeeMapAndDetailsBtn',
			parent: this,
			properties: {
				seeMapState: !collapsed
			}
		});
	},
	collapseDetailsPanel: function collapseDetailsPanel(collapsedPanel) {
		this.panelCollapsed = collapsedPanel;
		this.$el.toggleClass('jp-route-details-collapse');
	}
});

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda;

  return "<div class=\"jp-non-trasit-general-info-container\">\n    <div class=\"jp-non-transit-travel-mode\">\n        <i class=\"lmm-icon-"
    + alias4(((helper = (helper = helpers.travelMode || (depth0 != null ? depth0.travelMode : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"travelMode","hash":{},"data":data}) : helper)))
    + "\"></i>\n    </div>\n    <div class=\"jp-non-transit-info\">\n        <div class=\"jp-non-transit-time-distance-container\">\n            <div class=\"jp-non-transit-time\">("
    + alias4(alias5(((stack1 = ((stack1 = (depth0 != null ? depth0.route : depth0)) != null ? stack1.duration : stack1)) != null ? stack1.text : stack1), depth0))
    + ")</div>\n            <div class=\"jp-non-transit-distance\">"
    + alias4(alias5(((stack1 = ((stack1 = (depth0 != null ? depth0.route : depth0)) != null ? stack1.distance : stack1)) != null ? stack1.text : stack1), depth0))
    + "</div>\n        </div>\n        <div class=\"jp-non-transit-route-info\">\n            "
    + alias4((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"routeLabel.via",{"name":"t","hash":{},"data":data}))
    + " "
    + alias4(((helper = (helper = helpers.summary || (depth0 != null ? depth0.summary : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"summary","hash":{},"data":data}) : helper)))
    + "\n        </div>\n    </div>\n    <div class=\"jp-non-transit-options\">\n        <div class=\"see-map-details-btn\"></div>\n    </div>\n</div>";
},"useData":true});

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "                <div class=\"jp-transit-step-container\">\n"
    + ((stack1 = helpers["if"].call(alias1,(helpers.printStep || (depth0 && depth0.printStep) || helpers.helperMissing).call(alias1,(data && data.index),((stack1 = ((stack1 = (depths[1] != null ? depths[1].route : depths[1])) != null ? stack1.steps : stack1)) != null ? stack1.length : stack1),(depths[1] != null ? depths[1].stepsShownPerRoute : depths[1]),{"name":"printStep","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n                </div>\n";
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers["if"].call(alias1,(helpers.printDots || (depth0 && depth0.printDots) || helpers.helperMissing).call(alias1,(data && data.index),((stack1 = ((stack1 = (depths[1] != null ? depths[1].route : depths[1])) != null ? stack1.steps : stack1)) != null ? stack1.length : stack1),(depths[1] != null ? depths[1].stepsShownPerRoute : depths[1]),{"name":"printDots","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.program(5, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    return "                            ...\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.lineName : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(alias1,(data && data.last),{"name":"unless","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    return "                                <img class=\"jp-transit-image\" src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.icon : depth0), depth0))
    + "\">\n";
},"8":function(container,depth0,helpers,partials,data) {
    return "                                <i class=\"lmm-icon-"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.travelMode : depth0), depth0))
    + " jp-transit-icon\"></i>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                                <div class=\"jp-transit-line\"\n                                     "
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.color : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.lineName : depth0), depth0))
    + "</div>\n";
},"11":function(container,depth0,helpers,partials,data) {
    return "style=\"background: "
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.color : depth0), depth0))
    + "\"";
},"13":function(container,depth0,helpers,partials,data) {
    return "                                <div class=\"lmm-icon-chevron-right jp-transit-icon\"></div>\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.escapeExpression;

  return "            <div class=\"jp-transit-walking-time\">\n                <i class=\"lmm-icon-walking\"></i>\n                <div class=\"jp-transit-walking-time-text\">"
    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.route : depth0)) != null ? stack1.walkingTime : stack1), depth0))
    + " "
    + alias1((helpers.t || (depth0 && depth0.t) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"routeLabel.mins",{"name":"t","hash":{},"data":data}))
    + "</div>\n            </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda;

  return "<div class=\"jp-trasit-general-info-container\">\n    <div class=\"jp-transit-travel-mode\">\n        <i class=\"lmm-icon-"
    + alias2(((helper = (helper = helpers.travelMode || (depth0 != null ? depth0.travelMode : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"travelMode","hash":{},"data":data}) : helper)))
    + "\"></i>\n    </div>\n    <div class=\"jp-transit-info\">\n        <div class=\"jp-transit-time-distance-container\">\n            <div class=\"jp-transit-via\">"
    + alias2(alias3(((stack1 = (depth0 != null ? depth0.route : depth0)) != null ? stack1.departureTime : stack1), depth0))
    + "-"
    + alias2(alias3(((stack1 = (depth0 != null ? depth0.route : depth0)) != null ? stack1.arrivalTime : stack1), depth0))
    + "</div>\n            <div class=\"jp-transit-time\">"
    + alias2(alias3(((stack1 = (depth0 != null ? depth0.route : depth0)) != null ? stack1.time : stack1), depth0))
    + "</div>\n        </div>\n        <div class=\"jp-transit-steps\">\n"
    + ((stack1 = helpers.each.call(alias1,((stack1 = (depth0 != null ? depth0.route : depth0)) != null ? stack1.steps : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\n"
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.route : depth0)) != null ? stack1.walkingTime : stack1),{"name":"if","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n    <div class=\"jp-transit-options\">\n        <div class=\"see-map-details-btn\"></div>\n    </div>\n</div>";
},"useData":true,"useDepths":true});

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "            "
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.originIsMainHotel : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "\n";
},"2":function(container,depth0,helpers,partials,data) {
    return " jp-non-transit-hotel-icon ";
},"4":function(container,depth0,helpers,partials,data) {
    return " jp-non-transit-standard-marker-icon";
},"6":function(container,depth0,helpers,partials,data) {
    return "            jp-non-transit-origin-icon\n        ";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "            <div class=\"jp-non-transit-step\">\n                <div class=\"jp-non-transit-step-icon\"><i class=\"lmm-google-maneuver lmm-google-"
    + alias2(alias1((depth0 != null ? depth0.maneuver : depth0), depth0))
    + "\"></i>\n                </div>\n                <div class=\"jp-non-transit-step-info\">"
    + ((stack1 = alias1((depth0 != null ? depth0.instructions : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n            </div>\n            <div class=\"jp-non-transit-step-separator-container\">\n                <div class=\"jp-non-transit-step-separator\">\n                    <div class=\"jp-non-transit-step-separator-duration\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.duration : depth0)) != null ? stack1.text : stack1), depth0))
    + " ("
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.distance : depth0)) != null ? stack1.text : stack1), depth0))
    + ")\n                    </div>\n                    <div class=\"jp-non-transit-step-separator-line\"></div>\n                </div>\n            </div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "            "
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.destinationIsMainHotel : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "\n";
},"12":function(container,depth0,helpers,partials,data) {
    return "            jp-non-transit-destination-icon\n        ";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"jp-non-transit-locations\">\n        <div class=\"jp-non-transit-direction-icon \n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDetailHotelWidget : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "")
    + "\"\n        >\n        </div>\n        <div class=\"jp-non-transit-locations-text\">"
    + alias4(((helper = (helper = helpers.originText || (depth0 != null ? depth0.originText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"originText","hash":{},"data":data}) : helper)))
    + "</div>\n    </div>\n    <div class=\"jp-non-transit-steps-container\">\n"
    + ((stack1 = helpers.each.call(alias1,((stack1 = (depth0 != null ? depth0.route : depth0)) != null ? stack1.steps : stack1),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n    <div class=\"jp-non-transit-locations\">\n        <div class=\"jp-non-transit-direction-icon \n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDetailHotelWidget : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.program(12, data, 0),"data":data})) != null ? stack1 : "")
    + "\"\n        >\n        </div>\n        <div class=\"jp-non-transit-locations-text\">"
    + alias4(((helper = (helper = helpers.destinationText || (depth0 != null ? depth0.destinationText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"destinationText","hash":{},"data":data}) : helper)))
    + "</div>\n    </div>\n    <div class=\"jp-non-transit-message\">\n        "
    + alias4((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"routeLabel.message",{"name":"t","hash":{},"data":data}))
    + "\n    </div>\n</div>\n";
},"useData":true});

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.transit : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(5, data, 0),"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "                <div class=\"jp-transit-step\">\n                    <div class=\"jp-transit-step-icons-container\">\n                        <div class=\"jp-transit-step-departure-time\">"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.transit : depth0)) != null ? stack1.departure_time : stack1)) != null ? stack1.text : stack1), depth0))
    + "</div>\n                        <div class=\"jp-transit-step-info-image-container\">\n                            <img class=\"jp-transit-step-info-image\" src=\""
    + alias2(alias1(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.transit : depth0)) != null ? stack1.line : stack1)) != null ? stack1.vehicle : stack1)) != null ? stack1.icon : stack1), depth0))
    + "\">\n                        </div>\n                        <div class=\"jp-transit-step-arrival-time\">"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.transit : depth0)) != null ? stack1.arrival_time : stack1)) != null ? stack1.text : stack1), depth0))
    + "</div>\n                    </div>\n                    <div class=\"jp-transit-step-info-container\">\n                        <div class=\"jp-transit-step-departure-stop\">\n                            <i class=\"jp-transit-location-circle lmm-icon lmm-md-icon-circle\"></i>\n                            "
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.transit : depth0)) != null ? stack1.departure_stop : stack1)) != null ? stack1.name : stack1), depth0))
    + "\n                        </div>\n                        <div class=\"jp-transit-step-info-content\">\n                            <div class=\"jp-transit-step-separator-line\"></div>\n                            <div class=\"jp-transit-step-info-headsign\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.transit : depth0)) != null ? stack1.line : stack1)) != null ? stack1.vehicle : stack1)) != null ? stack1.local_icon : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                                <div class=\"jp-transit-step-info-text\">\n                                    "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.transit : depth0)) != null ? stack1.headsign : stack1), depth0))
    + "\n                                </div>\n                            </div>\n                            <div class=\"jp-transit-step-info-duration\">\n                                "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.duration : depth0)) != null ? stack1.text : stack1), depth0))
    + " ("
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.transit : depth0)) != null ? stack1.num_stops : stack1), depth0))
    + " stops)\n                            </div>\n                            <div class=\"jp-transit-step-separator-line\"></div>\n                        </div>\n                        <div class=\"jp-transit-step-arrival-stop\">\n                            <i class=\"jp-transit-location-circle lmm-icon lmm-md-icon-circle\"></i>\n                            "
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.transit : depth0)) != null ? stack1.arrival_stop : stack1)) != null ? stack1.name : stack1), depth0))
    + "\n                        </div>\n                    </div>\n                </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                                    <img class=\"jp-transit-step-info-image\"\n                                         src=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.transit : depth0)) != null ? stack1.line : stack1)) != null ? stack1.vehicle : stack1)) != null ? stack1.local_icon : stack1), depth0))
    + "\">\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=container.escapeExpression;

  return "                <div class=\"jp-transit-step-walking\">\n                    <div class=\"jp-transit-step-walking-icon-container\"><i\n                            class=\"lmm-icon-walking jp-transit-step-walking-icon\"></i></div>\n                    <div class=\"jp-transit-step-walkin-info\">\n                        <div class=\"jp-transit-step-separator-line\"></div>\n                        <div class=\"jp-transit-step-walking-instruction\">"
    + ((stack1 = alias1((depth0 != null ? depth0.instructions : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n                        <div class=\"jp-transit-step-walking-duration-container\">\n"
    + ((stack1 = helpers["if"].call(alias2,(depth0 != null ? depth0.steps : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                            <div class=\"jp-transit-step-walking-duration\">"
    + alias3(alias1(((stack1 = (depth0 != null ? depth0.duration : depth0)) != null ? stack1.text : stack1), depth0))
    + " ("
    + alias3(alias1(((stack1 = (depth0 != null ? depth0.distance : depth0)) != null ? stack1.text : stack1), depth0))
    + "\n                                )\n                            </div>\n                        </div>\n                        <div class=\"jp-transit-step-walking-steps-container\">\n"
    + ((stack1 = helpers.each.call(alias2,(depth0 != null ? depth0.steps : depth0),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                        </div>\n                        <div class=\"jp-transit-step-separator-line\"></div>\n                    </div>\n                </div>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "                                <i class=\"jp-transit-step-walking-steps-clickable lmm-icon-ic_keyboard_arrow_down_black_24px\"></i>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                                <div class=\"jp-transit-walking-step-content\">\n                                    <div class=\"jp-transit-walking-step-text\">"
    + ((stack1 = container.lambda((depth0 != null ? depth0.instructions : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n                                </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda;

  return "<div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"jp-transit-origin\">\n        <div class=\"jp-transit-origin-time\">"
    + alias4(alias5(((stack1 = ((stack1 = (depth0 != null ? depth0.route : depth0)) != null ? stack1.departure_time : stack1)) != null ? stack1.text : stack1), depth0))
    + "</div>\n        <div class=\"jp-transit-origin-text\"><i\n                class=\"jp-transit-location-circle lmm-icon lmm-md-icon-circle\"></i> "
    + alias4(((helper = (helper = helpers.originText || (depth0 != null ? depth0.originText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"originText","hash":{},"data":data}) : helper)))
    + "</div>\n    </div>\n    <div class=\"jp-transit-steps-container\">\n"
    + ((stack1 = helpers.each.call(alias1,((stack1 = (depth0 != null ? depth0.route : depth0)) != null ? stack1.steps : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n    <div class=\"jp-transit-destination\">\n        <div class=\"jp-transit-destination-time\">"
    + alias4(alias5(((stack1 = ((stack1 = (depth0 != null ? depth0.route : depth0)) != null ? stack1.arrival_time : stack1)) != null ? stack1.text : stack1), depth0))
    + "</div>\n        <div class=\"jp-transit-destination-text\"><i\n                class=\"jp-transit-location-circle lmm-icon lmm-md-icon-circle\"></i>"
    + alias4(((helper = (helper = helpers.destinationText || (depth0 != null ? depth0.destinationText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"destinationText","hash":{},"data":data}) : helper)))
    + "</div>\n    </div>\n    <div class=\"jp-transit-message\">\n        "
    + alias4((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"routeLabel.message",{"name":"t","hash":{},"data":data}))
    + "\n    </div>\n</div>";
},"useData":true});

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SeeMapAndDetailsBtn = _ComponentBase2.default.extend({

    template: __webpack_require__(171),

    events: {
        'click': 'toggleBtn'
    },

    identifier: 'jp-see-map-and-details-btn',

    constructor: function constructor(options) {
        options.identifier = this.identifier;
        this.componentClass = options.componentClass;
        this.componentConstructorClass = options.componentConstructorClass;
        _ComponentBase2.default.prototype.constructor.call(this, options);
    },
    initialize: function initialize(options) {
        this.bus = this.widget.bus;
        this.seeMapState = options.properties.seeMapState;
        this.templateConfig = _underscore2.default.extend(options, {
            componentClass: 'jp-see-map-and-details-btn',
            seeMapState: this.seeMapState
        });
        _ComponentBase2.default.prototype.initialize.call(this, options);
    },
    toggleBtn: function toggleBtn() {
        this.seeMapState = !this.seeMapState;
        this.templateConfig.seeMapState = this.seeMapState;
        this.$el.replaceWith(this.render().$el);
        this.parentComponent.collapseDetailsPanel(!this.seeMapState);
    }
});

exports.default = SeeMapAndDetailsBtn;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "        <div class=\"see-map-cta\">"
    + container.escapeExpression((helpers.t || (depth0 && depth0.t) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"routeLabel.viewMap",{"name":"t","hash":{},"data":data}))
    + "</div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "        <div class=\"details-cta\">"
    + container.escapeExpression((helpers.t || (depth0 && depth0.t) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"routeDetails.details",{"name":"t","hash":{},"data":data}))
    + "</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div>\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.seeMapState : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>";
},"useData":true});

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\""
    + alias4(((helper = (helper = helpers.mobileClass || (depth0 != null ? depth0.mobileClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"mobileClass","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"jp-route-details-header\">\n        <div class=\"jp-route-details-go-back\"></div>\n        <div class=\"jp-route-details-journey-summary\">\n            <div class=\"jp-details-summary-origin\">\n                <span class=\"jp-summary-label-text\">"
    + alias4((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"routeDetails.from",{"name":"t","hash":{},"data":data}))
    + ": </span>\n                <span class=\"jp-summary-label-data-text\">"
    + alias4(((helper = (helper = helpers.fromDataStr || (depth0 != null ? depth0.fromDataStr : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fromDataStr","hash":{},"data":data}) : helper)))
    + "</span>\n            </div>\n            <div class=\"jp-details-summary-destination\">\n                <span class=\"jp-summary-label-text\">"
    + alias4((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"routeDetails.to",{"name":"t","hash":{},"data":data}))
    + ": </span>\n                <span class=\"jp-summary-label-data-text\">"
    + alias4(((helper = (helper = helpers.toDataStr || (depth0 != null ? depth0.toDataStr : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"toDataStr","hash":{},"data":data}) : helper)))
    + "</span>\n            </div>\n        </div>\n        <div class=\"jp-route-details-close\">\n            <div class=\"jp-route-details-close-icon\"></div>\n        </div>\n    </div>\n    <div class=\"jp-route-details-general-info\">\n    </div>\n    <div class=\"jp-route-details-steps-info-container\"></div>\n</div>";
},"useData":true});

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ComponentBase = __webpack_require__(3);

var _ComponentBase2 = _interopRequireDefault(_ComponentBase);

var _Utils = __webpack_require__(6);

var _Utils2 = _interopRequireDefault(_Utils);

var _CategoriesLayer = __webpack_require__(174);

var _CategoriesLayer2 = _interopRequireDefault(_CategoriesLayer);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoriesPanel = _ComponentBase2.default.extend({
    template: __webpack_require__(178),
    componentClass: 'mainBox-categories-panel',

    events: {
        'click .melia-categories-container': 'selectCategory'
    },

    constructor: function constructor(options) {
        _ComponentBase2.default.prototype.constructor.call(this, options);
    },
    initialize: function initialize(options) {
        this._configCategories();
        _ComponentBase2.default.prototype.initialize.call(this, options);
        this.setHeight();
        this._listenersEvent();
    },
    _configCategories: function _configCategories() {
        var _this = this;

        this.templateConfig.categories = this.widget.config.categories.map(function (category) {
            if (category.imagePath !== undefined && category.imagePath !== '') {
                return {
                    catId: category.catId,
                    name: 'categories.' + category.catId,
                    imagePath: _Utils2.default.getImgUrl(category.imagePath, _this.widget)
                };
            } else {
                return {
                    catId: category.catId,
                    name: 'categories.' + category.catId,
                    iconClass: category.iconClass
                };
            }
        });
    },
    setHeight: function setHeight() {
        var widgetHeight = this.widget.getHeight();
        var heightAutocomplete = 50;
        var marginTopMainPanel = 10;
        var googleLogoHeight = 28;
        var marginBottomMainBoxInMobile = 100;
        if (this.widget.isMobileVersion) {
            this.$el.css('max-height', widgetHeight - marginBottomMainBoxInMobile - heightAutocomplete + 'px');
        } else {
            this.$el.css('max-height', widgetHeight - heightAutocomplete - marginTopMainPanel - googleLogoHeight + 'px');
        }
    },
    _listenersEvent: function _listenersEvent() {
        var _this2 = this;

        this.listenTo(this.bus, 'AUTOCOMPLETE_CATEGORY_SELECTED', function (item) {
            _this2.updateLayer(item.catId);
        });
        this.listenTo(this.bus, 'RESET_AUTOCOMPLETE', function () {
            if (_this2.categoryLayer) {
                _this2.categoryLayer.remove();
            }
        });
        google.maps.event.addDomListener(this.widget.map, 'resize', function () {
            _this2.setHeight();
        });
    },
    selectCategory: function selectCategory(e) {
        this.updateLayer(e.currentTarget.dataset.categoryid);
        this.parentComponent.caregorySelected((0, _jquery2.default)(e.currentTarget).find('.melia-categories-panel-text').text());
        this.bus.trigger('SELECT_RESULT');
    },
    createCategoriesLayer: function createCategoriesLayer() {
        var _this3 = this;

        var listCategoriesClasses = {};
        this.widget.config.categories.forEach(function (cat) {
            if (cat.iconClass) {
                listCategoriesClasses[cat.catId] = { iconClass: cat.iconClass };
            } else {
                listCategoriesClasses[cat.catId] = {
                    imagePath: _Utils2.default.getImgUrl(cat.imagePath, _this3.widget)
                };
            }
        });
        this.categoryLayer = new _CategoriesLayer2.default({
            widget: this.widget,
            id: 'CategoriesLayer',
            active: true,
            cleanMarkers: true,
            clickable: false,
            iconMarkerByType: listCategoriesClasses,
            iconMarker: {},
            minZoom: this.widget.config.minZoom
        });
        this.widget.addLayer(this.categoryLayer);
    },
    updateLayer: function updateLayer(catId) {
        if (!this.categoryLayer) {
            this.createCategoriesLayer();
        }
        this.categoryLayer.refreshCategory(catId);
    }
});

exports.default = CategoriesPanel;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GooglePlaces = __webpack_require__(175);

var _GooglePlaces2 = _interopRequireDefault(_GooglePlaces);

var _richmarker = __webpack_require__(34);

var _categoriesColors = __webpack_require__(177);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _GooglePlaces2.default.extend({
    initialize: function initialize(options) {
        _GooglePlaces2.default.prototype.initialize.call(this, options);
    },
    refreshCategory: function refreshCategory(category) {
        this.options.provider.load({ type: category });
        this.currentCategory = category;
    },
    add: function add() {},
    _createMarker: function _createMarker(feature) {
        var icon = this._getIconByCategory();
        var contentIcon = '';
        if (icon.iconClass) {
            contentIcon = '<i class="melia-categories-panel-icon ' + icon.iconClass + '"></i>';
        } else {
            contentIcon = '<img class="melia-categories-panel-image" src="' + icon.imagePath + '" alt="' + icon.imagePath + '" />';
        }
        var contentStr = '\n        <div class="category-marker"\n            style="--category-color: ' + _categoriesColors.CATEGORIES_COLORS[this.currentCategory] + ';">\n                ' + contentIcon + '\n        </div>\n        ';
        var marker = new _richmarker.RichMarker({
            shadow: 'none',
            content: contentStr,
            position: new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]),
            properties: feature.properties,
            zIndex: 10
        });
        return marker;
    },
    _getIconByCategory: function _getIconByCategory() {
        var icon = this.options.iconMarkerByType[this.currentCategory];
        if (!icon) {
            icon = this.options.iconMarkerByType['default'];
        }
        return icon;
    }
});

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MarkerLayer = __webpack_require__(25);

var _MarkerLayer2 = _interopRequireDefault(_MarkerLayer);

var _GPlacesProvider = __webpack_require__(176);

var _GPlacesProvider2 = _interopRequireDefault(_GPlacesProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MarkerLayer2.default.extend({
  /**
   * @memberOf module:Layers 
   * @class GooglePlaces
   * @classdesc Overrides GeoPoints in order to handle points from Google Places API
   * @extends GeoPoints
   * @param {object} options - The options provided by json
   * @example <caption>Google Places Layer example/caption>
      widget: this,
      id: 'GooglePlaces',
      active: true,
      cleanMarkers: true,
      categories: ['restaurant'],
      minZoom: 10,
      iconMarker: {
        default: {
          url: '06marker_otherPOI_hov.png'
        }
      }
  */
  constructor: function constructor(options) {
    this._initConfig(options);
    _MarkerLayer2.default.prototype.constructor.call(this, options);
  },


  /**
   * Initialize the layer
   */
  initialize: function initialize(options) {
    options.provider = new _GPlacesProvider2.default(options);
    _MarkerLayer2.default.prototype.initialize.call(this, options);
  },

  /**
   * @typedef {object} GooglePlaces 
   * @property {string} type The type of the layer. Must be GooglePlaces.
   * @property {boolean} active To activate the layer by default
   * @property {boolean} searchOnce To do the search of the features only once
   * @property {number} [minZoom=1] The min zoom from the layer is visible
   * @property {boolean} [markersClickable=true] To do the markers clickables or not
   * @property {boolean} [searchDelay=100] Timeout to avoid do a search several times on 'idle'
   * @property {boolean} [cleanMarkers=true] To remove the markers before doing a new processment
   * @property {core.Config.IconMarker} iconMarker The icon of the markers
   * @memberof core.Config 
   */

  /**
   * Initialize the config.
   * @param {object} options The options
   */
  _initConfig: function _initConfig(options) {
    //Pre-Filters doesn't apply to this layer
    options.preFilters = [];
    //Post-Filters doesn't apply to this layer
    options.postFilters = [];
    //Always place_id
    options.featureId = 'place_id';
    //This option does the markers clickables or not
    options.markersClickable = options.markersClickable ? options.markersClickable : true;
    //The provider doesn't load feature if it is not visible in a certain level zoom
    options.minZoom = options.minZoom ? options.minZoom : 1;
    //This option is to avoid several requests in a short time
    options.searchDelay = options.searchDelay ? options.searchDelay : 100;
    //Clean the markers after a load
    options.cleanMarkers = options.cleanMarkers ? options.cleanMarkers : true;
  },


  /**
   * Add the layer
   */
  add: function add() {
    this.options.provider.onReady();
  }
});

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Utils = __webpack_require__(6);

var _Utils2 = _interopRequireDefault(_Utils);

var _GPlacesHelper = __webpack_require__(30);

var _GPlacesHelper2 = _interopRequireDefault(_GPlacesHelper);

var _DataProvider2 = __webpack_require__(27);

var _DataProvider3 = _interopRequireDefault(_DataProvider2);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GPlacesProvider = function (_DataProvider) {
  _inherits(GPlacesProvider, _DataProvider);

  /**
   * @class GPlacesProvider
   * @classdesc This is a data provider from Google Places
   * @memberof core.layers.dataProviders
   * @constructs
   * @extends DataProvider
   * @param {object} map - The map on which the Google Places will be loaded
   * @param {object} options - The options to specify the search
   */
  function GPlacesProvider(options) {
    _classCallCheck(this, GPlacesProvider);

    //The provider doesn't load feature if it is not visible in a certain level zoom
    var _this = _possibleConstructorReturn(this, (GPlacesProvider.__proto__ || Object.getPrototypeOf(GPlacesProvider)).call(this));

    options.minZoom = options.minZoom ? options.minZoom : 1;
    //This option is to avoid several requests in a short time
    options.searchDelay = options.searchDelay ? options.searchDelay : 100;
    _this.options = options;
    _this.widget = options.widget;
    return _this;
  }

  /**
   * This method is executed when the layer is activated
   */


  _createClass(GPlacesProvider, [{
    key: 'onReady',
    value: function onReady() {
      if (this.options.searchOnce) {
        this._addListenersSearchOnce();
      } else {
        this._addListeners();
      }
      this._checkVisibility();
    }

    /**
     * This method is executed when the layer is removed
     */

  }, {
    key: 'onRemove',
    value: function onRemove() {
      google.maps.event.removeListener(this.idleEvent);
      google.maps.event.removeListener(this.zoomChangedEvent);
    }

    /**
     * Every 'idle' on the map does a load in order to find new features
     */

  }, {
    key: '_addListeners',
    value: function _addListeners() {
      var _this2 = this;

      this.idleEvent = google.maps.event.addListener(this.widget.map, 'idle', function () {
        if (!!_this2._timeout) {
          clearTimeout(_this2._timeout);
        }
        _this2._timeout = setTimeout(function () {
          if (_this2.options.model.isVisible()) {
            _this2.load();
          }
        }, _this2.options.searchDelay);
      });
    }

    /**
     * Every 'idle' on the map does a load in order to find new features
     */

  }, {
    key: '_addListenersSearchOnce',
    value: function _addListenersSearchOnce() {
      var _this3 = this;

      this.idleEvent = google.maps.event.addListenerOnce(this.widget.map, 'idle', function () {
        if (!!_this3._timeout) {
          clearTimeout(_this3._timeout);
        }
        _this3._timeout = setTimeout(function () {
          _this3.load();
        }, _this3.options.searchDelay);
      });
    }

    /**
     * Method to load the source data. Overrides the DataProvider method
     */

  }, {
    key: 'load',
    value: function load(options) {
      var _this4 = this;

      _GPlacesHelper2.default.searchNearby(this.map, _underscore2.default.extend({
        type: this.options.category,
        bounds: this.widget.map.getBounds()
      }, options)).then(function (results, status) {
        _this4.trigger('PROCESS_FEATURES', _Utils2.default.convertToGeoJSON(results).features, _this4);
      });
    }
  }]);

  return GPlacesProvider;
}(_DataProvider3.default);

exports.default = GPlacesProvider;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    CATEGORIES_COLORS: {
        bar: '#ff9e67',
        cafe: '#ff9e67',
        restaurant: '#ff9e67',

        airport: '#0fbdff',
        bus_station: '#0fbdff',
        subway_station: '#0fbdff',
        train_station: '#0fbdff',
        taxi_stand: '#0fbdff',
        transit_station: '#0fbdff',

        atm: '#8f9ce2',
        car_rental: '#8f9ce2',
        parking: '#8f9ce2',

        shopping_mall: '#4a96f3',

        museum: '#12b5c7',
        art_gallery: '#12b5c7',
        aquarium: '#12b5c7',
        amusement_park: '#12b5c7',
        zoo: '#12b5c7',
        casino: '#12b5c7',
        stadium: '#12b5c7',

        park: '#4db546',

        church: '#7b9eb1',
        city_hall: '#7b9eb1'
    }
};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {});

  return "        <div data-categoryId=\""
    + alias1(container.lambda((depth0 != null ? depth0.catId : depth0), depth0))
    + "\" class=\"melia-categories-container\">\n            <div class=\"melia-categories-panel-icon-container\">\n"
    + ((stack1 = helpers["if"].call(alias2,(depth0 != null ? depth0.imagePath : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "            </div>\n            <div class=\"melia-categories-panel-text\">"
    + alias1((helpers.t || (depth0 && depth0.t) || helpers.helperMissing).call(alias2,(depth0 != null ? depth0.name : depth0),{"name":"t","hash":{},"data":data}))
    + "</div>\n        </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "                    <img src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.imagePath : depth0), depth0))
    + "\" class=\"melia-categories-panel-image\">\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.iconClass : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    return "                        <i class=\"melia-categories-panel-icon "
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.iconClass : depth0), depth0))
    + "\"></i>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"melia-categories-panel\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.categories : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div>\n    <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-header\"></div>\n    <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-fluid-panel\"></div>\n    <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-toolbox\"></div>\n    <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-fluid-container\"></div>\n    <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-main-box-container "
    + alias4(((helper = (helper = helpers.meliaMobileVersionClass || (depth0 != null ? depth0.meliaMobileVersionClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"meliaMobileVersionClass","hash":{},"data":data}) : helper)))
    + "\"></div>\n    <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-directions-box-container "
    + alias4(((helper = (helper = helpers.meliaMobileVersionClass || (depth0 != null ? depth0.meliaMobileVersionClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"meliaMobileVersionClass","hash":{},"data":data}) : helper)))
    + "\"></div>\n    <div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-route-details-container "
    + alias4(((helper = (helper = helpers.meliaMobileVersionClass || (depth0 != null ? depth0.meliaMobileVersionClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"meliaMobileVersionClass","hash":{},"data":data}) : helper)))
    + "\"></div>\n</div>\n<div class=\""
    + alias4(((helper = (helper = helpers.componentClass || (depth0 != null ? depth0.componentClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"componentClass","hash":{},"data":data}) : helper)))
    + "-map-center "
    + alias4(((helper = (helper = helpers.meliaMobileVersionClass || (depth0 != null ? depth0.meliaMobileVersionClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"meliaMobileVersionClass","hash":{},"data":data}) : helper)))
    + "\"></div>\n";
},"useData":true});

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _elementResizeEvent = __webpack_require__(181);

var _elementResizeEvent2 = _interopRequireDefault(_elementResizeEvent);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _GoogleMapsUtils = __webpack_require__(18);

var _GoogleMapsUtils2 = _interopRequireDefault(_GoogleMapsUtils);

var _EventBus = __webpack_require__(182);

var _EventBus2 = _interopRequireDefault(_EventBus);

var _WidgetCommon = __webpack_require__(183);

var _WidgetCommon2 = _interopRequireDefault(_WidgetCommon);

var _HandleLayers = __webpack_require__(207);

var _HandleLayers2 = _interopRequireDefault(_HandleLayers);

var _enableControlsAwareCentering = __webpack_require__(209);

var _enableControlsAwareCentering2 = _interopRequireDefault(_enableControlsAwareCentering);

var _elementQuery = __webpack_require__(210);

var _elementQuery2 = _interopRequireDefault(_elementQuery);

var _assertValidConfig = __webpack_require__(46);

var _assertValidConfig2 = _interopRequireDefault(_assertValidConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function controlBBox(widget, limitedBBox) {
  google.maps.event.addListener(widget.map, 'center_changed', function () {
    _GoogleMapsUtils2.default.setLimitsToBBox(widget.map, limitedBBox);
  });
}

function setControlBBox(widget) {
  var limitedBBox = widget.map.getBounds();
  widget.map.minZoom = widget.map.getZoom();
  if (_underscore2.default.isObject(widget.config.defaultView.limitBounds)) {
    limitedBBox = _GoogleMapsUtils2.default.getBounds(widget.config.defaultView.limitBounds);
  } else if (widget.config.defaultView.bounds) {
    limitedBBox = _GoogleMapsUtils2.default.getBounds(widget.config.defaultView.bounds);
  }
  controlBBox(widget, limitedBBox);
}

function addCustomServices(widget, configServices) {
  var Services = widget.serviceClasses;
  _underscore2.default.each(configServices, function (service, key) {
    widget.customServices[key] = new Services[key](_underscore2.default.extend(service, {
      map: widget.map,
      widget: widget,
      config: service
    }));
  });
}

function isMobile(widget) {
  var breakpoints = widget.config.breakpoints,
      defaultBreakpoint = 720,
      widgetWidth = widget.$el.width();

  if (breakpoints.maxTablet) {
    defaultBreakpoint = parseFloat(breakpoints.maxTablet.replace('px', ''));
  } else if (breakpoints.maxMobile) {
    defaultBreakpoint = parseFloat(breakpoints.maxMobile.replace('px', ''));
  }
  return defaultBreakpoint >= widgetWidth;
}

function changeScreenSize(widget) {
  var isMobileNow = isMobile(widget);
  if (widget.isMobile !== isMobileNow) {
    widget.bus.trigger('CHANGE_SCREEN_SIZE', isMobileNow);
  }
  widget.isMobile = isMobileNow;
}

function addMapListeners(widget) {
  google.maps.event.addListenerOnce(widget.map, 'bounds_changed', function () {
    var Components = __webpack_require__(54).default;
    _WidgetCommon2.default.addCustomComponents(widget, widget.config.mapComponents, Components);
    if (widget.config.defaultView.limitBounds) {
      setControlBBox(widget);
    }
    widget.bus.trigger('WIDGET_INITIALIZED', widget.map.getBounds());
  });

  google.maps.event.addDomListener(widget.map, 'resize', function () {
    setTimeout(function () {
      widget.map.panTo(widget._lastCenter);
      changeScreenSize(widget);
    }, 1);
  });

  google.maps.event.addDomListener(widget.map, 'dragend', function () {
    widget.bus.trigger('USER_ACTION_TRACKING', {
      tracking: 'MapCenterChanged',
      boundingBox: widget.map.getBounds()
    });
  });

  google.maps.event.addDomListener(widget.map, 'zoom_changed', function () {
    widget.bus.trigger('USER_ACTION_TRACKING', {
      tracking: 'ZoomChanged',
      zoom: widget.map.getZoom()
    });
  });

  // We keep the last known center of the map in order to restore it in window or container resize.
  google.maps.event.addDomListener(widget.map, 'idle', function () {
    widget._lastCenter = widget.map.getCenter();
  });

  widget._lastCenter = widget.map.getCenter();
}

function resizeMapHandler(widget) {
  var element = widget.$el.find('.map-container')[0];

  // We trigger resize each time the container div changes its size.
  (0, _elementResizeEvent2.default)(element, function () {
    google.maps.event.trigger(widget.map, 'resize');
  });
}

function centerMapHandler(widget) {
  widget.listenTo(widget.bus, 'CENTER_MAP', function (center) {
    widget.map.panTo(center);
  });
}

function _getGoogleMapsControls(config) {
  var controlOptions = {};
  var components = _underscore2.default.filter(config.mapComponents, function (component) {
    return _underscore2.default.indexOf(_GoogleMapsUtils2.default.googleControls, component.componentConstructorClass) > -1;
  });

  _underscore2.default.each(components, function (component) {
    controlOptions[component.componentConstructorClass] = true;
    // Other Options
    var options = _underscore2.default.extend({}, component.options);
    // Control Position
    if (component.position) {
      options.position = google.maps.ControlPosition[component.position];
    }
    // Control Style
    if (component.style && component.style.control && component.style.controlStyle) {
      options.style = google.maps[component.style.control][component.style.controlStyle];
    }
    // Control MapIds
    if (component.mapTypeIds) {
      options.mapTypeIds = component.mapTypeIds;
    }
    controlOptions[component.nameOptions] = options;
  });

  return controlOptions;
}

function getMapOptions(widget) {
  var config = widget.config;
  var controlOptions = _getGoogleMapsControls(config);
  var mapOptions = _underscore2.default.extend({
    minZoom: 2,
    zoomControl: false,
    mapTypeControl: false,
    panControl: false,
    scaleControl: false,
    streetViewControl: false,
    overviewMapControl: false,
    fullscreenControl: false
  });

  if (!_underscore2.default.isObject(config.mapOptions)) {
    config.mapOptions = {};
  }
  _underscore2.default.extend(mapOptions, config.mapOptions, controlOptions);

  if (!config.defaultView) {
    config.defaultView = {};
  }

  if (_underscore2.default.isArray(config.defaultView.center) && !_underscore2.default.isEmpty(config.defaultView.center)) {
    var center = config.defaultView.center;
    mapOptions.center = new google.maps.LatLng(center[0], center[1]);
    mapOptions.zoom = config.defaultView.zoom;
  } else {
    var _bbox = widget._initialBBox = _underscore2.default.isObject(config.defaultView.bounds) ? config.defaultView.bounds : {
      neLat: 83.31110306468723,
      neLng: 180,
      swLat: -67.76757057057642,
      swLng: -180
    },
        bbox = _GoogleMapsUtils2.default.getBounds(_bbox);
    mapOptions.center = _GoogleMapsUtils2.default.getBoundsCenter(bbox);
  }

  return mapOptions;
}

function renderMap(widget) {
  var mapOptions = getMapOptions(widget);
  var mapContainer = widget.$el.find('.map-container')[0];
  /**
   *  A Google Map event
   *  @typedef {object} mapEvent
   */

  /**
   * Event fired when map zoom changes
   * @type {mapEvent}
   * @event Widget#zoom_changed
   */
  /**
   * Event fired when the map becomes idle after panning or zooming.
   * @type {mapEvent}
   * @event Widget#idle
   */
  widget.map = new google.maps.Map(mapContainer, mapOptions);

  /**
   * @name handleLayers
   * @desc The instance of HandleLayers used by the widget so components can get layers by id or create layers and stuff.
   * @type {core.widget.widgetHelpers.HandleLayers}
   * @memberof core.widget.Widget.prototype
   * @protected
   */
  widget.handleLayers = new _HandleLayers2.default(widget);

  if (widget.config.controlsAwareMapCentering) {
    // Replaces vainilla fitBounds  and setCenter functions with substitutes that take into account
    // the controls placed on the map.
    _enableControlsAwareCentering2.default.init(widget.map);
  }

  if (widget._initialBBox) {
    var bbox = _GoogleMapsUtils2.default.getBounds(widget._initialBBox);
    widget.map.fitBounds(bbox);
  }
  addMapListeners(widget);
  resizeMapHandler(widget);
  centerMapHandler(widget);
}

function _setBreakpoints(breakpoints) {
  var containerId = '.lmm-maps-widget-container',
      _params = {};

  _params[containerId] = {
    'max-width': breakpoints.maxTablet
  };
  (0, _elementQuery2.default)(_params, true);
}

function overwritteNavigationPosition(position) {
  navigator.geolocation.getCurrentPosition = function (success, failure) {
    success({
      coords: {
        latitude: position.lat,
        longitude: position.lng
      },
      timestamp: Date.now()
    });
  };
}

/**
 * The api object from integrationAPI
 * @typedef APIObject
 * @desc Contains methods that will be called for the widget to interact with the web page
 * embedding it. It is highly dependend on the project and must be implemented by the widget integrator.
 * @memberof core
 * @example <caption>API object example</caption>
 * var apiObject = {
 *  userAction: function(data){
 *    //do something
 *  },
 *  search: function(params){
 *    //do something
 *  },
 *  notify: function(params){
 *    //do something
 *  }
 * }
 */

var Widget = _backbone2.default.View.extend(
/**
 * @lends core.widget.Widget.prototype
 */
{

  /**
   * It is a template function used to generate the widgets's DOM, normally generated by requiring a Handlebars template and
   * letting the appropiate Webpack loader convert it to a function.
   *
   * Widget extending classes may provide their own templates.
   * @protected
   * @function
   * @param {object} data The data to be used to be referenced in the template to generate the DOM.
   */
  template: __webpack_require__(211),

  /**
   * The data to be passed to the template function when it gets rendered.
   * @protected
   */
  templateConfig: {},

  /**
   * Validation function, normally generated by requiring an JSON schema file and
   * letting Webpack compile the proper validaiton function.
   * Override this to allow for adding custom configuration properties to the class extending Widget.
   * @function
   * @param {core.Config} config
   * @protected
   */
  validation: __webpack_require__(212),

  /**
   * @desc The configuration object received by the widget, for use in components and layers that
   *  need to read directly from the config.
   * @protected
   * @type {core.Config}
   */
  config: null,

  /**
   * @desc The evnet bus instance used by components and layers to communicante using messages.
   * @type {core.widget.widgetHelpers.EventBus}
   * @protected
   */
  bus: null,

  /**
   * @desc Allows creating messages. The way that the messages are shown must be defined in a component that uses
   * this property as model
   * @type {core.widget.widgetHelpers.MessageControlCollection}
   */
  messageControl: null,

  /**
   * @desc The product layers created from the config's "productLayer" entry for this widget.
   * @type {core.layers.BaseLayer[]}
   * @protected
   */
  productLayers: null,

  /**
   * @desc The non product layers created from the config's "layers" property for this widget.
   * @type {core.layers.BaseLayer[]}
   * @protected
   */
  layers: null,

  /**
   * The registered component constructor functions that can be loaded through config.
   *
   * Should be added calling to registerDependencies' registerComponent function parameter.
   * @protected
   * @type {Object<string, function>}
   */
  componentClasses: {},

  /**
   * The registered layer constructor functions that can be loaded through config.
   *
   * Should be added calling to registerConfigClasses' registerLayer function parameter.
   * @protected
   * @type {Object<string, function>}
   */
  layerClasses: {},

  /**
   * The registered layer provider constructor functions that can be loaded through config.
   *
   * Should be added calling to registerConfigClasses' registerLayerProvider function parameter.
   * @protected
   * @type {Object<string, function>}
   */
  layerProviderClasses: {},

  /**
   * The registered Service constructor functions that can be loaded through config.
   *
   * Should be added calling to registerConfigClasses' registerService function received as parameter.
   * @protected
   * @type {Object<string, function>}
   */
  serviceClasses: {},

  /**
   * @type {google.maps.Map}
   * @desc the Google Maps instance used by the widget, for use in components, layers and other widget receiving classes.
   * @protected
   * @see https://developers.google.com/maps/documentation/javascript/reference#Map
   */
  map: null,

  /**
   * Create a widget instance.
   * @class Widget
   * @classdesc Base class so projects can create and define their own configurations
   * @abstract
   * @memberof core.widget
   * @param {string} containerId - The div id where the widget will append.
   * @param {core.Config} config - The config provided by JSON.
   * Extend this class when extending Widget to add project related configuration.
   * @param {core.APIObject} api - The object the widget will use to interact with the portal.
   * @throws {Error} If the container id parameter is falsy or is not the id of an existing DOM element;
   * or if the config parameter is not a valid configuration.
   */
  constructor: function constructor(containerId, config, api) {

    if (!containerId) {
      throw new Error(Widget.NO_CONTAINERID_ERR);
    }

    var container = (0, _jquery2.default)('#' + containerId);
    if (container.length !== 1) {
      throw new Error('Widget::constructor: containerId must be the id of an existing DOM element');
    }

    // We set the widget's config in the validation function, so we activate validation,
    // and with it the loading of the validation bundle.
    _assertValidConfig2.default.doValidation = config.doValidation;

    (0, _assertValidConfig2.default)('widget \'' + containerId + '\'', this.validation, config);

    this.config = _WidgetCommon2.default.prepareConfig(config, this);

    _WidgetCommon2.default.registerHelpers(this);
    this.customComponents = {};
    this.customServices = {};

    this.bus = new _EventBus2.default().bus;
    this.handleLayers = null;

    this.api = api;
    this.setElement(container, true);

    this.notify = this.portalInteraction;

    _backbone2.default.View.prototype.constructor.call(this);
  },


  /**
   * Initialize the widget
   * @private
   */
  initialize: function initialize() {
    var _this = this;

    // This allows setting the screen resolutions and load different
    // css resources for different devices
    if (this.config.screenResolution) {
      this.templateConfig = { className: '_' + this.config.screenResolution };
    }

    // The inheriting Widget class must specify which components will by available to be created through the config.
    this.registerConfigClasses(function (componentClassName, componentConstructor) {
      _this.componentClasses[componentClassName] = componentConstructor;
    }, function (layerClassName, layerConstructor) {
      _this.layerClasses[layerClassName] = layerConstructor;
    }, function (layerProviderClassName, layerProviderConstructor) {
      _this.layerProviderClasses[layerProviderClassName] = layerProviderConstructor;
    }, function (serviceClassName, serviceConstructor) {
      _this.serviceClasses[serviceClassName] = serviceConstructor;
    });

    _WidgetCommon2.default.setLocale(this).done(function () {

      if (!_this.config.breakpoints) {
        _this.config.breakpoints = {};
      }
      _setBreakpoints(_this.config.breakpoints);
      _this.isMobile = isMobile(_this);

      renderMap(_this.render());

      // Adds productLayers and layers properties.
      _underscore2.default.extend(_this, _this.handleLayers.createConfigLayers(_this.config.layerDefaults, _this.config.productLayers, _this.config.layers));

      addCustomServices(_this, _this.config.services);

      _WidgetCommon2.default.createMessageControl(_this);
      if (_this.config.fakeLocation) {
        overwritteNavigationPosition(_this.config.fakeLocation);
      }

      _this.onInitialized(_this.config);
    });
  },


  /**
   * Registers the dependencies of the widget. The extending class MUST override this method
   * in order to make the classes of dependencies to be created by interpreting configurations, i.e.
   * the widget's or a component's.
   *
   * @protected
   * @abstract
   * @param {function} registerComponent The function used to register component classes.
   * @param {function} registerLayer The function used to register layer classes to the widget.
   * @param {function} registerLayerProvider The function used to register layer provider classes.
   * @param {function} registerService The function used to register a service instantiable using the widget's config.
   */
  registerConfigClasses: function registerConfigClasses(registerComponent, registerLayer, registerLayerProvider, registerService) {
    throw new Error(Widget.OVERRIDE_REGISTERCONFIGCLASSES_ERR);
  },

  /**
   * Method to be overriden in derivate classes in order to, for example, add layers, components
   * or any other initialization.
   *
   * @protected
   * @abstract
   * @param {core.Config} config The widget's configuration
   */
  onInitialized: function onInitialized(config) {
    throw new Error(Widget.OVERRIDE_ONINITIALIZE_ERR);
  },


  /**
   * Makes the widget to stop listening events and destroys all resources.
   */
  destroy: function destroy() {
    this.stopListening();
    google.maps.event.clearInstanceListeners(this.map);
    this.map = null;
    // TODO: Destroy components (recursively) and layers.
  },

  /**
   * Adds a component to the widget. To be called by derivate classes to programatically add classes.
   * @protected
   * @param {core.components.base.ComponentBase} component
   * @throws {Error} If the received parameter is falsy.
   */
  addComponent: function addComponent(component) {
    if (!component) {
      throw new Error('Widget::addComponent: The component parameter cannot be falsy');
    }
    _WidgetCommon2.default.registerComponent(this, component);
  },


  /**
   * Adds a layer to the map. To be called by derivate classes to programatically add layers.
   * @protected
   * @param {core.layers.BaseLayer} layer The layer to be added to the map.
   * @throws {Error} If the layer is falsy or if it doesn't have an 'id' property.
   */
  addLayer: function addLayer(layer) {
    if (!layer) {
      throw new Error('Widget::addLayer: the layer cannot be null');
    }
    if (!layer.id) {
      throw new Error('Widget::addLayer: the layer must have an "id" property');
    }
    this.handleLayers.addToMap(layer);
  },


  /**
   * Render the template. Override if you want to change the way the widget is rendered.
   * @override
   * @protected
   * @param {Object} tmpObj - The new template data
   * @returns {core.widget.Widget} The rendered widget.
   */
  render: function render(tmpObj) {
    if (tmpObj) {
      this.templateConfig = _underscore2.default.extend({}, this.templateConfig, tmpObj);
    }
    this.$el.html(this.template(this.templateConfig));
    return this;
  },

  /**
   * @typedef {object} WidgetCommand
   * @property {string} type The name of the event
   * @property {any} object The payload of the event
   * @memberof core.widget.Widget
   */

  /**
   * Function used for communications from portal to widget.
   * @alias notify
   * @memberof core.widget.Widget.prototype
   * @param {core.widget.Widget.WidgetCommand} params The command sent from portal for
   * the widget to execute
   */
  portalInteraction: function portalInteraction(params) {
    this.bus.trigger(params.type, params.object);
  },

  /**
   * @typedef {object} UserAction
   * @desc A user action reported by the Widget to the portal trough the received API object, if any.
   * Might contain more properties but at least the tracking property must be present.
   * @property {string} tracking The name of the tracked value.
   * @memberof core.widget.Widget
   * @see core.widget.Widget.APIObject
   */

  /**
   * Called by components to notify the portal that the user did some action.
   * Only has effect if the widget received an API object containing a userAction function.
   * @param {UserAction} userAction The action to be reported to the portal.
   * @throws {Error} If the parameters doesn't  contain a tracking property.
   */
  trackUserAction: function trackUserAction(userAction) {
    var _this2 = this;

    if (!this.api || !this.api.userAction) {
      return;
    }

    if (!userAction.tracking) {
      throw new Error('Wiget::trackUserAction requires a tracking property in the received action!');
    }

    // Timeout to prevent too much reporting.
    if (!this._trackingTimeouts) {
      this._trackingTimeouts = {};
    }

    if (this._trackingTimeouts[userAction.tracking]) {
      // We cancel the current timeout for the event.
      clearTimeout(this._trackingTimeouts[userAction.tracking]);
    }

    var timeout = setTimeout(function () {
      _this2.api.userAction(userAction);
    }, 5);
    this._trackingTimeouts[userAction.tracking] = timeout;
  }
});

Widget.NO_CONTAINERID_ERR = 'Widget::constructor: containerId is a required parameter';
Widget.OVERRIDE_ONINITIALIZE_ERR = 'Widget::onInitialized: This method needs to be implemented in derivate classes';
Widget.OVERRIDE_REGISTERCONFIGCLASSES_ERR = 'Widget::registerConfigClasses: must be overriden in derivate classes';

exports.default = Widget;

/***/ }),
/* 181 */
/***/ (function(module, exports) {

var requestFrame = (function () {
  var window = this
  var raf = window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    function fallbackRAF(func) {
      return window.setTimeout(func, 20)
    }
  return function requestFrameFunction(func) {
    return raf(func)
  }
})()

var cancelFrame = (function () {
  var window = this
  var cancel = window.cancelAnimationFrame ||
    window.mozCancelAnimationFrame ||
    window.webkitCancelAnimationFrame ||
    window.clearTimeout
  return function cancelFrameFunction(id) {
    return cancel(id)
  }
})()

function resizeListener(e) {
  var win = e.target || e.srcElement
  if (win.__resizeRAF__) {
    cancelFrame(win.__resizeRAF__)
  }
  win.__resizeRAF__ = requestFrame(function () {
    var trigger = win.__resizeTrigger__
    trigger.__resizeListeners__.forEach(function (fn) {
      fn.call(trigger, e)
    })
  })
}

var exports = function exports(element, fn) {
  var window = this
  var document = window.document
  var isIE

  var attachEvent = document.attachEvent
  if (typeof navigator !== 'undefined') {
    isIE = navigator.userAgent.match(/Trident/) ||
      navigator.userAgent.match(/Edge/)
  }

  function objectLoad() {
    this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__
    this.contentDocument.defaultView.addEventListener('resize', resizeListener)
  }

  if (!element.__resizeListeners__) {
    element.__resizeListeners__ = []
    if (attachEvent) {
      element.__resizeTrigger__ = element
      element.attachEvent('onresize', resizeListener)
    } else {
      if (getComputedStyle(element).position === 'static') {
        element.style.position = 'relative'
      }
      var obj = (element.__resizeTrigger__ = document.createElement('object'))
      obj.setAttribute(
        'style',
        'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1; opacity: 0;'
      )
      obj.setAttribute('class', 'resize-sensor')
      obj.__resizeElement__ = element
      obj.onload = objectLoad
      obj.type = 'text/html'
      if (isIE) {
        element.appendChild(obj)
      }
      obj.data = 'about:blank'
      if (!isIE) {
        element.appendChild(obj)
      }
    }
  }
  element.__resizeListeners__.push(fn)
}

module.exports = typeof window === 'undefined' ? exports : exports.bind(window)

module.exports.unbind = function (element, fn) {
  var attachEvent = document.attachEvent
  if (fn) {
    element.__resizeListeners__.splice(
      element.__resizeListeners__.indexOf(fn),
      1
    )
  } else {
    element.__resizeListeners__ = []
  }
  if (!element.__resizeListeners__.length) {
    if (attachEvent) {
      element.detachEvent('onresize', resizeListener)
    } else {
      element.__resizeTrigger__.contentDocument.defaultView.removeEventListener(
        'resize',
        resizeListener
      )
      delete element.__resizeTrigger__.contentDocument.defaultView.__resizeTrigger__
      element.__resizeTrigger__ = !element.removeChild(
        element.__resizeTrigger__
      )
    }
    delete element.__resizeListeners__
  }
}


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The class used to communicate differente components
 * @memberof core.widget.widgetHelpers
 */
var EventBus = function () {
  function EventBus() {
    _classCallCheck(this, EventBus);
  }

  _createClass(EventBus, [{
    key: 'bus',

    /**
     * Gets an event bus instance
     * @type {core.widget.widgetHelpers.EventBus}
     */
    get: function get() {
      if (!_underscore2.default.isObject(this._bus)) {
        this._bus = _underscore2.default.extend({}, _backbone2.default.Events);
      }
      return this._bus;
    }
  }]);

  return EventBus;
}();

exports.default = EventBus;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _nodePolyglot = __webpack_require__(184);

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

var _runtime = __webpack_require__(13);

var _runtime2 = _interopRequireDefault(_runtime);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _GoogleMapsUtils = __webpack_require__(18);

var _GoogleMapsUtils2 = _interopRequireDefault(_GoogleMapsUtils);

var _MessageControlCollection = __webpack_require__(201);

var _MessageControlCollection2 = _interopRequireDefault(_MessageControlCollection);

var _getPreloadedJson = __webpack_require__(203);

var _getPreloadedJson2 = _interopRequireDefault(_getPreloadedJson);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @classdesc Helper class for building Widget Classes
 * @memberof core.widget
 * @alias WidgetCommon
 * @abstract
 */
var WidgetCommon = function () {
  function WidgetCommon() {
    _classCallCheck(this, WidgetCommon);
  }

  _createClass(WidgetCommon, null, [{
    key: 'prepareConfig',


    /**
     * Override JSON object configuration
     * @static
     * @protected
     * @param {object} config The config provided by json
     * @param {object} widget - The widget
     */
    value: function prepareConfig(conf, widget) {

      function process(obj, key, value) {
        if (key === 'cluster' && _underscore2.default.isString(value)) {
          if (conf.clustersConf[value]) {
            obj[key] = conf.clustersConf[value];
          }
        }
      }

      function traverse(data, func) {
        for (var i in data) {
          if (data.hasOwnProperty(i)) {
            func.apply(widget, [data, i, data[i]]);
            if (data[i] !== null && _typeof(data[i]) === 'object') {
              traverse(data[i], func);
            }
          }
        }
      }
      traverse(conf, process);
      return conf;
    }

    /**
     * Set language to the widget
     * @static
     * @protected
     * @param {object} widget - The widget
     */

  }, {
    key: 'setLocale',
    value: function setLocale(widget) {
      var promise = _jquery2.default.Deferred();
      var config = widget.config.locale ? widget.config.locale : {};
      var lang = _underscore2.default.isUndefined(config.preloaded) ? 'en' : config.preloaded;
      var locale = void 0,
          customLocale = void 0;
      try {
        locale = __webpack_require__(204)("./" + lang + '.json');
      } catch (e) {
        locale = __webpack_require__(65);
      }

      var polyglot = new _nodePolyglot2.default({ phrases: locale });
      widget.polyglot = polyglot;
      try {
        customLocale = (0, _getPreloadedJson2.default)('locales/' + lang + '.json');
      } catch (e) {
        customLocale = (0, _getPreloadedJson2.default)('locales/en.json');
        console.warn('Language file cannot be found.');
      }

      polyglot.extend(customLocale);

      if (config.url) {
        _jquery2.default.getJSON(config.url).done(function (json) {
          polyglot.extend(json);
          promise.resolve();
        });
      } else if (config.strings) {
        polyglot.extend(config.strings);
        promise.resolve();
      } else {
        //We don't extend the polyglot object but we need to finish the promise
        promise.resolve();
      }
      return promise;
    }

    /**
     * New helpers to use in handlebars template
     * @static
     * @protected
     * @param {object} widget - The widget
     */

  }, {
    key: 'registerHelpers',
    value: function registerHelpers(widget) {
      _runtime2.default.registerHelper('t', function (string) {
        return widget.polyglot.t(string);
      });

      _runtime2.default.registerHelper('list', function (items, options) {
        var i,
            l,
            out = '<ul>',
            className;
        for (i = 0, l = items.length; i < l; i++) {
          if (items[i]) {
            className = i === l - 1 ? 'lastItem' : '';
            out = out + '<li class="' + className + '">' + options.fn(items[i]) + '</li>';
          }
        }
        return out + '</ul>';
      });
    }

    /**
     * Added the components defined by config
     * @static 
     * @param {core.widget.Widget}
     * @param {object} configComponents - The configuration of the components
     */

  }, {
    key: 'addCustomComponents',
    value: function addCustomComponents(widget, configComponents, Components) {
      var _this = this;

      var components = _underscore2.default.filter(configComponents, function (component, key) {
        if (!component || _underscore2.default.indexOf(_GoogleMapsUtils2.default.googleControls, component.componentConstructorClass) !== -1) {
          return false;
        } else {
          component.identifier = key;
          return true;
        }
      });

      _underscore2.default.each(components, function (component, key) {
        if (_underscore2.default.isObject(Components[component.componentConstructorClass])) {
          _this.registerComponent(new Components[component.componentConstructorClass](_underscore2.default.extend(component, {
            map: _this.map,
            position: component.position,
            widget: _this
          })));
        } else {
          throw new Error('There is not any component with identifier ' + component.componentConstructorClass);
        }
      });
    }

    /**
     * Registers a component into the widget
     * @static 
     * @param {core.widget.Widget}
     * @param {core.components.base.ComponentBase} component The component to be registed.
     */

  }, {
    key: 'registerComponent',
    value: function registerComponent(widget, component) {
      widget.customComponents[component.identifier] = component;
    }

    /**
     * This function creates Message Control for all components
     * @static
     * @protected
     */

  }, {
    key: 'createMessageControl',
    value: function createMessageControl(widget) {
      widget.messageControl = new _MessageControlCollection2.default();
    }
  }]);

  return WidgetCommon;
}();

exports.default = WidgetCommon;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//     (c) 2012-2016 Airbnb, Inc.
//
//     polyglot.js may be freely distributed under the terms of the BSD
//     license. For all licensing information, details, and documention:
//     http://airbnb.github.com/polyglot.js
//
//
// Polyglot.js is an I18n helper library written in JavaScript, made to
// work both in the browser and in Node. It provides a simple solution for
// interpolation and pluralization, based off of Airbnb's
// experience adding I18n functionality to its Backbone.js and Node apps.
//
// Polylglot is agnostic to your translation backend. It doesn't perform any
// translation; it simply gives you a way to manage translated phrases from
// your client- or server-side JavaScript application.
//



var forEach = __webpack_require__(185);
var warning = __webpack_require__(186);
var has = __webpack_require__(10);
var trim = __webpack_require__(189);

var warn = function warn(message) {
  warning(false, message);
};

var replace = String.prototype.replace;
var split = String.prototype.split;

// #### Pluralization methods
// The string that separates the different phrase possibilities.
var delimeter = '||||';

// Mapping from pluralization group plural logic.
var pluralTypes = {
  arabic: function (n) {
    // http://www.arabeyes.org/Plural_Forms
    if (n < 3) { return n; }
    if (n % 100 >= 3 && n % 100 <= 10) return 3;
    return n % 100 >= 11 ? 4 : 5;
  },
  chinese: function () { return 0; },
  german: function (n) { return n !== 1 ? 1 : 0; },
  french: function (n) { return n > 1 ? 1 : 0; },
  russian: function (n) {
    if (n % 10 === 1 && n % 100 !== 11) { return 0; }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  czech: function (n) {
    if (n === 1) { return 0; }
    return (n >= 2 && n <= 4) ? 1 : 2;
  },
  polish: function (n) {
    if (n === 1) { return 0; }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  icelandic: function (n) { return (n % 10 !== 1 || n % 100 === 11) ? 1 : 0; }
};

// Mapping from pluralization group to individual locales.
var pluralTypeToLanguages = {
  arabic: ['ar'],
  chinese: ['fa', 'id', 'ja', 'ko', 'lo', 'ms', 'th', 'tr', 'zh'],
  german: ['da', 'de', 'en', 'es', 'fi', 'el', 'he', 'hu', 'it', 'nl', 'no', 'pt', 'sv'],
  french: ['fr', 'tl', 'pt-br'],
  russian: ['hr', 'ru', 'lt'],
  czech: ['cs', 'sk'],
  polish: ['pl'],
  icelandic: ['is']
};

function langToTypeMap(mapping) {
  var ret = {};
  forEach(mapping, function (langs, type) {
    forEach(langs, function (lang) {
      ret[lang] = type;
    });
  });
  return ret;
}

function pluralTypeName(locale) {
  var langToPluralType = langToTypeMap(pluralTypeToLanguages);
  return langToPluralType[locale]
    || langToPluralType[split.call(locale, /-/, 1)[0]]
    || langToPluralType.en;
}

function pluralTypeIndex(locale, count) {
  return pluralTypes[pluralTypeName(locale)](count);
}

var dollarRegex = /\$/g;
var dollarBillsYall = '$$';
var tokenRegex = /%\{(.*?)\}/g;

// ### transformPhrase(phrase, substitutions, locale)
//
// Takes a phrase string and transforms it by choosing the correct
// plural form and interpolating it.
//
//     transformPhrase('Hello, %{name}!', {name: 'Spike'});
//     // "Hello, Spike!"
//
// The correct plural form is selected if substitutions.smart_count
// is set. You can pass in a number instead of an Object as `substitutions`
// as a shortcut for `smart_count`.
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 1}, 'en');
//     // "1 new message"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 2}, 'en');
//     // "2 new messages"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', 5, 'en');
//     // "5 new messages"
//
// You should pass in a third argument, the locale, to specify the correct plural type.
// It defaults to `'en'` with 2 plural forms.
function transformPhrase(phrase, substitutions, locale) {
  if (typeof phrase !== 'string') {
    throw new TypeError('Polyglot.transformPhrase expects argument #1 to be string');
  }

  if (substitutions == null) {
    return phrase;
  }

  var result = phrase;

  // allow number as a pluralization shortcut
  var options = typeof substitutions === 'number' ? { smart_count: substitutions } : substitutions;

  // Select plural form: based on a phrase text that contains `n`
  // plural forms separated by `delimeter`, a `locale`, and a `substitutions.smart_count`,
  // choose the correct plural form. This is only done if `count` is set.
  if (options.smart_count != null && result) {
    var texts = split.call(result, delimeter);
    result = trim(texts[pluralTypeIndex(locale || 'en', options.smart_count)] || texts[0]);
  }

  // Interpolate: Creates a `RegExp` object for each interpolation placeholder.
  result = replace.call(result, tokenRegex, function (expression, argument) {
    if (!has(options, argument) || options[argument] == null) { return expression; }
    // Ensure replacement value is escaped to prevent special $-prefixed regex replace tokens.
    return replace.call(options[argument], dollarRegex, dollarBillsYall);
  });

  return result;
}

// ### Polyglot class constructor
function Polyglot(options) {
  var opts = options || {};
  this.phrases = {};
  this.extend(opts.phrases || {});
  this.currentLocale = opts.locale || 'en';
  var allowMissing = opts.allowMissing ? transformPhrase : null;
  this.onMissingKey = typeof opts.onMissingKey === 'function' ? opts.onMissingKey : allowMissing;
  this.warn = opts.warn || warn;
}

// ### polyglot.locale([locale])
//
// Get or set locale. Internally, Polyglot only uses locale for pluralization.
Polyglot.prototype.locale = function (newLocale) {
  if (newLocale) this.currentLocale = newLocale;
  return this.currentLocale;
};

// ### polyglot.extend(phrases)
//
// Use `extend` to tell Polyglot how to translate a given key.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The key can be any string.  Feel free to call `extend` multiple times;
// it will override any phrases with the same key, but leave existing phrases
// untouched.
//
// It is also possible to pass nested phrase objects, which get flattened
// into an object with the nested keys concatenated using dot notation.
//
//     polyglot.extend({
//       "nav": {
//         "hello": "Hello",
//         "hello_name": "Hello, %{name}",
//         "sidebar": {
//           "welcome": "Welcome"
//         }
//       }
//     });
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}',
//     //   'nav.sidebar.welcome': 'Welcome'
//     // }
//
// `extend` accepts an optional second argument, `prefix`, which can be used
// to prefix every key in the phrases object with some string, using dot
// notation.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     }, "nav");
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}'
//     // }
//
// This feature is used internally to support nested phrase objects.
Polyglot.prototype.extend = function (morePhrases, prefix) {
  forEach(morePhrases, function (phrase, key) {
    var prefixedKey = prefix ? prefix + '.' + key : key;
    if (typeof phrase === 'object') {
      this.extend(phrase, prefixedKey);
    } else {
      this.phrases[prefixedKey] = phrase;
    }
  }, this);
};

// ### polyglot.unset(phrases)
// Use `unset` to selectively remove keys from a polyglot instance.
//
//     polyglot.unset("some_key");
//     polyglot.unset({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The unset method can take either a string (for the key), or an object hash with
// the keys that you would like to unset.
Polyglot.prototype.unset = function (morePhrases, prefix) {
  if (typeof morePhrases === 'string') {
    delete this.phrases[morePhrases];
  } else {
    forEach(morePhrases, function (phrase, key) {
      var prefixedKey = prefix ? prefix + '.' + key : key;
      if (typeof phrase === 'object') {
        this.unset(phrase, prefixedKey);
      } else {
        delete this.phrases[prefixedKey];
      }
    }, this);
  }
};

// ### polyglot.clear()
//
// Clears all phrases. Useful for special cases, such as freeing
// up memory if you have lots of phrases but no longer need to
// perform any translation. Also used internally by `replace`.
Polyglot.prototype.clear = function () {
  this.phrases = {};
};

// ### polyglot.replace(phrases)
//
// Completely replace the existing phrases with a new set of phrases.
// Normally, just use `extend` to add more phrases, but under certain
// circumstances, you may want to make sure no old phrases are lying around.
Polyglot.prototype.replace = function (newPhrases) {
  this.clear();
  this.extend(newPhrases);
};


// ### polyglot.t(key, options)
//
// The most-used method. Provide a key, and `t` will return the
// phrase.
//
//     polyglot.t("hello");
//     => "Hello"
//
// The phrase value is provided first by a call to `polyglot.extend()` or
// `polyglot.replace()`.
//
// Pass in an object as the second argument to perform interpolation.
//
//     polyglot.t("hello_name", {name: "Spike"});
//     => "Hello, Spike"
//
// If you like, you can provide a default value in case the phrase is missing.
// Use the special option key "_" to specify a default.
//
//     polyglot.t("i_like_to_write_in_language", {
//       _: "I like to write in %{language}.",
//       language: "JavaScript"
//     });
//     => "I like to write in JavaScript."
//
Polyglot.prototype.t = function (key, options) {
  var phrase, result;
  var opts = options == null ? {} : options;
  if (typeof this.phrases[key] === 'string') {
    phrase = this.phrases[key];
  } else if (typeof opts._ === 'string') {
    phrase = opts._;
  } else if (this.onMissingKey) {
    var onMissingKey = this.onMissingKey;
    result = onMissingKey(key, opts, this.currentLocale);
  } else {
    this.warn('Missing translation for key: "' + key + '"');
    result = key;
  }
  if (typeof phrase === 'string') {
    result = transformPhrase(phrase, opts, this.currentLocale);
  }
  return result;
};


// ### polyglot.has(key)
//
// Check if polyglot has a translation for given key
Polyglot.prototype.has = function (key) {
  return has(this.phrases, key);
};

// export transformPhrase
Polyglot.transformPhrase = transformPhrase;

module.exports = Polyglot;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__(36);

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (process.env.NODE_ENV !== 'production') {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)))

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(7);
var define = __webpack_require__(62);

var implementation = __webpack_require__(63);
var getPolyfill = __webpack_require__(64);
var shim = __webpack_require__(200);

var boundTrim = bind.call(Function.call, getPolyfill());

define(boundTrim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundTrim;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 191 */
/***/ (function(module, exports) {


var hasOwn = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

module.exports = function forEach (obj, fn, ctx) {
    if (toString.call(fn) !== '[object Function]') {
        throw new TypeError('iterator must be a function');
    }
    var l = obj.length;
    if (l === +l) {
        for (var i = 0; i < l; i++) {
            fn.call(ctx, obj[i], i, obj);
        }
    } else {
        for (var k in obj) {
            if (hasOwn.call(obj, k)) {
                fn.call(ctx, obj[k], k, obj);
            }
        }
    }
};



/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(193);

var $Object = GetIntrinsic('%Object%');
var $TypeError = GetIntrinsic('%TypeError%');
var $String = GetIntrinsic('%String%');

var $isNaN = __webpack_require__(194);
var $isFinite = __webpack_require__(195);

var sign = __webpack_require__(196);
var mod = __webpack_require__(197);

var IsCallable = __webpack_require__(36);
var toPrimitive = __webpack_require__(198);

var has = __webpack_require__(10);

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return !!value;
	},
	ToNumber: function ToNumber(value) {
		return +value; // eslint-disable-line no-implicit-coercion
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return $String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return $Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new $TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// https://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
		if (this.Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};
		// jscs:disable
		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}
		// jscs:enable
		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.1
	IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new $TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
			return false;
		}

		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.2
	IsDataDescriptor: function IsDataDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new $TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
			return false;
		}

		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.3
	IsGenericDescriptor: function IsGenericDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new $TypeError('Desc must be a Property Descriptor');
		}

		if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
			return true;
		}

		return false;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.4
	FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new $TypeError('Desc must be a Property Descriptor');
		}

		if (this.IsDataDescriptor(Desc)) {
			return {
				value: Desc['[[Value]]'],
				writable: !!Desc['[[Writable]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else if (this.IsAccessorDescriptor(Desc)) {
			return {
				get: Desc['[[Get]]'],
				set: Desc['[[Set]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else {
			throw new $TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
		}
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.5
	ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
		if (this.Type(Obj) !== 'Object') {
			throw new $TypeError('ToPropertyDescriptor requires an object');
		}

		var desc = {};
		if (has(Obj, 'enumerable')) {
			desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
		}
		if (has(Obj, 'configurable')) {
			desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
		}
		if (has(Obj, 'value')) {
			desc['[[Value]]'] = Obj.value;
		}
		if (has(Obj, 'writable')) {
			desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
		}
		if (has(Obj, 'get')) {
			var getter = Obj.get;
			if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
				throw new TypeError('getter must be a function');
			}
			desc['[[Get]]'] = getter;
		}
		if (has(Obj, 'set')) {
			var setter = Obj.set;
			if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
				throw new $TypeError('setter must be a function');
			}
			desc['[[Set]]'] = setter;
		}

		if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
			throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
		}
		return desc;
	}
};

module.exports = ES5;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Set,
	Map,
	WeakSet,
	WeakMap,

	Promise,

	Symbol,
	Proxy,

	Atomics,
	SharedArrayBuffer,

	ArrayBuffer,
	DataView,
	Uint8Array,
	Float32Array,
	Float64Array,
	Int8Array,
	Int16Array,
	Int32Array,
	Uint8ClampedArray,
	Uint16Array,
	Uint32Array,
*/

var undefined; // eslint-disable-line no-shadow-restricted-names

var ThrowTypeError = Object.getOwnPropertyDescriptor
	? (function () { return Object.getOwnPropertyDescriptor(arguments, 'callee').get; }())
	: function () { throw new TypeError(); };

var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'$ %Array%': Array,
	'$ %ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'$ %ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'$ %ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'$ %ArrayPrototype%': Array.prototype,
	'$ %ArrayProto_entries%': Array.prototype.entries,
	'$ %ArrayProto_forEach%': Array.prototype.forEach,
	'$ %ArrayProto_keys%': Array.prototype.keys,
	'$ %ArrayProto_values%': Array.prototype.values,
	'$ %AsyncFromSyncIteratorPrototype%': undefined,
	'$ %AsyncFunction%': asyncFunction,
	'$ %AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'$ %AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'$ %AsyncGeneratorFunction%': asyncGenFunction,
	'$ %AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'$ %AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'$ %Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'$ %Boolean%': Boolean,
	'$ %BooleanPrototype%': Boolean.prototype,
	'$ %DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'$ %DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'$ %Date%': Date,
	'$ %DatePrototype%': Date.prototype,
	'$ %decodeURI%': decodeURI,
	'$ %decodeURIComponent%': decodeURIComponent,
	'$ %encodeURI%': encodeURI,
	'$ %encodeURIComponent%': encodeURIComponent,
	'$ %Error%': Error,
	'$ %ErrorPrototype%': Error.prototype,
	'$ %eval%': eval, // eslint-disable-line no-eval
	'$ %EvalError%': EvalError,
	'$ %EvalErrorPrototype%': EvalError.prototype,
	'$ %Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'$ %Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'$ %Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'$ %Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'$ %Function%': Function,
	'$ %FunctionPrototype%': Function.prototype,
	'$ %Generator%': generator ? getProto(generator()) : undefined,
	'$ %GeneratorFunction%': generatorFunction,
	'$ %GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'$ %Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'$ %Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'$ %Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'$ %Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'$ %Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'$ %Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'$ %isFinite%': isFinite,
	'$ %isNaN%': isNaN,
	'$ %IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'$ %JSON%': JSON,
	'$ %JSONParse%': JSON.parse,
	'$ %Map%': typeof Map === 'undefined' ? undefined : Map,
	'$ %MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'$ %MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'$ %Math%': Math,
	'$ %Number%': Number,
	'$ %NumberPrototype%': Number.prototype,
	'$ %Object%': Object,
	'$ %ObjectPrototype%': Object.prototype,
	'$ %ObjProto_toString%': Object.prototype.toString,
	'$ %ObjProto_valueOf%': Object.prototype.valueOf,
	'$ %parseFloat%': parseFloat,
	'$ %parseInt%': parseInt,
	'$ %Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'$ %PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'$ %PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'$ %Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'$ %Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'$ %Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'$ %Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'$ %RangeError%': RangeError,
	'$ %RangeErrorPrototype%': RangeError.prototype,
	'$ %ReferenceError%': ReferenceError,
	'$ %ReferenceErrorPrototype%': ReferenceError.prototype,
	'$ %Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'$ %RegExp%': RegExp,
	'$ %RegExpPrototype%': RegExp.prototype,
	'$ %Set%': typeof Set === 'undefined' ? undefined : Set,
	'$ %SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'$ %SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'$ %SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'$ %SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'$ %String%': String,
	'$ %StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'$ %StringPrototype%': String.prototype,
	'$ %Symbol%': hasSymbols ? Symbol : undefined,
	'$ %SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'$ %SyntaxError%': SyntaxError,
	'$ %SyntaxErrorPrototype%': SyntaxError.prototype,
	'$ %ThrowTypeError%': ThrowTypeError,
	'$ %TypedArray%': TypedArray,
	'$ %TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'$ %TypeError%': TypeError,
	'$ %TypeErrorPrototype%': TypeError.prototype,
	'$ %Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'$ %Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'$ %Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'$ %Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'$ %Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'$ %Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'$ %Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'$ %Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'$ %URIError%': URIError,
	'$ %URIErrorPrototype%': URIError.prototype,
	'$ %WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'$ %WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'$ %WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'$ %WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var key = '$ ' + name;
	if (!(key in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[key] === 'undefined' && !allowMissing) {
		throw new TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}
	return INTRINSICS[key];
};


/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 195 */
/***/ (function(module, exports) {

var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(199);

var isCallable = __webpack_require__(36);

// https://es5.github.io/#x8.12
var ES5internalSlots = {
	'[[DefaultValue]]': function (O, hint) {
		var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// https://es5.github.io/#x9
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
};


/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(62);
var getPolyfill = __webpack_require__(64);

module.exports = function shimStringTrim() {
	var polyfill = getPolyfill();
	define(String.prototype, { trim: polyfill }, { trim: function () { return String.prototype.trim !== polyfill; } });
	return polyfill;
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

var _MessageControlModel = __webpack_require__(202);

var _MessageControlModel2 = _interopRequireDefault(_MessageControlModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _backbone2.default.Collection.extend(
/**
 * @lends core.widget.widgetHelpers.MessageControlCollection.prototype
 */
{
  model: _MessageControlModel2.default,
  /**
   * @class MessageControlCollection
   * @memberof core.widget.widgetHelpers
   * @classdesc This component controls the {@link MessageControlModel} elements
   * @extends Backbone.Collection
   */
  initialize: function initialize() {},

  /**
   * Add a new {@link MessageControlModel} to the collection
   * @function
   * @param {object} messageControlConfig - Data to create the candidate model
   */
  add: function add(messageControlConfig) {
    if (this.isRepeteable(messageControlConfig)) {
      var model = new _MessageControlModel2.default(messageControlConfig);
      _backbone2.default.Collection.prototype.add.call(this, model);
      return model.get('id');
    }
  },


  /**
   * Creates a message
   * 
   * @param {string} type 
   * @param {string} text 
   * @param {boolean} [autohide=false] 
   * @param {boolean} [repeatable=false] 
   * @param {string} [msgId=undefined] 
   */
  createMessage: function createMessage(type, text) {
    var autohide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var repeatable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var msgId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

    var config = {
      type: type,
      text: text,
      autohide: autohide,
      repeatable: repeatable,
      msgId: msgId
    };
    this.add(config);
  },


  /**
   * removes a {@link MessageControlModel} to the collection
   * @function
   * @param {String} id - Id of the model to be deleted
   */
  removeById: function removeById(id) {
    var model = this.get(id);
    this.remove(model);
  },

  /**
   * remove all {@link MessageControlModel} to the collection
   * @memberOf module:MessageControl
   * @function
   */
  clean: function clean() {
    this.reset();
  },

  /**
   * remove a {@link MessageControlModel} to the collection by message id
   * @memberOf module:MessageControl
   * @function
   * @param {String} msgId - msgId of the model to be deleted
   */
  removeByMsgId: function removeByMsgId(msgId) {
    var models = this.where({ 'msgId': msgId });
    this.remove(models);
  },

  /**
   * Checks if the new message can be presented, depending it can be repeated or not
   * @memberOf module:MessageControl
   * @function
   * @param {object} messageConfig - Data to create the possible model
   * */
  isRepeteable: function isRepeteable(messageConfig) {
    var canPrint = true;
    this.each(function (model) {
      if (!messageConfig.repeatable && model.attributes.text === messageConfig.text) {
        canPrint = false;
      }
    });
    return canPrint;
  }
});

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageControlModel = _backbone2.default.Model.extend({
  /**
   * @class MessageControlModel
   * @extends Backbone.Model
   * @memberof core.widget.widgetHelpers
   * @classdesc This model create and controls the attribute id
   */
  initialize: function initialize(config) {
    this.createId();
  },

  /**
   * Set 'id' as unique id
   * @memberOf module:MessageControl
   * @function
   */
  createId: function createId() {
    this.set('id', _underscore2.default.uniqueId('msg_'));
  }
});

exports.default = MessageControlModel;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Requires a JSON file stored in the project's src/data folder
 * 
 * @memberof core.helpers
 * @param {string} filePath The relative file path (from the projects src/data folder) 
 *  of the json file to load.
 * @returns The required file.
 */
function getPreloadedJson(filePath) {
  var path = filePath.replace(new RegExp('.json$'), '').replace(new RegExp('^./data/'), ''),
      json = __webpack_require__(43)("./" + path + '.json');
  return json;
}

exports.default = getPreloadedJson;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": 65,
	"./es.json": 205,
	"./fr.json": 206
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = {"autocomplete.placeholder":"Búsqueda","autocomplete.notResultFound":"No hemos encontrado ningún resultado con esa búsqueda. Pruebe con una ciudad, calle o código postal.","mylocation.notfound":"Lo siento, no hemos podido determinar tu localización. /link/Haz click aquí/link/","mylocation.notinallowedarea":"Esta posición está fuera del área disponible.","mylocation.help":"Ayuda","loadingWarning.mainMsg":"Cargando","streetview.notAvailable":"Street View no está disponible.","carousel.noImages":"Ninguna imagen disponible.","mylocation.linkText":"Click aquí","mylocation.helpMobile":"https://support.google.com/maps/answer/1250066?p=ml_location_help&hl=es&rd=1","mylocation.helpDesktop":"https://support.google.com/maps/answer/2839911?hl=es&visit_id=1-636149094206978280-3844184764&rd=1","placesCard.website":"Ver sitio web","travelTime.turnOn":"Activar filtro","travelTime.turnOff":"Desactivar filtro","travelTime.info":"Puedes arrastrar el punto de referencia por el mapa. Elige el modo de transporte y tiempo máximo desde el punto de referencia para filtrar las propiedades.","calculateTravelTime.turnOn":"Activar Calcular tiempo","calculateTravelTime.turnOff":"Desactivar Calcular tiempo","calculateTravelTime.placeholder":"Busca ubicación deseada","calculateTravelTime.info":"Busca un lugar para calcular el tiempo respecto a una propiedad.","calculateTravelTime.placeholderLimitReached":"Borra algún POI para seguir buscando","calculateTravelTime.infoMessage":"Ahora puedes hacer click en una propiedad y se calculará el tiempo de viaje.","calculateTravelTime.poiAddedMessage":"El punto de interés se ha añadido correctamente.","calculateTravelTime.poisLimitMessage":"No hay más POIs disponibles. Has llegado al máximo número de puntos.","calculateTravelTime.noRouteMessage":"Lo siento, no hemos podido encontrar una ruta. Intenta otra, por favor.","calculateTravelTime.errorMessage":"Lo siento, un error ha ocurrido. Inténtalo de nuevo.","calculateTravelTime.noRouteLabel":"No hay ruta","calculateTravelTime.hoursLabel":"horas","calculateTravelTime.hourLabel":"hora","drawingTool.enabled":"Haz click sobre el mapa para dibujar la zona donde te gustaría buscar. Cierra la zona haciendo doble click o uniendo nodos","transitStops.departure":"Salida","transitStops.arrival":"Llegada","transitStops.headsign":"Dirección","transitStops.line":"Linea","transitStops.stops":"paradas","routeLabel.days":"días","routeLabel.hours":"h","routeLabel.mins":"min"}

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = {"autocomplete.placeholder":"Cliquez ici pour rechercher","autocomplete.notResultFound":"Nous n'avons trouvé aucun résultat correspondant à la recherche! Essayez d'ajouter une ville, rue ou code postal.","mylocation.notfound":"Nous n'avons pas réussi à déterminer votre localisation exacte. /link/Cliquez ici !/link/","mylocation.notinallowedarea":"La localisation est en dehors du secteur autorisé.","mylocation.help":"Aide","loadingWarning.mainMsg":"Chargement en cours","streetview.notAvailable":"Street view non disponible pour cette localisation.","carousel.noImages":"Aucune image ne peut être affichée.","mylocation.linkText":"Cliquez ici.","mylocation.helpMobile":"https://support.google.com/maps/answer/1250066?p=ml_location_help&hl=es&rd=1","mylocation.helpDesktop":"https://support.google.com/maps/answer/2839911?hl=es&visit_id=1-636149094206978280-3844184764&rd=1","placesCard.website":"Voir site web","travelTime.turnOn":"Activer filtre","travelTime.turnOff":"Désactiver filtre","travelTime.info":"Vous pouvez glisser et déposer le point de référence n'importe où sur la carte. Choisissez le mode de transport et le temps maximal du point de référence pour filtrer les propriétés.","calculateTravelTime.turnOn":"Activer le calcul du temps","calculateTravelTime.turnOff":"Désactiver le calcul tu temps","calculateTravelTime.placeholder":"Chercher le lieu souhaité...","calculateTravelTime.info":"Chercher un lieu afin de calculer le temps depuis une propriété","calculateTravelTime.placeholderLimitReached":"Supprimer un POI pour chercher de nouveau","calculateTravelTime.infoMessage":"Maintenant vous pouvez cliquer sur une propiété et le temps de Voyage sera calculé.","calculateTravelTime.poiAddedMessage":"Point d'intêret ajouté correctament.","calculateTravelTime.poisLimitMessage":"Vous ne pouvez pas ajouter plus de points. La limite a été atteinte.","calculateTravelTime.noRouteMessage":"Désolé, ça n'a pas été possible de trouver la route. Essayez une autre, s'il vous plaît.","calculateTravelTime.errorMessage":"Désolé, une error a été produite. Essayez de nouveau.","calculateTravelTime.noRouteLabel":"Pas de route","calculateTravelTime.hoursLabel":"heures","calculateTravelTime.hourLabel":"heure","drawingTool.enabled":"Cliquez sur la carte pour dessiner la zone où vous souhaitez effectuer la recherche. Fermer la zone par un double-clic ou par des noeuds d'assemblage","routeLabel.days":"jours","routeLabel.hours":"h","routeLabel.mins":"min"}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

var _backbone = __webpack_require__(4);

var _backbone2 = _interopRequireDefault(_backbone);

var _sortBy = __webpack_require__(208);

var _sortBy2 = _interopRequireDefault(_sortBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createLayers(handleLayers, layerDefaults, layersConfig) {
  var layersConf = (0, _sortBy2.default)(layersConfig);
  var layersLength = layersConf.length,
      alreadyBooked = handleLayers.bookOverlaysSpace(layersLength),
      layers = [];

  layersConf.forEach(function (layerConf, index) {
    layerConf.index = layersLength - index + alreadyBooked;
    // We clone the defaults so it's not overwritten by _.extend
    var defaults = layerDefaults ? _underscore2.default.clone(layerDefaults) : {};
    layerConf = _underscore2.default.extend(defaults, layerConf);
    var layer = handleLayers.createLayer(layerConf);
    if (layer.model.get('visibleOnMap')) {
      handleLayers.addToMap(layer);
    }
    layers.push(layer);
  });

  return layers;
}

function updateVisibleFeatures(widget) {
  widget.features = [];
  for (var index in widget.productLayers) {
    if (widget.productLayers.hasOwnProperty(index)) {
      var layer = widget.productLayers[index];
      if (layer.model.get('active') && layer.model.get('visibleOnMap')) {
        widget.features = _underscore2.default.union(layer.features, widget.features);
      }
    }
  }
}

/**
 * Validate the configuration of the product layers
 * @private
 */
function validateProductLayers(productLayers) {
  _underscore2.default.each(productLayers, function (layer) {
    //If markers are updated dinamically we can't fit bounds automatically so we disable it
    if (!layer.params.searchOnce) {
      layer.params.fitBounds = false;
    }
  });
}

/**
 * Class to create and handle layers behaviours
 * @memberof module:Layers
 * @classdesc Create and handle layers on the map.
 * @listens EventBus#FIT_BOUNDS_LAYERS to update the widget's view to the markers displayed in an API Layer
 */

var HandleLayers = function () {

  /**
   * Creates the HandleLayers instance
   * @param {Widget} widget - The needed widget to handle events
   */
  function HandleLayers(widget) {
    var _this = this;

    _classCallCheck(this, HandleLayers);

    this.map = widget.map;
    this.bookedSpaces = 0;
    this.layers = [];
    this.layersView = [];
    this.widget = widget;
    this.layersCollection = new _backbone2.default.Collection({});
    this.clusters = {};
    this.minZIndexProductLayers = 1000;
    this.minZIndexLayers = 1;
    this.jumpValueZIndex = 10; //add a Zindex number by 10
    this.zIndexAdded = []; //to know which zIndexs are used

    this.widget.listenTo(this.bus, 'FIT_BOUNDS_LAYERS', function () {
      updateVisibleFeatures(_this.widget);
      if (_this.widget.features.length > 0) {
        var boundingBox = new google.maps.LatLngBounds();
        _this.widget.features.forEach(function (feature) {
          var featurePosition = new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
          boundingBox.extend(featurePosition);
        });
        _this.map.fitBounds(boundingBox);
      }
    });
  }

  /**
   * Method to save array space to load each layer
   * @param {Integer} spaces - Number of spaces to save
   * @returns {Integer}
   */


  _createClass(HandleLayers, [{
    key: 'bookOverlaysSpace',
    value: function bookOverlaysSpace(spaces) {
      var startedAt = this.bookedSpaces;
      this.bookedSpaces = this.bookedSpaces + spaces;
      return startedAt;
    }

    /**
     * Method to create a layer
     * @param {object} source - Layer params
     * @param {String} layerId - Layer ID
     * @returns {module:core.layers.BaseLayer}
     */

  }, {
    key: 'createLayer',
    value: function createLayer(source, layerId) {
      if (!source.id && layerId) {
        source.id = layerId;
      }

      if (_underscore2.default.indexOf(this.layers, source) === -1 && _underscore2.default.isUndefined(source.layer)) {
        if (_underscore2.default.isUndefined(this.widget.layerClasses[source.type])) {
          throw new Error(source.type + ' layer type doesn\'t exist');
        } else if (source.id) {
          var _model = this.layersCollection.get(source.id);
          if (_model) {
            var layer = this.layersView.filter(function (source) {
              return _model === source.model;
            });
            if (_underscore2.default.isEmpty(layer)) {
              //if the layer view doesn't exist, create a new one.
              return this.createLayerView(source);
            } else {
              //if the layer view exists, return the prevous one.
              return layer[0];
            }
          } else {
            return this.createLayerView(source);
          }
        } else {
          return this.createLayerView(source);
        }
      } else {
        return source.layer;
      }
    }

    /**
     * Method to add a layer on the map
     * @param {module:Layers.BaseLayer} layer - Layer to be loaded
     */

  }, {
    key: 'addToMap',
    value: function addToMap(layer) {
      if (_underscore2.default.indexOf(this.layers, layer) === -1) {
        this.layers.push(layer);
      }
      var index = layer.index = layer.model.get('index') || layer.index || this.bookOverlaysSpace(1) + 1;
      layer.add(index);
    }

    /**
     * Method to get a layer index
     * @param {Object} idLayer - id layer
     * @returns {number} layerIndex
     */

  }, {
    key: 'getLayerIndex',
    value: function getLayerIndex(idLayer) {
      var layerIndex = _underscore2.default.findIndex(this.layers, function (layer) {
        return layer.id === idLayer;
      });

      return layerIndex;
    }

    /**
     * Method to remove a layer from the map
     * @param {module:Layers.BaseLayer} layer - Layer to be removed
     */

  }, {
    key: 'deleteLayer',
    value: function deleteLayer(layer) {
      var index = _underscore2.default.indexOf(this.layers, layer);
      if (index > -1) {
        layer.remove();
      }
    }

    /**
     * Method to remove a layer by id from the map
     * @param {Object} idLayer - Layer id to be removed
     */

  }, {
    key: 'deleteLayerById',
    value: function deleteLayerById(idLayer) {
      var layerToRemove = this.getLayerIndex(idLayer);
      if (layerToRemove > -1) {
        this.layers[layerToRemove].remove();
        this.layers.splice(layerToRemove, 1);
      }
    }

    /**
     * Method to get the model from a layer
     * @param {String} layerId - Layer id to get its model
     * @returns {object}
     */

  }, {
    key: 'getLayerModel',
    value: function getLayerModel(layerId) {
      return this.layersCollection.get(layerId);
    }
  }, {
    key: '_layerVisibilityFixer',
    value: function _layerVisibilityFixer(source) {
      var _this2 = this;

      var layersToFix = this.layers.filter(function (src) {
        return src.layer === source.layer && src !== source && source.model.get('active');
      });
      _underscore2.default.each(layersToFix, function (src) {
        _this2.map.overlayMapTypes.setAt(src.index, src.layer);
      });
    }

    /**
     * Method to create a layer view (layer without model)
     * @param {Object} source - Layer parameters
     * @returns {module:Layers.BaseLayer}
     */

  }, {
    key: 'createLayerView',
    value: function createLayerView(source) {
      var layerView = new this.widget.layerClasses[source.type]({ source: source, widget: this.widget });
      this.layersView.push(layerView);
      return layerView;
    }

    /**
     * Method to remove a layer view (layer without model) from the map
     * @param {String} id - Layer id to be removed
     */

  }, {
    key: 'deleteLayerView',
    value: function deleteLayerView(id) {
      var layer = void 0,
          index = void 0;
      for (var i = 0; i < this.layersView.length; i++) {
        if (this.layersView[i].id === id) {
          layer = this.layersView[i];
          index = i;
          break;
        }
      }
      if (layer !== null && index > -1) {
        this.layersView.splice(index, 1);
        this.deleteLayer(layer);
      }
    }

    /**
     * Method to get a layer view (layer without model) by id
     * @param {String} id - Layer id to be returned
     * @returns {module:Layers.BaseLayer | null}
     */

  }, {
    key: 'getLayerView',
    value: function getLayerView(id) {
      var layerView = _underscore2.default.find(this.layersView, function (layer) {
        return layer.id === id;
      });

      return _underscore2.default.isUndefined(layerView) ? null : layerView;
    }

    /**
     * Order the products layers by ZIndex
     * @param {module:Layers.BaseLayer[]} layers - Array of productLayers
     */

  }, {
    key: 'setOrderProductLayers',
    value: function setOrderProductLayers(layers) {
      var minZIndex = this.minZIndexProductLayers; //Product layers have a zIndex higher than others layers
      var maxZindex = this._getMaxZIndex(layers) * this.jumpValueZIndex;
      this._orderLayers(layers, minZIndex, maxZindex);
    }

    /**
     * Order the secondary layers (Google Places, etc) by ZIndex
     * @param {module:Layers.BaseLayer[]} layers - Array of layers
     */

  }, {
    key: 'setOrderSecondaryLayers',
    value: function setOrderSecondaryLayers(layers) {
      var minZIndex = this.minZIndexLayers;
      var maxZindex = this._getMaxZIndex(layers) * this.jumpValueZIndex;
      this._orderLayers(layers, minZIndex, maxZindex);
    }

    /**
     * Order the  layers by ZIndex
     * @private
     * @param {module:Layers.BaseLayer[]} layers - Array of layers
     * @param {Number} minZIndex - The minZIndex for this layers
     * @param {Number} maxZindex - The minimum zIndex for layers without zIndex by config
     */

  }, {
    key: '_orderLayers',
    value: function _orderLayers(layers, minZIndex, maxZindex) {
      var _this3 = this;

      _underscore2.default.each(layers, function (layer) {
        //We increase the range of the zIndex for order others layers with the same zIndex
        var zIndex = _this3._getZIndex(layer) * _this3.jumpValueZIndex;
        //We use the same zIndex if it wasn't added before by other layer
        if (zIndex && _underscore2.default.indexOf(_this3.zIndexAdded, zIndex) === -1) {
          layer.markersZIndex = zIndex;
          //If the zIndex exists, we increment one unit after an unused zIndex
        } else if (zIndex && _underscore2.default.indexOf(_this3.zIndexAdded, zIndex) > -1) {
          var foundSlot = false;
          //The condition i < zIndex + 30 is for to avoid a infinite loop
          //We try to find the zIndex 30 times maximum
          for (var i = zIndex + 1; !foundSlot && i < zIndex + 30; i++) {
            if (_underscore2.default.indexOf(_this3.zIndexAdded, i) === -1) {
              layer.markersZIndex = i;
              foundSlot = true;
            }
          }
          //If after 30 units incremented we dont find a zIndex unused, we use the first zIndex
          if (!foundSlot) {
            layer.markersZIndex = zIndex;
          }
        } else {
          //If the layer doesnt have a zIndex by config, we increment the maximum zIndex by config to add one
          var _foundSlot = false;
          //The condition i < zIndex + 30 is for to avoid a infinite loop
          //We try to find the zIndex 30 times maximum
          for (var _i = maxZindex + 1; !_foundSlot && _i < maxZindex + 30; _i++) {
            if (_underscore2.default.indexOf(_this3.zIndexAdded, _i) === -1) {
              layer.markersZIndex = _i;
              _foundSlot = true;
            }
          }
          if (!_foundSlot) {
            layer.markersZIndex = maxZindex;
          }
        }
        _this3.zIndexAdded.push(layer.markersZIndex);
      });
    }
    /**
     * Get the zIndex added by config
     * @private
     * @param {module:Layers.BaseLayer} layer - layer
     * @return the zIndex by config or null if it doesn't exist
     */

  }, {
    key: '_getZIndex',
    value: function _getZIndex(layer) {
      if (!_underscore2.default.isUndefined(layer.markersZIndex) && !_underscore2.default.isNull(layer.markersZIndex)) {
        return layer.markersZIndex;
      } else {
        return null;
      }
    }
    /**
     * Get the zIndex maximum by config in order to find zIndex unused after this number
     * @private
     * @param {module:Layers.BaseLayer[]} layer - array of layers added by config
     * @return the zIndex maximum by config
     */

  }, {
    key: '_getMaxZIndex',
    value: function _getMaxZIndex(layers) {
      var max = 1;
      _underscore2.default.each(layers, function (layer) {
        if (!_underscore2.default.isUndefined(layer.markersZIndex) && !_underscore2.default.isNull(layer.markersZIndex) && max < layer.markersZIndex) {
          max = layer.markersZIndex;
        }
      });
      return max;
    }

    /**
     * @typedef {object} CreateConfigLayersResult
     * @property {core.layers.BaseLayer[]} productLayers The product layers created.
     * @property {core.layers.BaseLayer[]} layers The non-product layers created   * 
     * @memberof core.widget.widgetHelpers.HandleLayers
     */

    /**
     * Creates layers from their configuration.
     * @param {object} layerDefaults
     * @param {object} productLayersCfg 
     * @param {object} layersCfg 
     * @returns {core.widget.widgetHelpers.CreateConfigLayersResult}
     */

  }, {
    key: 'createConfigLayers',
    value: function createConfigLayers(layerDefaults, productLayersCfg, layersCfg) {
      //Creation of productLayers
      var productLayers = [],
          layers = [];
      if (_underscore2.default.isObject(productLayersCfg)) {
        validateProductLayers(productLayersCfg);
        productLayers = createLayers(this, layerDefaults, productLayersCfg);
        this.setOrderProductLayers(productLayers);
      }
      //Creation of layers gPlaces, carto or WMS
      if (_underscore2.default.isObject(layers)) {
        layers = createLayers(this, layerDefaults, layersCfg);
        this.setOrderSecondaryLayers(layers);
      }

      return {
        productLayers: productLayers,
        layers: layers
      };
    }
  }]);

  return HandleLayers;
}();

exports.default = HandleLayers;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Sorts the item of an array of object by the value of one property of said objects
 * (order by default);
 * @memberof core.helpers
 * @param {object[]} array The array to be sorted
 * @param {string} [sortBy='order'] The property to sort the objects in the array by.
 * @returns The ordered array.
 */
function sortBy(array) {
  var sortBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'order';

  return _underscore2.default.sortBy(_underscore2.default.map(array, function (item, key) {
    item.id = item.id || key;
    return item;
  }), sortBy) || [];
}

exports.default = sortBy;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Calculates the pixels that a particular control hides, and accumulates it in the globalOffset variable.
 * @private
 * @param {google.maps.Map} map 
 * @param {google.maps.ControlPosition} position 
 * @param {object} globalOffset 
 * @param {number} globalOffset.top
 * @param {number} globalOffset.right
 * @param {number} globalOffset.bottom
 * @param {number} globalOffset.left
 */
function calculateControlOffset(map, position, globalOffset) {
  return function (control) {
    var controlOffset = { top: 0, left: 0, right: 0, bottom: 0 };

    //if the component doesn't fill the entire height screen, else ignore it
    if (map.getDiv().offsetHeight !== control.offsetHeight) {
      if (position === google.maps.ControlPosition.TOP_CENTER || position === google.maps.ControlPosition.TOP_LEFT || position === google.maps.ControlPosition.TOP_RIGHT || position === google.maps.ControlPosition.LEFT_TOP || position === google.maps.ControlPosition.RIGHT_TOP) {
        controlOffset.top = control.offsetHeight ? control.offsetTop + control.offsetHeight : control.offsetHeight;
      }

      if (position === google.maps.ControlPosition.BOTTOM_CENTER || position === google.maps.ControlPosition.BOTTOM_LEFT || position === google.maps.ControlPosition.BOTTOM_RIGHT || position === google.maps.ControlPosition.LEFT_BOTTOM || position === google.maps.ControlPosition.RIGHT_BOTTOM) {
        controlOffset.bottom = map.getDiv().offsetHeight - control.offsetTop;
      }
    }
    //if the component doesn't fill the entire width screen, else ignore it
    if (map.getDiv().offsetWidth !== control.offsetWidth) {
      if (position === google.maps.ControlPosition.LEFT_CENTER || position === google.maps.ControlPosition.BOTTOM_LEFT || position === google.maps.ControlPosition.TOP_LEFT || position === google.maps.ControlPosition.LEFT_BOTTOM || position === google.maps.ControlPosition.LEFT_TOP) {
        controlOffset.left = control.offsetWidth ? control.offsetLeft + control.offsetWidth : control.offsetWidth;
      }

      if (position === google.maps.ControlPosition.RIGHT_CENTER || position === google.maps.ControlPosition.BOTTOM_RIGHT || position === google.maps.ControlPosition.TOP_RIGHT || position === google.maps.ControlPosition.RIGHT_BOTTOM || position === google.maps.ControlPosition.RIGHT_TOP) {
        controlOffset.right = map.getDiv().offsetWidth - control.offsetLeft;
      }
    }

    // We only keep the smallest offset, either vertically or horizontally if possible.
    if (controlOffset.top > 0 && (controlOffset.top < controlOffset.left || controlOffset.top < controlOffset.right)) {
      controlOffset.left = 0;
      controlOffset.right = 0;
    } else {
      controlOffset.top = 0;
    }

    if (controlOffset.bottom > 0 && (controlOffset.bottom < controlOffset.left || controlOffset.bottom < controlOffset.right)) {
      controlOffset.left = 0;
      controlOffset.right = 0;
    } else {
      controlOffset.bottom = 0;
    }

    // And then extend the global offset if the new values are bigger.
    if (controlOffset.top > globalOffset.top) {
      globalOffset.top = controlOffset.top;
    }

    if (controlOffset.left > globalOffset.left) {
      globalOffset.left = controlOffset.left;
    }
    if (controlOffset.bottom > globalOffset.bottom) {
      globalOffset.bottom = controlOffset.bottom;
    }
    if (controlOffset.right > globalOffset.right) {
      globalOffset.right = controlOffset.right;
    }
  };
}

/**
 * Returns the offsets that we need to apply in each of the four borders of the map to avoid being hidden
 * by any map control.
 * @private
 * @param {google.maps.Map} map the map instance the offsets are calculated for.
 * @returns {object} The offsets to avoid placing things under for the four borders of the map.
 */
function calculateGlobalOffset(map) {
  var globalOffset = { top: 0, left: 0, right: 0, bottom: 0 };

  for (var position in map.controls) {
    if (!map.controls.hasOwnProperty(position)) {
      continue;
    }
    map.controls[position].forEach(calculateControlOffset(map, parseInt(position), globalOffset));
  }

  return globalOffset;
}

/**
 * Map fitBounds substitute function that applies a bounding box to a given map, preventing
 * the received bounding box from being hidden by a control.
 * @private
 * @param {any} map 
 * @param {any} bbox 
 */
function controlAwareFitBounds(map, bbox) {
  map._oldFitBounds(bbox);

  var projection = map.getProjection();
  if (!projection || !map.getZoom()) {
    // Too early for this kind of operation...
    return;
  }

  var globalOffset = calculateGlobalOffset(map);

  // Now we apply the offsets to the corners of the current bounding bounds.
  var sw = bbox.getSouthWest();
  var ne = bbox.getNorthEast();

  var swPt = projection.fromLatLngToPoint(sw);
  var nePt = projection.fromLatLngToPoint(ne);
  var zoomMultiplier = Math.pow(2, map.getZoom());
  swPt.x -= globalOffset.left / zoomMultiplier;
  swPt.y += globalOffset.bottom / zoomMultiplier;

  nePt.x += globalOffset.right / zoomMultiplier;
  nePt.y -= globalOffset.top / zoomMultiplier;

  sw = projection.fromPointToLatLng(swPt);
  ne = projection.fromPointToLatLng(nePt);

  map._oldFitBounds(new google.maps.LatLngBounds(sw, ne));
}

/**
 * Sets the map center taking into account areas of the map that might be hiden by controls, so the map seems
 * properly centered.
 * @private
 * @param {any} map 
 * @param {any} position 
 */
function controlAwareSetCenter(map, position) {
  var projection = map.getProjection();
  if (!projection || !map.getZoom()) {
    // Too early for this!
    map._oldSetCenter(position);
    return;
  }
  var globalOffset = calculateGlobalOffset(map);

  var point = projection.fromLatLngToPoint(position);

  var zoomMultiplier = 2 * Math.pow(2, map.getZoom());
  // We calculate the camera displacement vector.
  point.x += (globalOffset.right - globalOffset.left) / zoomMultiplier;
  point.y += (globalOffset.bottom - globalOffset.top) / zoomMultiplier;

  map._oldSetCenter(projection.fromPointToLatLng(point));
}

/**
 * Enables centerting and fit bounds avoiding areas hidden by map controls.
 * @memberof core.helpers
 * @param {googe.maps.Map} map 
 */
exports.default = {
  /**
   * Replaces the map vainilla's fitBounds and setCenter functions with
   * substitutes that takes into account the areas hidden by controls in order to properly position
   * the map so nothing that we want to show to the user is hidden.
   */
  init: function init(map) {
    map._oldFitBounds = map.fitBounds;
    map.fitBounds = function (bbox) {
      controlAwareFitBounds(map, bbox);
    };

    map._oldSetCenter = map.setCenter;

    function setCenter(position) {
      var stackPiece = void 0;
      try {
        throw new Error();
      } catch (error) {
        stackPiece = error.stack ? error.stack.split('\n')[3] : null;
      }
      if (stackPiece && stackPiece.indexOf('googleapis.com') !== -1 || stackPiece === null) {
        // The code was called from google's script, so we work in vainilla mode to avoid breaking things.
        map._oldSetCenter(position);
        return;
      }
      controlAwareSetCenter(map, position);
    }

    map.setCenter = setCenter;
  }
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (factory) {
  if (( false ? 'undefined' : _typeof(exports)) === 'object') {
    var jQuery = void 0;
    try {
      jQuery = __webpack_require__(0);
    } catch (e) {}
    module.exports = factory(jQuery);
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    factory(window.jQuery, window);
  }
})(function (jQuery, _window) {
  // Enable strict mode
  'use strict';

  // Use Sizzle standalone or from jQuery

  var sizzle = window.Sizzle || jQuery.find,
      queryData = {},
      cssRules = null,
      important = '!important;',
      style = 'position:absolute' + important + 'visibility:hidden' + important + 'width:1em' + important + 'font-size:1em' + important + 'padding:0' + important;

  function getEmPixels(element) {
    var extraBody, testElement, value;

    if (!element) {
      // Emulate the documentElement to get rem value (documentElement does not work in IE6-7)
      element = extraBody = document.createElement('body');
      extraBody.style.cssText = 'font-size:1em' + important;
      document.documentElement.insertBefore(extraBody, document.body);
    }

    // Create and style a test element
    testElement = document.createElement('i');
    testElement.style.cssText = style;
    element.appendChild(testElement);

    // Get the client width of the test element
    value = testElement.clientWidth;

    if (extraBody) {
      // Remove the extra body element
      document.documentElement.removeChild(extraBody);
    } else {
      // Remove the test element
      element.removeChild(testElement);
    }

    // Return the em value in pixels
    return value;
  }

  function setCssRules() {
    if (document.styleSheets[0]) {
      cssRules = document.styleSheets[0].cssRules !== undefined ? 'cssRules' : 'rules';
    }
  }

  function addQueryDataValue(selector, type, pair, number, value) {

    selector = trim(selector);

    if (selector !== '') {
      var parts;
      if (!number && !value) {
        parts = /^([0-9]*.?[0-9]+)(px|em)$/.exec(pair);
        if (parts !== null) {
          number = Number(parts[1]);
          if (number + '' !== 'NaN') {
            value = parts[2];
          }
        }
      }

      if (value) {
        // Compile the sizzle selector
        if (sizzle.compile) {
          sizzle.compile(selector);
        }

        // Update the queryData object
        if (queryData[selector] === undefined) {
          queryData[selector] = {};
        }
        if (queryData[selector][type] === undefined) {
          queryData[selector][type] = {};
        }
        queryData[selector][type][pair] = [number, value];
      }
    }
  }

  function refresh() {

    var i, ei, j, k, elements, element, val;

    // For each selector
    for (i in queryData) {

      // Get the items matching the selector
      elements = sizzle(i);

      if (elements.length > 0) {

        // For each matching element
        for (ei = 0; ei < elements.length; ei++) {
          element = elements[ei];

          // For each min|max-width|height string
          for (j in queryData[i]) {

            // For each number px|em value pair
            for (k in queryData[i][j]) {

              val = queryData[i][j][k][0];

              if (queryData[i][j][k][1] === 'em') {
                // Convert EMs to pixels
                val = val * (window.getEmPixels ? getEmPixels(element) : 16); // NOTE: Using getEmPixels() has a small performance impact
              }

              /* NOTE: Using offsetWidth/Height so an element can be adjusted when it reaches a specific size.
              /* For Nested queries scrollWidth/Height or clientWidth/Height may sometime be desired but are not supported. */

              if (j === 'min-width' && element.offsetWidth >= val || j === 'max-width' && element.offsetWidth <= val || j === 'min-height' && element.offsetHeight >= val || j === 'max-height' && element.offsetHeight <= val) {
                // Add matching attr value
                addTo(element, j, k);
              } else {
                // Remove non-matching attr value
                removeFrom(element, j, k);
              }
            }
          }
        }
      }
    }

    if (!window.addEventListener && window.attachEvent) {
      // Force a repaint in IE7 and IE8
      var className = document.documentElement.className;
      document.documentElement.className = ' ' + className;
      document.documentElement.className = className;
    }
  }

  function updateQueryData(data, doUpdate) {

    var i, j, k;
    for (i in data) {
      for (j in data[i]) {
        if (typeof data[i][j] === 'string') {
          addQueryDataValue(i, j, data[i][j]);
        } else if (_typeof(data[i][j]) === 'object') {
          for (k = 0; k < data[i][j].length; k++) {
            addQueryDataValue(i, j, data[i][j][k]);
          }
        }
      }
    }

    if (doUpdate === true) {
      refresh();
    }
  }

  function processSelector(selectorText) {

    if (selectorText) {

      var regex = /(\[(min\-width|max\-width|min\-height|max\-height)\~\=(\'|\')([0-9]*.?[0-9]+)(px|em)(\'|\')\])(\[(min\-width|max\-width|min\-height|max\-height)\~\=(\'|\')([0-9]*.?[0-9]+)(px|em)(\'|\')\])?/gi;

      // Split out the full selectors separated by a comma ','
      var selectors = selectorText.split(',');
      var i, selector, result, number, prevIndex, k, tail, t;
      for (i = 0; i < selectors.length; i++) {

        selector = null;
        prevIndex = 0;
        k = 0;
        while (k === 0 || result !== null) {
          result = regex.exec(selectors[i]);
          if (result !== null) {

            // result[2] = min-width|max-width|min-height|max-height
            // result[4] = number
            // result[5] = px|em
            // result[7] = has another

            // Ensure that it contains a valid numeric value to compare against
            number = Number(result[4]);
            if (number + '' !== 'NaN') {

              if (selector === null) {
                // New set: update the current selector
                selector = selectors[i].substring(prevIndex, result.index);

                // Append second half of the selector
                tail = selectors[i].substring(result.index + result[1].length);
                if (tail.length > 0) {

                  t = tail.indexOf(' ');
                  if (t !== 0) {
                    if (t > 0) {
                      // Take only the current part
                      tail = tail.substring(0, t);
                    }

                    // Remove any sibling element queries
                    tail = tail.replace(/(\[(min\-width|max\-width|min\-height|max\-height)\~\=(\'|\')([0-9]*.?[0-9]+)(px|em)(\'|\')\])/gi, '');
                    selector += tail;
                  }
                }
              }

              // Update the queryData object
              addQueryDataValue(selector, result[2], result[4] + result[5], number, result[5]);
            }

            if (result[7] === undefined || result[7] === '') {
              // Reached the end of the set
              prevIndex = result.index + result[1].length;
              selector = null;
            } else {
              // Update result index to process next item in the set
              regex.lastIndex = result.index + result[1].length;
            }
          }
          k++;
        }
      }
    }
  }

  function processStyleSheet(styleSheet, force) {

    if (cssRules === null) {
      setCssRules();
    }
    if (styleSheet[cssRules] && styleSheet[cssRules].length > 0) {

      var ownerNode = styleSheet.ownerNode || styleSheet.owningElement;
      if (force || ownerNode.getAttribute('data-elementquery-bypass') === null && ownerNode.getAttribute('data-elementquery-processed') === null) {

        var i, j, rule;

        for (i = 0; i < styleSheet[cssRules].length; i++) {
          rule = styleSheet[cssRules][i];

          // Check nested rules in media queries etc
          if (rule[cssRules] && rule[cssRules].length > 0) {
            for (j = 0; j < rule[cssRules].length; j++) {
              processSelector(rule[cssRules][j].selectorText);
            }
          } else {
            processSelector(rule.selectorText);
          }
        }

        // Flag the style sheet as processed
        ownerNode.setAttribute('data-elementquery-processed', '');
      }
    }
  }

  // Refactor from jQuery.trim()
  function trim(text) {
    if (text === null) {
      return '';
    } else {
      var core_trim = ''.trim;
      if (core_trim && !core_trim.call('\uFEFF\xA0')) {
        return core_trim.call(text);
      } else {
        return (text + '').replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
      }
    }
  }

  // Refactor from jquery().addClass() and jquery().removeClass()
  function clean(element, attr) {
    // This expression is here for better compressibility
    var val = element.getAttribute(attr);
    return val ? (' ' + val + ' ').replace(/[\t\r\n]/g, ' ') : ' ';
  }

  // Refactor from jquery().addClass()
  function addTo(element, attr, value) {

    if (element.nodeType === 1) {
      var val = trim(value);
      if (val !== '') {
        var cur = clean(element, attr);

        if (cur.indexOf(' ' + val + ' ') < 0) {
          // Add the value if its not already there
          element.setAttribute(attr, trim(cur + val));
        }
      }
    }
  }

  // Refactor from jquery().removeClass()
  function removeFrom(element, attr, value) {

    if (element.nodeType === 1) {
      var val = trim(value);
      if (val !== '') {
        var cur = clean(element, attr);
        var updated = false;
        while (cur.indexOf(' ' + val + ' ') >= 0) {
          // Remove the value
          cur = cur.replace(' ' + val + ' ', ' ');
          updated = true;
        }
        if (updated) {
          // Update the attribute
          element.setAttribute(attr, trim(cur));
        }
      }
    }
  }

  function init() {

    // Process the style sheets
    var i;
    for (i = 0; i < document.styleSheets.length; i++) {
      processStyleSheet(document.styleSheets[i]);
    }

    refresh();
  }

  // Expose some public functions
  var elementQuery = function elementQuery(arg1, arg2) {
    if (arg1 && (typeof arg1 === 'undefined' ? 'undefined' : _typeof(arg1)) === 'object') {
      if (arg1.cssRules || arg1.rules) {
        // Process a new style sheet
        processStyleSheet(arg1, true);

        if (arg2 === true) {
          refresh();
        }
      } else {
        // Add new selector queries
        updateQueryData(arg1, arg2);
      }
    } else if (!arg1 && !arg2) {
      refresh();
    }
  };

  //NOTE: For development purposes only!
  elementQuery.selectors = function () {

    var data = {};
    var i, j, k;

    // For each selector
    for (i in queryData) {

      // For each min|max-width|height string
      for (j in queryData[i]) {

        // For each number px|em value pair
        for (k in queryData[i][j]) {

          if (data[i] === undefined) {
            data[i] = {};
          }
          if (data[i][j] === undefined) {
            data[i][j] = [];
          }
          data[i][j][data[i][j].length] = k;
        }
      }
    }
    return data;
  };

  if (window.addEventListener) {
    window.addEventListener('resize', refresh, false);
    window.addEventListener('DOMContentLoaded', init, false);
    window.addEventListener('load', init, false);
  } else if (window.attachEvent) {
    window.attachEvent('onresize', refresh);
    window.attachEvent('onload', init);
  }

  if (_window === window) {
    window.elementQuery = elementQuery;
  } else {
    return elementQuery;
  }
});

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(2);
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"lmm-maps-widget-container "
    + container.escapeExpression(((helper = (helper = helpers.className || (depth0 != null ? depth0.className : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"className","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"map-container\"></div>\n</div>";
},"useData":true});

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(0).then((function(require) {
		cb(__webpack_require__(248));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GPlacesHelper = __webpack_require__(30);

var _GPlacesHelper2 = _interopRequireDefault(_GPlacesHelper);

var _Utils = __webpack_require__(6);

var _Utils2 = _interopRequireDefault(_Utils);

var _BaseLayer = __webpack_require__(14);

var _BaseLayer2 = _interopRequireDefault(_BaseLayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import InfowindowPOIBasemap from '../views/infowindow/infowindowPOIBasemap/InfowindowPOIBasemap';
// import DistanceMatrixService from '../services/DistanceMatrixService';
exports.default = _BaseLayer2.default.extend({
    initialize: function initialize() {
        var _this = this;

        this.widget.selectedPOI = null;
        this.selectedPOI = null;
        // this.distanceMatrixService = new DistanceMatrixService();
        // this.selectedPOIIW = new InfowindowPOIBasemap({
        //   widget: this.widget
        // });
        this.listenTo(this.widget.bus, 'CLOSED_POIMAPBASE_IW', function () {
            _this.removeMarker();
        });
        this.listenTo(this.widget.bus, 'CLICK_ON_MARKER', function () {
            _this.unSelectPOI();
        });

        this.listenTo(this.widget.bus, 'POIBASE_SELECTED', function () {
            var marker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            _this.getDataPlaceFromSearch(marker);
        });

        this.listenTo(this.widget.bus, 'CREATE_POINT_REFERENCE', function (configPRef) {
            var markerConfig = configPRef;
            if (!(configPRef && configPRef.properties && configPRef.properties.hotel && configPRef.properties.hotel.code)) {
                markerConfig.map = _this.widget.map;
            }
            markerConfig.clickable = false;
            var icon = {
                url: _Utils2.default.getImgUrl(_this.widget.config.genericIconMarker, _this.widget),
                size: new google.maps.Size(50, 50),
                scaledSize: new google.maps.Size(40, 40)
            };
            markerConfig.icon = icon;
            _this._removeAutocompleteMarker();
            _this.pointReference = new google.maps.Marker(markerConfig);
        });

        this.listenTo(this.widget.bus, 'RESET_AUTOCOMPLETE', function () {
            _this._removeAutocompleteMarker();
        });

        this.listenTo(this.widget.bus, 'DELETE_POINT_REFERENCE', function () {
            _this._removeAutocompleteMarker();
        });

        // this._addEventListener();
    },
    _removeAutocompleteMarker: function _removeAutocompleteMarker() {
        if (this.pointReference) {
            this.pointReference.setMap(null);
            this.pointReference = null;
        }
    },
    _addEventListener: function _addEventListener() {
        var _this2 = this;

        this.widget.map.addListener('click', function (event) {
            _this2.unSelectPOI();
            event.stop();

            if (_this2.widget.clickAlternativeHotels === true && (navigator.userAgent.toLowerCase().indexOf('android') > -1 || _this2.widget.isMobile)) {
                _this2.widget.clickAlternativeHotels = false;
                return;
            }

            if (typeof _this2.widget.componentsStatus === 'undefined' || _this2.widget.componentsStatus.directionHide && _this2.widget.componentsStatus.routeDetailsPanel) {
                if (typeof _this2.widget.isTravelTimeActivated !== 'undefined' && _this2.widget.isTravelTimeActivated === true) {
                    _this2.addTraveltimeToInfowindow(event);
                } else {
                    _this2.createBaseInfowindow(event);
                }
            } else if (!_this2.widget.componentsStatus.directionHide) {
                _this2.widget.bus.trigger('CLICK_ON_MAP_ROUTE', Object.assign({}, event));
            }
        });
    },
    _addClickListener: function _addClickListener(marker) {
        var _this3 = this;

        marker.clickListener = google.maps.event.addListener(marker, 'click', function (event) {
            if (event instanceof Event) {
                event.stopPropagation();
            }
            _this3.widget.bus.trigger('CLICK_ON_MAIN_HOTEL_MARKER');
        });
    },
    add: function add() {},
    remove: function remove() {},


    // TODO change param name
    addMarker: function addMarker(object, customIcon) {
        var position = void 0;
        if (object.position instanceof google.maps.LatLng) {
            position = object.position;
        } else {
            position = new google.maps.LatLng(object.position);
        }
        var marker = new google.maps.Marker({
            position: position,
            map: this.widget.map,
            // properties: place,
            icon: customIcon,
            zIndex: 0
        });
        this._addClickListener(marker);
        return marker;
    },
    createBaseInfowindow: function createBaseInfowindow(event) {
        if (event.placeId) {
            this.getDataPlace(event);
        } else {
            this.unSelectPOI();
            //Informs that others infowindows should be removed.
            this.widget.bus.trigger('CLICK_ON_MAP');
        }
    },
    addTraveltimeToInfowindow: function addTraveltimeToInfowindow(event) {
        var _this4 = this;

        this.distanceMatrixService.calculateDistance({
            origin: this.widget.mainHotel.position,
            destinations: [{ position: event.latLng }],
            travelMode: this.widget.travelModeComponent.toUpperCase()
        }).then(function (results) {
            _this4.widget.selectedPOIDistanceMatrix = results[0];
            if (_this4.selectedPOIIW.infowindow.isOpen()) {
                _this4.selectedPOIIW.addTravelTimeInfo();
            } else {
                _this4.createBaseInfowindow(event);
            }
        });
    },
    getDataPlaceFromSearch: function getDataPlaceFromSearch(event) {
        var _this5 = this;

        this.unSelectPOI();
        var prop = event.placeId === undefined ? 'place_id' : 'placeId';
        var avoidedConfigCat = this.widget.config.avoidedCategoriesOnMap;
        var ignore = [];
        _GPlacesHelper2.default.getDetails(this.widget.map, event[prop]).done(function (place) {
            if (avoidedConfigCat) {
                ignore = place[0].types.filter(function (val) {
                    return avoidedConfigCat.indexOf(val) !== -1;
                });
            }
            if (!ignore.length) {
                if (typeof _this5.widget.isTravelTimeActivated !== 'undefined' && _this5.widget.isTravelTimeActivated) {
                    _this5.distanceMatrixService.calculateDistance({
                        origin: _this5.widget.mainHotel.position,
                        destinations: [{ position: place[0].geometry.location }],
                        travelMode: _this5.widget.travelModeComponent.toUpperCase()
                    }).then(function (results) {
                        _this5.widget.selectedPOIDistanceMatrix = results[0];
                        _this5.selectPOI(place[0], event.customIcon);
                    });
                } else {
                    _this5.selectPOI(place[0], event.customIcon);
                }
            }
        }).fail(function () {
            console.log('fail');
        });
    },
    getDataPlace: function getDataPlace(event) {
        var _this6 = this;

        var prop = event.placeId === undefined ? 'place_id' : 'placeId';
        var avoidedConfigCat = this.widget.config.avoidedCategoriesOnMap;
        var ignore = [];
        _GPlacesHelper2.default.getDetails(this.widget.map, event[prop]).done(function (place) {
            if (avoidedConfigCat) {
                ignore = place[0].types.filter(function (val) {
                    return avoidedConfigCat.indexOf(val) !== -1;
                });
            }
            if (!ignore.length) {
                _this6.selectPOI(place[0], event.customIcon);
            }
        }).fail(function () {
            console.log('fail');
        });
    },
    selectPOI: function selectPOI(place, customIcon) {
        this.unSelectPOI();
        var position = place.geometry.location;
        this.selectedPOI = new google.maps.Marker({
            position: new google.maps.LatLng(position.lat(), position.lng()),
            map: this.widget.map,
            properties: place,
            icon: customIcon,
            zIndex: 999
        });

        this.selectedPOI.setMap(this.widget.map);
        this.widget.selectedPOI = this.selectedPOI;
        // this.selectedPOIIW.openInfowindow(this.widget.selectedPOI);
        // this.widget.infowindowCategoryPOI = this.selectedPOIIW;
        //Informs that others infowindows should be removed.
        this.widget.bus.trigger('CLICK_ON_POIBASEMAP');
        this.setSuggestedLocationsInLocalStorage(place);
    },
    removeMarker: function removeMarker() {
        if (this.widget.selectedPOI !== null && this.selectedPOI !== null) {
            this.widget.selectedPOI.setMap(null);
            this.widget.selectedPOI = null;
            this.selectedPOI = null;
        }
        this.widget.selectedPOI = null;
    },
    unSelectPOI: function unSelectPOI() {
        if (this.selectedPOI !== null) {
            this.removeMarker();
            // this.selectedPOIIW.closeInfowindow();
        }
    },
    getSelectedPoi: function getSelectedPoi() {
        return this.widget.selectedPOI;
    },
    getSelectedPoiIW: function getSelectedPoiIW() {
        return this.selectedPOIIW;
    },
    setSuggestedLocationsInLocalStorage: function setSuggestedLocationsInLocalStorage(element) {
        if (typeof Storage !== 'undefined' && typeof element !== 'undefined') {
            var suggestedLocations = !localStorage.getItem('suggestedLocations') ? [] : JSON.parse(localStorage.getItem('suggestedLocations'));

            for (var i = 0; i < suggestedLocations.length; i++) {
                if (suggestedLocations[i].name === element.name) {
                    suggestedLocations.splice(i, 1);
                    suggestedLocations.unshift(element);
                    localStorage.setItem('suggestedLocations', JSON.stringify(suggestedLocations));
                    return;
                }
            }

            if (suggestedLocations.length >= this.widget.maxNumbersOfSuggestedPlaces) {
                suggestedLocations.pop();
            }
            suggestedLocations.unshift(element);

            localStorage.setItem('suggestedLocations', JSON.stringify(suggestedLocations));
        }
    }
});

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(66);
var bind = __webpack_require__(7);

var implementation = __webpack_require__(67);
var getPolyfill = __webpack_require__(87);
var polyfill = getPolyfill();
var shim = __webpack_require__(239);

var boundFlatMap = bind.call(Function.call, polyfill);

define(boundFlatMap, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundFlatMap;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trimStart = __webpack_require__(216);
var trimEnd = __webpack_require__(218);
var inspect = __webpack_require__(37);

var ES2018 = __webpack_require__(221);
var assign = __webpack_require__(16);
var MAX_SAFE_INTEGER = __webpack_require__(79);

var GetIntrinsic = __webpack_require__(5);

var $TypeError = GetIntrinsic('%TypeError%');

var ES2019 = assign(assign({}, ES2018), {
	// https://tc39.es/ecma262/#sec-add-entries-from-iterable
	AddEntriesFromIterable: function AddEntriesFromIterable(target, iterable, adder) {
		if (!this.IsCallable(adder)) {
			throw new $TypeError('Assertion failed: `adder` is not callable');
		}
		if (iterable == null) {
			throw new $TypeError('Assertion failed: `iterable` is present, and not nullish');
		}
		var iteratorRecord = this.GetIterator(iterable);
		while (true) { // eslint-disable-line no-constant-condition
			var next = this.IteratorStep(iteratorRecord);
			if (!next) {
				return target;
			}
			var nextItem = this.IteratorValue(next);
			if (this.Type(nextItem) !== 'Object') {
				var error = new $TypeError('iterator next must return an Object, got ' + inspect(nextItem));
				return this.IteratorClose(
					iteratorRecord,
					function () { throw error; } // eslint-disable-line no-loop-func
				);
			}
			try {
				var k = this.Get(nextItem, '0');
				var v = this.Get(nextItem, '1');
				this.Call(adder, target, [k, v]);
			} catch (e) {
				return this.IteratorClose(
					iteratorRecord,
					function () { throw e; } // eslint-disable-line no-loop-func
				);
			}
		}
	},

	// https://ecma-international.org/ecma-262/10.0/#sec-flattenintoarray
	// eslint-disable-next-line max-params, max-statements
	FlattenIntoArray: function FlattenIntoArray(target, source, sourceLen, start, depth) {
		var mapperFunction;
		if (arguments.length > 5) {
			mapperFunction = arguments[5];
		}

		var targetIndex = start;
		var sourceIndex = 0;
		while (sourceIndex < sourceLen) {
			var P = this.ToString(sourceIndex);
			var exists = this.HasProperty(source, P);
			if (exists === true) {
				var element = this.Get(source, P);
				if (typeof mapperFunction !== 'undefined') {
					if (arguments.length <= 6) {
						throw new $TypeError('Assertion failed: thisArg is required when mapperFunction is provided');
					}
					element = this.Call(mapperFunction, arguments[6], [element, sourceIndex, source]);
				}
				var shouldFlatten = false;
				if (depth > 0) {
					shouldFlatten = this.IsArray(element);
				}
				if (shouldFlatten) {
					var elementLen = this.ToLength(this.Get(element, 'length'));
					targetIndex = this.FlattenIntoArray(target, element, elementLen, targetIndex, depth - 1);
				} else {
					if (targetIndex >= MAX_SAFE_INTEGER) {
						throw new $TypeError('index too large');
					}
					this.CreateDataPropertyOrThrow(target, this.ToString(targetIndex), element);
					targetIndex += 1;
				}
			}
			sourceIndex += 1;
		}

		return targetIndex;
	},

	// https://ecma-international.org/ecma-262/10.0/#sec-trimstring
	TrimString: function TrimString(string, where) {
		var str = this.RequireObjectCoercible(string);
		var S = this.ToString(str);
		var T;
		if (where === 'start') {
			T = trimStart(S);
		} else if (where === 'end') {
			T = trimEnd(S);
		} else if (where === 'start+end') {
			T = trimStart(trimEnd(S));
		} else {
			throw new $TypeError('Assertion failed: invalid `where` value; must be "start", "end", or "start+end"');
		}
		return T;
	}
});

module.exports = ES2019;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(7);
var define = __webpack_require__(68);

var implementation = __webpack_require__(69);
var getPolyfill = __webpack_require__(70);
var shim = __webpack_require__(217);

var bound = bind.call(Function.call, getPolyfill());

define(bound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = bound;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(68);
var getPolyfill = __webpack_require__(70);

module.exports = function shimTrimLeft() {
	var polyfill = getPolyfill();
	define(
		String.prototype,
		{ trimLeft: polyfill },
		{ trimLeft: function () { return String.prototype.trimLeft !== polyfill; } }
	);
	return polyfill;
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(7);
var define = __webpack_require__(71);

var implementation = __webpack_require__(72);
var getPolyfill = __webpack_require__(73);
var shim = __webpack_require__(219);

var bound = bind.call(Function.call, getPolyfill());

define(bound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = bound;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(71);
var getPolyfill = __webpack_require__(73);

module.exports = function shimTrimRight() {
	var polyfill = getPolyfill();
	define(
		String.prototype,
		{ trimRight: polyfill },
		{ trimRight: function () { return String.prototype.trimRight !== polyfill; } }
	);
	return polyfill;
};


/***/ }),
/* 220 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(5);

var keys = __webpack_require__(74);
var inspect = __webpack_require__(37);

var ES2017 = __webpack_require__(224);
var assign = __webpack_require__(16);
var forEach = __webpack_require__(40);
var callBind = __webpack_require__(24);
var every = __webpack_require__(41);
var isPrefixOf = __webpack_require__(86);

var $String = GetIntrinsic('%String%');
var $TypeError = GetIntrinsic('%TypeError%');

var callBound = __webpack_require__(11);
var regexTester = __webpack_require__(83);
var $isNaN = __webpack_require__(39);

var $SymbolValueOf = callBound('Symbol.prototype.valueOf', true);
// var $charAt = callBound('String.prototype.charAt');
var $strSlice = callBound('String.prototype.slice');
var $indexOf = callBound('String.prototype.indexOf');
var $parseInt = parseInt;

var isDigit = regexTester(/^[0-9]$/);

var $PromiseResolve = callBound('Promise.resolve', true);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var $pushApply = callBind.apply(GetIntrinsic('%Array.prototype.push%'));
var $gOPS = $SymbolValueOf ? GetIntrinsic('%Object.getOwnPropertySymbols%') : null;

var padTimeComponent = function padTimeComponent(c, count) {
	return $strSlice('00' + c, -(count || 2));
};

var weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

var OwnPropertyKeys = function OwnPropertyKeys(ES, source) {
	var ownKeys = keys(source);
	if ($gOPS) {
		$pushApply(ownKeys, $gOPS(source));
	}
	return ownKeys;
};

var ES2018 = assign(assign({}, ES2017), {
	EnumerableOwnPropertyNames: ES2017.EnumerableOwnProperties,

	// https://ecma-international.org/ecma-262/9.0/#sec-thissymbolvalue
	thisSymbolValue: function thisSymbolValue(value) {
		if (!$SymbolValueOf) {
			throw new SyntaxError('Symbols are not supported; thisSymbolValue requires that `value` be a Symbol or a Symbol object');
		}
		if (this.Type(value) === 'Symbol') {
			return value;
		}
		return $SymbolValueOf(value);
	},

	// https://www.ecma-international.org/ecma-262/9.0/#sec-isstringprefix
	IsStringPrefix: function IsStringPrefix(p, q) {
		if (this.Type(p) !== 'String') {
			throw new TypeError('Assertion failed: "p" must be a String');
		}

		if (this.Type(q) !== 'String') {
			throw new TypeError('Assertion failed: "q" must be a String');
		}

		return isPrefixOf(p, q);
		/*
		if (p === q || p === '') {
			return true;
		}

		var pLength = p.length;
		var qLength = q.length;
		if (pLength >= qLength) {
			return false;
		}

		// assert: pLength < qLength

		for (var i = 0; i < pLength; i += 1) {
			if ($charAt(p, i) !== $charAt(q, i)) {
				return false;
			}
		}
		return true;
		*/
	},

	// https://www.ecma-international.org/ecma-262/9.0/#sec-tostring-applied-to-the-number-type
	NumberToString: function NumberToString(m) {
		if (this.Type(m) !== 'Number') {
			throw new TypeError('Assertion failed: "m" must be a String');
		}

		return $String(m);
	},

	// https://www.ecma-international.org/ecma-262/9.0/#sec-copydataproperties
	CopyDataProperties: function CopyDataProperties(target, source, excludedItems) {
		if (this.Type(target) !== 'Object') {
			throw new TypeError('Assertion failed: "target" must be an Object');
		}

		if (!this.IsArray(excludedItems)) {
			throw new TypeError('Assertion failed: "excludedItems" must be a List of Property Keys');
		}
		for (var i = 0; i < excludedItems.length; i += 1) {
			if (!this.IsPropertyKey(excludedItems[i])) {
				throw new TypeError('Assertion failed: "excludedItems" must be a List of Property Keys');
			}
		}

		if (typeof source === 'undefined' || source === null) {
			return target;
		}

		var ES = this;

		var fromObj = ES.ToObject(source);

		var sourceKeys = OwnPropertyKeys(ES, fromObj);
		forEach(sourceKeys, function (nextKey) {
			var excluded = false;

			forEach(excludedItems, function (e) {
				if (ES.SameValue(e, nextKey) === true) {
					excluded = true;
				}
			});

			var enumerable = $isEnumerable(fromObj, nextKey) || (
				// this is to handle string keys being non-enumerable in older engines
				typeof source === 'string'
				&& nextKey >= 0
				&& ES.IsInteger(ES.ToNumber(nextKey))
			);
			if (excluded === false && enumerable) {
				var propValue = ES.Get(fromObj, nextKey);
				ES.CreateDataProperty(target, nextKey, propValue);
			}
		});

		return target;
	},

	// https://ecma-international.org/ecma-262/9.0/#sec-promise-resolve
	PromiseResolve: function PromiseResolve(C, x) {
		if (!$PromiseResolve) {
			throw new SyntaxError('This environment does not support Promises.');
		}
		return $PromiseResolve(C, x);
	},

	// http://www.ecma-international.org/ecma-262/9.0/#sec-getsubstitution
	// eslint-disable-next-line max-statements, max-params, max-lines-per-function
	GetSubstitution: function GetSubstitution(matched, str, position, captures, namedCaptures, replacement) {
		if (this.Type(matched) !== 'String') {
			throw new $TypeError('Assertion failed: `matched` must be a String');
		}
		var matchLength = matched.length;

		if (this.Type(str) !== 'String') {
			throw new $TypeError('Assertion failed: `str` must be a String');
		}
		var stringLength = str.length;

		if (!this.IsInteger(position) || position < 0 || position > stringLength) {
			throw new $TypeError('Assertion failed: `position` must be a nonnegative integer, and less than or equal to the length of `string`, got ' + inspect(position));
		}

		var ES = this;
		var isStringOrHole = function (capture, index, arr) { return ES.Type(capture) === 'String' || !(index in arr); };
		if (!this.IsArray(captures) || !every(captures, isStringOrHole)) {
			throw new $TypeError('Assertion failed: `captures` must be a List of Strings, got ' + inspect(captures));
		}

		if (this.Type(replacement) !== 'String') {
			throw new $TypeError('Assertion failed: `replacement` must be a String');
		}

		var tailPos = position + matchLength;
		var m = captures.length;
		if (this.Type(namedCaptures) !== 'Undefined') {
			namedCaptures = this.ToObject(namedCaptures); // eslint-disable-line no-param-reassign
		}

		var result = '';
		for (var i = 0; i < replacement.length; i += 1) {
			// if this is a $, and it's not the end of the replacement
			var current = replacement[i];
			var isLast = (i + 1) >= replacement.length;
			var nextIsLast = (i + 2) >= replacement.length;
			if (current === '$' && !isLast) {
				var next = replacement[i + 1];
				if (next === '$') {
					result += '$';
					i += 1;
				} else if (next === '&') {
					result += matched;
					i += 1;
				} else if (next === '`') {
					result += position === 0 ? '' : $strSlice(str, 0, position - 1);
					i += 1;
				} else if (next === "'") {
					result += tailPos >= stringLength ? '' : $strSlice(str, tailPos);
					i += 1;
				} else {
					var nextNext = nextIsLast ? null : replacement[i + 2];
					if (isDigit(next) && next !== '0' && (nextIsLast || !isDigit(nextNext))) {
						// $1 through $9, and not followed by a digit
						var n = $parseInt(next, 10);
						// if (n > m, impl-defined)
						result += (n <= m && this.Type(captures[n - 1]) === 'Undefined') ? '' : captures[n - 1];
						i += 1;
					} else if (isDigit(next) && (nextIsLast || isDigit(nextNext))) {
						// $00 through $99
						var nn = next + nextNext;
						var nnI = $parseInt(nn, 10) - 1;
						// if nn === '00' or nn > m, impl-defined
						result += (nn <= m && this.Type(captures[nnI]) === 'Undefined') ? '' : captures[nnI];
						i += 2;
					} else if (next === '<') {
						// eslint-disable-next-line max-depth
						if (this.Type(namedCaptures) === 'Undefined') {
							result += '$<';
							i += 2;
						} else {
							var endIndex = $indexOf(replacement, '>', i);
							// eslint-disable-next-line max-depth
							if (endIndex > -1) {
								var groupName = $strSlice(replacement, i, endIndex);
								var capture = this.Get(namedCaptures, groupName);
								// eslint-disable-next-line max-depth
								if (this.Type(capture) !== 'Undefined') {
									result += this.ToString(capture);
								}
								i += '$<' + groupName + '>'.length;
							}
						}
					} else {
						result += '$';
					}
				}
			} else {
				// the final $, or else not a $
				result += replacement[i];
			}
		}
		return result;
	},

	// https://www.ecma-international.org/ecma-262/9.0/#sec-datestring
	DateString: function DateString(tv) {
		if (this.Type(tv) !== 'Number' || $isNaN(tv)) {
			throw new $TypeError('Assertion failed: `tv` must be a non-NaN Number');
		}
		var weekday = weekdays[this.WeekDay(tv)];
		var month = months[this.MonthFromTime(tv)];
		var day = padTimeComponent(this.DateFromTime(tv));
		var year = padTimeComponent(this.YearFromTime(tv), 4);
		return weekday + '\x20' + month + '\x20' + day + '\x20' + year;
	},

	// https://www.ecma-international.org/ecma-262/9.0/#sec-timestring
	TimeString: function TimeString(tv) {
		if (this.Type(tv) !== 'Number' || $isNaN(tv)) {
			throw new $TypeError('Assertion failed: `tv` must be a non-NaN Number');
		}
		var hour = this.HourFromTime(tv);
		var minute = this.MinFromTime(tv);
		var second = this.SecFromTime(tv);
		return padTimeComponent(hour) + ':' + padTimeComponent(minute) + ':' + padTimeComponent(second) + '\x20GMT';
	}
});

delete ES2018.EnumerableOwnProperties; // replaced with EnumerableOwnPropertyNames

delete ES2018.IsPropertyDescriptor; // not an actual abstract operation

module.exports = ES2018;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 17], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(75); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(5);

var ES2016 = __webpack_require__(225);
var assign = __webpack_require__(16);
var forEach = __webpack_require__(40);
var callBind = __webpack_require__(24);

var $TypeError = GetIntrinsic('%TypeError%');
var callBound = __webpack_require__(11);
var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var $pushApply = callBind.apply(GetIntrinsic('%Array.prototype.push%'));
var $arrayPush = callBound('Array.prototype.push');

var ES2017 = assign(assign({}, ES2016), {
	ToIndex: function ToIndex(value) {
		if (typeof value === 'undefined') {
			return 0;
		}
		var integerIndex = this.ToInteger(value);
		if (integerIndex < 0) {
			throw new RangeError('index must be >= 0');
		}
		var index = this.ToLength(integerIndex);
		if (!this.SameValueZero(integerIndex, index)) {
			throw new RangeError('index must be >= 0 and < 2 ** 53 - 1');
		}
		return index;
	},

	// https://www.ecma-international.org/ecma-262/8.0/#sec-enumerableownproperties
	EnumerableOwnProperties: function EnumerableOwnProperties(O, kind) {
		var keys = ES2016.EnumerableOwnNames(O);
		if (kind === 'key') {
			return keys;
		}
		if (kind === 'value' || kind === 'key+value') {
			var results = [];
			forEach(keys, function (key) {
				if ($isEnumerable(O, key)) {
					$pushApply(results, [
						kind === 'value' ? O[key] : [key, O[key]]
					]);
				}
			});
			return results;
		}
		throw new $TypeError('Assertion failed: "kind" is not "key", "value", or "key+value": ' + kind);
	},

	// https://www.ecma-international.org/ecma-262/8.0/#sec-iterabletolist
	IterableToList: function IterableToList(items, method) {
		var iterator = this.GetIterator(items, method);
		var values = [];
		var next = true;
		while (next) {
			next = this.IteratorStep(iterator);
			if (next) {
				var nextValue = this.IteratorValue(next);
				$arrayPush(values, nextValue);
			}
		}
		return values;
	}
});

delete ES2017.EnumerableOwnNames; // replaced with EnumerableOwnProperties
delete ES2017.IterableToArrayLike; // replaced with IterableToList

module.exports = ES2017;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES2015 = __webpack_require__(226);
var GetIntrinsic = __webpack_require__(5);
var assign = __webpack_require__(16);
var $setProto = __webpack_require__(85);

var callBound = __webpack_require__(11);
var getIteratorMethod = __webpack_require__(84);

var $TypeError = GetIntrinsic('%TypeError%');
var $arrayPush = callBound('Array.prototype.push');
var $getProto = __webpack_require__(238);

var ES2016 = assign(assign({}, ES2015), {
	// https://www.ecma-international.org/ecma-262/7.0/#sec-samevaluenonnumber
	SameValueNonNumber: function SameValueNonNumber(x, y) {
		if (typeof x === 'number' || typeof x !== typeof y) {
			throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
		}
		return this.SameValue(x, y);
	},

	// https://www.ecma-international.org/ecma-262/7.0/#sec-iterabletoarraylike
	IterableToArrayLike: function IterableToArrayLike(items) {
		var usingIterator = getIteratorMethod(this, items);
		if (typeof usingIterator !== 'undefined') {
			var iterator = this.GetIterator(items, usingIterator);
			var values = [];
			var next = true;
			while (next) {
				next = this.IteratorStep(iterator);
				if (next) {
					var nextValue = this.IteratorValue(next);
					$arrayPush(values, nextValue);
				}
			}
			return values;
		}

		return this.ToObject(items);
	},

	// https://ecma-international.org/ecma-262/7.0/#sec-ordinarygetprototypeof
	OrdinaryGetPrototypeOf: function (O) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: O must be an Object');
		}
		if (!$getProto) {
			throw new $TypeError('This environment does not support fetching prototypes.');
		}
		return $getProto(O);
	},

	// https://ecma-international.org/ecma-262/7.0/#sec-ordinarysetprototypeof
	OrdinarySetPrototypeOf: function (O, V) {
		if (this.Type(V) !== 'Object' && this.Type(V) !== 'Null') {
			throw new $TypeError('Assertion failed: V must be Object or Null');
		}
		/*
		var extensible = this.IsExtensible(O);
		var current = this.OrdinaryGetPrototypeOf(O);
		if (this.SameValue(V, current)) {
			return true;
		}
		if (!extensible) {
			return false;
		}
		*/
		try {
			$setProto(O, V);
		} catch (e) {
			return false;
		}
		return this.OrdinaryGetPrototypeOf(O) === V;
		/*
		var p = V;
		var done = false;
		while (!done) {
			if (p === null) {
				done = true;
			} else if (this.SameValue(p, O)) {
				return false;
			} else {
				if (wat) {
					done = true;
				} else {
					p = p.[[Prototype]];
				}
			}
		 }
		 O.[[Prototype]] = V;
		 return true;
		 */
	}
});

module.exports = ES2016;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(10);
var toPrimitive = __webpack_require__(227);
var keys = __webpack_require__(74);
var inspect = __webpack_require__(37);

var GetIntrinsic = __webpack_require__(5);

var $TypeError = GetIntrinsic('%TypeError%');
var $RangeError = GetIntrinsic('%RangeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');
var $Array = GetIntrinsic('%Array%');
var $ArrayPrototype = $Array.prototype;
var $String = GetIntrinsic('%String%');
var $Object = GetIntrinsic('%Object%');
var $Number = GetIntrinsic('%Number%');
var $Symbol = GetIntrinsic('%Symbol%', true);
var $RegExp = GetIntrinsic('%RegExp%');
var $Date = GetIntrinsic('%Date%');
var $Function = GetIntrinsic('%Function%');
var $preventExtensions = $Object.preventExtensions;

var hasSymbols = __webpack_require__(23)();

var assertRecord = __webpack_require__(77);
var $isNaN = __webpack_require__(39);
var $isFinite = __webpack_require__(78);
var MAX_ARRAY_LENGTH = Math.pow(2, 32) - 1;
var MAX_SAFE_INTEGER = __webpack_require__(79);

var assign = __webpack_require__(16);
var sign = __webpack_require__(80);
var mod = __webpack_require__(81);
var isPrimitive = __webpack_require__(231);
var forEach = __webpack_require__(40);
var every = __webpack_require__(41);
var isSamePropertyDescriptor = __webpack_require__(232);
var isPropertyDescriptor = __webpack_require__(82);
var parseInteger = parseInt;
var callBound = __webpack_require__(11);
var regexTester = __webpack_require__(83);
var getIteratorMethod = __webpack_require__(84);
var getSymbolDescription = __webpack_require__(233);

var $PromiseThen = callBound('Promise.prototype.then', true);
var arraySlice = callBound('Array.prototype.slice');
var strSlice = callBound('String.prototype.slice');
var $indexOf = callBound('Array.prototype.indexOf');
var $push = callBound('Array.prototype.push');

var isBinary = regexTester(/^0b[01]+$/i);
var isOctal = regexTester(/^0o[0-7]+$/i);
var isDigit = regexTester(/^[0-9]$/);
var regexExec = callBound('RegExp.prototype.exec');
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = regexTester(nonWSregex);
var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
var $charCodeAt = callBound('String.prototype.charCodeAt');
var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

var toStr = callBound('Object.prototype.toString');

var $NumberValueOf = callBound('Number.prototype.valueOf');
var $BooleanValueOf = callBound('Boolean.prototype.valueOf');
var $StringValueOf = callBound('String.prototype.valueOf');
var $DateValueOf = callBound('Date.prototype.valueOf');
var $SymbolToString = callBound('Symbol.prototype.toString', true);

var $floor = Math.floor;
var $abs = Math.abs;

var $ObjectCreate = $Object.create;
var $gOPD = $Object.getOwnPropertyDescriptor;
var $gOPN = $Object.getOwnPropertyNames;
var $gOPS = $Object.getOwnPropertySymbols;
var $isExtensible = $Object.isExtensible;
var $defineProperty = $Object.defineProperty;
var $setProto = __webpack_require__(85);

var DefineOwnProperty = function DefineOwnProperty(ES, O, P, desc) {
	if (!$defineProperty) {
		if (!ES.IsDataDescriptor(desc)) {
			// ES3 does not support getters/setters
			return false;
		}
		if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) {
			return false;
		}

		// fallback for ES3
		if (P in O && $isEnumerable(O, P) !== !!desc['[[Enumerable]]']) {
			// a non-enumerable existing property
			return false;
		}

		// property does not exist at all, or exists but is enumerable
		var V = desc['[[Value]]'];
		O[P] = V; // will use [[Define]]
		return ES.SameValue(O[P], V);
	}
	$defineProperty(O, P, ES.FromPropertyDescriptor(desc));
	return true;
};

// whitespace from: https://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var $replace = callBound('String.prototype.replace');
var trim = function (value) {
	return $replace(value, trimRegex, '');
};

var ES5 = __webpack_require__(235);

var hasRegExpMatcher = __webpack_require__(237);

// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
var ES6 = assign(assign({}, ES5), {

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
	Call: function Call(F, V) {
		var args = arguments.length > 2 ? arguments[2] : [];
		if (!this.IsCallable(F)) {
			throw new $TypeError(inspect(F) + ' is not a function');
		}
		return F.apply(V, args);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
	ToPrimitive: toPrimitive,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
	// ToBoolean: ES5.ToBoolean,

	// https://ecma-international.org/ecma-262/6.0/#sec-tonumber
	ToNumber: function ToNumber(argument) {
		var value = isPrimitive(argument) ? argument : toPrimitive(argument, $Number);
		if (typeof value === 'symbol') {
			throw new $TypeError('Cannot convert a Symbol value to a number');
		}
		if (typeof value === 'string') {
			if (isBinary(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 2));
			} else if (isOctal(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 8));
			} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
				return NaN;
			} else {
				var trimmed = trim(value);
				if (trimmed !== value) {
					return this.ToNumber(trimmed);
				}
			}
		}
		return $Number(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
	// ToInteger: ES5.ToNumber,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
	// ToInt32: ES5.ToInt32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
	// ToUint32: ES5.ToUint32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
	ToInt16: function ToInt16(argument) {
		var int16bit = this.ToUint16(argument);
		return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
	// ToUint16: ES5.ToUint16,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
	ToInt8: function ToInt8(argument) {
		var int8bit = this.ToUint8(argument);
		return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
	ToUint8: function ToUint8(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * $floor($abs(number));
		return mod(posInt, 0x100);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
	ToUint8Clamp: function ToUint8Clamp(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number <= 0) { return 0; }
		if (number >= 0xFF) { return 0xFF; }
		var f = $floor(argument);
		if (f + 0.5 < number) { return f + 1; }
		if (number < f + 0.5) { return f; }
		if (f % 2 !== 0) { return f + 1; }
		return f;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
	ToString: function ToString(argument) {
		if (typeof argument === 'symbol') {
			throw new $TypeError('Cannot convert a Symbol value to a string');
		}
		return $String(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
	ToObject: function ToObject(value) {
		this.RequireObjectCoercible(value);
		return $Object(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
	ToPropertyKey: function ToPropertyKey(argument) {
		var key = this.ToPrimitive(argument, $String);
		return typeof key === 'symbol' ? key : this.ToString(key);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	ToLength: function ToLength(argument) {
		var len = this.ToInteger(argument);
		if (len <= 0) { return 0; } // includes converting -0 to +0
		if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
		return len;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
	CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
		if (toStr(argument) !== '[object String]') {
			throw new $TypeError('must be a string');
		}
		if (argument === '-0') { return -0; }
		var n = this.ToNumber(argument);
		if (this.SameValue(this.ToString(n), argument)) { return n; }
		return void 0;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
	RequireObjectCoercible: ES5.CheckObjectCoercible,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
	IsArray: $Array.isArray || function IsArray(argument) {
		return toStr(argument) === '[object Array]';
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
	// IsCallable: ES5.IsCallable,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
	IsConstructor: function IsConstructor(argument) {
		return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument` or Proxy
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
	IsExtensible: $preventExtensions
		? function IsExtensible(obj) {
			if (isPrimitive(obj)) {
				return false;
			}
			return $isExtensible(obj);
		}
		: function isExtensible(obj) { return true; }, // eslint-disable-line no-unused-vars

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
	IsInteger: function IsInteger(argument) {
		if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
			return false;
		}
		var abs = $abs(argument);
		return $floor(abs) === abs;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
	IsPropertyKey: function IsPropertyKey(argument) {
		return typeof argument === 'string' || typeof argument === 'symbol';
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-isregexp
	IsRegExp: function IsRegExp(argument) {
		if (!argument || typeof argument !== 'object') {
			return false;
		}
		if (hasSymbols) {
			var isRegExp = argument[$Symbol.match];
			if (typeof isRegExp !== 'undefined') {
				return ES5.ToBoolean(isRegExp);
			}
		}
		return hasRegExpMatcher(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
	// SameValue: ES5.SameValue,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
	SameValueZero: function SameValueZero(x, y) {
		return (x === y) || ($isNaN(x) && $isNaN(y));
	},

	/**
	 * 7.3.2 GetV (V, P)
	 * 1. Assert: IsPropertyKey(P) is true.
	 * 2. Let O be ToObject(V).
	 * 3. ReturnIfAbrupt(O).
	 * 4. Return O.[[Get]](P, V).
	 */
	GetV: function GetV(V, P) {
		// 7.3.2.1
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.2.2-3
		var O = this.ToObject(V);

		// 7.3.2.4
		return O[P];
	},

	/**
	 * 7.3.9 - https://ecma-international.org/ecma-262/6.0/#sec-getmethod
	 * 1. Assert: IsPropertyKey(P) is true.
	 * 2. Let func be GetV(O, P).
	 * 3. ReturnIfAbrupt(func).
	 * 4. If func is either undefined or null, return undefined.
	 * 5. If IsCallable(func) is false, throw a TypeError exception.
	 * 6. Return func.
	 */
	GetMethod: function GetMethod(O, P) {
		// 7.3.9.1
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.9.2
		var func = this.GetV(O, P);

		// 7.3.9.4
		if (func == null) {
			return void 0;
		}

		// 7.3.9.5
		if (!this.IsCallable(func)) {
			throw new $TypeError(P + 'is not a function');
		}

		// 7.3.9.6
		return func;
	},

	/**
	 * 7.3.1 Get (O, P) - https://ecma-international.org/ecma-262/6.0/#sec-get-o-p
	 * 1. Assert: Type(O) is Object.
	 * 2. Assert: IsPropertyKey(P) is true.
	 * 3. Return O.[[Get]](P, O).
	 */
	Get: function Get(O, P) {
		// 7.3.1.1
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		// 7.3.1.2
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true, got ' + inspect(P));
		}
		// 7.3.1.3
		return O[P];
	},

	Type: function Type(x) {
		if (typeof x === 'symbol') {
			return 'Symbol';
		}
		return ES5.Type(x);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
	SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		var C = O.constructor;
		if (typeof C === 'undefined') {
			return defaultConstructor;
		}
		if (this.Type(C) !== 'Object') {
			throw new $TypeError('O.constructor is not an Object');
		}
		var S = hasSymbols && $Symbol.species ? C[$Symbol.species] : void 0;
		if (S == null) {
			return defaultConstructor;
		}
		if (this.IsConstructor(S)) {
			return S;
		}
		throw new $TypeError('no constructor found');
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-frompropertydescriptor
	FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		var obj = {};
		if ('[[Value]]' in Desc) {
			obj.value = Desc['[[Value]]'];
		}
		if ('[[Writable]]' in Desc) {
			obj.writable = Desc['[[Writable]]'];
		}
		if ('[[Get]]' in Desc) {
			obj.get = Desc['[[Get]]'];
		}
		if ('[[Set]]' in Desc) {
			obj.set = Desc['[[Set]]'];
		}
		if ('[[Enumerable]]' in Desc) {
			obj.enumerable = Desc['[[Enumerable]]'];
		}
		if ('[[Configurable]]' in Desc) {
			obj.configurable = Desc['[[Configurable]]'];
		}
		return obj;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-completepropertydescriptor
	CompletePropertyDescriptor: function CompletePropertyDescriptor(Desc) {
		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (this.IsGenericDescriptor(Desc) || this.IsDataDescriptor(Desc)) {
			if (!has(Desc, '[[Value]]')) {
				Desc['[[Value]]'] = void 0;
			}
			if (!has(Desc, '[[Writable]]')) {
				Desc['[[Writable]]'] = false;
			}
		} else {
			if (!has(Desc, '[[Get]]')) {
				Desc['[[Get]]'] = void 0;
			}
			if (!has(Desc, '[[Set]]')) {
				Desc['[[Set]]'] = void 0;
			}
		}
		if (!has(Desc, '[[Enumerable]]')) {
			Desc['[[Enumerable]]'] = false;
		}
		if (!has(Desc, '[[Configurable]]')) {
			Desc['[[Configurable]]'] = false;
		}
		return Desc;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-set-o-p-v-throw
	Set: function Set(O, P, V, Throw) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('P must be a Property Key');
		}
		if (this.Type(Throw) !== 'Boolean') {
			throw new $TypeError('Throw must be a Boolean');
		}
		if (Throw) {
			O[P] = V;
			return true;
		} else {
			try {
				O[P] = V;
			} catch (e) {
				return false;
			}
		}
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-hasownproperty
	HasOwnProperty: function HasOwnProperty(O, P) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('P must be a Property Key');
		}
		return has(O, P);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty
	HasProperty: function HasProperty(O, P) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('P must be a Property Key');
		}
		return P in O;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-isconcatspreadable
	IsConcatSpreadable: function IsConcatSpreadable(O) {
		if (this.Type(O) !== 'Object') {
			return false;
		}
		if (hasSymbols && typeof $Symbol.isConcatSpreadable === 'symbol') {
			var spreadable = this.Get(O, Symbol.isConcatSpreadable);
			if (typeof spreadable !== 'undefined') {
				return this.ToBoolean(spreadable);
			}
		}
		return this.IsArray(O);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-invoke
	Invoke: function Invoke(O, P) {
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('P must be a Property Key');
		}
		var argumentsList = arraySlice(arguments, 2);
		var func = this.GetV(O, P);
		return this.Call(func, O, argumentsList);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-getiterator
	GetIterator: function GetIterator(obj, method) {
		var actualMethod = method;
		if (arguments.length < 2) {
			actualMethod = getIteratorMethod(this, obj);
		}
		var iterator = this.Call(actualMethod, obj);
		if (this.Type(iterator) !== 'Object') {
			throw new $TypeError('iterator must return an object');
		}

		return iterator;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-iteratornext
	IteratorNext: function IteratorNext(iterator, value) {
		var result = this.Invoke(iterator, 'next', arguments.length < 2 ? [] : [value]);
		if (this.Type(result) !== 'Object') {
			throw new $TypeError('iterator next must return an object');
		}
		return result;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-iteratorcomplete
	IteratorComplete: function IteratorComplete(iterResult) {
		if (this.Type(iterResult) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
		}
		return this.ToBoolean(this.Get(iterResult, 'done'));
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-iteratorvalue
	IteratorValue: function IteratorValue(iterResult) {
		if (this.Type(iterResult) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
		}
		return this.Get(iterResult, 'value');
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-iteratorstep
	IteratorStep: function IteratorStep(iterator) {
		var result = this.IteratorNext(iterator);
		var done = this.IteratorComplete(result);
		return done === true ? false : result;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-iteratorclose
	IteratorClose: function IteratorClose(iterator, completion) {
		if (this.Type(iterator) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(iterator) is not Object');
		}
		if (!this.IsCallable(completion)) {
			throw new $TypeError('Assertion failed: completion is not a thunk for a Completion Record');
		}
		var completionThunk = completion;

		var iteratorReturn = this.GetMethod(iterator, 'return');

		if (typeof iteratorReturn === 'undefined') {
			return completionThunk();
		}

		var completionRecord;
		try {
			var innerResult = this.Call(iteratorReturn, iterator, []);
		} catch (e) {
			// if we hit here, then "e" is the innerResult completion that needs re-throwing

			// if the completion is of type "throw", this will throw.
			completionRecord = completionThunk();
			completionThunk = null; // ensure it's not called twice.

			// if not, then return the innerResult completion
			throw e;
		}
		completionRecord = completionThunk(); // if innerResult worked, then throw if the completion does
		completionThunk = null; // ensure it's not called twice.

		if (this.Type(innerResult) !== 'Object') {
			throw new $TypeError('iterator .return must return an object');
		}

		return completionRecord;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-createiterresultobject
	CreateIterResultObject: function CreateIterResultObject(value, done) {
		if (this.Type(done) !== 'Boolean') {
			throw new $TypeError('Assertion failed: Type(done) is not Boolean');
		}
		return {
			value: value,
			done: done
		};
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-regexpexec
	RegExpExec: function RegExpExec(R, S) {
		if (this.Type(R) !== 'Object') {
			throw new $TypeError('R must be an Object');
		}
		if (this.Type(S) !== 'String') {
			throw new $TypeError('S must be a String');
		}
		var exec = this.Get(R, 'exec');
		if (this.IsCallable(exec)) {
			var result = this.Call(exec, R, [S]);
			if (result === null || this.Type(result) === 'Object') {
				return result;
			}
			throw new $TypeError('"exec" method must return `null` or an Object');
		}
		return regexExec(R, S);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate
	ArraySpeciesCreate: function ArraySpeciesCreate(originalArray, length) {
		if (!this.IsInteger(length) || length < 0) {
			throw new $TypeError('Assertion failed: length must be an integer >= 0');
		}
		var len = length === 0 ? 0 : length;
		var C;
		var isArray = this.IsArray(originalArray);
		if (isArray) {
			C = this.Get(originalArray, 'constructor');
			// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
			// if (this.IsConstructor(C)) {
			// 	if C is another realm's Array, C = undefined
			// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
			// }
			if (this.Type(C) === 'Object' && hasSymbols && $Symbol.species) {
				C = this.Get(C, $Symbol.species);
				if (C === null) {
					C = void 0;
				}
			}
		}
		if (typeof C === 'undefined') {
			return $Array(len);
		}
		if (!this.IsConstructor(C)) {
			throw new $TypeError('C must be a constructor');
		}
		return new C(len); // this.Construct(C, len);
	},

	CreateDataProperty: function CreateDataProperty(O, P, V) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		var oldDesc = $gOPD(O, P);
		var extensible = oldDesc || this.IsExtensible(O);
		var immutable = oldDesc && (!oldDesc.writable || !oldDesc.configurable);
		if (immutable || !extensible) {
			return false;
		}
		return DefineOwnProperty(this, O, P, {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Value]]': V,
			'[[Writable]]': true
		});
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow
	CreateDataPropertyOrThrow: function CreateDataPropertyOrThrow(O, P, V) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		var success = this.CreateDataProperty(O, P, V);
		if (!success) {
			throw new $TypeError('unable to create data property');
		}
		return success;
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-objectcreate
	ObjectCreate: function ObjectCreate(proto, internalSlotsList) {
		if (proto !== null && this.Type(proto) !== 'Object') {
			throw new $TypeError('Assertion failed: proto must be null or an object');
		}
		var slots = arguments.length < 2 ? [] : internalSlotsList;
		if (slots.length > 0) {
			throw new $SyntaxError('es-abstract does not yet support internal slots');
		}

		if (proto === null && !$ObjectCreate) {
			throw new $SyntaxError('native Object.create support is required to create null objects');
		}

		return $ObjectCreate(proto);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-advancestringindex
	AdvanceStringIndex: function AdvanceStringIndex(S, index, unicode) {
		if (this.Type(S) !== 'String') {
			throw new $TypeError('S must be a String');
		}
		if (!this.IsInteger(index) || index < 0 || index > MAX_SAFE_INTEGER) {
			throw new $TypeError('Assertion failed: length must be an integer >= 0 and <= 2**53');
		}
		if (this.Type(unicode) !== 'Boolean') {
			throw new $TypeError('Assertion failed: unicode must be a Boolean');
		}
		if (!unicode) {
			return index + 1;
		}
		var length = S.length;
		if ((index + 1) >= length) {
			return index + 1;
		}

		var first = $charCodeAt(S, index);
		if (first < 0xD800 || first > 0xDBFF) {
			return index + 1;
		}

		var second = $charCodeAt(S, index + 1);
		if (second < 0xDC00 || second > 0xDFFF) {
			return index + 1;
		}

		return index + 2;
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-createmethodproperty
	CreateMethodProperty: function CreateMethodProperty(O, P, V) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}

		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		var newDesc = {
			'[[Configurable]]': true,
			'[[Enumerable]]': false,
			'[[Value]]': V,
			'[[Writable]]': true
		};
		return DefineOwnProperty(this, O, P, newDesc);
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow
	DefinePropertyOrThrow: function DefinePropertyOrThrow(O, P, desc) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}

		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		var Desc = isPropertyDescriptor(this, desc) ? desc : this.ToPropertyDescriptor(desc);
		if (!isPropertyDescriptor(this, Desc)) {
			throw new $TypeError('Assertion failed: Desc is not a valid Property Descriptor');
		}

		return DefineOwnProperty(this, O, P, Desc);
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-deletepropertyorthrow
	DeletePropertyOrThrow: function DeletePropertyOrThrow(O, P) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}

		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		var success = delete O[P];
		if (!success) {
			throw new TypeError('Attempt to delete property failed.');
		}
		return success;
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-enumerableownnames
	EnumerableOwnNames: function EnumerableOwnNames(O) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}

		return keys(O);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-number-prototype-object
	thisNumberValue: function thisNumberValue(value) {
		if (this.Type(value) === 'Number') {
			return value;
		}

		return $NumberValueOf(value);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-boolean-prototype-object
	thisBooleanValue: function thisBooleanValue(value) {
		if (this.Type(value) === 'Boolean') {
			return value;
		}

		return $BooleanValueOf(value);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-string-prototype-object
	thisStringValue: function thisStringValue(value) {
		if (this.Type(value) === 'String') {
			return value;
		}

		return $StringValueOf(value);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-date-prototype-object
	thisTimeValue: function thisTimeValue(value) {
		return $DateValueOf(value);
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-setintegritylevel
	SetIntegrityLevel: function SetIntegrityLevel(O, level) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		if (level !== 'sealed' && level !== 'frozen') {
			throw new $TypeError('Assertion failed: `level` must be `"sealed"` or `"frozen"`');
		}
		if (!$preventExtensions) {
			throw new $SyntaxError('SetIntegrityLevel requires native `Object.preventExtensions` support');
		}
		var status = $preventExtensions(O);
		if (!status) {
			return false;
		}
		if (!$gOPN) {
			throw new $SyntaxError('SetIntegrityLevel requires native `Object.getOwnPropertyNames` support');
		}
		var theKeys = $gOPN(O);
		var ES = this;
		if (level === 'sealed') {
			forEach(theKeys, function (k) {
				ES.DefinePropertyOrThrow(O, k, { configurable: false });
			});
		} else if (level === 'frozen') {
			forEach(theKeys, function (k) {
				var currentDesc = $gOPD(O, k);
				if (typeof currentDesc !== 'undefined') {
					var desc;
					if (ES.IsAccessorDescriptor(ES.ToPropertyDescriptor(currentDesc))) {
						desc = { configurable: false };
					} else {
						desc = { configurable: false, writable: false };
					}
					ES.DefinePropertyOrThrow(O, k, desc);
				}
			});
		}
		return true;
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-testintegritylevel
	TestIntegrityLevel: function TestIntegrityLevel(O, level) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		if (level !== 'sealed' && level !== 'frozen') {
			throw new $TypeError('Assertion failed: `level` must be `"sealed"` or `"frozen"`');
		}
		var status = this.IsExtensible(O);
		if (status) {
			return false;
		}
		var theKeys = $gOPN(O);
		var ES = this;
		return theKeys.length === 0 || every(theKeys, function (k) {
			var currentDesc = $gOPD(O, k);
			if (typeof currentDesc !== 'undefined') {
				if (currentDesc.configurable) {
					return false;
				}
				if (level === 'frozen' && ES.IsDataDescriptor(ES.ToPropertyDescriptor(currentDesc)) && currentDesc.writable) {
					return false;
				}
			}
			return true;
		});
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-ordinaryhasinstance
	OrdinaryHasInstance: function OrdinaryHasInstance(C, O) {
		if (this.IsCallable(C) === false) {
			return false;
		}
		if (this.Type(O) !== 'Object') {
			return false;
		}
		var P = this.Get(C, 'prototype');
		if (this.Type(P) !== 'Object') {
			throw new $TypeError('OrdinaryHasInstance called on an object with an invalid prototype property.');
		}
		return O instanceof C;
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-ordinaryhasproperty
	OrdinaryHasProperty: function OrdinaryHasProperty(O, P) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: P must be a Property Key');
		}
		return P in O;
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-instanceofoperator
	InstanceofOperator: function InstanceofOperator(O, C) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		var instOfHandler = hasSymbols && $Symbol.hasInstance ? this.GetMethod(C, $Symbol.hasInstance) : void 0;
		if (typeof instOfHandler !== 'undefined') {
			return this.ToBoolean(this.Call(instOfHandler, C, [O]));
		}
		if (!this.IsCallable(C)) {
			throw new $TypeError('`C` is not Callable');
		}
		return this.OrdinaryHasInstance(C, O);
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-ispromise
	IsPromise: function IsPromise(x) {
		if (this.Type(x) !== 'Object') {
			return false;
		}
		if (!$PromiseThen) { // Promises are not supported
			return false;
		}
		try {
			$PromiseThen(x); // throws if not a promise
		} catch (e) {
			return false;
		}
		return true;
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-abstract-equality-comparison
	'Abstract Equality Comparison': function AbstractEqualityComparison(x, y) {
		var xType = this.Type(x);
		var yType = this.Type(y);
		if (xType === yType) {
			return x === y; // ES6+ specified this shortcut anyways.
		}
		if (x == null && y == null) {
			return true;
		}
		if (xType === 'Number' && yType === 'String') {
			return this['Abstract Equality Comparison'](x, this.ToNumber(y));
		}
		if (xType === 'String' && yType === 'Number') {
			return this['Abstract Equality Comparison'](this.ToNumber(x), y);
		}
		if (xType === 'Boolean') {
			return this['Abstract Equality Comparison'](this.ToNumber(x), y);
		}
		if (yType === 'Boolean') {
			return this['Abstract Equality Comparison'](x, this.ToNumber(y));
		}
		if ((xType === 'String' || xType === 'Number' || xType === 'Symbol') && yType === 'Object') {
			return this['Abstract Equality Comparison'](x, this.ToPrimitive(y));
		}
		if (xType === 'Object' && (yType === 'String' || yType === 'Number' || yType === 'Symbol')) {
			return this['Abstract Equality Comparison'](this.ToPrimitive(x), y);
		}
		return false;
	},

	// eslint-disable-next-line max-lines-per-function, max-statements, id-length, max-params
	ValidateAndApplyPropertyDescriptor: function ValidateAndApplyPropertyDescriptor(O, P, extensible, Desc, current) {
		// this uses the ES2017+ logic, since it fixes a number of bugs in the ES2015 logic.
		var oType = this.Type(O);
		if (oType !== 'Undefined' && oType !== 'Object') {
			throw new $TypeError('Assertion failed: O must be undefined or an Object');
		}
		if (this.Type(extensible) !== 'Boolean') {
			throw new $TypeError('Assertion failed: extensible must be a Boolean');
		}
		if (!isPropertyDescriptor(this, Desc)) {
			throw new $TypeError('Assertion failed: Desc must be a Property Descriptor');
		}
		if (this.Type(current) !== 'Undefined' && !isPropertyDescriptor(this, current)) {
			throw new $TypeError('Assertion failed: current must be a Property Descriptor, or undefined');
		}
		if (oType !== 'Undefined' && !this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: if O is not undefined, P must be a Property Key');
		}
		if (this.Type(current) === 'Undefined') {
			if (!extensible) {
				return false;
			}
			if (this.IsGenericDescriptor(Desc) || this.IsDataDescriptor(Desc)) {
				if (oType !== 'Undefined') {
					DefineOwnProperty(this, O, P, {
						'[[Configurable]]': Desc['[[Configurable]]'],
						'[[Enumerable]]': Desc['[[Enumerable]]'],
						'[[Value]]': Desc['[[Value]]'],
						'[[Writable]]': Desc['[[Writable]]']
					});
				}
			} else {
				if (!this.IsAccessorDescriptor(Desc)) {
					throw new $TypeError('Assertion failed: Desc is not an accessor descriptor');
				}
				if (oType !== 'Undefined') {
					return DefineOwnProperty(this, O, P, Desc);
				}
			}
			return true;
		}
		if (this.IsGenericDescriptor(Desc) && !('[[Configurable]]' in Desc) && !('[[Enumerable]]' in Desc)) {
			return true;
		}
		if (isSamePropertyDescriptor(this, Desc, current)) {
			return true; // removed by ES2017, but should still be correct
		}
		// "if every field in Desc is absent, return true" can't really match the assertion that it's a Property Descriptor
		if (!current['[[Configurable]]']) {
			if (Desc['[[Configurable]]']) {
				return false;
			}
			if ('[[Enumerable]]' in Desc && !Desc['[[Enumerable]]'] === !!current['[[Enumerable]]']) {
				return false;
			}
		}
		if (this.IsGenericDescriptor(Desc)) {
			// no further validation is required.
		} else if (this.IsDataDescriptor(current) !== this.IsDataDescriptor(Desc)) {
			if (!current['[[Configurable]]']) {
				return false;
			}
			if (this.IsDataDescriptor(current)) {
				if (oType !== 'Undefined') {
					DefineOwnProperty(this, O, P, {
						'[[Configurable]]': current['[[Configurable]]'],
						'[[Enumerable]]': current['[[Enumerable]]'],
						'[[Get]]': undefined
					});
				}
			} else if (oType !== 'Undefined') {
				DefineOwnProperty(this, O, P, {
					'[[Configurable]]': current['[[Configurable]]'],
					'[[Enumerable]]': current['[[Enumerable]]'],
					'[[Value]]': undefined
				});
			}
		} else if (this.IsDataDescriptor(current) && this.IsDataDescriptor(Desc)) {
			if (!current['[[Configurable]]'] && !current['[[Writable]]']) {
				if ('[[Writable]]' in Desc && Desc['[[Writable]]']) {
					return false;
				}
				if ('[[Value]]' in Desc && !this.SameValue(Desc['[[Value]]'], current['[[Value]]'])) {
					return false;
				}
				return true;
			}
		} else if (this.IsAccessorDescriptor(current) && this.IsAccessorDescriptor(Desc)) {
			if (!current['[[Configurable]]']) {
				if ('[[Set]]' in Desc && !this.SameValue(Desc['[[Set]]'], current['[[Set]]'])) {
					return false;
				}
				if ('[[Get]]' in Desc && !this.SameValue(Desc['[[Get]]'], current['[[Get]]'])) {
					return false;
				}
				return true;
			}
		} else {
			throw new $TypeError('Assertion failed: current and Desc are not both data, both accessors, or one accessor and one data.');
		}
		if (oType !== 'Undefined') {
			return DefineOwnProperty(this, O, P, Desc);
		}
		return true;
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-ordinarydefineownproperty
	OrdinaryDefineOwnProperty: function OrdinaryDefineOwnProperty(O, P, Desc) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: P must be a Property Key');
		}
		if (!isPropertyDescriptor(this, Desc)) {
			throw new $TypeError('Assertion failed: Desc must be a Property Descriptor');
		}
		var desc = $gOPD(O, P);
		var current = desc && this.ToPropertyDescriptor(desc);
		var extensible = this.IsExtensible(O);
		return this.ValidateAndApplyPropertyDescriptor(O, P, extensible, Desc, current);
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-ordinarygetownproperty
	OrdinaryGetOwnProperty: function OrdinaryGetOwnProperty(O, P) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: P must be a Property Key');
		}
		if (!has(O, P)) {
			return void 0;
		}
		if (!$gOPD) {
			// ES3 fallback
			var arrayLength = this.IsArray(O) && P === 'length';
			var regexLastIndex = this.IsRegExp(O) && P === 'lastIndex';
			return {
				'[[Configurable]]': !(arrayLength || regexLastIndex),
				'[[Enumerable]]': $isEnumerable(O, P),
				'[[Value]]': O[P],
				'[[Writable]]': true
			};
		}
		return this.ToPropertyDescriptor($gOPD(O, P));
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-arraycreate
	ArrayCreate: function ArrayCreate(length) {
		if (!this.IsInteger(length) || length < 0) {
			throw new $TypeError('Assertion failed: `length` must be an integer Number >= 0');
		}
		if (length > MAX_ARRAY_LENGTH) {
			throw new $RangeError('length is greater than (2**32 - 1)');
		}
		var proto = arguments.length > 1 ? arguments[1] : $ArrayPrototype;
		var A = []; // steps 5 - 7, and 9
		if (proto !== $ArrayPrototype) { // step 8
			if (!$setProto) {
				throw new $SyntaxError('ArrayCreate: a `proto` argument that is not `Array.prototype` is not supported in an environment that does not support setting the [[Prototype]]');
			}
			$setProto(A, proto);
		}
		if (length !== 0) { // bypasses the need for step 2
			A.length = length;
		}
		/* step 10, the above as a shortcut for the below
		this.OrdinaryDefineOwnProperty(A, 'length', {
			'[[Configurable]]': false,
			'[[Enumerable]]': false,
			'[[Value]]': length,
			'[[Writable]]': true
		});
		*/
		return A;
	},

	// eslint-disable-next-line max-statements, max-lines-per-function
	ArraySetLength: function ArraySetLength(A, Desc) {
		if (!this.IsArray(A)) {
			throw new $TypeError('Assertion failed: A must be an Array');
		}
		if (!isPropertyDescriptor(this, Desc)) {
			throw new $TypeError('Assertion failed: Desc must be a Property Descriptor');
		}
		if (!('[[Value]]' in Desc)) {
			return this.OrdinaryDefineOwnProperty(A, 'length', Desc);
		}
		var newLenDesc = assign({}, Desc);
		var newLen = this.ToUint32(Desc['[[Value]]']);
		var numberLen = this.ToNumber(Desc['[[Value]]']);
		if (newLen !== numberLen) {
			throw new $RangeError('Invalid array length');
		}
		newLenDesc['[[Value]]'] = newLen;
		var oldLenDesc = this.OrdinaryGetOwnProperty(A, 'length');
		if (!this.IsDataDescriptor(oldLenDesc)) {
			throw new $TypeError('Assertion failed: an array had a non-data descriptor on `length`');
		}
		var oldLen = oldLenDesc['[[Value]]'];
		if (newLen >= oldLen) {
			return this.OrdinaryDefineOwnProperty(A, 'length', newLenDesc);
		}
		if (!oldLenDesc['[[Writable]]']) {
			return false;
		}
		var newWritable;
		if (!('[[Writable]]' in newLenDesc) || newLenDesc['[[Writable]]']) {
			newWritable = true;
		} else {
			newWritable = false;
			newLenDesc['[[Writable]]'] = true;
		}
		var succeeded = this.OrdinaryDefineOwnProperty(A, 'length', newLenDesc);
		if (!succeeded) {
			return false;
		}
		while (newLen < oldLen) {
			oldLen -= 1;
			var deleteSucceeded = delete A[this.ToString(oldLen)];
			if (!deleteSucceeded) {
				newLenDesc['[[Value]]'] = oldLen + 1;
				if (!newWritable) {
					newLenDesc['[[Writable]]'] = false;
					this.OrdinaryDefineOwnProperty(A, 'length', newLenDesc);
					return false;
				}
			}
		}
		if (!newWritable) {
			return this.OrdinaryDefineOwnProperty(A, 'length', { '[[Writable]]': false });
		}
		return true;
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-createhtml
	CreateHTML: function CreateHTML(string, tag, attribute, value) {
		if (this.Type(tag) !== 'String' || this.Type(attribute) !== 'String') {
			throw new $TypeError('Assertion failed: `tag` and `attribute` must be strings');
		}
		var str = this.RequireObjectCoercible(string);
		var S = this.ToString(str);
		var p1 = '<' + tag;
		if (attribute !== '') {
			var V = this.ToString(value);
			var escapedV = $replace(V, /\x22/g, '&quot;');
			p1 += '\x20' + attribute + '\x3D\x22' + escapedV + '\x22';
		}
		return p1 + '>' + S + '</' + tag + '>';
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-getownpropertykeys
	GetOwnPropertyKeys: function GetOwnPropertyKeys(O, Type) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		if (Type === 'Symbol') {
			return hasSymbols && $gOPS ? $gOPS(O) : [];
		}
		if (Type === 'String') {
			if (!$gOPN) {
				return keys(O);
			}
			return $gOPN(O);
		}
		throw new $TypeError('Assertion failed: `Type` must be `"String"` or `"Symbol"`');
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-symboldescriptivestring
	SymbolDescriptiveString: function SymbolDescriptiveString(sym) {
		if (this.Type(sym) !== 'Symbol') {
			throw new $TypeError('Assertion failed: `sym` must be a Symbol');
		}
		return $SymbolToString(sym);
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-getsubstitution
	// eslint-disable-next-line max-statements, max-params, max-lines-per-function
	GetSubstitution: function GetSubstitution(matched, str, position, captures, replacement) {
		if (this.Type(matched) !== 'String') {
			throw new $TypeError('Assertion failed: `matched` must be a String');
		}
		var matchLength = matched.length;

		if (this.Type(str) !== 'String') {
			throw new $TypeError('Assertion failed: `str` must be a String');
		}
		var stringLength = str.length;

		if (!this.IsInteger(position) || position < 0 || position > stringLength) {
			throw new $TypeError('Assertion failed: `position` must be a nonnegative integer, and less than or equal to the length of `string`, got ' + inspect(position));
		}

		var ES = this;
		var isStringOrHole = function (capture, index, arr) { return ES.Type(capture) === 'String' || !(index in arr); };
		if (!this.IsArray(captures) || !every(captures, isStringOrHole)) {
			throw new $TypeError('Assertion failed: `captures` must be a List of Strings, got ' + inspect(captures));
		}

		if (this.Type(replacement) !== 'String') {
			throw new $TypeError('Assertion failed: `replacement` must be a String');
		}

		var tailPos = position + matchLength;
		var m = captures.length;

		var result = '';
		for (var i = 0; i < replacement.length; i += 1) {
			// if this is a $, and it's not the end of the replacement
			var current = replacement[i];
			var isLast = (i + 1) >= replacement.length;
			var nextIsLast = (i + 2) >= replacement.length;
			if (current === '$' && !isLast) {
				var next = replacement[i + 1];
				if (next === '$') {
					result += '$';
					i += 1;
				} else if (next === '&') {
					result += matched;
					i += 1;
				} else if (next === '`') {
					result += position === 0 ? '' : strSlice(str, 0, position - 1);
					i += 1;
				} else if (next === "'") {
					result += tailPos >= stringLength ? '' : strSlice(str, tailPos);
					i += 1;
				} else {
					var nextNext = nextIsLast ? null : replacement[i + 2];
					if (isDigit(next) && next !== '0' && (nextIsLast || !isDigit(nextNext))) {
						// $1 through $9, and not followed by a digit
						var n = parseInteger(next, 10);
						// if (n > m, impl-defined)
						result += (n <= m && this.Type(captures[n - 1]) === 'Undefined') ? '' : captures[n - 1];
						i += 1;
					} else if (isDigit(next) && (nextIsLast || isDigit(nextNext))) {
						// $00 through $99
						var nn = next + nextNext;
						var nnI = parseInteger(nn, 10) - 1;
						// if nn === '00' or nn > m, impl-defined
						result += (nn <= m && this.Type(captures[nnI]) === 'Undefined') ? '' : captures[nnI];
						i += 2;
					} else {
						result += '$';
					}
				}
			} else {
				// the final $, or else not a $
				result += replacement[i];
			}
		}
		return result;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-todatestring
	ToDateString: function ToDateString(tv) {
		if (this.Type(tv) !== 'Number') {
			throw new $TypeError('Assertion failed: `tv` must be a Number');
		}
		if ($isNaN(tv)) {
			return 'Invalid Date';
		}
		return $Date(tv);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-createlistfromarraylike
	CreateListFromArrayLike: function CreateListFromArrayLike(obj) {
		var elementTypes = arguments.length > 1
			? arguments[1]
			: ['Undefined', 'Null', 'Boolean', 'String', 'Symbol', 'Number', 'Object'];

		if (this.Type(obj) !== 'Object') {
			throw new $TypeError('Assertion failed: `obj` must be an Object');
		}
		if (!this.IsArray(elementTypes)) {
			throw new $TypeError('Assertion failed: `elementTypes`, if provided, must be an array');
		}
		var len = this.ToLength(this.Get(obj, 'length'));
		var list = [];
		var index = 0;
		while (index < len) {
			var indexName = this.ToString(index);
			var next = this.Get(obj, indexName);
			var nextType = this.Type(next);
			if ($indexOf(elementTypes, nextType) < 0) {
				throw new $TypeError('item type ' + nextType + ' is not a valid elementType');
			}
			$push(list, next);
			index += 1;
		}
		return list;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-getprototypefromconstructor
	GetPrototypeFromConstructor: function GetPrototypeFromConstructor(constructor, intrinsicDefaultProto) {
		var intrinsic = GetIntrinsic(intrinsicDefaultProto); // throws if not a valid intrinsic
		if (!this.IsConstructor(constructor)) {
			throw new $TypeError('Assertion failed: `constructor` must be a constructor');
		}
		var proto = this.Get(constructor, 'prototype');
		if (this.Type(proto) !== 'Object') {
			if (!(constructor instanceof $Function)) {
				// ignore other realms, for now
				throw new $TypeError('cross-realm constructors not currently supported');
			}
			proto = intrinsic;
		}
		return proto;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-setfunctionname
	SetFunctionName: function SetFunctionName(F, name) {
		if (typeof F !== 'function') {
			throw new $TypeError('Assertion failed: `F` must be a function');
		}
		if (!this.IsExtensible(F) || has(F, 'name')) {
			throw new $TypeError('Assertion failed: `F` must be extensible, and must not have a `name` own property');
		}
		var nameType = this.Type(name);
		if (nameType !== 'Symbol' && nameType !== 'String') {
			throw new $TypeError('Assertion failed: `name` must be a Symbol or a String');
		}
		if (nameType === 'Symbol') {
			var description = getSymbolDescription(name);
			// eslint-disable-next-line no-param-reassign
			name = typeof description === 'undefined' ? '' : '[' + description + ']';
		}
		if (arguments.length > 2) {
			var prefix = arguments[2];
			// eslint-disable-next-line no-param-reassign
			name = prefix + ' ' + name;
		}
		return this.DefinePropertyOrThrow(F, 'name', {
			'[[Value]]': name,
			'[[Writable]]': false,
			'[[Enumerable]]': false,
			'[[Configurable]]': true
		});
	}
});

delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible

module.exports = ES6;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(228);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var isPrimitive = __webpack_require__(76);
var isCallable = __webpack_require__(38);
var isDate = __webpack_require__(229);
var isSymbol = __webpack_require__(230);

var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDate(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateObject(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) { return false; }
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = __webpack_require__(23)();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false && value;
	};
}


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var every = __webpack_require__(41);

module.exports = function isSamePropertyDescriptor(ES, D1, D2) {
	var fields = [
		'[[Configurable]]',
		'[[Enumerable]]',
		'[[Get]]',
		'[[Set]]',
		'[[Value]]',
		'[[Writable]]'
	];
	return every(fields, function (field) {
		if ((field in D1) !== (field in D2)) {
			return false;
		}
		return ES.SameValue(D1[field], D2[field]);
	});
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(5);

var callBound = __webpack_require__(11);

var $SyntaxError = GetIntrinsic('%SyntaxError%');
var symToStr = callBound('Symbol.prototype.toString', true);

var getInferredName = __webpack_require__(234);

module.exports = function getSymbolDescription(symbol) {
	if (!symToStr) {
		throw new $SyntaxError('Symbols are not supported in this environment');
	}
	var str = symToStr(symbol); // will throw if not a symbol

	if (getInferredName) {
		var name = getInferredName(symbol);
		if (name === '') { return; }
		// eslint-disable-next-line consistent-return
		return name.slice(1, -1); // name.slice('['.length, -']'.length);
	}

	var desc = str.slice(7, -1); // str.slice('Symbol('.length, -')'.length);
	if (desc) {
		// eslint-disable-next-line consistent-return
		return desc;
	}
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getInferredName;
try {
	// eslint-disable-next-line no-new-func
	getInferredName = Function('s', 'return { [s]() {} }[s].name;');
} catch (e) {}

var inferred = function () {};
module.exports = getInferredName && inferred.name === 'inferred' ? getInferredName : null;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(5);

var $Object = GetIntrinsic('%Object%');
var $EvalError = GetIntrinsic('%EvalError%');
var $TypeError = GetIntrinsic('%TypeError%');
var $String = GetIntrinsic('%String%');
var $Date = GetIntrinsic('%Date%');
var $Number = GetIntrinsic('%Number%');
var $floor = GetIntrinsic('%Math.floor%');
var $DateUTC = GetIntrinsic('%Date.UTC%');
var $abs = GetIntrinsic('%Math.abs%');

var assertRecord = __webpack_require__(77);
var isPropertyDescriptor = __webpack_require__(82);
var $isNaN = __webpack_require__(39);
var $isFinite = __webpack_require__(78);
var sign = __webpack_require__(80);
var mod = __webpack_require__(81);
var isPrefixOf = __webpack_require__(86);
var callBound = __webpack_require__(11);

var IsCallable = __webpack_require__(38);
var toPrimitive = __webpack_require__(236);

var has = __webpack_require__(10);

var $getUTCFullYear = callBound('Date.prototype.getUTCFullYear');

var HoursPerDay = 24;
var MinutesPerHour = 60;
var SecondsPerMinute = 60;
var msPerSecond = 1e3;
var msPerMinute = msPerSecond * SecondsPerMinute;
var msPerHour = msPerMinute * MinutesPerHour;
var msPerDay = 86400000;

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return !!value;
	},
	ToNumber: function ToNumber(value) {
		return +value; // eslint-disable-line no-implicit-coercion
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return $String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return $Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new $TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
		return isPropertyDescriptor(this, Desc);
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.1
	IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
			return false;
		}

		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.2
	IsDataDescriptor: function IsDataDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
			return false;
		}

		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.3
	IsGenericDescriptor: function IsGenericDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
			return true;
		}

		return false;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.4
	FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (this.IsDataDescriptor(Desc)) {
			return {
				value: Desc['[[Value]]'],
				writable: !!Desc['[[Writable]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else if (this.IsAccessorDescriptor(Desc)) {
			return {
				get: Desc['[[Get]]'],
				set: Desc['[[Set]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else {
			throw new $TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
		}
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.5
	ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
		if (this.Type(Obj) !== 'Object') {
			throw new $TypeError('ToPropertyDescriptor requires an object');
		}

		var desc = {};
		if (has(Obj, 'enumerable')) {
			desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
		}
		if (has(Obj, 'configurable')) {
			desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
		}
		if (has(Obj, 'value')) {
			desc['[[Value]]'] = Obj.value;
		}
		if (has(Obj, 'writable')) {
			desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
		}
		if (has(Obj, 'get')) {
			var getter = Obj.get;
			if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
				throw new TypeError('getter must be a function');
			}
			desc['[[Get]]'] = getter;
		}
		if (has(Obj, 'set')) {
			var setter = Obj.set;
			if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
				throw new $TypeError('setter must be a function');
			}
			desc['[[Set]]'] = setter;
		}

		if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
			throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
		}
		return desc;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-11.9.3
	'Abstract Equality Comparison': function AbstractEqualityComparison(x, y) {
		var xType = this.Type(x);
		var yType = this.Type(y);
		if (xType === yType) {
			return x === y; // ES6+ specified this shortcut anyways.
		}
		if (x == null && y == null) {
			return true;
		}
		if (xType === 'Number' && yType === 'String') {
			return this['Abstract Equality Comparison'](x, this.ToNumber(y));
		}
		if (xType === 'String' && yType === 'Number') {
			return this['Abstract Equality Comparison'](this.ToNumber(x), y);
		}
		if (xType === 'Boolean') {
			return this['Abstract Equality Comparison'](this.ToNumber(x), y);
		}
		if (yType === 'Boolean') {
			return this['Abstract Equality Comparison'](x, this.ToNumber(y));
		}
		if ((xType === 'String' || xType === 'Number') && yType === 'Object') {
			return this['Abstract Equality Comparison'](x, this.ToPrimitive(y));
		}
		if (xType === 'Object' && (yType === 'String' || yType === 'Number')) {
			return this['Abstract Equality Comparison'](this.ToPrimitive(x), y);
		}
		return false;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-11.9.6
	'Strict Equality Comparison': function StrictEqualityComparison(x, y) {
		var xType = this.Type(x);
		var yType = this.Type(y);
		if (xType !== yType) {
			return false;
		}
		if (xType === 'Undefined' || xType === 'Null') {
			return true;
		}
		return x === y; // shortcut for steps 4-7
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-11.8.5
	// eslint-disable-next-line max-statements
	'Abstract Relational Comparison': function AbstractRelationalComparison(x, y, LeftFirst) {
		if (this.Type(LeftFirst) !== 'Boolean') {
			throw new $TypeError('Assertion failed: LeftFirst argument must be a Boolean');
		}
		var px;
		var py;
		if (LeftFirst) {
			px = this.ToPrimitive(x, $Number);
			py = this.ToPrimitive(y, $Number);
		} else {
			py = this.ToPrimitive(y, $Number);
			px = this.ToPrimitive(x, $Number);
		}
		var bothStrings = this.Type(px) === 'String' && this.Type(py) === 'String';
		if (!bothStrings) {
			var nx = this.ToNumber(px);
			var ny = this.ToNumber(py);
			if ($isNaN(nx) || $isNaN(ny)) {
				return undefined;
			}
			if ($isFinite(nx) && $isFinite(ny) && nx === ny) {
				return false;
			}
			if (nx === 0 && ny === 0) {
				return false;
			}
			if (nx === Infinity) {
				return false;
			}
			if (ny === Infinity) {
				return true;
			}
			if (ny === -Infinity) {
				return false;
			}
			if (nx === -Infinity) {
				return true;
			}
			return nx < ny; // by now, these are both nonzero, finite, and not equal
		}
		if (isPrefixOf(py, px)) {
			return false;
		}
		if (isPrefixOf(px, py)) {
			return true;
		}
		return px < py; // both strings, neither a prefix of the other. shortcut for steps c-f
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.10
	msFromTime: function msFromTime(t) {
		return mod(t, msPerSecond);
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.10
	SecFromTime: function SecFromTime(t) {
		return mod($floor(t / msPerSecond), SecondsPerMinute);
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.10
	MinFromTime: function MinFromTime(t) {
		return mod($floor(t / msPerMinute), MinutesPerHour);
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.10
	HourFromTime: function HourFromTime(t) {
		return mod($floor(t / msPerHour), HoursPerDay);
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.2
	Day: function Day(t) {
		return $floor(t / msPerDay);
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.2
	TimeWithinDay: function TimeWithinDay(t) {
		return mod(t, msPerDay);
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.3
	DayFromYear: function DayFromYear(y) {
		return (365 * (y - 1970)) + $floor((y - 1969) / 4) - $floor((y - 1901) / 100) + $floor((y - 1601) / 400);
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.3
	TimeFromYear: function TimeFromYear(y) {
		return msPerDay * this.DayFromYear(y);
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.3
	YearFromTime: function YearFromTime(t) {
		// largest y such that this.TimeFromYear(y) <= t
		return $getUTCFullYear(new $Date(t));
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.6
	WeekDay: function WeekDay(t) {
		return mod(this.Day(t) + 4, 7);
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.3
	DaysInYear: function DaysInYear(y) {
		if (mod(y, 4) !== 0) {
			return 365;
		}
		if (mod(y, 100) !== 0) {
			return 366;
		}
		if (mod(y, 400) !== 0) {
			return 365;
		}
		return 366;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.3
	InLeapYear: function InLeapYear(t) {
		var days = this.DaysInYear(this.YearFromTime(t));
		if (days === 365) {
			return 0;
		}
		if (days === 366) {
			return 1;
		}
		throw new $EvalError('Assertion failed: there are not 365 or 366 days in a year, got: ' + days);
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.4
	DayWithinYear: function DayWithinYear(t) {
		return this.Day(t) - this.DayFromYear(this.YearFromTime(t));
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.4
	MonthFromTime: function MonthFromTime(t) {
		var day = this.DayWithinYear(t);
		if (0 <= day && day < 31) {
			return 0;
		}
		var leap = this.InLeapYear(t);
		if (31 <= day && day < (59 + leap)) {
			return 1;
		}
		if ((59 + leap) <= day && day < (90 + leap)) {
			return 2;
		}
		if ((90 + leap) <= day && day < (120 + leap)) {
			return 3;
		}
		if ((120 + leap) <= day && day < (151 + leap)) {
			return 4;
		}
		if ((151 + leap) <= day && day < (181 + leap)) {
			return 5;
		}
		if ((181 + leap) <= day && day < (212 + leap)) {
			return 6;
		}
		if ((212 + leap) <= day && day < (243 + leap)) {
			return 7;
		}
		if ((243 + leap) <= day && day < (273 + leap)) {
			return 8;
		}
		if ((273 + leap) <= day && day < (304 + leap)) {
			return 9;
		}
		if ((304 + leap) <= day && day < (334 + leap)) {
			return 10;
		}
		if ((334 + leap) <= day && day < (365 + leap)) {
			return 11;
		}
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.5
	DateFromTime: function DateFromTime(t) {
		var m = this.MonthFromTime(t);
		var d = this.DayWithinYear(t);
		if (m === 0) {
			return d + 1;
		}
		if (m === 1) {
			return d - 30;
		}
		var leap = this.InLeapYear(t);
		if (m === 2) {
			return d - 58 - leap;
		}
		if (m === 3) {
			return d - 89 - leap;
		}
		if (m === 4) {
			return d - 119 - leap;
		}
		if (m === 5) {
			return d - 150 - leap;
		}
		if (m === 6) {
			return d - 180 - leap;
		}
		if (m === 7) {
			return d - 211 - leap;
		}
		if (m === 8) {
			return d - 242 - leap;
		}
		if (m === 9) {
			return d - 272 - leap;
		}
		if (m === 10) {
			return d - 303 - leap;
		}
		if (m === 11) {
			return d - 333 - leap;
		}
		throw new $EvalError('Assertion failed: MonthFromTime returned an impossible value: ' + m);
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.12
	MakeDay: function MakeDay(year, month, date) {
		if (!$isFinite(year) || !$isFinite(month) || !$isFinite(date)) {
			return NaN;
		}
		var y = this.ToInteger(year);
		var m = this.ToInteger(month);
		var dt = this.ToInteger(date);
		var ym = y + $floor(m / 12);
		var mn = mod(m, 12);
		var t = $DateUTC(ym, mn, 1);
		if (this.YearFromTime(t) !== ym || this.MonthFromTime(t) !== mn || this.DateFromTime(t) !== 1) {
			return NaN;
		}
		return this.Day(t) + dt - 1;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.13
	MakeDate: function MakeDate(day, time) {
		if (!$isFinite(day) || !$isFinite(time)) {
			return NaN;
		}
		return (day * msPerDay) + time;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.11
	MakeTime: function MakeTime(hour, min, sec, ms) {
		if (!$isFinite(hour) || !$isFinite(min) || !$isFinite(sec) || !$isFinite(ms)) {
			return NaN;
		}
		var h = this.ToInteger(hour);
		var m = this.ToInteger(min);
		var s = this.ToInteger(sec);
		var milli = this.ToInteger(ms);
		var t = (h * msPerHour) + (m * msPerMinute) + (s * msPerSecond) + milli;
		return t;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.14
	TimeClip: function TimeClip(time) {
		if (!$isFinite(time) || $abs(time) > 8.64e15) {
			return NaN;
		}
		return $Number(new $Date(this.ToNumber(time)));
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-5.2
	modulo: function modulo(x, y) {
		return mod(x, y);
	}
};

module.exports = ES5;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(76);

var isCallable = __webpack_require__(38);

// http://ecma-international.org/ecma-262/5.1/#sec-8.12.8
var ES5internalSlots = {
	'[[DefaultValue]]': function (O) {
		var actualHint;
		if (arguments.length > 1) {
			actualHint = arguments[1];
		} else {
			actualHint = toStr.call(O) === '[object Date]' ? String : Number;
		}

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// http://ecma-international.org/ecma-262/5.1/#sec-9.1
module.exports = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	if (arguments.length > 1) {
		return ES5internalSlots['[[DefaultValue]]'](input, arguments[1]);
	}
	return ES5internalSlots['[[DefaultValue]]'](input);
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(10);
var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0;

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex;
	}
};
var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		return toStr.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(5);

var originalGetProto = GetIntrinsic('%Object.getPrototypeOf%', true);
var $ArrayProto = GetIntrinsic('%Array.prototype%');

module.exports = originalGetProto || (
	// eslint-disable-next-line no-proto
	[].__proto__ === $ArrayProto
		? function (O) {
			return O.__proto__; // eslint-disable-line no-proto
		}
		: null
);


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(66);
var getPolyfill = __webpack_require__(87);

module.exports = function shimFlatMap() {
	var polyfill = getPolyfill();
	define(
		Array.prototype,
		{ flatMap: polyfill },
		{ flatMap: function () { return Array.prototype.flatMap !== polyfill; } }
	);
	return polyfill;
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(0).then((function(require) {
		cb(__webpack_require__(249));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(0).then((function(require) {
		cb(__webpack_require__(250));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MeliaWidget = __webpack_require__(35);

var _MeliaWidget2 = _interopRequireDefault(_MeliaWidget);

var _SecondaryHotelsProvider = __webpack_require__(26);

var _SecondaryHotelsProvider2 = _interopRequireDefault(_SecondaryHotelsProvider);

var _SecondaryHotelsLayer = __webpack_require__(42);

var _SecondaryHotelsLayer2 = _interopRequireDefault(_SecondaryHotelsLayer);

var _MeliaMainMenu = __webpack_require__(33);

var _MeliaMainMenu2 = _interopRequireDefault(_MeliaMainMenu);

var _Autocomplete = __webpack_require__(19);

var _Autocomplete2 = _interopRequireDefault(_Autocomplete);

var _GoogleAutocomplete = __webpack_require__(29);

var _GoogleAutocomplete2 = _interopRequireDefault(_GoogleAutocomplete);

var _HotelLocation = __webpack_require__(20);

var _HotelLocation2 = _interopRequireDefault(_HotelLocation);

var _DirectionsMobileCTA = __webpack_require__(51);

var _DirectionsMobileCTA2 = _interopRequireDefault(_DirectionsMobileCTA);

var _ListCategoriesProvider = __webpack_require__(44);

var _ListCategoriesProvider2 = _interopRequireDefault(_ListCategoriesProvider);

var _hotelSummaryMobilePanel = __webpack_require__(31);

var _hotelSummaryMobilePanel2 = _interopRequireDefault(_hotelSummaryMobilePanel);

var _MessageControl = __webpack_require__(32);

var _MessageControl2 = _interopRequireDefault(_MessageControl);

var _ListHotelsProvider = __webpack_require__(28);

var _ListHotelsProvider2 = _interopRequireDefault(_ListHotelsProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MeliaWidget2.default.extend({
	validation: __webpack_require__(243),

	constructor: function constructor(containerId, config, api) {
		config.directionsOriginDestinationIcons = {
			origin: 'route-point-origin.png',
			destination: 'route-point-dest.png'
		};
		_MeliaWidget2.default.prototype.constructor.call(this, containerId, config, api);
	},
	initialize: function initialize() {
		_MeliaWidget2.default.prototype.initialize.call(this);
	},
	onInitialized: function onInitialized() {
		_MeliaWidget2.default.prototype.onInitialized.call(this);
		this.initializeBaseLayer();
		this.addComponent(new _MeliaMainMenu2.default({
			identifier: 'main-menu',
			widget: this,
			componentClass: 'melia-main-menu-class',
			classPrefix: '.melia-main-menu-class-',
			position: 'TOP_LEFT',
			visible: true,
			properties: {
				components: {
					MainBox: {
						position: 'main-box-container',
						componentConstructorClass: 'MainBox',
						properties: {}
					},
					DirectionsBox: {
						position: 'directions-box-container',
						componentConstructorClass: 'DirectionsBox',
						componentClass: 'directions-box',
						properties: {}
					},
					JPRouteDetails: {
						position: 'route-details-container',
						componentConstructorClass: 'JPRouteDetails',
						componentClass: 'jp-route-details',
						properties: {}
					}
				}
			}
		}));

		this.addComponent(new _HotelLocation2.default({
			identifier: 'main-menu',
			widget: this,
			componentClass: 'melia-main-menu-class',
			classPrefix: '.melia-main-menu-class-',
			position: 'RIGHT_BOTTOM',
			visible: true,
			properties: {}
		}));

		this.addComponent(new _MessageControl2.default({
			identifier: 'message-control' + (this.isMobileVersion ? '-mobile' : ''),
			position: 'TOP_RIGHT',
			widget: this
		}));

		if (this.isMobileVersion) {
			this.addMobileComponents();
		}
	},
	addMobileComponents: function addMobileComponents() {
		this.addComponent(new _DirectionsMobileCTA2.default({
			identifier: 'directions-mobile-cta',
			widget: this,
			componentClass: 'directions-mobile-cta',
			classPrefix: 'directions-mobile-cta',
			position: 'RIGHT_BOTTOM',
			visible: true
		}));
	},
	registerConfigClasses: function registerConfigClasses(registerComponent, registerLayer, registerLayerProvider) {
		registerLayer('SecondaryHotelsLayer', _SecondaryHotelsLayer2.default);
		registerLayerProvider('SecondaryHotelsProvider', _SecondaryHotelsProvider2.default);
		_Autocomplete2.default.registerProviderClass('GPlacesAutocomplete', _GoogleAutocomplete2.default);
		_Autocomplete2.default.registerProviderClass('ListCategoriesProvider', _ListCategoriesProvider2.default);
		_Autocomplete2.default.registerProviderClass('ListHotelsProvider', _ListHotelsProvider2.default);

		registerComponent('MeliaMainMenu', _MeliaMainMenu2.default);
		registerComponent('DirectionsMobileCTA', _DirectionsMobileCTA2.default);
		registerComponent('hotelSummaryMobilePanel', _hotelSummaryMobilePanel2.default);
		registerComponent('MessageControl', _MessageControl2.default);
	},
	initializeBaseLayer: function initializeBaseLayer() {
		var _this = this;

		this.initBaseMapLayer();
		this.addLayer(new _SecondaryHotelsLayer2.default({
			widget: this,
			provider: _SecondaryHotelsProvider2.default,
			id: 'SecondaryHotelsLayer',
			iconMarker: {
				default: {
					url: this.hotelsJson.alternativeHotelList.iconMarker
				},
				hover: {
					url: this.hotelsJson.alternativeHotelList.iconMarker
				},
				selected: {
					url: this.hotelsJson.alternativeHotelList.iconMarker
				}
			},
			featureId: 'id',
			minZoom: this.config.minZoom
		}));
		this.listenTo(this.bus, 'CLICK_ON_MARKER', function (marker) {
			if (marker.id && marker.layerId === 'SecondaryHotelsLayer') {
				_this.getMainHotelData(marker.id).then(function (hotelData) {
					var hotelMobileSummaryPanel = _this.customComponents['hotel-summary-panel'];
					if (_this.isMobileVersion) {
						if (hotelMobileSummaryPanel) {
							hotelMobileSummaryPanel.$el.remove();
							hotelMobileSummaryPanel.remove();
						}
						_this.addComponent(new _hotelSummaryMobilePanel2.default({
							identifier: 'hotel-summary-panel',
							widget: _this,
							componentClass: 'hotel-summary-panel',
							classPrefix: 'hotel-summary-panel',
							position: 'BOTTOM_CENTER',
							visible: true,
							properties: {
								hotelData: hotelData
							}
						}));
					} else {
						_this.bus.trigger('UPDATED_HOTEL_SELECTED_DATA', hotelData);
					}
					var closeDirBox = false;
					_this.bus.trigger('directions_btn_event', closeDirBox);
				});
			}
		});
	}
});

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(0).then((function(require) {
		cb(__webpack_require__(251));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MeliaWidget = __webpack_require__(35);

var _MeliaWidget2 = _interopRequireDefault(_MeliaWidget);

var _MeliaMainMenu = __webpack_require__(33);

var _MeliaMainMenu2 = _interopRequireDefault(_MeliaMainMenu);

var _Autocomplete = __webpack_require__(19);

var _Autocomplete2 = _interopRequireDefault(_Autocomplete);

var _GoogleAutocomplete = __webpack_require__(29);

var _GoogleAutocomplete2 = _interopRequireDefault(_GoogleAutocomplete);

var _DestinationsTreeProvider = __webpack_require__(88);

var _DestinationsTreeProvider2 = _interopRequireDefault(_DestinationsTreeProvider);

var _DestinationsTreeLayer = __webpack_require__(245);

var _DestinationsTreeLayer2 = _interopRequireDefault(_DestinationsTreeLayer);

var _ListHotelsProvider = __webpack_require__(28);

var _ListHotelsProvider2 = _interopRequireDefault(_ListHotelsProvider);

var _hotelSummaryMobilePanel = __webpack_require__(31);

var _hotelSummaryMobilePanel2 = _interopRequireDefault(_hotelSummaryMobilePanel);

var _HotelLocation = __webpack_require__(20);

var _HotelLocation2 = _interopRequireDefault(_HotelLocation);

var _MessageControl = __webpack_require__(32);

var _MessageControl2 = _interopRequireDefault(_MessageControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MeliaWidget2.default.extend({
	constructor: function constructor(containerId, config, api) {
		_MeliaWidget2.default.prototype.constructor.call(this, containerId, config, api);
	},
	initialize: function initialize() {
		_MeliaWidget2.default.prototype.initialize.call(this);
	},
	onInitialized: function onInitialized() {
		_MeliaWidget2.default.prototype.onInitialized.call(this);
		this.initializeBaseLayer();
		this.addComponent(new _MeliaMainMenu2.default({
			identifier: 'main-menu',
			widget: this,
			componentClass: 'melia-main-menu-class',
			classPrefix: '.melia-main-menu-class-',
			position: 'TOP_LEFT',
			visible: true,
			properties: {
				components: {
					BlockAutocomplete: {
						position: 'main-box-container',
						componentConstructorClass: 'BlockAutocomplete',
						properties: {}
					}
				}
			}
		}));

		this.addComponent(new _HotelLocation2.default({
			identifier: 'main-menu',
			widget: this,
			componentClass: 'melia-main-menu-class',
			classPrefix: '.melia-main-menu-class-',
			position: 'RIGHT_BOTTOM',
			visible: true,
			properties: {}
		}));

		this.addComponent(new _MessageControl2.default({
			identifier: 'message-control' + (this.isMobileVersion ? '-mobile' : ''),
			position: 'TOP_RIGHT',
			widget: this
		}));

		if (this.isMobileVersion) {
			this.addMobileComponents();
		}
	},
	addMobileComponents: function addMobileComponents() {},
	registerConfigClasses: function registerConfigClasses(registerComponent, registerLayer, registerLayerProvider) {
		registerLayer('destinationTreeLayer', _DestinationsTreeLayer2.default);
		registerLayerProvider('DestinationsTreeProvider', _DestinationsTreeProvider2.default);
		_Autocomplete2.default.registerProviderClass('GPlacesAutocomplete', _GoogleAutocomplete2.default);
		_Autocomplete2.default.registerProviderClass('ListHotelsProvider', _ListHotelsProvider2.default);

		registerComponent('MeliaMainMenu', _MeliaMainMenu2.default);
		registerComponent('hotelSummaryMobilePanel', _hotelSummaryMobilePanel2.default);
		registerComponent('HotelLocation', _HotelLocation2.default);
		registerComponent('MessageControl', _MessageControl2.default);
	},
	initializeBaseLayer: function initializeBaseLayer() {
		var _this = this;

		this.initBaseMapLayer();
		this.addLayer(new _DestinationsTreeLayer2.default({
			widget: this,
			provider: _DestinationsTreeProvider2.default,
			id: 'destinationTreeLayer',
			iconMarker: {
				default: {
					url: this.hotelsJson.alternativeHotelList.iconMarker
				},
				hover: {
					url: this.hotelsJson.alternativeHotelList.iconMarker
				},
				selected: {
					url: this.hotelsJson.alternativeHotelList.iconMarker
				}
			},
			featureId: 'id',
			minZoom: false,
			cluster: {
				options: {
					radius: 150,
					maxZoom: 13,
					minZoom: 0,
					extend: 512,
					nodeSize: 64,
					log: false
				},
				iconStyles: {
					url: this.config.clusterHotelsIcon || 'secondary-hotel-marker.svg'
				}
			}
		}));

		this.listenTo(this.bus, 'CLICK_ON_MARKER', function (marker) {
			if (marker.id && marker.layerId === 'destinationTreeLayer') {
				_this.getMainHotelData(marker.id).then(function (hotelData) {
					var hotelMobileSummaryPanel = _this.customComponents['hotel-summary-panel'];
					if (_this.isMobileVersion) {
						if (hotelMobileSummaryPanel) {
							hotelMobileSummaryPanel.$el.remove();
							hotelMobileSummaryPanel.remove();
						}
						_this.addComponent(new _hotelSummaryMobilePanel2.default({
							identifier: 'hotel-summary-panel',
							widget: _this,
							componentClass: 'hotel-summary-panel',
							classPrefix: 'hotel-summary-panel',
							position: 'BOTTOM_CENTER',
							visible: true,
							properties: {
								hotelData: hotelData
							}
						}));
					} else {
						_this.bus.trigger('UPDATED_HOTEL_SELECTED_DATA', hotelData);
					}
				});
			}
		});
	},
	getDestinationsTreeData: function getDestinationsTreeData() {}
});

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MarkerLayer = __webpack_require__(25);

var _MarkerLayer2 = _interopRequireDefault(_MarkerLayer);

var _DestinationsTreeProvider = __webpack_require__(88);

var _DestinationsTreeProvider2 = _interopRequireDefault(_DestinationsTreeProvider);

var _BoundingBoxFilter = __webpack_require__(246);

var _BoundingBoxFilter2 = _interopRequireDefault(_BoundingBoxFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLUSTER_ID = 'cluster_id';

var DestinationsTreeLayer = _MarkerLayer2.default.extend({
	constructor: function constructor(options) {
		_MarkerLayer2.default.prototype.constructor.call(this, options);
		this._bindListener();
	},
	initialize: function initialize(options) {
		var _this = this;

		this.markers = [];
		this.featuresTest = [];
		this.options.provider = new _DestinationsTreeProvider2.default(options);
		this.options.preFilters = this._initPreFilters(options.widget);
		this.options.postFilters = [];
		this.options.markersClickable = true;
		this.options.minZoom = options.minZoom !== undefined ? options.minZoom : 16;
		if (this.isAvailableZoom(this.options.minZoom)) {
			this.options.model.show();
		}
		this.options.model.activate();
		_MarkerLayer2.default.prototype.initialize.call(this, options);
		this.options.provider.load(this.widget.config.initialDestinationId);
		this.listenTo(this.widget.bus, 'LOCATION_TREE', function (destination) {
			_this.options.provider.load(destination.regionId);
			_this.remove();
			_this.initialize(_this.options);
		});
		this.listenTo(this.widget.bus, 'REGION_CHANGED', function (destination) {
			_this.options.provider.load(destination.regionId);
			_this.widget.config.initialDestinationId = destination.regionId;
		});
	},
	_bindListener: function _bindListener() {
		var _this2 = this;

		google.maps.event.addListener(this.widget.map, 'zoom_changed', function () {
			_this2._processFeatures(_this2.featuresTest);
		});
	},
	_bindMarkerLayerEvents: function _bindMarkerLayerEvents() {
		var _this3 = this;

		this.listenTo(this.options.provider, 'PROCESS_FEATURES', function (features) {
			_this3.featuresTest = features;
			_this3._processFeatures(features);
			_this3.widget.bus.trigger('LAYER_LOADED', _this3, features);
		});
	},
	add: function add() {},
	_createMarkers: function _createMarkers(features) {
		var _this4 = this;

		this.remove();
		features.forEach(function (feature) {
			var marker = _this4.getMarkerFromId(_this4._getFeatureId(feature));
			if (!marker) {
				marker = _this4._createMarker(feature);
				_this4._addListeners(marker);
				_this4._showMarker(marker);
				_this4.markers.push(marker);
			}
			_this4.trigger('createdMarker', marker, feature);
		});
		this.widget.bus.trigger('RELOAD_LIST', this.widget.hotelMeliaList);
	},
	_clusterClicked: function _clusterClicked(cluster) {
		this.clusterHelper.setClusterExpansion(cluster.properties[CLUSTER_ID]);
		this._processFeatures(this.featuresTest);
	},
	_initPreFilters: function _initPreFilters(widget) {
		return [new _BoundingBoxFilter2.default(widget)];
	},
	_markerClicked: function _markerClicked(marker, e) {
		this.deselectMarker();
		this.selectMarker(marker, e);
	},
	_createMarker: function _createMarker(feature) {
		var marker = new google.maps.Marker({
			id: this._getFeatureId(feature),
			layerId: this.options.id,
			position: new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]),
			properties: feature.properties,
			optimized: !this.widget.config.debugEnabled,
			clickable: this.options.markersClickable,
			zIndex: this.options.markersZIndex ? this.options.markersZIndex : 1
		});
		if (feature.properties.cluster) {
			marker.setIcon(this.clusterHelper.getIconCluster(this.widget));
		} else {
			marker.setIcon(this._getIconMarker(feature.properties, 'default'));
		}
		return marker;
	}
});

exports.default = DestinationsTreeLayer;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(1);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @classdesc The filter by bounding box
 * @memberof core.filters
 */
var BoundingBoxFilter = function () {
  /** 
   * Creates a new BoundingBoxFilter instance
   * @param {core.widget.Widget} widget - The widget the filter is added to.
   */
  function BoundingBoxFilter(widget) {
    _classCallCheck(this, BoundingBoxFilter);

    this.widget = widget;
    this.cleanMarkers = true; //used to know in APILayer that we need to clean the markers in every 'idle'
  }
  /**
   * Filter the features by bounding box
   * @function
   * @memberOf BoundingBoxFilter
   * @param {Feature[]} features - The features to filter
   * @returns {Promise}
   */


  _createClass(BoundingBoxFilter, [{
    key: 'filterFeatures',
    value: function filterFeatures(features) {
      var _this = this;

      var deferred = _jquery2.default.Deferred();
      var featuresInBoundingBox = [];
      _underscore2.default.each(features, function (feature) {
        var coordinate = {
          lat: feature.geometry.coordinates[1],
          lng: feature.geometry.coordinates[0]
        };
        if (_this.widget.map.getBounds().contains(new google.maps.LatLng(coordinate))) {
          featuresInBoundingBox.push(feature);
        }
      });
      deferred.resolve(featuresInBoundingBox);
      return deferred.promise();
    }
  }]);

  return BoundingBoxFilter;
}();

exports.default = BoundingBoxFilter;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// dist/js/lmm-maps-widget.js